//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { ORG_ID } from '../utils/org-id';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class CostUnitsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     */
    getCostUnitTypes(): Observable<CostUnitTypesResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/costUnit/types";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostUnitTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostUnitTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitTypesResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitTypesResponseDto>;
        }));
    }

    protected processGetCostUnitTypes(response: HttpResponseBase): Observable<CostUnitTypesResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostUnitTypesResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param costUnitTypeId Cost unit type custom id
     * @param search (optional) Search parameter to support filtering. Do not use together with cursor. Search can not contain any of these special characters: & % ' " = Maximum of 50 characters are allowed.
     * @param cursor (optional) Use the cursor token to get next part of a list. When used, do not provide search parameter, it is already included in token.
     * @return OK
     */
    getCostUnitTypeValues(costUnitTypeId: string, search?: string | undefined, cursor?: string | undefined): Observable<CostUnitTypeValuesResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/costUnit/type/{costUnitTypeId}/values?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (costUnitTypeId === undefined || costUnitTypeId === null)
            throw new Error("The parameter 'costUnitTypeId' must be defined.");
            url_ = url_.replace("{costUnitTypeId}", encodeURIComponent("" + costUnitTypeId));
    
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
    
        if (cursor === null)
            throw new Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostUnitTypeValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostUnitTypeValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitTypeValuesResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitTypeValuesResponseDto>;
        }));
    }

    protected processGetCostUnitTypeValues(response: HttpResponseBase): Observable<CostUnitTypeValuesResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostUnitTypeValuesResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param costUnitTypeId Cost unit type custom id
     * @param costUnitValueId Cost unit value custom id
     * @return OK
     */
    getCostUnitTypeValue(costUnitTypeId: string, costUnitValueId: string): Observable<CostUnitValueDto> {
        let url_ = this.baseUrl + "/org/{orgId}/costUnit/type/{costUnitTypeId}/value/{costUnitValueId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (costUnitTypeId === undefined || costUnitTypeId === null)
            throw new Error("The parameter 'costUnitTypeId' must be defined.");
            url_ = url_.replace("{costUnitTypeId}", encodeURIComponent("" + costUnitTypeId));
    
        if (costUnitValueId === undefined || costUnitValueId === null)
            throw new Error("The parameter 'costUnitValueId' must be defined.");
            url_ = url_.replace("{costUnitValueId}", encodeURIComponent("" + costUnitValueId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostUnitTypeValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostUnitTypeValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitValueDto>;
        }));
    }

    protected processGetCostUnitTypeValue(response: HttpResponseBase): Observable<CostUnitValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostUnitValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Action was already created and will be processed or has already been processed
     */
    postCostUnitTypeCreate(body: CostUnitTypeCreateRequestDto): Observable<OkActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/actions/costUnitTypeCreate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCostUnitTypeCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCostUnitTypeCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkActionResponseDto>;
        }));
    }

    protected processPostCostUnitTypeCreate(response: HttpResponseBase): Observable<OkActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Action was already created and will be processed or has already been processed
     */
    postCostUnitTypeUpdate(body: CostUnitTypeUpdateRequestDto): Observable<OkActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/actions/costUnitTypeUpdate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCostUnitTypeUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCostUnitTypeUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkActionResponseDto>;
        }));
    }

    protected processPostCostUnitTypeUpdate(response: HttpResponseBase): Observable<OkActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     * @deprecated
     */
    postCostUnitValueUpsert(body: CostUnitValueUpsertOperationRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitValueUpsert";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCostUnitValueUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCostUnitValueUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostCostUnitValueUpsert(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     * @deprecated
     */
    getCostUnitValueUpsertOperation(operationId: string): Observable<CostUnitValueUpsertOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitValueUpsert/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostUnitValueUpsertOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostUnitValueUpsertOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitValueUpsertOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitValueUpsertOperationDto>;
        }));
    }

    protected processGetCostUnitValueUpsertOperation(response: HttpResponseBase): Observable<CostUnitValueUpsertOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostUnitValueUpsertOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     * @deprecated
     */
    postCostUnitValueUpsertGetTasks(operationId: string, body: GetTasksRequestDto): Observable<CostUnitValueUpsertTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitValueUpsert/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCostUnitValueUpsertGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCostUnitValueUpsertGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitValueUpsertTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitValueUpsertTaskDto[]>;
        }));
    }

    protected processPostCostUnitValueUpsertGetTasks(response: HttpResponseBase): Observable<CostUnitValueUpsertTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostUnitValueUpsertTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postManageCostUnitValues(body: ManageCostUnitValuesOperationRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/manageCostUnitValues";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostManageCostUnitValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostManageCostUnitValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostManageCostUnitValues(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getManageCostUnitValuesOperation(operationId: string): Observable<ManageCostUnitValuesOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/manageCostUnitValues/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManageCostUnitValuesOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManageCostUnitValuesOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageCostUnitValuesOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageCostUnitValuesOperationDto>;
        }));
    }

    protected processGetManageCostUnitValuesOperation(response: HttpResponseBase): Observable<ManageCostUnitValuesOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageCostUnitValuesOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postCostUnitTypeCreateOperation(body: CostUnitTypesCreateRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitTypeCreate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCostUnitTypeCreateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCostUnitTypeCreateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostCostUnitTypeCreateOperation(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getCostUnitTypesCreateOperation(operationId: string): Observable<CostUnitTypesCreateOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitTypeCreate/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostUnitTypesCreateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostUnitTypesCreateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitTypesCreateOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitTypesCreateOperationDto>;
        }));
    }

    protected processGetCostUnitTypesCreateOperation(response: HttpResponseBase): Observable<CostUnitTypesCreateOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostUnitTypesCreateOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postCostUnitTypeUpdateOperation(body: CostUnitTypesUpdateRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitTypeUpdate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCostUnitTypeUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCostUnitTypeUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostCostUnitTypeUpdateOperation(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getCostUnitTypesUpdateOperation(operationId: string): Observable<CostUnitTypesUpdateOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/costUnitTypeUpdate/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostUnitTypesUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostUnitTypesUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostUnitTypesUpdateOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostUnitTypesUpdateOperationDto>;
        }));
    }

    protected processGetCostUnitTypesUpdateOperation(response: HttpResponseBase): Observable<CostUnitTypesUpdateOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostUnitTypesUpdateOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AbsenceRegistrationImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postAbsenceRegistrationImport(body: AbsenceRegistrationImportRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/absenceRegistrationImport";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAbsenceRegistrationImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAbsenceRegistrationImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostAbsenceRegistrationImport(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getAbsenceRegistrationImportOperation(operationId: string): Observable<AbsenceRegistrationImportOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/absenceRegistrationImport/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAbsenceRegistrationImportOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAbsenceRegistrationImportOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbsenceRegistrationImportOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbsenceRegistrationImportOperationDto>;
        }));
    }

    protected processGetAbsenceRegistrationImportOperation(response: HttpResponseBase): Observable<AbsenceRegistrationImportOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbsenceRegistrationImportOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VacationBalanceImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postVacationBalanceImport(body: VacationBalanceImportRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/vacationBalanceImport";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostVacationBalanceImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostVacationBalanceImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostVacationBalanceImport(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getVacationBalanceImportOperation(operationId: string): Observable<VacationBalanceImportOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/vacationBalanceImport/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacationBalanceImportOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacationBalanceImportOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacationBalanceImportOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacationBalanceImportOperationDto>;
        }));
    }

    protected processGetVacationBalanceImportOperation(response: HttpResponseBase): Observable<VacationBalanceImportOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationBalanceImportOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postVacationBalanceImportGetTasks(operationId: string, body: GetTasksRequestDto): Observable<VacationBalanceImportTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/vacationBalanceImport/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostVacationBalanceImportGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostVacationBalanceImportGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacationBalanceImportTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacationBalanceImportTaskDto[]>;
        }));
    }

    protected processPostVacationBalanceImportGetTasks(response: HttpResponseBase): Observable<VacationBalanceImportTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VacationBalanceImportTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PositionTagsUpdateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postPositionTagsUpdateOperation(body: PositionTagsUpdateOperationRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/positionTagsUpdate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPositionTagsUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPositionTagsUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostPositionTagsUpdateOperation(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getPositionTagsUpdateGetOperation(operationId: string): Observable<PositionTagsUpdateOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/positionTagsUpdate/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionTagsUpdateGetOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionTagsUpdateGetOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionTagsUpdateOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionTagsUpdateOperationDto>;
        }));
    }

    protected processGetPositionTagsUpdateGetOperation(response: HttpResponseBase): Observable<PositionTagsUpdateOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionTagsUpdateOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postPositionTagsUpdateGetTasks(operationId: string, body: GetTasksRequestDto): Observable<PositionTagsUpdateTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/positionTagsUpdate/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPositionTagsUpdateGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPositionTagsUpdateGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionTagsUpdateTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionTagsUpdateTaskDto[]>;
        }));
    }

    protected processPostPositionTagsUpdateGetTasks(response: HttpResponseBase): Observable<PositionTagsUpdateTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionTagsUpdateTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EndPositionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     * @deprecated
     */
    getEmployeesForEndPositions(nextToken?: string | undefined): Observable<EmployeesForEndPositionsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesForEndPositions?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForEndPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForEndPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesForEndPositionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesForEndPositionsResponseDto>;
        }));
    }

    protected processGetEmployeesForEndPositions(response: HttpResponseBase): Observable<EmployeesForEndPositionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesForEndPositionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     * @deprecated
     */
    postEndPositions(body: EndPositionsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/endPositions";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEndPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEndPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostEndPositions(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     * @deprecated
     */
    getEndPositionsOperation(operationId: string): Observable<EndPositionsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/endPositions/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndPositionsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndPositionsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndPositionsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndPositionsOperationDto>;
        }));
    }

    protected processGetEndPositionsOperation(response: HttpResponseBase): Observable<EndPositionsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndPositionsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     * @deprecated
     */
    postEndPositionsGetTasks(operationId: string, body: GetTasksRequestDto): Observable<EndPositionsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/endPositions/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEndPositionsGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEndPositionsGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndPositionsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndPositionsTaskDto[]>;
        }));
    }

    protected processPostEndPositionsGetTasks(response: HttpResponseBase): Observable<EndPositionsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EndPositionsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditPositionEndDatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getEmployeesForEditPositionEndDates(nextToken?: string | undefined): Observable<EmployeesForEditPositionEndDatesResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesForEditPositionEndDates?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForEditPositionEndDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForEditPositionEndDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesForEditPositionEndDatesResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesForEditPositionEndDatesResponseDto>;
        }));
    }

    protected processGetEmployeesForEditPositionEndDates(response: HttpResponseBase): Observable<EmployeesForEditPositionEndDatesResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesForEditPositionEndDatesResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postEditPositionEndDates(body: EditPositionEndDatesRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/editPositionEndDates";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEditPositionEndDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEditPositionEndDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostEditPositionEndDates(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getEditPositionEndDatesOperation(operationId: string): Observable<EditPositionEndDatesOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/editPositionEndDates/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditPositionEndDatesOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditPositionEndDatesOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditPositionEndDatesOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditPositionEndDatesOperationDto>;
        }));
    }

    protected processGetEditPositionEndDatesOperation(response: HttpResponseBase): Observable<EditPositionEndDatesOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditPositionEndDatesOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postEditPositionEndDatesGetTasks(operationId: string, body: GetTasksRequestDto): Observable<EditPositionEndDatesTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/editPositionEndDates/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEditPositionEndDatesGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEditPositionEndDatesGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditPositionEndDatesTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditPositionEndDatesTaskDto[]>;
        }));
    }

    protected processPostEditPositionEndDatesGetTasks(response: HttpResponseBase): Observable<EditPositionEndDatesTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditPositionEndDatesTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SalaryUpdateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getEmployeesForSalaryUpdate(nextToken?: string | undefined): Observable<EmployeesForSalaryUpdateResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesForSalaryUpdate?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForSalaryUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForSalaryUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesForSalaryUpdateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesForSalaryUpdateResponseDto>;
        }));
    }

    protected processGetEmployeesForSalaryUpdate(response: HttpResponseBase): Observable<EmployeesForSalaryUpdateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesForSalaryUpdateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postSalaryUpdateV2(body: SalaryUpdateV2RequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/salaryUpdateV2";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSalaryUpdateV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSalaryUpdateV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostSalaryUpdateV2(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getSalaryUpdateV2Operation(operationId: string): Observable<SalaryUpdateV2OperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/salaryUpdateV2/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryUpdateV2Operation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryUpdateV2Operation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryUpdateV2OperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryUpdateV2OperationDto>;
        }));
    }

    protected processGetSalaryUpdateV2Operation(response: HttpResponseBase): Observable<SalaryUpdateV2OperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalaryUpdateV2OperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postSalaryUpdateV2GetTasks(operationId: string, body: GetTasksRequestDto): Observable<SalaryUpdateV2TaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/salaryUpdateV2/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSalaryUpdateV2GetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSalaryUpdateV2GetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryUpdateV2TaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryUpdateV2TaskDto[]>;
        }));
    }

    protected processPostSalaryUpdateV2GetTasks(response: HttpResponseBase): Observable<SalaryUpdateV2TaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryUpdateV2TaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PayRateUpdateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getEmployeesForPayRateUpdate(nextToken?: string | undefined): Observable<EmployeesForPayRateUpdateResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesForPayRateUpdate?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForPayRateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForPayRateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesForPayRateUpdateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesForPayRateUpdateResponseDto>;
        }));
    }

    protected processGetEmployeesForPayRateUpdate(response: HttpResponseBase): Observable<EmployeesForPayRateUpdateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesForPayRateUpdateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postPayRateUpdate(body: PayRateUpdateRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/payRateUpdate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPayRateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPayRateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostPayRateUpdate(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getPayRateUpdateOperation(operationId: string): Observable<PayRateUpdateOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/payRateUpdate/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRateUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRateUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateUpdateOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateUpdateOperationDto>;
        }));
    }

    protected processGetPayRateUpdateOperation(response: HttpResponseBase): Observable<PayRateUpdateOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayRateUpdateOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssignUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getEmployeesForAssignUser(nextToken?: string | undefined): Observable<EmployeesForAssignUserResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesForAssignUser?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForAssignUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForAssignUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesForAssignUserResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesForAssignUserResponseDto>;
        }));
    }

    protected processGetEmployeesForAssignUser(response: HttpResponseBase): Observable<EmployeesForAssignUserResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesForAssignUserResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postAssignUser(body: AssignUserRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/assignUser";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAssignUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAssignUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostAssignUser(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getAssignUserOperation(operationId: string): Observable<AssignUserOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/assignUser/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignUserOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignUserOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignUserOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignUserOperationDto>;
        }));
    }

    protected processGetAssignUserOperation(response: HttpResponseBase): Observable<AssignUserOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignUserOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postAssignUserGetTasks(operationId: string, body: GetTasksRequestDto): Observable<AssignUserTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/assignUser/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAssignUserGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAssignUserGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignUserTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignUserTaskDto[]>;
        }));
    }

    protected processPostAssignUserGetTasks(response: HttpResponseBase): Observable<AssignUserTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignUserTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChangeManagerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getEmployeesForChangeManager(nextToken?: string | undefined): Observable<EmployeesForChangeManagerResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesForChangeManager?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForChangeManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForChangeManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesForChangeManagerResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesForChangeManagerResponseDto>;
        }));
    }

    protected processGetEmployeesForChangeManager(response: HttpResponseBase): Observable<EmployeesForChangeManagerResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesForChangeManagerResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postChangeManager(body: ChangeManagerRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/changeManager";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostChangeManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostChangeManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostChangeManager(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getChangeManagerOperation(operationId: string): Observable<ChangeManagerOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/changeManager/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeManagerOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeManagerOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeManagerOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeManagerOperationDto>;
        }));
    }

    protected processGetChangeManagerOperation(response: HttpResponseBase): Observable<ChangeManagerOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeManagerOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postChangeManagerGetTasks(operationId: string, body: GetTasksRequestDto): Observable<ChangeManagerTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/changeManager/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostChangeManagerGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostChangeManagerGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeManagerTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeManagerTaskDto[]>;
        }));
    }

    protected processPostChangeManagerGetTasks(response: HttpResponseBase): Observable<ChangeManagerTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeManagerTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeActionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Employee data already matches request.
     */
    postEmployeeCreate(body: ActionV3EmployeeCreateRequestDto): Observable<OkEmployeeActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employees/create";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEmployeeCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEmployeeCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkEmployeeActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkEmployeeActionResponseDto>;
        }));
    }

    protected processPostEmployeeCreate(response: HttpResponseBase): Observable<OkEmployeeActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkEmployeeActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkEmployeeActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId Employee id (field engine employment id)
     * @return Employee data already matches request.
     */
    postEmployeeRehire(employeeId: string, body: ActionV3EmployeeRehireRequestDto): Observable<OkEmployeeActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employees/{employeeId}/rehire";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
            url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEmployeeRehire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEmployeeRehire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkEmployeeActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkEmployeeActionResponseDto>;
        }));
    }

    protected processPostEmployeeRehire(response: HttpResponseBase): Observable<OkEmployeeActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkEmployeeActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkEmployeeActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId Employee id (field engine employment id)
     * @return Employee data already matches request.
     */
    postEmployeeEdit(employeeId: string, body: ActionV3EmployeeEditRequestDto): Observable<OkEmployeeActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employees/{employeeId}/edit";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
            url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEmployeeEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEmployeeEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkEmployeeActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkEmployeeActionResponseDto>;
        }));
    }

    protected processPostEmployeeEdit(response: HttpResponseBase): Observable<OkEmployeeActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkEmployeeActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkEmployeeActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId Employee id (field engine employment id)
     * @return Employee data already matches request.
     */
    postEmployeeDelete(employeeId: string, body: ActionV3EmployeeDeleteRequestDto): Observable<OkEmployeeActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employees/{employeeId}/delete";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
            url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEmployeeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEmployeeDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkEmployeeActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkEmployeeActionResponseDto>;
        }));
    }

    protected processPostEmployeeDelete(response: HttpResponseBase): Observable<OkEmployeeActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkEmployeeActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkEmployeeActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeDate Use to filter only currently active items
     * @return OK
     */
    getCarUsage(activeDate: Date): Observable<CarUsageResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/carUsage?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (activeDate === undefined || activeDate === null)
            throw new Error("The parameter 'activeDate' must be defined and cannot be null.");
        else
            url_ += "activeDate=" + encodeURIComponent(activeDate ? "" + formatDate(activeDate) : "") + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarUsageResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarUsageResponseDto>;
        }));
    }

    protected processGetCarUsage(response: HttpResponseBase): Observable<CarUsageResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarUsageResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param employeeId Employee id (field engine employment id)
     * @return OK
     */
    getEmployee(employeeId: string): Observable<EmployeeV3ForCardResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employees/{employeeId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
            url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeV3ForCardResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeV3ForCardResponseDto>;
        }));
    }

    protected processGetEmployee(response: HttpResponseBase): Observable<EmployeeV3ForCardResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeV3ForCardResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ItemCacheClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     */
    getIcStartClear(): Observable<IcStartClearResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/icStartClear";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIcStartClear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIcStartClear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IcStartClearResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IcStartClearResponseDto>;
        }));
    }

    protected processGetIcStartClear(response: HttpResponseBase): Observable<IcStartClearResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IcStartClearResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getIcStartSync(type: IcLookupTypeEnumDto, id?: string | undefined): Observable<IcStartSyncResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/icStartSync?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
    
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIcStartSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIcStartSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IcStartSyncResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IcStartSyncResponseDto>;
        }));
    }

    protected processGetIcStartSync(response: HttpResponseBase): Observable<IcStartSyncResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IcStartSyncResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param type (optional) When specified, only lookup items of the given type will be returned.
    If there are more items available than can be returned at once,
    `nextToken` will contain the lookup type and it is not necessary to specify this in the next call.
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getIcLookup(type?: IcLookupTypeEnumDto | undefined, nextToken?: string | undefined): Observable<IcLookupInitialResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/icLookup?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
    
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIcLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIcLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IcLookupInitialResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IcLookupInitialResponseDto>;
        }));
    }

    protected processGetIcLookup(response: HttpResponseBase): Observable<IcLookupInitialResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IcLookupInitialResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     */
    getTags(): Observable<TagsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/tags";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagsResponseDto>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<TagsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Action was already created and will be processed or has already been processed
     */
    postTagCreate(body: TagCreateRequestDto): Observable<OkActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/actions/tagCreate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTagCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTagCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkActionResponseDto>;
        }));
    }

    protected processPostTagCreate(response: HttpResponseBase): Observable<OkActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Action was already created and will be processed or has already been processed
     */
    postTagUpdate(body: TagUpdateRequestDto): Observable<OkActionResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/actions/tagUpdate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTagUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTagUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkActionResponseDto>;
        }));
    }

    protected processPostTagUpdate(response: HttpResponseBase): Observable<OkActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OkActionResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Action was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postTagCreateOperation(body: TagCreateOperationRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/tagCreate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTagCreateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTagCreateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostTagCreateOperation(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getTagCreateOperation(operationId: string): Observable<TagCreateOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/tagCreate/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagCreateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagCreateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagCreateOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagCreateOperationDto>;
        }));
    }

    protected processGetTagCreateOperation(response: HttpResponseBase): Observable<TagCreateOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagCreateOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postTagUpdateOperation(body: TagUpdateOperationRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/tagUpdate";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTagUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTagUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostTagUpdateOperation(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getTagUpdateOperation(operationId: string): Observable<TagUpdateOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/tagUpdate/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagUpdateOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagUpdateOperationDto>;
        }));
    }

    protected processGetTagUpdateOperation(response: HttpResponseBase): Observable<TagUpdateOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagUpdateOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaxUnitsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     * @deprecated
     */
    getTaxUnits(): Observable<TaxUnitsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/taxUnits";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxUnitsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxUnitsResponseDto>;
        }));
    }

    protected processGetTaxUnits(response: HttpResponseBase): Observable<TaxUnitsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxUnitsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CarsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     * @deprecated
     */
    getCars(): Observable<CarsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/cars";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarsResponseDto>;
        }));
    }

    protected processGetCars(response: HttpResponseBase): Observable<CarsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WorkTimeAgreementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     * @deprecated
     */
    getWorkTimeAgreements(): Observable<WorkTimeAgreementsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/workTimeAgreements";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkTimeAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkTimeAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTimeAgreementsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTimeAgreementsResponseDto>;
        }));
    }

    protected processGetWorkTimeAgreements(response: HttpResponseBase): Observable<WorkTimeAgreementsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTimeAgreementsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param org (optional) OdpOrgId of the active organization, used for feature flag toggling
     * @return OK
     */
    getSession(org?: string | undefined): Observable<SessionDto> {
        let url_ = this.baseUrl + "/session?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (org === null)
            throw new Error("The parameter 'org' cannot be null.");
        else if (org !== undefined)
            url_ += "org=" + encodeURIComponent("" + org) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionDto>;
        }));
    }

    protected processGetSession(response: HttpResponseBase): Observable<SessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMenuItems(): Observable<MenuItemsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/menuItems";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMenuItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenuItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MenuItemsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MenuItemsResponseDto>;
        }));
    }

    protected processGetMenuItems(response: HttpResponseBase): Observable<MenuItemsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MenuItemsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OverviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @param limit (optional) Order of magnitude of items to return per page (1-1000)
    Recommended default is 50, with alternatives 500 and 1000.
    TBD: make required in VHDI-3875
     * @param createdBefore (optional) Filter operations created at or before this date-time (inclusive)
     * @param createdAfter (optional) Filter operations created at or after this date-time (inclusive)
     * @param operationType (optional) Filter operations by type
     * @return OK
     */
    getOperations(nextToken?: string | undefined, limit?: number | undefined, createdBefore?: Date | undefined, createdAfter?: Date | undefined, operationType?: OperationTypeEnum | undefined): Observable<OperationOverviewDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    
        if (createdBefore === null)
            throw new Error("The parameter 'createdBefore' cannot be null.");
        else if (createdBefore !== undefined)
            url_ += "createdBefore=" + encodeURIComponent(createdBefore ? "" + formatDate(createdBefore) : "") + "&";
    
        if (createdAfter === null)
            throw new Error("The parameter 'createdAfter' cannot be null.");
        else if (createdAfter !== undefined)
            url_ += "createdAfter=" + encodeURIComponent(createdAfter ? "" + formatDate(createdAfter) : "") + "&";
    
        if (operationType === null)
            throw new Error("The parameter 'operationType' cannot be null.");
        else if (operationType !== undefined)
            url_ += "operationType=" + encodeURIComponent("" + operationType) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationOverviewDto[]>;
        }));
    }

    protected processGetOperations(response: HttpResponseBase): Observable<OperationOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OperationOverviewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWsConnections(): Observable<WsConnectionsDto> {
        let url_ = this.baseUrl + "/org/{orgId}/wsConnections";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWsConnections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWsConnections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WsConnectionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WsConnectionsDto>;
        }));
    }

    protected processGetWsConnections(response: HttpResponseBase): Observable<WsConnectionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WsConnectionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PollClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getOperationState(operationId: string): Observable<OperationStateDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/{operationId}/state";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationStateDto>;
        }));
    }

    protected processGetOperationState(response: HttpResponseBase): Observable<OperationStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getOperationCheckActiveJobStatus(operationId: string): Observable<OperationStateDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/{operationId}/checkActiveJobStatus";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationCheckActiveJobStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationCheckActiveJobStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationStateDto>;
        }));
    }

    protected processGetOperationCheckActiveJobStatus(response: HttpResponseBase): Observable<OperationStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PostmanClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     */
    getAwsBehavior(key: string, action: string): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/org/{orgId}/awsBehavior/{key}/{action}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
            url_ = url_.replace("{key}", encodeURIComponent("" + key));
    
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined.");
            url_ = url_.replace("{action}", encodeURIComponent("" + action));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwsBehavior(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwsBehavior(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processGetAwsBehavior(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    postDeleteTenants(body: string): Observable<DeleteTenantsResponseDto> {
        let url_ = this.baseUrl + "/deleteTenants";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "text/plain",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDeleteTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDeleteTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTenantsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTenantsResponseDto>;
        }));
    }

    protected processPostDeleteTenants(response: HttpResponseBase): Observable<DeleteTenantsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTenantsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    postStartDatabaseMigration(body: StartDatabaseMigrationRequestDto): Observable<string> {
        let url_ = this.baseUrl + "/startDatabaseMigration";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostStartDatabaseMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostStartDatabaseMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPostStartDatabaseMigration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @param activeAfter Filter items by active date (inclusive) being on or after selected date
     * @param paycodeId Paycode identifier to filter on returned results
     * @param activeBefore (optional) Filter items by active date (inclusive) being on or before selected date
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getFixedTransactions(activeAfter: Date, paycodeId: string, activeBefore?: Date | undefined, nextToken?: string | undefined): Observable<TransactionsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/fixedTransactions?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (activeAfter === undefined || activeAfter === null)
            throw new Error("The parameter 'activeAfter' must be defined and cannot be null.");
        else
            url_ += "activeAfter=" + encodeURIComponent(activeAfter ? "" + formatDate(activeAfter) : "") + "&";
    
        if (paycodeId === undefined || paycodeId === null)
            throw new Error("The parameter 'paycodeId' must be defined and cannot be null.");
        else
            url_ += "paycodeId=" + encodeURIComponent("" + paycodeId) + "&";
    
        if (activeBefore === null)
            throw new Error("The parameter 'activeBefore' cannot be null.");
        else if (activeBefore !== undefined)
            url_ += "activeBefore=" + encodeURIComponent(activeBefore ? "" + formatDate(activeBefore) : "") + "&";
    
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFixedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFixedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionsResponseDto>;
        }));
    }

    protected processGetFixedTransactions(response: HttpResponseBase): Observable<TransactionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeAfter Filter items by active date (inclusive) being on or after selected date
     * @param activeBefore (optional) Filter items by active date (inclusive) being on or before selected date
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     * @deprecated
     */
    getFixedTransactionsForList(activeAfter: Date, activeBefore?: Date | undefined, nextToken?: string | undefined): Observable<TransactionsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/fixedTransactionsForList?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (activeAfter === undefined || activeAfter === null)
            throw new Error("The parameter 'activeAfter' must be defined and cannot be null.");
        else
            url_ += "activeAfter=" + encodeURIComponent(activeAfter ? "" + formatDate(activeAfter) : "") + "&";
    
        if (activeBefore === null)
            throw new Error("The parameter 'activeBefore' cannot be null.");
        else if (activeBefore !== undefined)
            url_ += "activeBefore=" + encodeURIComponent(activeBefore ? "" + formatDate(activeBefore) : "") + "&";
    
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFixedTransactionsForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFixedTransactionsForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionsResponseDto>;
        }));
    }

    protected processGetFixedTransactionsForList(response: HttpResponseBase): Observable<TransactionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeId Employee id (field engine employment id)
     * @param activeAfter Filter items by active date (inclusive) being on or after selected date
     * @param positionId (optional) Position id
     * @param activeBefore (optional) Filter items by active date (inclusive) being on or before selected date
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     */
    getFixedTransactionsEmployee(employeeId: string, activeAfter: Date, positionId?: string | undefined, activeBefore?: Date | undefined, nextToken?: string | undefined): Observable<TransactionsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employee/{employeeId}/fixedTransactions?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
            url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    
        if (activeAfter === undefined || activeAfter === null)
            throw new Error("The parameter 'activeAfter' must be defined and cannot be null.");
        else
            url_ += "activeAfter=" + encodeURIComponent(activeAfter ? "" + formatDate(activeAfter) : "") + "&";
    
        if (positionId === null)
            throw new Error("The parameter 'positionId' cannot be null.");
        else if (positionId !== undefined)
            url_ += "positionId=" + encodeURIComponent("" + positionId) + "&";
    
        if (activeBefore === null)
            throw new Error("The parameter 'activeBefore' cannot be null.");
        else if (activeBefore !== undefined)
            url_ += "activeBefore=" + encodeURIComponent(activeBefore ? "" + formatDate(activeBefore) : "") + "&";
    
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFixedTransactionsEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFixedTransactionsEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionsResponseDto>;
        }));
    }

    protected processGetFixedTransactionsEmployee(response: HttpResponseBase): Observable<TransactionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     * @deprecated
     */
    getTransactionsForEndFixed(nextToken?: string | undefined): Observable<TransactionsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/transactionsForEndFixed?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionsForEndFixed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsForEndFixed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionsResponseDto>;
        }));
    }

    protected processGetTransactionsForEndFixed(response: HttpResponseBase): Observable<TransactionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paycodeId Paycode identifier to filter on returned results
     * @param activeDate Use to filter only currently active items
     * @param nextToken (optional) Use to get next items in a paginated list
     * @return OK
     * @deprecated
     */
    getTransactionsForEditFixed(paycodeId: string, activeDate: Date, nextToken?: string | undefined): Observable<TransactionsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/transactionsForEditFixed?";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (paycodeId === undefined || paycodeId === null)
            throw new Error("The parameter 'paycodeId' must be defined and cannot be null.");
        else
            url_ += "paycodeId=" + encodeURIComponent("" + paycodeId) + "&";
    
        if (activeDate === undefined || activeDate === null)
            throw new Error("The parameter 'activeDate' must be defined and cannot be null.");
        else
            url_ += "activeDate=" + encodeURIComponent(activeDate ? "" + formatDate(activeDate) : "") + "&";
    
        if (nextToken === null)
            throw new Error("The parameter 'nextToken' cannot be null.");
        else if (nextToken !== undefined)
            url_ += "nextToken=" + encodeURIComponent("" + nextToken) + "&";
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionsForEditFixed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsForEditFixed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionsResponseDto>;
        }));
    }

    protected processGetTransactionsForEditFixed(response: HttpResponseBase): Observable<TransactionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AddFixedTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postAddFixedTransactions(body: AddFixedTransactionsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/addFixedTransactions";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAddFixedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAddFixedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostAddFixedTransactions(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getAddFixedTransactionsOperation(operationId: string): Observable<AddFixedTransactionsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/addFixedTransactions/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddFixedTransactionsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddFixedTransactionsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFixedTransactionsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFixedTransactionsOperationDto>;
        }));
    }

    protected processGetAddFixedTransactionsOperation(response: HttpResponseBase): Observable<AddFixedTransactionsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddFixedTransactionsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postAddFixedTransactionsGetTasks(operationId: string, body: GetTasksRequestDto): Observable<AddFixedTransactionsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/addFixedTransactions/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAddFixedTransactionsGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAddFixedTransactionsGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFixedTransactionsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFixedTransactionsTaskDto[]>;
        }));
    }

    protected processPostAddFixedTransactionsGetTasks(response: HttpResponseBase): Observable<AddFixedTransactionsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddFixedTransactionsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EndFixedTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postEndFixedTransactions(body: EndFixedTransactionsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/endFixedTransactions";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEndFixedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEndFixedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostEndFixedTransactions(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getEndFixedTransactionsOperation(operationId: string): Observable<EndFixedTransactionsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/endFixedTransactions/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndFixedTransactionsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndFixedTransactionsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndFixedTransactionsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndFixedTransactionsOperationDto>;
        }));
    }

    protected processGetEndFixedTransactionsOperation(response: HttpResponseBase): Observable<EndFixedTransactionsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndFixedTransactionsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postEndFixedTransactionsGetTasks(operationId: string, body: GetTasksRequestDto): Observable<EndFixedTransactionsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/endFixedTransactions/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEndFixedTransactionsGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEndFixedTransactionsGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndFixedTransactionsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndFixedTransactionsTaskDto[]>;
        }));
    }

    protected processPostEndFixedTransactionsGetTasks(response: HttpResponseBase): Observable<EndFixedTransactionsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EndFixedTransactionsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditFixedTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postEditFixedTransactions(body: EditFixedTransactionsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/editFixedTransactions";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEditFixedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEditFixedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostEditFixedTransactions(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getEditFixedTransactionsOperation(operationId: string): Observable<EditFixedTransactionsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/editFixedTransactions/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditFixedTransactionsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditFixedTransactionsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditFixedTransactionsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditFixedTransactionsOperationDto>;
        }));
    }

    protected processGetEditFixedTransactionsOperation(response: HttpResponseBase): Observable<EditFixedTransactionsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditFixedTransactionsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postEditFixedTransactionsGetTasks(operationId: string, body: GetTasksRequestDto): Observable<EditFixedTransactionsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/editFixedTransactions/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEditFixedTransactionsGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEditFixedTransactionsGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditFixedTransactionsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditFixedTransactionsTaskDto[]>;
        }));
    }

    protected processPostEditFixedTransactionsGetTasks(response: HttpResponseBase): Observable<EditFixedTransactionsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditFixedTransactionsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeleteFixedTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postDeleteFixedTransactions(body: DeleteFixedTransactionsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/deleteFixedTransactions";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDeleteFixedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDeleteFixedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostDeleteFixedTransactions(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getDeleteFixedTransactionsOperation(operationId: string): Observable<DeleteFixedTransactionsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/deleteFixedTransactions/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeleteFixedTransactionsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeleteFixedTransactionsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFixedTransactionsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFixedTransactionsOperationDto>;
        }));
    }

    protected processGetDeleteFixedTransactionsOperation(response: HttpResponseBase): Observable<DeleteFixedTransactionsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFixedTransactionsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postDeleteFixedTransactionsGetTasks(operationId: string, body: GetTasksRequestDto): Observable<DeleteFixedTransactionsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/deleteFixedTransactions/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDeleteFixedTransactionsGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDeleteFixedTransactionsGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFixedTransactionsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFixedTransactionsTaskDto[]>;
        }));
    }

    protected processPostDeleteFixedTransactionsGetTasks(response: HttpResponseBase): Observable<DeleteFixedTransactionsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeleteFixedTransactionsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PauseFixedTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postPauseFixedTransactions(body: PauseFixedTransactionsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/pauseFixedTransactions";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPauseFixedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPauseFixedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostPauseFixedTransactions(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getPauseFixedTransactionsOperation(operationId: string): Observable<PauseFixedTransactionsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/pauseFixedTransactions/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPauseFixedTransactionsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPauseFixedTransactionsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PauseFixedTransactionsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PauseFixedTransactionsOperationDto>;
        }));
    }

    protected processGetPauseFixedTransactionsOperation(response: HttpResponseBase): Observable<PauseFixedTransactionsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PauseFixedTransactionsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postPauseFixedTransactionsTasks(operationId: string, body: GetTasksRequestDto): Observable<PauseFixedTransactionsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/pauseFixedTransactions/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPauseFixedTransactionsTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPauseFixedTransactionsTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PauseFixedTransactionsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PauseFixedTransactionsTaskDto[]>;
        }));
    }

    protected processPostPauseFixedTransactionsTasks(response: HttpResponseBase): Observable<PauseFixedTransactionsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PauseFixedTransactionsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TimeAgreementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return OK
     */
    getTimeAgreements(): Observable<TimeAgreementsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/timeAgreements";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeAgreementsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeAgreementsResponseDto>;
        }));
    }

    protected processGetTimeAgreements(response: HttpResponseBase): Observable<TimeAgreementsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAgreementsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEmployeesTimeAgreements(): Observable<EmployeesTimeAgreementsResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/employeesTimeAgreements";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesTimeAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesTimeAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesTimeAgreementsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesTimeAgreementsResponseDto>;
        }));
    }

    protected processGetEmployeesTimeAgreements(response: HttpResponseBase): Observable<EmployeesTimeAgreementsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesTimeAgreementsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChangeTimeAgreementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private orgId: string;

    constructor(@Inject(ORG_ID) orgId: string, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.di.hrm.int.test.visma.net/";
        this.orgId = orgId;
    }

    /**
     * @return Operation is created and will be processed. Poll progress using the return id.
     */
    postChangeTimeAgreements(body: ChangeTimeAgreementsRequestDto): Observable<CreatedOperationResponseDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/changeTimeAgreements";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostChangeTimeAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostChangeTimeAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedOperationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedOperationResponseDto>;
        }));
    }

    protected processPostChangeTimeAgreements(response: HttpResponseBase): Observable<CreatedOperationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedOperationResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestDto.fromJS(resultData400);
            return throwException("Operation was not created because of input validation errors.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    getChangeTimeAgreementsOperation(operationId: string): Observable<ChangeTimeAgreementsOperationDto> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/changeTimeAgreements/{operationId}";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeTimeAgreementsOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeTimeAgreementsOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeTimeAgreementsOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeTimeAgreementsOperationDto>;
        }));
    }

    protected processGetChangeTimeAgreementsOperation(response: HttpResponseBase): Observable<ChangeTimeAgreementsOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeTimeAgreementsOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operationId The id (GUID) of the operation
     * @return OK
     */
    postChangeTimeAgreementsGetTasks(operationId: string, body: GetTasksRequestDto): Observable<ChangeTimeAgreementsTaskDto[]> {
        let url_ = this.baseUrl + "/org/{orgId}/operations/changeTimeAgreements/{operationId}/tasks";
        url_ = url_.replace("{orgId}", encodeURIComponent(this.orgId));
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
            url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostChangeTimeAgreementsGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostChangeTimeAgreementsGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeTimeAgreementsTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeTimeAgreementsTaskDto[]>;
        }));
    }

    protected processPostChangeTimeAgreementsGetTasks(response: HttpResponseBase): Observable<ChangeTimeAgreementsTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeTimeAgreementsTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CostUnitTypesResponseDto implements ICostUnitTypesResponseDto {
    /** returned list is not sorted */
    costUnitTypesTimeline?: CostUnitTypeDto[];

    constructor(data?: ICostUnitTypesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costUnitTypesTimeline"])) {
                this.costUnitTypesTimeline = [] as any;
                for (let item of _data["costUnitTypesTimeline"])
                    this.costUnitTypesTimeline!.push(CostUnitTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostUnitTypesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costUnitTypesTimeline)) {
            data["costUnitTypesTimeline"] = [];
            for (let item of this.costUnitTypesTimeline)
                data["costUnitTypesTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CostUnitTypesResponseDto {
        const json = this.toJSON();
        let result = new CostUnitTypesResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesResponseDto {
    /** returned list is not sorted */
    costUnitTypesTimeline?: CostUnitTypeDto[];
}

export class OverlapTimelineItem implements IOverlapTimelineItem {
    from?: Date;
    to?: Date;

    constructor(data?: IOverlapTimelineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OverlapTimelineItem {
        data = typeof data === 'object' ? data : {};
        let result = new OverlapTimelineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }

    clone(): OverlapTimelineItem {
        const json = this.toJSON();
        let result = new OverlapTimelineItem();
        result.init(json);
        return result;
    }
}

export interface IOverlapTimelineItem {
    from?: Date;
    to?: Date;
}

export class CostUnitTypeDto extends OverlapTimelineItem implements ICostUnitTypeDto {
    accountingServiceId!: string;
    version!: string;
    /** Unique custom identifier for cost unit. When creating new cost unit types, the value must be a stringified integer, but existing types could have any string value.
 */
    customId!: string;
    name!: string;
    isCustomIdValuesRestrictedToInteger!: boolean;
    /** returned list is sorted by from date in ascending order */
    precedenceTimeline!: CostUnitPrecedenceDto[];

    constructor(data?: ICostUnitTypeDto) {
        super(data);
        if (!data) {
            this.precedenceTimeline = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountingServiceId = _data["accountingServiceId"];
            this.version = _data["version"];
            this.customId = _data["customId"];
            this.name = _data["name"];
            this.isCustomIdValuesRestrictedToInteger = _data["isCustomIdValuesRestrictedToInteger"];
            if (Array.isArray(_data["precedenceTimeline"])) {
                this.precedenceTimeline = [] as any;
                for (let item of _data["precedenceTimeline"])
                    this.precedenceTimeline!.push(CostUnitPrecedenceDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingServiceId"] = this.accountingServiceId;
        data["version"] = this.version;
        data["customId"] = this.customId;
        data["name"] = this.name;
        data["isCustomIdValuesRestrictedToInteger"] = this.isCustomIdValuesRestrictedToInteger;
        if (Array.isArray(this.precedenceTimeline)) {
            data["precedenceTimeline"] = [];
            for (let item of this.precedenceTimeline)
                data["precedenceTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypeDto {
        const json = this.toJSON();
        let result = new CostUnitTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypeDto extends IOverlapTimelineItem {
    accountingServiceId: string;
    version: string;
    /** Unique custom identifier for cost unit. When creating new cost unit types, the value must be a stringified integer, but existing types could have any string value.
 */
    customId: string;
    name: string;
    isCustomIdValuesRestrictedToInteger: boolean;
    /** returned list is sorted by from date in ascending order */
    precedenceTimeline: CostUnitPrecedenceDto[];
}

export class FullTimelineItem implements IFullTimelineItem {
    from?: Date;
    to?: Date;

    constructor(data?: IFullTimelineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FullTimelineItem {
        data = typeof data === 'object' ? data : {};
        let result = new FullTimelineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }

    clone(): FullTimelineItem {
        const json = this.toJSON();
        let result = new FullTimelineItem();
        result.init(json);
        return result;
    }
}

export interface IFullTimelineItem {
    from?: Date;
    to?: Date;
}

export class CostUnitPrecedenceDto extends FullTimelineItem implements ICostUnitPrecedenceDto {
    precedence!: CostUnitPrecedenceEnum;

    constructor(data?: ICostUnitPrecedenceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.precedence = _data["precedence"];
        }
    }

    static override fromJS(data: any): CostUnitPrecedenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitPrecedenceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precedence"] = this.precedence;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitPrecedenceDto {
        const json = this.toJSON();
        let result = new CostUnitPrecedenceDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitPrecedenceDto extends IFullTimelineItem {
    precedence: CostUnitPrecedenceEnum;
}

export class CostUnitValueDto extends OverlapTimelineItem implements ICostUnitValueDto {
    /** Used only when updating cost unit value. It is id that is used internally in accounting API.
 */
    accountingServiceId!: string;
    /** This is the key to match cost unit value with the value on positions/transactions.
 */
    customId!: string;
    name!: string;

    constructor(data?: ICostUnitValueDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountingServiceId = _data["accountingServiceId"];
            this.customId = _data["customId"];
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): CostUnitValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingServiceId"] = this.accountingServiceId;
        data["customId"] = this.customId;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitValueDto {
        const json = this.toJSON();
        let result = new CostUnitValueDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitValueDto extends IOverlapTimelineItem {
    /** Used only when updating cost unit value. It is id that is used internally in accounting API.
 */
    accountingServiceId: string;
    /** This is the key to match cost unit value with the value on positions/transactions.
 */
    customId: string;
    name: string;
}

export class CostUnitTypeValuesResponseDto implements ICostUnitTypeValuesResponseDto {
    valuesForType?: CostUnitValuesDto;

    constructor(data?: ICostUnitTypeValuesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valuesForType = _data["valuesForType"] ? CostUnitValuesDto.fromJS(_data["valuesForType"]) : undefined as any;
        }
    }

    static fromJS(data: any): CostUnitTypeValuesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypeValuesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valuesForType"] = this.valuesForType ? this.valuesForType.toJSON() : undefined as any;
        return data;
    }

    clone(): CostUnitTypeValuesResponseDto {
        const json = this.toJSON();
        let result = new CostUnitTypeValuesResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypeValuesResponseDto {
    valuesForType?: CostUnitValuesDto;
}

export class CostUnitValuesDto implements ICostUnitValuesDto {
    typeCustomId!: string;
    /** Set if and only if there are more values available for this search.
 */
    cursor?: string;
    costUnitValues!: CostUnitValueDto[];

    constructor(data?: ICostUnitValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.costUnitValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            this.cursor = _data["cursor"];
            if (Array.isArray(_data["costUnitValues"])) {
                this.costUnitValues = [] as any;
                for (let item of _data["costUnitValues"])
                    this.costUnitValues!.push(CostUnitValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostUnitValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        data["cursor"] = this.cursor;
        if (Array.isArray(this.costUnitValues)) {
            data["costUnitValues"] = [];
            for (let item of this.costUnitValues)
                data["costUnitValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CostUnitValuesDto {
        const json = this.toJSON();
        let result = new CostUnitValuesDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitValuesDto {
    typeCustomId: string;
    /** Set if and only if there are more values available for this search.
 */
    cursor?: string;
    costUnitValues: CostUnitValueDto[];
}

export class BaseActionRequestDto implements IBaseActionRequestDto {
    /** Action id created by the caller. Duplicate IDs will be ignored. */
    actionId!: string;

    constructor(data?: IBaseActionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
        }
    }

    static fromJS(data: any): BaseActionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseActionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        return data;
    }

    clone(): BaseActionRequestDto {
        const json = this.toJSON();
        let result = new BaseActionRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBaseActionRequestDto {
    /** Action id created by the caller. Duplicate IDs will be ignored. */
    actionId: string;
}

export class CostUnitTypeCreateRequestDto extends BaseActionRequestDto implements ICostUnitTypeCreateRequestDto {
    newData!: CostUnitTypeCreateRequestItemDto;

    constructor(data?: ICostUnitTypeCreateRequestDto) {
        super(data);
        if (!data) {
            this.newData = new CostUnitTypeCreateRequestItemDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newData = _data["newData"] ? CostUnitTypeCreateRequestItemDto.fromJS(_data["newData"]) : new CostUnitTypeCreateRequestItemDto();
        }
    }

    static override fromJS(data: any): CostUnitTypeCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypeCreateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypeCreateRequestDto {
        const json = this.toJSON();
        let result = new CostUnitTypeCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypeCreateRequestDto extends IBaseActionRequestDto {
    newData: CostUnitTypeCreateRequestItemDto;
}

export class CostUnitTypeUpdateRequestDto extends BaseActionRequestDto implements ICostUnitTypeUpdateRequestDto {
    oldData!: CostUnitTypeDto;
    newData!: CostUnitTypeDto;

    constructor(data?: ICostUnitTypeUpdateRequestDto) {
        super(data);
        if (!data) {
            this.oldData = new CostUnitTypeDto();
            this.newData = new CostUnitTypeDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldData = _data["oldData"] ? CostUnitTypeDto.fromJS(_data["oldData"]) : new CostUnitTypeDto();
            this.newData = _data["newData"] ? CostUnitTypeDto.fromJS(_data["newData"]) : new CostUnitTypeDto();
        }
    }

    static override fromJS(data: any): CostUnitTypeUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypeUpdateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldData"] = this.oldData ? this.oldData.toJSON() : undefined as any;
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypeUpdateRequestDto {
        const json = this.toJSON();
        let result = new CostUnitTypeUpdateRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypeUpdateRequestDto extends IBaseActionRequestDto {
    oldData: CostUnitTypeDto;
    newData: CostUnitTypeDto;
}

export class CostUnitTypeCreateRequestItemDto extends OverlapTimelineItem implements ICostUnitTypeCreateRequestItemDto {
    /** Unique custom identifier for cost unit. The value must be a stringified integer.
 */
    customId!: string;
    name!: string;
    isCustomIdValuesRestrictedToInteger!: boolean;
    precedence!: CostUnitPrecedenceEnum;

    constructor(data?: ICostUnitTypeCreateRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customId = _data["customId"];
            this.name = _data["name"];
            this.isCustomIdValuesRestrictedToInteger = _data["isCustomIdValuesRestrictedToInteger"];
            this.precedence = _data["precedence"];
        }
    }

    static override fromJS(data: any): CostUnitTypeCreateRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypeCreateRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customId"] = this.customId;
        data["name"] = this.name;
        data["isCustomIdValuesRestrictedToInteger"] = this.isCustomIdValuesRestrictedToInteger;
        data["precedence"] = this.precedence;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypeCreateRequestItemDto {
        const json = this.toJSON();
        let result = new CostUnitTypeCreateRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypeCreateRequestItemDto extends IOverlapTimelineItem {
    /** Unique custom identifier for cost unit. The value must be a stringified integer.
 */
    customId: string;
    name: string;
    isCustomIdValuesRestrictedToInteger: boolean;
    precedence: CostUnitPrecedenceEnum;
}

export class BaseRequestDto implements IBaseRequestDto {
    /** Operation id created by the caller. Duplicate IDs will be ignored. */
    id!: string;
    /** Should be used for operations, that are not relevant to be shown in the history. If `true`, the operation will not be shown in the history of the organization. If `false` or `undefined`, the operation will be shown in the history of the organization.
 */
    hideFromHistory?: boolean;

    constructor(data?: IBaseRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hideFromHistory = _data["hideFromHistory"];
        }
    }

    static fromJS(data: any): BaseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hideFromHistory"] = this.hideFromHistory;
        return data;
    }

    clone(): BaseRequestDto {
        const json = this.toJSON();
        let result = new BaseRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBaseRequestDto {
    /** Operation id created by the caller. Duplicate IDs will be ignored. */
    id: string;
    /** Should be used for operations, that are not relevant to be shown in the history. If `true`, the operation will not be shown in the history of the organization. If `false` or `undefined`, the operation will be shown in the history of the organization.
 */
    hideFromHistory?: boolean;
}

export class CostUnitValueUpsertOperationRequestDto extends BaseRequestDto implements ICostUnitValueUpsertOperationRequestDto {
    /** Cost unit type custom id. */
    typeCustomId!: string;
    /** List of cost unit values to upsert */
    items!: CostUnitValueUpsertOperationItemDto[];

    constructor(data?: ICostUnitValueUpsertOperationRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CostUnitValueUpsertOperationItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitValueUpsertOperationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValueUpsertOperationRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitValueUpsertOperationRequestDto {
        const json = this.toJSON();
        let result = new CostUnitValueUpsertOperationRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitValueUpsertOperationRequestDto extends IBaseRequestDto {
    /** Cost unit type custom id. */
    typeCustomId: string;
    /** List of cost unit values to upsert */
    items: CostUnitValueUpsertOperationItemDto[];
}

export class CostUnitValueUpsertOperationItemDto implements ICostUnitValueUpsertOperationItemDto {
    /** Set when updating cost unit value It is id that is used internally in accounting API.
 */
    accountingServiceId?: string;
    /** This is the key to match cost unit value with the value on positions/transactions.
 */
    customId!: string;
    oldName?: string;
    oldFrom?: Date;
    oldTo?: Date;
    newName!: string;
    newFrom?: Date;
    newTo?: Date;

    constructor(data?: ICostUnitValueUpsertOperationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingServiceId = _data["accountingServiceId"];
            this.customId = _data["customId"];
            this.oldName = _data["oldName"];
            this.oldFrom = _data["oldFrom"] ? new Date(_data["oldFrom"].toString()) : undefined as any;
            this.oldTo = _data["oldTo"] ? new Date(_data["oldTo"].toString()) : undefined as any;
            this.newName = _data["newName"];
            this.newFrom = _data["newFrom"] ? new Date(_data["newFrom"].toString()) : undefined as any;
            this.newTo = _data["newTo"] ? new Date(_data["newTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CostUnitValueUpsertOperationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValueUpsertOperationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingServiceId"] = this.accountingServiceId;
        data["customId"] = this.customId;
        data["oldName"] = this.oldName;
        data["oldFrom"] = this.oldFrom ? formatDate(this.oldFrom) : undefined as any;
        data["oldTo"] = this.oldTo ? formatDate(this.oldTo) : undefined as any;
        data["newName"] = this.newName;
        data["newFrom"] = this.newFrom ? formatDate(this.newFrom) : undefined as any;
        data["newTo"] = this.newTo ? formatDate(this.newTo) : undefined as any;
        return data;
    }

    clone(): CostUnitValueUpsertOperationItemDto {
        const json = this.toJSON();
        let result = new CostUnitValueUpsertOperationItemDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitValueUpsertOperationItemDto {
    /** Set when updating cost unit value It is id that is used internally in accounting API.
 */
    accountingServiceId?: string;
    /** This is the key to match cost unit value with the value on positions/transactions.
 */
    customId: string;
    oldName?: string;
    oldFrom?: Date;
    oldTo?: Date;
    newName: string;
    newFrom?: Date;
    newTo?: Date;
}

/** Operation with status per task ID. Used for polling operation progress, maximum progress is `taskCount`. Look for new entries in `failedTaskIds`, `succeededTaskIds` and `pollingTimeoutTaskIds` to fetch task specific status in batch. `status` is included for ease of use; it is generated based on `taskCount`, `failedTaskIds`, `succeededTaskIds` and `pollingTimeoutTaskIds`. Once a task has been completed (failed, succeeded or polling timed out) its ID will be added to the respective list. It will not be removed from that list again and it will not be added to the either of the other two lists. */
export class OperationStateDto implements IOperationStateDto {
    /** Operation id */
    id!: string;
    /** The id of the organization this operation was created for */
    odpOrgId!: string;
    /** date time when the operation was started in the backend */
    createdTime!: Date;
    operationType!: OperationTypeEnum;
    status!: OperationStatusEnum;
    taskCount!: number;
    failedTaskIds!: string[];
    succeededTaskIds!: string[];
    pollingTimeoutTaskIds!: string[];

    constructor(data?: IOperationStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.failedTaskIds = [];
            this.succeededTaskIds = [];
            this.pollingTimeoutTaskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.odpOrgId = _data["odpOrgId"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : undefined as any;
            this.operationType = _data["operationType"];
            this.status = _data["status"];
            this.taskCount = _data["taskCount"];
            if (Array.isArray(_data["failedTaskIds"])) {
                this.failedTaskIds = [] as any;
                for (let item of _data["failedTaskIds"])
                    this.failedTaskIds!.push(item);
            }
            if (Array.isArray(_data["succeededTaskIds"])) {
                this.succeededTaskIds = [] as any;
                for (let item of _data["succeededTaskIds"])
                    this.succeededTaskIds!.push(item);
            }
            if (Array.isArray(_data["pollingTimeoutTaskIds"])) {
                this.pollingTimeoutTaskIds = [] as any;
                for (let item of _data["pollingTimeoutTaskIds"])
                    this.pollingTimeoutTaskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OperationStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["odpOrgId"] = this.odpOrgId;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : undefined as any;
        data["operationType"] = this.operationType;
        data["status"] = this.status;
        data["taskCount"] = this.taskCount;
        if (Array.isArray(this.failedTaskIds)) {
            data["failedTaskIds"] = [];
            for (let item of this.failedTaskIds)
                data["failedTaskIds"].push(item);
        }
        if (Array.isArray(this.succeededTaskIds)) {
            data["succeededTaskIds"] = [];
            for (let item of this.succeededTaskIds)
                data["succeededTaskIds"].push(item);
        }
        if (Array.isArray(this.pollingTimeoutTaskIds)) {
            data["pollingTimeoutTaskIds"] = [];
            for (let item of this.pollingTimeoutTaskIds)
                data["pollingTimeoutTaskIds"].push(item);
        }
        return data;
    }

    clone(): OperationStateDto {
        const json = this.toJSON();
        let result = new OperationStateDto();
        result.init(json);
        return result;
    }
}

/** Operation with status per task ID. Used for polling operation progress, maximum progress is `taskCount`. Look for new entries in `failedTaskIds`, `succeededTaskIds` and `pollingTimeoutTaskIds` to fetch task specific status in batch. `status` is included for ease of use; it is generated based on `taskCount`, `failedTaskIds`, `succeededTaskIds` and `pollingTimeoutTaskIds`. Once a task has been completed (failed, succeeded or polling timed out) its ID will be added to the respective list. It will not be removed from that list again and it will not be added to the either of the other two lists. */
export interface IOperationStateDto {
    /** Operation id */
    id: string;
    /** The id of the organization this operation was created for */
    odpOrgId: string;
    /** date time when the operation was started in the backend */
    createdTime: Date;
    operationType: OperationTypeEnum;
    status: OperationStatusEnum;
    taskCount: number;
    failedTaskIds: string[];
    succeededTaskIds: string[];
    pollingTimeoutTaskIds: string[];
}

/** full information about a single cost unit value upsert operation */
export class CostUnitValueUpsertOperationDto extends OperationStateDto implements ICostUnitValueUpsertOperationDto {
    /** Cost unit type custom id. */
    typeCustomId?: string;
    /** List cost unit value being or having been upserted */
    tasks!: CostUnitValueUpsertTaskDto[];

    constructor(data?: ICostUnitValueUpsertOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(CostUnitValueUpsertTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitValueUpsertOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValueUpsertOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitValueUpsertOperationDto {
        const json = this.toJSON();
        let result = new CostUnitValueUpsertOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single cost unit value upsert operation */
export interface ICostUnitValueUpsertOperationDto extends IOperationStateDto {
    /** Cost unit type custom id. */
    typeCustomId?: string;
    /** List cost unit value being or having been upserted */
    tasks: CostUnitValueUpsertTaskDto[];
}

export class CostUnitValueUpsertTaskDto extends CostUnitValueUpsertOperationItemDto implements ICostUnitValueUpsertTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;

    constructor(data?: ICostUnitValueUpsertTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
        }
    }

    static override fromJS(data: any): CostUnitValueUpsertTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValueUpsertTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitValueUpsertTaskDto {
        const json = this.toJSON();
        let result = new CostUnitValueUpsertTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitValueUpsertTaskDto extends ICostUnitValueUpsertOperationItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
}

export class ManageCostUnitValuesOperationRequestDto extends BaseRequestDto implements IManageCostUnitValuesOperationRequestDto {
    /** Cost unit type custom id. */
    typeCustomId!: string;
    /** List of cost unit values to manage */
    items!: ManageCostUnitValuesOperationItemDto[];

    constructor(data?: IManageCostUnitValuesOperationRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManageCostUnitValuesOperationItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ManageCostUnitValuesOperationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageCostUnitValuesOperationRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ManageCostUnitValuesOperationRequestDto {
        const json = this.toJSON();
        let result = new ManageCostUnitValuesOperationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IManageCostUnitValuesOperationRequestDto extends IBaseRequestDto {
    /** Cost unit type custom id. */
    typeCustomId: string;
    /** List of cost unit values to manage */
    items: ManageCostUnitValuesOperationItemDto[];
}

export class ManageCostUnitValuesOperationItemDto implements IManageCostUnitValuesOperationItemDto {
    changeType!: OperationChangeTypeEnum;
    /** Set when updating cost unit value It is id that is used internally in accounting API.
 */
    accountingServiceId?: string;
    /** This is the key to match cost unit value with the value on positions/transactions.
 */
    customId!: string;
    oldName?: string;
    oldFrom?: Date;
    oldTo?: Date;
    /** Mandatory when changeType is 'upsert'
 */
    newName?: string;
    newFrom?: Date;
    newTo?: Date;

    constructor(data?: IManageCostUnitValuesOperationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeType = _data["changeType"];
            this.accountingServiceId = _data["accountingServiceId"];
            this.customId = _data["customId"];
            this.oldName = _data["oldName"];
            this.oldFrom = _data["oldFrom"] ? new Date(_data["oldFrom"].toString()) : undefined as any;
            this.oldTo = _data["oldTo"] ? new Date(_data["oldTo"].toString()) : undefined as any;
            this.newName = _data["newName"];
            this.newFrom = _data["newFrom"] ? new Date(_data["newFrom"].toString()) : undefined as any;
            this.newTo = _data["newTo"] ? new Date(_data["newTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ManageCostUnitValuesOperationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageCostUnitValuesOperationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeType"] = this.changeType;
        data["accountingServiceId"] = this.accountingServiceId;
        data["customId"] = this.customId;
        data["oldName"] = this.oldName;
        data["oldFrom"] = this.oldFrom ? formatDate(this.oldFrom) : undefined as any;
        data["oldTo"] = this.oldTo ? formatDate(this.oldTo) : undefined as any;
        data["newName"] = this.newName;
        data["newFrom"] = this.newFrom ? formatDate(this.newFrom) : undefined as any;
        data["newTo"] = this.newTo ? formatDate(this.newTo) : undefined as any;
        return data;
    }

    clone(): ManageCostUnitValuesOperationItemDto {
        const json = this.toJSON();
        let result = new ManageCostUnitValuesOperationItemDto();
        result.init(json);
        return result;
    }
}

export interface IManageCostUnitValuesOperationItemDto {
    changeType: OperationChangeTypeEnum;
    /** Set when updating cost unit value It is id that is used internally in accounting API.
 */
    accountingServiceId?: string;
    /** This is the key to match cost unit value with the value on positions/transactions.
 */
    customId: string;
    oldName?: string;
    oldFrom?: Date;
    oldTo?: Date;
    /** Mandatory when changeType is 'upsert'
 */
    newName?: string;
    newFrom?: Date;
    newTo?: Date;
}

/** full information about a single cost unit value upsert operation */
export class ManageCostUnitValuesOperationDto extends OperationStateDto implements IManageCostUnitValuesOperationDto {
    /** Cost unit type custom id. */
    typeCustomId?: string;
    /** List cost unit value being or having been upserted */
    tasks!: ManageCostUnitValuesTaskDto[];

    constructor(data?: IManageCostUnitValuesOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ManageCostUnitValuesTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ManageCostUnitValuesOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageCostUnitValuesOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ManageCostUnitValuesOperationDto {
        const json = this.toJSON();
        let result = new ManageCostUnitValuesOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single cost unit value upsert operation */
export interface IManageCostUnitValuesOperationDto extends IOperationStateDto {
    /** Cost unit type custom id. */
    typeCustomId?: string;
    /** List cost unit value being or having been upserted */
    tasks: ManageCostUnitValuesTaskDto[];
}

export class ManageCostUnitValuesTaskDto extends ManageCostUnitValuesOperationItemDto implements IManageCostUnitValuesTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;

    constructor(data?: IManageCostUnitValuesTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
        }
    }

    static override fromJS(data: any): ManageCostUnitValuesTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageCostUnitValuesTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        super.toJSON(data);
        return data;
    }

    clone(): ManageCostUnitValuesTaskDto {
        const json = this.toJSON();
        let result = new ManageCostUnitValuesTaskDto();
        result.init(json);
        return result;
    }
}

export interface IManageCostUnitValuesTaskDto extends IManageCostUnitValuesOperationItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
}

export class CostUnitTypesCreateRequestDto extends BaseRequestDto implements ICostUnitTypesCreateRequestDto {
    /** List of cost unit types to create */
    items!: CostUnitTypesCreateItemDto[];

    constructor(data?: ICostUnitTypesCreateRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CostUnitTypesCreateItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitTypesCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesCreateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesCreateRequestDto {
        const json = this.toJSON();
        let result = new CostUnitTypesCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesCreateRequestDto extends IBaseRequestDto {
    /** List of cost unit types to create */
    items: CostUnitTypesCreateItemDto[];
}

export class CostUnitTypesCreateItemDto extends OverlapTimelineItem implements ICostUnitTypesCreateItemDto {
    /** Unique custom identifier for cost unit type. The value must be a stringified integer.
 */
    customId!: string;
    name!: string;
    isCustomIdValuesRestrictedToInteger!: boolean;
    precedence!: CostUnitPrecedenceEnum;

    constructor(data?: ICostUnitTypesCreateItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customId = _data["customId"];
            this.name = _data["name"];
            this.isCustomIdValuesRestrictedToInteger = _data["isCustomIdValuesRestrictedToInteger"];
            this.precedence = _data["precedence"];
        }
    }

    static override fromJS(data: any): CostUnitTypesCreateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesCreateItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customId"] = this.customId;
        data["name"] = this.name;
        data["isCustomIdValuesRestrictedToInteger"] = this.isCustomIdValuesRestrictedToInteger;
        data["precedence"] = this.precedence;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesCreateItemDto {
        const json = this.toJSON();
        let result = new CostUnitTypesCreateItemDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesCreateItemDto extends IOverlapTimelineItem {
    /** Unique custom identifier for cost unit type. The value must be a stringified integer.
 */
    customId: string;
    name: string;
    isCustomIdValuesRestrictedToInteger: boolean;
    precedence: CostUnitPrecedenceEnum;
}

/** Full information about a cost unit types create operation */
export class CostUnitTypesCreateOperationDto extends OperationStateDto implements ICostUnitTypesCreateOperationDto {
    /** List of cost unit type create tasks */
    tasks!: CostUnitTypesCreateTaskDto[];

    constructor(data?: ICostUnitTypesCreateOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(CostUnitTypesCreateTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitTypesCreateOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesCreateOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesCreateOperationDto {
        const json = this.toJSON();
        let result = new CostUnitTypesCreateOperationDto();
        result.init(json);
        return result;
    }
}

/** Full information about a cost unit types create operation */
export interface ICostUnitTypesCreateOperationDto extends IOperationStateDto {
    /** List of cost unit type create tasks */
    tasks: CostUnitTypesCreateTaskDto[];
}

/** General task state information. Used for polling task state, but returned only as part of an operation type specific task. */
export class TaskStateDto implements ITaskStateDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;

    constructor(data?: ITaskStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
        }
    }

    static fromJS(data: any): TaskStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        return data;
    }

    clone(): TaskStateDto {
        const json = this.toJSON();
        let result = new TaskStateDto();
        result.init(json);
        return result;
    }
}

/** General task state information. Used for polling task state, but returned only as part of an operation type specific task. */
export interface ITaskStateDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
}

export class CostUnitTypesCreateTaskDto extends TaskStateDto implements ICostUnitTypesCreateTaskDto {
    /** Unique custom identifier for cost unit type. The value must be a stringified integer.
 */
    customId!: string;
    name!: string;
    isCustomIdValuesRestrictedToInteger!: boolean;
    precedence!: CostUnitPrecedenceEnum;
    from?: Date;
    to?: Date;

    constructor(data?: ICostUnitTypesCreateTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customId = _data["customId"];
            this.name = _data["name"];
            this.isCustomIdValuesRestrictedToInteger = _data["isCustomIdValuesRestrictedToInteger"];
            this.precedence = _data["precedence"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): CostUnitTypesCreateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesCreateTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customId"] = this.customId;
        data["name"] = this.name;
        data["isCustomIdValuesRestrictedToInteger"] = this.isCustomIdValuesRestrictedToInteger;
        data["precedence"] = this.precedence;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesCreateTaskDto {
        const json = this.toJSON();
        let result = new CostUnitTypesCreateTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesCreateTaskDto extends ITaskStateDto {
    /** Unique custom identifier for cost unit type. The value must be a stringified integer.
 */
    customId: string;
    name: string;
    isCustomIdValuesRestrictedToInteger: boolean;
    precedence: CostUnitPrecedenceEnum;
    from?: Date;
    to?: Date;
}

export class CostUnitTypesUpdateRequestDto extends BaseRequestDto implements ICostUnitTypesUpdateRequestDto {
    /** Employee IDs to validate position period coverage against. If provided, validates that cost unit type periods cover all position periods for these employees that use this cost unit type.
 */
    employeeIds?: string[];
    /** List of cost unit types to update */
    items!: CostUnitTypesUpdateItemDto[];

    constructor(data?: ICostUnitTypesUpdateRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CostUnitTypesUpdateItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitTypesUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesUpdateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesUpdateRequestDto {
        const json = this.toJSON();
        let result = new CostUnitTypesUpdateRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesUpdateRequestDto extends IBaseRequestDto {
    /** Employee IDs to validate position period coverage against. If provided, validates that cost unit type periods cover all position periods for these employees that use this cost unit type.
 */
    employeeIds?: string[];
    /** List of cost unit types to update */
    items: CostUnitTypesUpdateItemDto[];
}

export class CostUnitTypesUpdateItemDto implements ICostUnitTypesUpdateItemDto {
    oldData!: CostUnitTypeDto;
    newData!: CostUnitTypeDto;

    constructor(data?: ICostUnitTypesUpdateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.oldData = new CostUnitTypeDto();
            this.newData = new CostUnitTypeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldData = _data["oldData"] ? CostUnitTypeDto.fromJS(_data["oldData"]) : new CostUnitTypeDto();
            this.newData = _data["newData"] ? CostUnitTypeDto.fromJS(_data["newData"]) : new CostUnitTypeDto();
        }
    }

    static fromJS(data: any): CostUnitTypesUpdateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesUpdateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldData"] = this.oldData ? this.oldData.toJSON() : undefined as any;
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        return data;
    }

    clone(): CostUnitTypesUpdateItemDto {
        const json = this.toJSON();
        let result = new CostUnitTypesUpdateItemDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesUpdateItemDto {
    oldData: CostUnitTypeDto;
    newData: CostUnitTypeDto;
}

/** Full information about a cost unit types update operation */
export class CostUnitTypesUpdateOperationDto extends OperationStateDto implements ICostUnitTypesUpdateOperationDto {
    /** List of cost unit type update tasks */
    tasks!: CostUnitTypesUpdateTaskDto[];

    constructor(data?: ICostUnitTypesUpdateOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(CostUnitTypesUpdateTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CostUnitTypesUpdateOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesUpdateOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesUpdateOperationDto {
        const json = this.toJSON();
        let result = new CostUnitTypesUpdateOperationDto();
        result.init(json);
        return result;
    }
}

/** Full information about a cost unit types update operation */
export interface ICostUnitTypesUpdateOperationDto extends IOperationStateDto {
    /** List of cost unit type update tasks */
    tasks: CostUnitTypesUpdateTaskDto[];
}

export class CostUnitTypesUpdateTaskDto extends TaskStateDto implements ICostUnitTypesUpdateTaskDto {
    oldData!: CostUnitTypeDto;
    newData!: CostUnitTypeDto;

    constructor(data?: ICostUnitTypesUpdateTaskDto) {
        super(data);
        if (!data) {
            this.oldData = new CostUnitTypeDto();
            this.newData = new CostUnitTypeDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldData = _data["oldData"] ? CostUnitTypeDto.fromJS(_data["oldData"]) : new CostUnitTypeDto();
            this.newData = _data["newData"] ? CostUnitTypeDto.fromJS(_data["newData"]) : new CostUnitTypeDto();
        }
    }

    static override fromJS(data: any): CostUnitTypesUpdateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitTypesUpdateTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldData"] = this.oldData ? this.oldData.toJSON() : undefined as any;
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): CostUnitTypesUpdateTaskDto {
        const json = this.toJSON();
        let result = new CostUnitTypesUpdateTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitTypesUpdateTaskDto extends ITaskStateDto {
    oldData: CostUnitTypeDto;
    newData: CostUnitTypeDto;
}

export class AbsenceRegistrationImportEventCodeMappingDto implements IAbsenceRegistrationImportEventCodeMappingDto {
    eventCodes?: AbsenceRegistrationImportEventCodeDto[];

    constructor(data?: IAbsenceRegistrationImportEventCodeMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["eventCodes"])) {
                this.eventCodes = [] as any;
                for (let item of _data["eventCodes"])
                    this.eventCodes!.push(AbsenceRegistrationImportEventCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbsenceRegistrationImportEventCodeMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportEventCodeMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.eventCodes)) {
            data["eventCodes"] = [];
            for (let item of this.eventCodes)
                data["eventCodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AbsenceRegistrationImportEventCodeMappingDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportEventCodeMappingDto();
        result.init(json);
        return result;
    }
}

export interface IAbsenceRegistrationImportEventCodeMappingDto {
    eventCodes?: AbsenceRegistrationImportEventCodeDto[];
}

export class AbsenceRegistrationImportEventCodeDto implements IAbsenceRegistrationImportEventCodeDto {
    eventName!: LocalizedStringDto;
    eventCode!: string;
    calendarEventCodeIds?: string[];

    constructor(data?: IAbsenceRegistrationImportEventCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.eventName = new LocalizedStringDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventName = _data["eventName"] ? LocalizedStringDto.fromJS(_data["eventName"]) : new LocalizedStringDto();
            this.eventCode = _data["eventCode"];
            if (Array.isArray(_data["calendarEventCodeIds"])) {
                this.calendarEventCodeIds = [] as any;
                for (let item of _data["calendarEventCodeIds"])
                    this.calendarEventCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AbsenceRegistrationImportEventCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportEventCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventName"] = this.eventName ? this.eventName.toJSON() : undefined as any;
        data["eventCode"] = this.eventCode;
        if (Array.isArray(this.calendarEventCodeIds)) {
            data["calendarEventCodeIds"] = [];
            for (let item of this.calendarEventCodeIds)
                data["calendarEventCodeIds"].push(item);
        }
        return data;
    }

    clone(): AbsenceRegistrationImportEventCodeDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportEventCodeDto();
        result.init(json);
        return result;
    }
}

export interface IAbsenceRegistrationImportEventCodeDto {
    eventName: LocalizedStringDto;
    eventCode: string;
    calendarEventCodeIds?: string[];
}

export class AbsenceRegistrationImportRequestDto extends BaseRequestDto implements IAbsenceRegistrationImportRequestDto {
    /** List of absence registrations */
    items!: AbsenceRegistrationImportRequestItemDto[];

    constructor(data?: IAbsenceRegistrationImportRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AbsenceRegistrationImportRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AbsenceRegistrationImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AbsenceRegistrationImportRequestDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAbsenceRegistrationImportRequestDto extends IBaseRequestDto {
    /** List of absence registrations */
    items: AbsenceRegistrationImportRequestItemDto[];
}

export class BaseRequestItemV2Dto implements IBaseRequestItemV2Dto {
    employeeId!: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    firstName!: string;
    lastName!: string;

    constructor(data?: IBaseRequestItemV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): BaseRequestItemV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestItemV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeNumber"] = this.employeeNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }

    clone(): BaseRequestItemV2Dto {
        const json = this.toJSON();
        let result = new BaseRequestItemV2Dto();
        result.init(json);
        return result;
    }
}

export interface IBaseRequestItemV2Dto {
    employeeId: string;
    /** Organization specific employee number */
    employeeNumber: string;
    firstName: string;
    lastName: string;
}

export class AbsenceRegistrationImportRequestItemDto extends BaseRequestItemV2Dto implements IAbsenceRegistrationImportRequestItemDto {
    employeeId!: string;
    /** List of absences to register for employee */
    absences!: AbsenceRegistrationImportDto[];

    constructor(data?: IAbsenceRegistrationImportRequestItemDto) {
        super(data);
        if (!data) {
            this.absences = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["absences"])) {
                this.absences = [] as any;
                for (let item of _data["absences"])
                    this.absences!.push(AbsenceRegistrationImportDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AbsenceRegistrationImportRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.absences)) {
            data["absences"] = [];
            for (let item of this.absences)
                data["absences"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AbsenceRegistrationImportRequestItemDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IAbsenceRegistrationImportRequestItemDto extends IBaseRequestItemV2Dto {
    employeeId: string;
    /** List of absences to register for employee */
    absences: AbsenceRegistrationImportDto[];
}

export class AbsenceRegistrationImportDto implements IAbsenceRegistrationImportDto {
    fileEventCodeId!: string;
    eventCodeId!: string;
    fromDate!: Date;
    toDate!: Date;
    comment?: string;
    percentage!: number;

    constructor(data?: IAbsenceRegistrationImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileEventCodeId = _data["fileEventCodeId"];
            this.eventCodeId = _data["eventCodeId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): AbsenceRegistrationImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileEventCodeId"] = this.fileEventCodeId;
        data["eventCodeId"] = this.eventCodeId;
        data["fromDate"] = this.fromDate ? formatDate(this.fromDate) : undefined as any;
        data["toDate"] = this.toDate ? formatDate(this.toDate) : undefined as any;
        data["comment"] = this.comment;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): AbsenceRegistrationImportDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportDto();
        result.init(json);
        return result;
    }
}

export interface IAbsenceRegistrationImportDto {
    fileEventCodeId: string;
    eventCodeId: string;
    fromDate: Date;
    toDate: Date;
    comment?: string;
    percentage: number;
}

/** full information about a single absence registration */
export class AbsenceRegistrationImportOperationDto extends OperationStateDto implements IAbsenceRegistrationImportOperationDto {
    eventCodeMapping?: AbsenceRegistrationImportEventCodeMappingDto;
    /** List of vacation balances being or having been imported */
    tasks!: AbsenceRegistrationImportTaskDto[];

    constructor(data?: IAbsenceRegistrationImportOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventCodeMapping = _data["eventCodeMapping"] ? AbsenceRegistrationImportEventCodeMappingDto.fromJS(_data["eventCodeMapping"]) : undefined as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AbsenceRegistrationImportTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AbsenceRegistrationImportOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventCodeMapping"] = this.eventCodeMapping ? this.eventCodeMapping.toJSON() : undefined as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AbsenceRegistrationImportOperationDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single absence registration */
export interface IAbsenceRegistrationImportOperationDto extends IOperationStateDto {
    eventCodeMapping?: AbsenceRegistrationImportEventCodeMappingDto;
    /** List of vacation balances being or having been imported */
    tasks: AbsenceRegistrationImportTaskDto[];
}

export class AbsenceRegistrationImportTaskDto extends AbsenceRegistrationImportRequestItemDto implements IAbsenceRegistrationImportTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IAbsenceRegistrationImportTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): AbsenceRegistrationImportTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceRegistrationImportTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): AbsenceRegistrationImportTaskDto {
        const json = this.toJSON();
        let result = new AbsenceRegistrationImportTaskDto();
        result.init(json);
        return result;
    }
}

export interface IAbsenceRegistrationImportTaskDto extends IAbsenceRegistrationImportRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class VacationBalanceImportRequestDto extends BaseRequestDto implements IVacationBalanceImportRequestDto {
    /** Year to use for the vacation balances import. */
    importYear!: number;
    /** List of vacation balances to import */
    items!: VacationBalanceImportRequestItemDto[];

    constructor(data?: IVacationBalanceImportRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.importYear = _data["importYear"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VacationBalanceImportRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VacationBalanceImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacationBalanceImportRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importYear"] = this.importYear;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VacationBalanceImportRequestDto {
        const json = this.toJSON();
        let result = new VacationBalanceImportRequestDto();
        result.init(json);
        return result;
    }
}

export interface IVacationBalanceImportRequestDto extends IBaseRequestDto {
    /** Year to use for the vacation balances import. */
    importYear: number;
    /** List of vacation balances to import */
    items: VacationBalanceImportRequestItemDto[];
}

export class BaseRequestItemDto implements IBaseRequestItemDto {
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IBaseRequestItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): BaseRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        return data;
    }

    clone(): BaseRequestItemDto {
        const json = this.toJSON();
        let result = new BaseRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IBaseRequestItemDto {
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

/** Only the days properties that are set will be affected. `undefined` or `null` properties will keep the calendar value they have, if any. */
export class VacationBalanceImportRequestItemDto extends BaseRequestItemDto implements IVacationBalanceImportRequestItemDto {
    employeeId!: string;
    /** employee position id */
    positionId!: string;
    normalDays?: number;
    transferredDays?: number;
    additionalDays?: number;
    advancedDays?: number;
    unpaidDays?: number;
    transferredAdditionalDays?: number;

    constructor(data?: IVacationBalanceImportRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.positionId = _data["positionId"];
            this.normalDays = _data["normalDays"];
            this.transferredDays = _data["transferredDays"];
            this.additionalDays = _data["additionalDays"];
            this.advancedDays = _data["advancedDays"];
            this.unpaidDays = _data["unpaidDays"];
            this.transferredAdditionalDays = _data["transferredAdditionalDays"];
        }
    }

    static override fromJS(data: any): VacationBalanceImportRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacationBalanceImportRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["positionId"] = this.positionId;
        data["normalDays"] = this.normalDays;
        data["transferredDays"] = this.transferredDays;
        data["additionalDays"] = this.additionalDays;
        data["advancedDays"] = this.advancedDays;
        data["unpaidDays"] = this.unpaidDays;
        data["transferredAdditionalDays"] = this.transferredAdditionalDays;
        super.toJSON(data);
        return data;
    }

    clone(): VacationBalanceImportRequestItemDto {
        const json = this.toJSON();
        let result = new VacationBalanceImportRequestItemDto();
        result.init(json);
        return result;
    }
}

/** Only the days properties that are set will be affected. `undefined` or `null` properties will keep the calendar value they have, if any. */
export interface IVacationBalanceImportRequestItemDto extends IBaseRequestItemDto {
    employeeId: string;
    /** employee position id */
    positionId: string;
    normalDays?: number;
    transferredDays?: number;
    additionalDays?: number;
    advancedDays?: number;
    unpaidDays?: number;
    transferredAdditionalDays?: number;
}

/** full information about a single vacation balance import */
export class VacationBalanceImportOperationDto extends OperationStateDto implements IVacationBalanceImportOperationDto {
    /** year used in the vacation balance import */
    importYear!: number;
    /** List of vacation balances being or having been imported */
    tasks!: VacationBalanceImportTaskDto[];

    constructor(data?: IVacationBalanceImportOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.importYear = _data["importYear"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(VacationBalanceImportTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VacationBalanceImportOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacationBalanceImportOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importYear"] = this.importYear;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VacationBalanceImportOperationDto {
        const json = this.toJSON();
        let result = new VacationBalanceImportOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single vacation balance import */
export interface IVacationBalanceImportOperationDto extends IOperationStateDto {
    /** year used in the vacation balance import */
    importYear: number;
    /** List of vacation balances being or having been imported */
    tasks: VacationBalanceImportTaskDto[];
}

export class VacationBalanceImportTaskDto extends VacationBalanceImportRequestItemDto implements IVacationBalanceImportTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IVacationBalanceImportTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): VacationBalanceImportTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacationBalanceImportTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): VacationBalanceImportTaskDto {
        const json = this.toJSON();
        let result = new VacationBalanceImportTaskDto();
        result.init(json);
        return result;
    }
}

export interface IVacationBalanceImportTaskDto extends IVacationBalanceImportRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

/** The same string expressed in multiple languages. */
export class LocalizedStringDto implements ILocalizedStringDto {
    /** String in English */
    english!: string;
    /** String in Norwegian */
    norwegian!: string;

    constructor(data?: ILocalizedStringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.english = _data["english"];
            this.norwegian = _data["norwegian"];
        }
    }

    static fromJS(data: any): LocalizedStringDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["english"] = this.english;
        data["norwegian"] = this.norwegian;
        return data;
    }

    clone(): LocalizedStringDto {
        const json = this.toJSON();
        let result = new LocalizedStringDto();
        result.init(json);
        return result;
    }
}

/** The same string expressed in multiple languages. */
export interface ILocalizedStringDto {
    /** String in English */
    english: string;
    /** String in Norwegian */
    norwegian: string;
}

/** Employee task state information. Used for polling task state, but returned only as part of an operation type specific task. */
export class EmployeeTaskStateDto implements IEmployeeTaskStateDto {
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IEmployeeTaskStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): EmployeeTaskStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTaskStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        return data;
    }

    clone(): EmployeeTaskStateDto {
        const json = this.toJSON();
        let result = new EmployeeTaskStateDto();
        result.init(json);
        return result;
    }
}

/** Employee task state information. Used for polling task state, but returned only as part of an operation type specific task. */
export interface IEmployeeTaskStateDto {
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class GetTasksRequestDto implements IGetTasksRequestDto {
    /** List of tasks for which to retrieve state. The expected normal flow is to only retrieve state for failed tasks. */
    taskIds!: string[];

    constructor(data?: IGetTasksRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.taskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTasksRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        return data;
    }

    clone(): GetTasksRequestDto {
        const json = this.toJSON();
        let result = new GetTasksRequestDto();
        result.init(json);
        return result;
    }
}

export interface IGetTasksRequestDto {
    /** List of tasks for which to retrieve state. The expected normal flow is to only retrieve state for failed tasks. */
    taskIds: string[];
}

export class OkActionResponseDto implements IOkActionResponseDto {
    /** Action id */
    id!: string;
    /** `true` when already created (response code 200), `false` when action didn't already exist (response code 201).
 */
    isDuplicate!: boolean;
    /** When the backend created the action */
    createdTimeIso!: string;
    /** Correlation ID of the client instance that created the action */
    sessionCorrelationId!: string;
    /** Correlation ID of the client call that created the action */
    callCorrelationId!: string;

    constructor(data?: IOkActionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDuplicate = _data["isDuplicate"];
            this.createdTimeIso = _data["createdTimeIso"];
            this.sessionCorrelationId = _data["sessionCorrelationId"];
            this.callCorrelationId = _data["callCorrelationId"];
        }
    }

    static fromJS(data: any): OkActionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OkActionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDuplicate"] = this.isDuplicate;
        data["createdTimeIso"] = this.createdTimeIso;
        data["sessionCorrelationId"] = this.sessionCorrelationId;
        data["callCorrelationId"] = this.callCorrelationId;
        return data;
    }

    clone(): OkActionResponseDto {
        const json = this.toJSON();
        let result = new OkActionResponseDto();
        result.init(json);
        return result;
    }
}

export interface IOkActionResponseDto {
    /** Action id */
    id: string;
    /** `true` when already created (response code 200), `false` when action didn't already exist (response code 201).
 */
    isDuplicate: boolean;
    /** When the backend created the action */
    createdTimeIso: string;
    /** Correlation ID of the client instance that created the action */
    sessionCorrelationId: string;
    /** Correlation ID of the client call that created the action */
    callCorrelationId: string;
}

/** Operation metadata to use for polling. */
export class CreatedOperationResponseDto implements ICreatedOperationResponseDto {
    /** Operation id */
    id!: string;

    constructor(data?: ICreatedOperationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatedOperationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedOperationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): CreatedOperationResponseDto {
        const json = this.toJSON();
        let result = new CreatedOperationResponseDto();
        result.init(json);
        return result;
    }
}

/** Operation metadata to use for polling. */
export interface ICreatedOperationResponseDto {
    /** Operation id */
    id: string;
}

/** Bad request may contain general or validation errors. */
export class BadRequestDto implements IBadRequestDto {
    generalError?: string;
    validationItems?: ValidationItemDto[];
    callCorrelationId!: string;

    constructor(data?: IBadRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalError = _data["generalError"];
            if (Array.isArray(_data["validationItems"])) {
                this.validationItems = [] as any;
                for (let item of _data["validationItems"])
                    this.validationItems!.push(ValidationItemDto.fromJS(item));
            }
            this.callCorrelationId = _data["callCorrelationId"];
        }
    }

    static fromJS(data: any): BadRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalError"] = this.generalError;
        if (Array.isArray(this.validationItems)) {
            data["validationItems"] = [];
            for (let item of this.validationItems)
                data["validationItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["callCorrelationId"] = this.callCorrelationId;
        return data;
    }

    clone(): BadRequestDto {
        const json = this.toJSON();
        let result = new BadRequestDto();
        result.init(json);
        return result;
    }
}

/** Bad request may contain general or validation errors. */
export interface IBadRequestDto {
    generalError?: string;
    validationItems?: ValidationItemDto[];
    callCorrelationId: string;
}

/** A single validation error used in the list of validation errors. An invalid property value was found in `propertyName` in the request DTO. If multiple properties are involved, there should be one error item per property, all with the same `message` (which should mention all properties). */
export class ValidationItemDto implements IValidationItemDto {
    /** Operation specific unique identifier (1-to-1 mappable with a task id for operations) */
    itemId?: string;
    /** Replaced by `itemId` */
    positionId?: string;
    propertyName!: string;
    message!: string;
    /** Can be any type - array, boolean, number, object or string */
    value?: any;

    constructor(data?: IValidationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.positionId = _data["positionId"];
            this.propertyName = _data["propertyName"];
            this.message = _data["message"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ValidationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["positionId"] = this.positionId;
        data["propertyName"] = this.propertyName;
        data["message"] = this.message;
        data["value"] = this.value;
        return data;
    }

    clone(): ValidationItemDto {
        const json = this.toJSON();
        let result = new ValidationItemDto();
        result.init(json);
        return result;
    }
}

/** A single validation error used in the list of validation errors. An invalid property value was found in `propertyName` in the request DTO. If multiple properties are involved, there should be one error item per property, all with the same `message` (which should mention all properties). */
export interface IValidationItemDto {
    /** Operation specific unique identifier (1-to-1 mappable with a task id for operations) */
    itemId?: string;
    /** Replaced by `itemId` */
    positionId?: string;
    propertyName: string;
    message: string;
    /** Can be any type - array, boolean, number, object or string */
    value?: any;
}

export class TagsResponseDto implements ITagsResponseDto {
    tags!: TagDto[];

    constructor(data?: ITagsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TagsResponseDto {
        const json = this.toJSON();
        let result = new TagsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITagsResponseDto {
    tags: TagDto[];
}

export class TagDto implements ITagDto {
    /** Unique internal identifier for tag. Always set except for ongoing create actions. */
    id?: string;
    name!: string;
    description?: string;
    /** Tag color hex code. */
    color?: string;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }

    clone(): TagDto {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}

export interface ITagDto {
    /** Unique internal identifier for tag. Always set except for ongoing create actions. */
    id?: string;
    name: string;
    description?: string;
    /** Tag color hex code. */
    color?: string;
}

export class TaxUnitsResponseDto implements ITaxUnitsResponseDto {
    taxUnits!: TaxUnitDto[];

    constructor(data?: ITaxUnitsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.taxUnits = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taxUnits"])) {
                this.taxUnits = [] as any;
                for (let item of _data["taxUnits"])
                    this.taxUnits!.push(TaxUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxUnitsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxUnitsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxUnits)) {
            data["taxUnits"] = [];
            for (let item of this.taxUnits)
                data["taxUnits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TaxUnitsResponseDto {
        const json = this.toJSON();
        let result = new TaxUnitsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITaxUnitsResponseDto {
    taxUnits: TaxUnitDto[];
}

export class TaxUnitDto implements ITaxUnitDto {
    /** Unique internal identifier for tax unit. Could be either a GUID or an integer as string, after ORG API has done their tax unit mapping changes the id should always be guid.
 */
    id!: string;
    /** Unique internal identifier for tax unit. Is an integer as string, might not be set and will be removed when no longer needed.
 */
    legacyId!: string;
    activeStart?: Date;
    activeEnd?: Date;
    /** Start date for a-melding to tax authorities. Must always be the 1st of the month.
 */
    aMessageStartDate!: Date;
    employerFeeCalculationCode!: EmployerFeeCalculationCodeEnum;
    /** Sorted on activeStart, oldest first. */
    organizationNumberTimeline!: StringFullTimeline[];
    /** Sorted on activeStart, oldest first. */
    nameTimeline!: StringFullTimeline[];
    /** Sorted on activeStart, oldest first. Reference to "kommunenummer" as defined on https://www.regjeringen.no/no/tema/kommuner-og-regioner/kommunestruktur/nye-kommune-og-fylkesnummer-fra-1.-januar-2024/id2924701/ (or older versions, depending on activeStart). Internally defined in reference table 30010 (Municipality), which public APIs don't expose, but the number can be used as is.
 */
    municipalityNumberTimeline!: StringFullTimeline[];

    constructor(data?: ITaxUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.organizationNumberTimeline = [];
            this.nameTimeline = [];
            this.municipalityNumberTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyId = _data["legacyId"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.aMessageStartDate = _data["aMessageStartDate"] ? new Date(_data["aMessageStartDate"].toString()) : undefined as any;
            this.employerFeeCalculationCode = _data["employerFeeCalculationCode"];
            if (Array.isArray(_data["organizationNumberTimeline"])) {
                this.organizationNumberTimeline = [] as any;
                for (let item of _data["organizationNumberTimeline"])
                    this.organizationNumberTimeline!.push(StringFullTimeline.fromJS(item));
            }
            if (Array.isArray(_data["nameTimeline"])) {
                this.nameTimeline = [] as any;
                for (let item of _data["nameTimeline"])
                    this.nameTimeline!.push(StringFullTimeline.fromJS(item));
            }
            if (Array.isArray(_data["municipalityNumberTimeline"])) {
                this.municipalityNumberTimeline = [] as any;
                for (let item of _data["municipalityNumberTimeline"])
                    this.municipalityNumberTimeline!.push(StringFullTimeline.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["aMessageStartDate"] = this.aMessageStartDate ? formatDate(this.aMessageStartDate) : undefined as any;
        data["employerFeeCalculationCode"] = this.employerFeeCalculationCode;
        if (Array.isArray(this.organizationNumberTimeline)) {
            data["organizationNumberTimeline"] = [];
            for (let item of this.organizationNumberTimeline)
                data["organizationNumberTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nameTimeline)) {
            data["nameTimeline"] = [];
            for (let item of this.nameTimeline)
                data["nameTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.municipalityNumberTimeline)) {
            data["municipalityNumberTimeline"] = [];
            for (let item of this.municipalityNumberTimeline)
                data["municipalityNumberTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TaxUnitDto {
        const json = this.toJSON();
        let result = new TaxUnitDto();
        result.init(json);
        return result;
    }
}

export interface ITaxUnitDto {
    /** Unique internal identifier for tax unit. Could be either a GUID or an integer as string, after ORG API has done their tax unit mapping changes the id should always be guid.
 */
    id: string;
    /** Unique internal identifier for tax unit. Is an integer as string, might not be set and will be removed when no longer needed.
 */
    legacyId: string;
    activeStart?: Date;
    activeEnd?: Date;
    /** Start date for a-melding to tax authorities. Must always be the 1st of the month.
 */
    aMessageStartDate: Date;
    employerFeeCalculationCode: EmployerFeeCalculationCodeEnum;
    /** Sorted on activeStart, oldest first. */
    organizationNumberTimeline: StringFullTimeline[];
    /** Sorted on activeStart, oldest first. */
    nameTimeline: StringFullTimeline[];
    /** Sorted on activeStart, oldest first. Reference to "kommunenummer" as defined on https://www.regjeringen.no/no/tema/kommuner-og-regioner/kommunestruktur/nye-kommune-og-fylkesnummer-fra-1.-januar-2024/id2924701/ (or older versions, depending on activeStart). Internally defined in reference table 30010 (Municipality), which public APIs don't expose, but the number can be used as is.
 */
    municipalityNumberTimeline: StringFullTimeline[];
}

export class StringFullTimeline implements IStringFullTimeline {
    value!: string;
    activeStart?: Date;

    constructor(data?: IStringFullTimeline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StringFullTimeline {
        data = typeof data === 'object' ? data : {};
        let result = new StringFullTimeline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        return data;
    }

    clone(): StringFullTimeline {
        const json = this.toJSON();
        let result = new StringFullTimeline();
        result.init(json);
        return result;
    }
}

export interface IStringFullTimeline {
    value: string;
    activeStart?: Date;
}

export class PositionTagsUpdateOperationRequestDto extends BaseRequestDto implements IPositionTagsUpdateOperationRequestDto {
    /** List of position to update */
    items!: PositionTagsUpdateOperationItemDto[];

    constructor(data?: IPositionTagsUpdateOperationRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PositionTagsUpdateOperationItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PositionTagsUpdateOperationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionTagsUpdateOperationRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PositionTagsUpdateOperationRequestDto {
        const json = this.toJSON();
        let result = new PositionTagsUpdateOperationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPositionTagsUpdateOperationRequestDto extends IBaseRequestDto {
    /** List of position to update */
    items: PositionTagsUpdateOperationItemDto[];
}

export class PositionRequestItemDto extends BaseRequestItemDto implements IPositionRequestItemDto {
    employeeId!: string;
    positionId!: string;

    constructor(data?: IPositionRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.positionId = _data["positionId"];
        }
    }

    static override fromJS(data: any): PositionRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["positionId"] = this.positionId;
        super.toJSON(data);
        return data;
    }

    clone(): PositionRequestItemDto {
        const json = this.toJSON();
        let result = new PositionRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IPositionRequestItemDto extends IBaseRequestItemDto {
    employeeId: string;
    positionId: string;
}

export class PositionTagsUpdateOperationItemDto extends PositionRequestItemDto implements IPositionTagsUpdateOperationItemDto {
    oldData!: string[];
    newData!: string[];

    constructor(data?: IPositionTagsUpdateOperationItemDto) {
        super(data);
        if (!data) {
            this.oldData = [];
            this.newData = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["oldData"])) {
                this.oldData = [] as any;
                for (let item of _data["oldData"])
                    this.oldData!.push(item);
            }
            if (Array.isArray(_data["newData"])) {
                this.newData = [] as any;
                for (let item of _data["newData"])
                    this.newData!.push(item);
            }
        }
    }

    static override fromJS(data: any): PositionTagsUpdateOperationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionTagsUpdateOperationItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oldData)) {
            data["oldData"] = [];
            for (let item of this.oldData)
                data["oldData"].push(item);
        }
        if (Array.isArray(this.newData)) {
            data["newData"] = [];
            for (let item of this.newData)
                data["newData"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PositionTagsUpdateOperationItemDto {
        const json = this.toJSON();
        let result = new PositionTagsUpdateOperationItemDto();
        result.init(json);
        return result;
    }
}

export interface IPositionTagsUpdateOperationItemDto extends IPositionRequestItemDto {
    oldData: string[];
    newData: string[];
}

/** full information about a single position tags update */
export class PositionTagsUpdateOperationDto extends OperationStateDto implements IPositionTagsUpdateOperationDto {
    /** List of position tags being or having been updated */
    tasks!: PositionTagsUpdateTaskDto[];

    constructor(data?: IPositionTagsUpdateOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(PositionTagsUpdateTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PositionTagsUpdateOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionTagsUpdateOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PositionTagsUpdateOperationDto {
        const json = this.toJSON();
        let result = new PositionTagsUpdateOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single position tags update */
export interface IPositionTagsUpdateOperationDto extends IOperationStateDto {
    /** List of position tags being or having been updated */
    tasks: PositionTagsUpdateTaskDto[];
}

export class PositionTagsUpdateTaskDto extends PositionTagsUpdateOperationItemDto implements IPositionTagsUpdateTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IPositionTagsUpdateTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): PositionTagsUpdateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionTagsUpdateTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): PositionTagsUpdateTaskDto {
        const json = this.toJSON();
        let result = new PositionTagsUpdateTaskDto();
        result.init(json);
        return result;
    }
}

export interface IPositionTagsUpdateTaskDto extends IPositionTagsUpdateOperationItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EmployeesForEndPositionsResponseDto implements IEmployeesForEndPositionsResponseDto {
    nextToken?: string;
    employees!: EmployeeForEndPositionsDto[];

    constructor(data?: IEmployeesForEndPositionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employees = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeForEndPositionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesForEndPositionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesForEndPositionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesForEndPositionsResponseDto {
        const json = this.toJSON();
        let result = new EmployeesForEndPositionsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesForEndPositionsResponseDto {
    nextToken?: string;
    employees: EmployeeForEndPositionsDto[];
}

export class EmployeeForEndPositionsDto extends BaseRequestItemDto implements IEmployeeForEndPositionsDto {
    /** is mapped from employmentId of legacy employee structure. */
    id!: string;
    /** Not ordered */
    positions!: EmployeePositionForEndPositionsDto[];

    constructor(data?: IEmployeeForEndPositionsDto) {
        super(data);
        if (!data) {
            this.positions = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EmployeePositionForEndPositionsDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EmployeeForEndPositionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForEndPositionsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeForEndPositionsDto {
        const json = this.toJSON();
        let result = new EmployeeForEndPositionsDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForEndPositionsDto extends IBaseRequestItemDto {
    /** is mapped from employmentId of legacy employee structure. */
    id: string;
    /** Not ordered */
    positions: EmployeePositionForEndPositionsDto[];
}

export class EmployeePositionForEndPositionsDto implements IEmployeePositionForEndPositionsDto {
    positionId!: string;
    activeStart!: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    positionEndReason?: PositionEndReasonV3EnumDto;

    constructor(data?: IEmployeePositionForEndPositionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.typeOfPosition = _data["typeOfPosition"];
            this.positionEndReason = _data["positionEndReason"];
        }
    }

    static fromJS(data: any): EmployeePositionForEndPositionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionForEndPositionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["typeOfPosition"] = this.typeOfPosition;
        data["positionEndReason"] = this.positionEndReason;
        return data;
    }

    clone(): EmployeePositionForEndPositionsDto {
        const json = this.toJSON();
        let result = new EmployeePositionForEndPositionsDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionForEndPositionsDto {
    positionId: string;
    activeStart: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    positionEndReason?: PositionEndReasonV3EnumDto;
}

export class EndPositionsRequestDto extends BaseRequestDto implements IEndPositionsRequestDto {
    /** List of positions to end */
    items!: EndPositionsRequestItemDto[];

    constructor(data?: IEndPositionsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EndPositionsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EndPositionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndPositionsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EndPositionsRequestDto {
        const json = this.toJSON();
        let result = new EndPositionsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IEndPositionsRequestDto extends IBaseRequestDto {
    /** List of positions to end */
    items: EndPositionsRequestItemDto[];
}

export class EndPositionsRequestItemDto extends PositionRequestItemDto implements IEndPositionsRequestItemDto {
    oldActiveEnd?: Date;
    oldPositionEndReason?: PositionEndReasonV3EnumDto;
    newActiveEnd!: Date;
    newPositionEndReason?: PositionEndReasonV3EnumDto;

    constructor(data?: IEndPositionsRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldActiveEnd = _data["oldActiveEnd"] ? new Date(_data["oldActiveEnd"].toString()) : undefined as any;
            this.oldPositionEndReason = _data["oldPositionEndReason"];
            this.newActiveEnd = _data["newActiveEnd"] ? new Date(_data["newActiveEnd"].toString()) : undefined as any;
            this.newPositionEndReason = _data["newPositionEndReason"];
        }
    }

    static override fromJS(data: any): EndPositionsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndPositionsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldActiveEnd"] = this.oldActiveEnd ? formatDate(this.oldActiveEnd) : undefined as any;
        data["oldPositionEndReason"] = this.oldPositionEndReason;
        data["newActiveEnd"] = this.newActiveEnd ? formatDate(this.newActiveEnd) : undefined as any;
        data["newPositionEndReason"] = this.newPositionEndReason;
        super.toJSON(data);
        return data;
    }

    clone(): EndPositionsRequestItemDto {
        const json = this.toJSON();
        let result = new EndPositionsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IEndPositionsRequestItemDto extends IPositionRequestItemDto {
    oldActiveEnd?: Date;
    oldPositionEndReason?: PositionEndReasonV3EnumDto;
    newActiveEnd: Date;
    newPositionEndReason?: PositionEndReasonV3EnumDto;
}

/** Deprecated (VHDI-3957): Use editPositionEndDates instead. Full information about a single end of positions operation */
export class EndPositionsOperationDto extends OperationStateDto implements IEndPositionsOperationDto {
    /** List of positions being or having been ended */
    tasks!: EndPositionsTaskDto[];

    constructor(data?: IEndPositionsOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(EndPositionsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EndPositionsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndPositionsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EndPositionsOperationDto {
        const json = this.toJSON();
        let result = new EndPositionsOperationDto();
        result.init(json);
        return result;
    }
}

/** Deprecated (VHDI-3957): Use editPositionEndDates instead. Full information about a single end of positions operation */
export interface IEndPositionsOperationDto extends IOperationStateDto {
    /** List of positions being or having been ended */
    tasks: EndPositionsTaskDto[];
}

export class EndPositionsTaskDto extends EndPositionsRequestItemDto implements IEndPositionsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IEndPositionsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): EndPositionsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndPositionsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): EndPositionsTaskDto {
        const json = this.toJSON();
        let result = new EndPositionsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IEndPositionsTaskDto extends IEndPositionsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EmployeesForEditPositionEndDatesResponseDto implements IEmployeesForEditPositionEndDatesResponseDto {
    nextToken?: string;
    employees!: EmployeeForEditPositionEndDatesDto[];

    constructor(data?: IEmployeesForEditPositionEndDatesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employees = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeForEditPositionEndDatesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesForEditPositionEndDatesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesForEditPositionEndDatesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesForEditPositionEndDatesResponseDto {
        const json = this.toJSON();
        let result = new EmployeesForEditPositionEndDatesResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesForEditPositionEndDatesResponseDto {
    nextToken?: string;
    employees: EmployeeForEditPositionEndDatesDto[];
}

export class EmployeeForEditPositionEndDatesDto extends BaseRequestItemDto implements IEmployeeForEditPositionEndDatesDto {
    /** is mapped from employmentId of legacy employee structure. */
    id!: string;
    /** Not ordered */
    positions!: EmployeePositionForEditPositionEndDatesDto[];

    constructor(data?: IEmployeeForEditPositionEndDatesDto) {
        super(data);
        if (!data) {
            this.positions = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EmployeePositionForEditPositionEndDatesDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EmployeeForEditPositionEndDatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForEditPositionEndDatesDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeForEditPositionEndDatesDto {
        const json = this.toJSON();
        let result = new EmployeeForEditPositionEndDatesDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForEditPositionEndDatesDto extends IBaseRequestItemDto {
    /** is mapped from employmentId of legacy employee structure. */
    id: string;
    /** Not ordered */
    positions: EmployeePositionForEditPositionEndDatesDto[];
}

export class EmployeePositionForEditPositionEndDatesDto implements IEmployeePositionForEditPositionEndDatesDto {
    positionId!: string;
    activeStart!: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    positionEndReason?: PositionEndReasonV3EnumDto;

    constructor(data?: IEmployeePositionForEditPositionEndDatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.typeOfPosition = _data["typeOfPosition"];
            this.positionEndReason = _data["positionEndReason"];
        }
    }

    static fromJS(data: any): EmployeePositionForEditPositionEndDatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionForEditPositionEndDatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["typeOfPosition"] = this.typeOfPosition;
        data["positionEndReason"] = this.positionEndReason;
        return data;
    }

    clone(): EmployeePositionForEditPositionEndDatesDto {
        const json = this.toJSON();
        let result = new EmployeePositionForEditPositionEndDatesDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionForEditPositionEndDatesDto {
    positionId: string;
    activeStart: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    positionEndReason?: PositionEndReasonV3EnumDto;
}

export class EditPositionEndDatesRequestDto extends BaseRequestDto implements IEditPositionEndDatesRequestDto {
    /** List of positions to edit end dates for */
    items!: EditPositionEndDatesRequestItemDto[];

    constructor(data?: IEditPositionEndDatesRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditPositionEndDatesRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditPositionEndDatesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPositionEndDatesRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditPositionEndDatesRequestDto {
        const json = this.toJSON();
        let result = new EditPositionEndDatesRequestDto();
        result.init(json);
        return result;
    }
}

export interface IEditPositionEndDatesRequestDto extends IBaseRequestDto {
    /** List of positions to edit end dates for */
    items: EditPositionEndDatesRequestItemDto[];
}

export class EditPositionEndDatesRequestItemDto extends PositionRequestItemDto implements IEditPositionEndDatesRequestItemDto {
    /** Previous end date (for display/audit purposes) */
    oldActiveEnd?: Date;
    oldPositionEndReason?: PositionEndReasonV3EnumDto;
    /** New end date. If undefined, clears the end date. */
    newActiveEnd?: Date;
    newPositionEndReason?: PositionEndReasonV3EnumDto;

    constructor(data?: IEditPositionEndDatesRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldActiveEnd = _data["oldActiveEnd"] ? new Date(_data["oldActiveEnd"].toString()) : undefined as any;
            this.oldPositionEndReason = _data["oldPositionEndReason"];
            this.newActiveEnd = _data["newActiveEnd"] ? new Date(_data["newActiveEnd"].toString()) : undefined as any;
            this.newPositionEndReason = _data["newPositionEndReason"];
        }
    }

    static override fromJS(data: any): EditPositionEndDatesRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPositionEndDatesRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldActiveEnd"] = this.oldActiveEnd ? formatDate(this.oldActiveEnd) : undefined as any;
        data["oldPositionEndReason"] = this.oldPositionEndReason;
        data["newActiveEnd"] = this.newActiveEnd ? formatDate(this.newActiveEnd) : undefined as any;
        data["newPositionEndReason"] = this.newPositionEndReason;
        super.toJSON(data);
        return data;
    }

    clone(): EditPositionEndDatesRequestItemDto {
        const json = this.toJSON();
        let result = new EditPositionEndDatesRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IEditPositionEndDatesRequestItemDto extends IPositionRequestItemDto {
    /** Previous end date (for display/audit purposes) */
    oldActiveEnd?: Date;
    oldPositionEndReason?: PositionEndReasonV3EnumDto;
    /** New end date. If undefined, clears the end date. */
    newActiveEnd?: Date;
    newPositionEndReason?: PositionEndReasonV3EnumDto;
}

/** Full information about a single edit position end dates operation */
export class EditPositionEndDatesOperationDto extends OperationStateDto implements IEditPositionEndDatesOperationDto {
    /** List of positions being or having been edited */
    tasks!: EditPositionEndDatesTaskDto[];

    constructor(data?: IEditPositionEndDatesOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(EditPositionEndDatesTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditPositionEndDatesOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPositionEndDatesOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditPositionEndDatesOperationDto {
        const json = this.toJSON();
        let result = new EditPositionEndDatesOperationDto();
        result.init(json);
        return result;
    }
}

/** Full information about a single edit position end dates operation */
export interface IEditPositionEndDatesOperationDto extends IOperationStateDto {
    /** List of positions being or having been edited */
    tasks: EditPositionEndDatesTaskDto[];
}

export class EditPositionEndDatesTaskDto extends EditPositionEndDatesRequestItemDto implements IEditPositionEndDatesTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IEditPositionEndDatesTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): EditPositionEndDatesTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPositionEndDatesTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): EditPositionEndDatesTaskDto {
        const json = this.toJSON();
        let result = new EditPositionEndDatesTaskDto();
        result.init(json);
        return result;
    }
}

export interface IEditPositionEndDatesTaskDto extends IEditPositionEndDatesRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EmployeesForSalaryUpdateResponseDto implements IEmployeesForSalaryUpdateResponseDto {
    nextToken?: string;
    employees!: EmployeeForSalaryUpdateDto[];

    constructor(data?: IEmployeesForSalaryUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employees = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeForSalaryUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesForSalaryUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesForSalaryUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesForSalaryUpdateResponseDto {
        const json = this.toJSON();
        let result = new EmployeesForSalaryUpdateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesForSalaryUpdateResponseDto {
    nextToken?: string;
    employees: EmployeeForSalaryUpdateDto[];
}

export class EmployeeForSalaryUpdateDto extends BaseRequestItemDto implements IEmployeeForSalaryUpdateDto {
    /** is mapped from employmentId of legacy employee structure. */
    id!: string;
    /** Not ordered */
    positions!: EmployeePositionForSalaryUpdateDto[];

    constructor(data?: IEmployeeForSalaryUpdateDto) {
        super(data);
        if (!data) {
            this.positions = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EmployeePositionForSalaryUpdateDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EmployeeForSalaryUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForSalaryUpdateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeForSalaryUpdateDto {
        const json = this.toJSON();
        let result = new EmployeeForSalaryUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForSalaryUpdateDto extends IBaseRequestItemDto {
    /** is mapped from employmentId of legacy employee structure. */
    id: string;
    /** Not ordered */
    positions: EmployeePositionForSalaryUpdateDto[];
}

export class EmployeePositionForSalaryUpdateDto implements IEmployeePositionForSalaryUpdateDto {
    positionId!: string;
    activeStart!: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    /** Ordered by timeline dates oldest first. Array is never empty. */
    salaries?: EmployeePositionSalaryForSalaryUpdateDto[];
    /** Ordered by timeline dates oldest first. Array is never empty. */
    inputs?: EmployeePositionInputForSalaryUpdateDto[];

    constructor(data?: IEmployeePositionForSalaryUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.typeOfPosition = _data["typeOfPosition"];
            if (Array.isArray(_data["salaries"])) {
                this.salaries = [] as any;
                for (let item of _data["salaries"])
                    this.salaries!.push(EmployeePositionSalaryForSalaryUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(EmployeePositionInputForSalaryUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePositionForSalaryUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionForSalaryUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["typeOfPosition"] = this.typeOfPosition;
        if (Array.isArray(this.salaries)) {
            data["salaries"] = [];
            for (let item of this.salaries)
                data["salaries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeePositionForSalaryUpdateDto {
        const json = this.toJSON();
        let result = new EmployeePositionForSalaryUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionForSalaryUpdateDto {
    positionId: string;
    activeStart: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    /** Ordered by timeline dates oldest first. Array is never empty. */
    salaries?: EmployeePositionSalaryForSalaryUpdateDto[];
    /** Ordered by timeline dates oldest first. Array is never empty. */
    inputs?: EmployeePositionInputForSalaryUpdateDto[];
}

export class EmployeePositionSalaryForSalaryUpdateDto implements IEmployeePositionSalaryForSalaryUpdateDto {
    contractSalaryType?: BasePayInputTypeV3EnumDto;
    hourlySalary?: number;
    monthlySalary?: number;
    yearlySalary?: number;
    activeStart?: Date;
    activeEnd?: Date;

    constructor(data?: IEmployeePositionSalaryForSalaryUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractSalaryType = _data["contractSalaryType"];
            this.hourlySalary = _data["hourlySalary"];
            this.monthlySalary = _data["monthlySalary"];
            this.yearlySalary = _data["yearlySalary"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmployeePositionSalaryForSalaryUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionSalaryForSalaryUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractSalaryType"] = this.contractSalaryType;
        data["hourlySalary"] = this.hourlySalary;
        data["monthlySalary"] = this.monthlySalary;
        data["yearlySalary"] = this.yearlySalary;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        return data;
    }

    clone(): EmployeePositionSalaryForSalaryUpdateDto {
        const json = this.toJSON();
        let result = new EmployeePositionSalaryForSalaryUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionSalaryForSalaryUpdateDto {
    contractSalaryType?: BasePayInputTypeV3EnumDto;
    hourlySalary?: number;
    monthlySalary?: number;
    yearlySalary?: number;
    activeStart?: Date;
    activeEnd?: Date;
}

export class EmployeePositionInputForSalaryUpdateDto implements IEmployeePositionInputForSalaryUpdateDto {
    workTimeAgreementId?: string;
    ftePercentage?: string;
    activeStart?: Date;
    activeEnd?: Date;

    constructor(data?: IEmployeePositionInputForSalaryUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workTimeAgreementId = _data["workTimeAgreementId"];
            this.ftePercentage = _data["ftePercentage"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmployeePositionInputForSalaryUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionInputForSalaryUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workTimeAgreementId"] = this.workTimeAgreementId;
        data["ftePercentage"] = this.ftePercentage;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        return data;
    }

    clone(): EmployeePositionInputForSalaryUpdateDto {
        const json = this.toJSON();
        let result = new EmployeePositionInputForSalaryUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionInputForSalaryUpdateDto {
    workTimeAgreementId?: string;
    ftePercentage?: string;
    activeStart?: Date;
    activeEnd?: Date;
}

export class SalaryUpdateV2RequestDto extends BaseRequestDto implements ISalaryUpdateV2RequestDto {
    /** Active time of new salaries. Update will fail for employees with newer salaries. */
    activeStart!: Date;
    /** List of salaries to update */
    items!: SalaryUpdateV2RequestItemDto[];

    constructor(data?: ISalaryUpdateV2RequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SalaryUpdateV2RequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SalaryUpdateV2RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryUpdateV2RequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SalaryUpdateV2RequestDto {
        const json = this.toJSON();
        let result = new SalaryUpdateV2RequestDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryUpdateV2RequestDto extends IBaseRequestDto {
    /** Active time of new salaries. Update will fail for employees with newer salaries. */
    activeStart: Date;
    /** List of salaries to update */
    items: SalaryUpdateV2RequestItemDto[];
}

export class SalaryUpdateV2RequestItemDto extends PositionRequestItemDto implements ISalaryUpdateV2RequestItemDto {
    oldContractSalaryType!: BasePayInputTypeV3EnumDto;
    /** Used for reporting only. */
    oldHourlySalary!: number;
    /** Used for reporting only. */
    oldMonthlySalary!: number;
    /** Used for reporting only. */
    oldYearlySalary!: number;
    /** Used for reporting only. */
    changePercent!: number;
    /** Used for reporting only. */
    changeAmount!: number;
    newContractSalaryType!: BasePayInputTypeV3EnumDto;
    /** Used to update the salary. Should be the result of a calculation with `changePercent` and `changeAmount`, and -- depending on `oldContractSalaryType` -- one of `oldHourlySalary`, `oldMonthlySalary` and `oldYearlySalary`.
 */
    newSalary!: number;

    constructor(data?: ISalaryUpdateV2RequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldContractSalaryType = _data["oldContractSalaryType"];
            this.oldHourlySalary = _data["oldHourlySalary"];
            this.oldMonthlySalary = _data["oldMonthlySalary"];
            this.oldYearlySalary = _data["oldYearlySalary"];
            this.changePercent = _data["changePercent"];
            this.changeAmount = _data["changeAmount"];
            this.newContractSalaryType = _data["newContractSalaryType"];
            this.newSalary = _data["newSalary"];
        }
    }

    static override fromJS(data: any): SalaryUpdateV2RequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryUpdateV2RequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldContractSalaryType"] = this.oldContractSalaryType;
        data["oldHourlySalary"] = this.oldHourlySalary;
        data["oldMonthlySalary"] = this.oldMonthlySalary;
        data["oldYearlySalary"] = this.oldYearlySalary;
        data["changePercent"] = this.changePercent;
        data["changeAmount"] = this.changeAmount;
        data["newContractSalaryType"] = this.newContractSalaryType;
        data["newSalary"] = this.newSalary;
        super.toJSON(data);
        return data;
    }

    clone(): SalaryUpdateV2RequestItemDto {
        const json = this.toJSON();
        let result = new SalaryUpdateV2RequestItemDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryUpdateV2RequestItemDto extends IPositionRequestItemDto {
    oldContractSalaryType: BasePayInputTypeV3EnumDto;
    /** Used for reporting only. */
    oldHourlySalary: number;
    /** Used for reporting only. */
    oldMonthlySalary: number;
    /** Used for reporting only. */
    oldYearlySalary: number;
    /** Used for reporting only. */
    changePercent: number;
    /** Used for reporting only. */
    changeAmount: number;
    newContractSalaryType: BasePayInputTypeV3EnumDto;
    /** Used to update the salary. Should be the result of a calculation with `changePercent` and `changeAmount`, and -- depending on `oldContractSalaryType` -- one of `oldHourlySalary`, `oldMonthlySalary` and `oldYearlySalary`.
 */
    newSalary: number;
}

/** full information about a single salary update */
export class SalaryUpdateV2OperationDto extends OperationStateDto implements ISalaryUpdateV2OperationDto {
    /** Active time of new salaries. Update will fail for employees with newer salaries. */
    activeStart!: Date;
    /** List of salaries being or having been updated */
    tasks!: SalaryUpdateV2TaskDto[];

    constructor(data?: ISalaryUpdateV2OperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(SalaryUpdateV2TaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SalaryUpdateV2OperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryUpdateV2OperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SalaryUpdateV2OperationDto {
        const json = this.toJSON();
        let result = new SalaryUpdateV2OperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single salary update */
export interface ISalaryUpdateV2OperationDto extends IOperationStateDto {
    /** Active time of new salaries. Update will fail for employees with newer salaries. */
    activeStart: Date;
    /** List of salaries being or having been updated */
    tasks: SalaryUpdateV2TaskDto[];
}

export class SalaryUpdateV2TaskDto extends SalaryUpdateV2RequestItemDto implements ISalaryUpdateV2TaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: ISalaryUpdateV2TaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): SalaryUpdateV2TaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryUpdateV2TaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): SalaryUpdateV2TaskDto {
        const json = this.toJSON();
        let result = new SalaryUpdateV2TaskDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryUpdateV2TaskDto extends ISalaryUpdateV2RequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EmployeesForPayRateUpdateResponseDto implements IEmployeesForPayRateUpdateResponseDto {
    nextToken?: string;
    employees!: EmployeeForPayRateUpdateDto[];

    constructor(data?: IEmployeesForPayRateUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employees = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeForPayRateUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesForPayRateUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesForPayRateUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesForPayRateUpdateResponseDto {
        const json = this.toJSON();
        let result = new EmployeesForPayRateUpdateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesForPayRateUpdateResponseDto {
    nextToken?: string;
    employees: EmployeeForPayRateUpdateDto[];
}

export class EmployeeForPayRateUpdateDto extends BaseRequestItemDto implements IEmployeeForPayRateUpdateDto {
    /** employment id in field engine */
    id!: string;
    /** Ordered by position start date */
    positionTimeline?: EmployeePositionItemForPayRateUpdateDto[];

    constructor(data?: IEmployeeForPayRateUpdateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["positionTimeline"])) {
                this.positionTimeline = [] as any;
                for (let item of _data["positionTimeline"])
                    this.positionTimeline!.push(EmployeePositionItemForPayRateUpdateDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EmployeeForPayRateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForPayRateUpdateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.positionTimeline)) {
            data["positionTimeline"] = [];
            for (let item of this.positionTimeline)
                data["positionTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeForPayRateUpdateDto {
        const json = this.toJSON();
        let result = new EmployeeForPayRateUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForPayRateUpdateDto extends IBaseRequestItemDto {
    /** employment id in field engine */
    id: string;
    /** Ordered by position start date */
    positionTimeline?: EmployeePositionItemForPayRateUpdateDto[];
}

/** An item in a gap timeline. An empty gap timeline is the same as the timeline not being set. If set, no items may have overlapping date ranges. */
export class GapV3TimelineItemDto implements IGapV3TimelineItemDto {
    /** Inclusive start of range.

The list of timeline items must be sorted on `from`.

Mandatory on all items except the first, where it is optional (not set means since forever).

When set, it must:
- be more than previous item's `to`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) The requirement that an explicitly specified date be within
an encompassing timeline item's date range is not validated by the monolith.
Except in the case of `layoffTimeline[].from`, probably because
"Absence" is the only field on a position using explicit fields for
the dates rather than the timeline concept.
___
 */
    from?: Date;
    /** Inclusive end of range.

Mandatory on all items except the last, where it is optional (not set means until forever).

When set, it must:
- be less than next item's `from`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    to?: Date;

    constructor(data?: IGapV3TimelineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GapV3TimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GapV3TimelineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }

    clone(): GapV3TimelineItemDto {
        const json = this.toJSON();
        let result = new GapV3TimelineItemDto();
        result.init(json);
        return result;
    }
}

/** An item in a gap timeline. An empty gap timeline is the same as the timeline not being set. If set, no items may have overlapping date ranges. */
export interface IGapV3TimelineItemDto {
    /** Inclusive start of range.

The list of timeline items must be sorted on `from`.

Mandatory on all items except the first, where it is optional (not set means since forever).

When set, it must:
- be more than previous item's `to`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) The requirement that an explicitly specified date be within
an encompassing timeline item's date range is not validated by the monolith.
Except in the case of `layoffTimeline[].from`, probably because
"Absence" is the only field on a position using explicit fields for
the dates rather than the timeline concept.
___
 */
    from?: Date;
    /** Inclusive end of range.

Mandatory on all items except the last, where it is optional (not set means until forever).

When set, it must:
- be less than next item's `from`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    to?: Date;
}

export class EmployeePositionItemForPayRateUpdateDto extends GapV3TimelineItemDto implements IEmployeePositionItemForPayRateUpdateDto {
    value!: EmployeePositionValueForPayRateUpdateDto;

    constructor(data?: IEmployeePositionItemForPayRateUpdateDto) {
        super(data);
        if (!data) {
            this.value = new EmployeePositionValueForPayRateUpdateDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeePositionValueForPayRateUpdateDto.fromJS(_data["value"]) : new EmployeePositionValueForPayRateUpdateDto();
        }
    }

    static override fromJS(data: any): EmployeePositionItemForPayRateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionItemForPayRateUpdateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeePositionItemForPayRateUpdateDto {
        const json = this.toJSON();
        let result = new EmployeePositionItemForPayRateUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionItemForPayRateUpdateDto extends IGapV3TimelineItemDto {
    value: EmployeePositionValueForPayRateUpdateDto;
}

export class EmployeePositionValueForPayRateUpdateDto implements IEmployeePositionValueForPayRateUpdateDto {
    positionId!: string;
    employmentType?: EmploymentTypeV3EnumDto;
    payRateTimeline?: EmployeeV3PayRateItemDto[];

    constructor(data?: IEmployeePositionValueForPayRateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.employmentType = _data["employmentType"];
            if (Array.isArray(_data["payRateTimeline"])) {
                this.payRateTimeline = [] as any;
                for (let item of _data["payRateTimeline"])
                    this.payRateTimeline!.push(EmployeeV3PayRateItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePositionValueForPayRateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionValueForPayRateUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["employmentType"] = this.employmentType;
        if (Array.isArray(this.payRateTimeline)) {
            data["payRateTimeline"] = [];
            for (let item of this.payRateTimeline)
                data["payRateTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeePositionValueForPayRateUpdateDto {
        const json = this.toJSON();
        let result = new EmployeePositionValueForPayRateUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionValueForPayRateUpdateDto {
    positionId: string;
    employmentType?: EmploymentTypeV3EnumDto;
    payRateTimeline?: EmployeeV3PayRateItemDto[];
}

export class PayRateUpdateRequestDto extends BaseRequestDto implements IPayRateUpdateRequestDto {
    /** Start date of new pay rates.
Update will fail for employees with a newer pay rate,
but pay rates on the same date will be overwritten.
 */
    from!: Date;
    /** List of salaries to update */
    items!: PayRateUpdateRequestItemDto[];

    constructor(data?: IPayRateUpdateRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayRateUpdateRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PayRateUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateUpdateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PayRateUpdateRequestDto {
        const json = this.toJSON();
        let result = new PayRateUpdateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPayRateUpdateRequestDto extends IBaseRequestDto {
    /** Start date of new pay rates.
Update will fail for employees with a newer pay rate,
but pay rates on the same date will be overwritten.
 */
    from: Date;
    /** List of salaries to update */
    items: PayRateUpdateRequestItemDto[];
}

export class PayRateUpdateRequestItemDto extends PositionRequestItemDto implements IPayRateUpdateRequestItemDto {
    oldRate4?: string;
    oldRate5?: string;
    oldRate6?: string;
    oldRate7?: string;
    oldRate8?: string;
    oldRate9?: string;
    newRate4?: string;
    newRate5?: string;
    newRate6?: string;
    newRate7?: string;
    newRate8?: string;
    newRate9?: string;

    constructor(data?: IPayRateUpdateRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldRate4 = _data["oldRate4"];
            this.oldRate5 = _data["oldRate5"];
            this.oldRate6 = _data["oldRate6"];
            this.oldRate7 = _data["oldRate7"];
            this.oldRate8 = _data["oldRate8"];
            this.oldRate9 = _data["oldRate9"];
            this.newRate4 = _data["newRate4"];
            this.newRate5 = _data["newRate5"];
            this.newRate6 = _data["newRate6"];
            this.newRate7 = _data["newRate7"];
            this.newRate8 = _data["newRate8"];
            this.newRate9 = _data["newRate9"];
        }
    }

    static override fromJS(data: any): PayRateUpdateRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateUpdateRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldRate4"] = this.oldRate4;
        data["oldRate5"] = this.oldRate5;
        data["oldRate6"] = this.oldRate6;
        data["oldRate7"] = this.oldRate7;
        data["oldRate8"] = this.oldRate8;
        data["oldRate9"] = this.oldRate9;
        data["newRate4"] = this.newRate4;
        data["newRate5"] = this.newRate5;
        data["newRate6"] = this.newRate6;
        data["newRate7"] = this.newRate7;
        data["newRate8"] = this.newRate8;
        data["newRate9"] = this.newRate9;
        super.toJSON(data);
        return data;
    }

    clone(): PayRateUpdateRequestItemDto {
        const json = this.toJSON();
        let result = new PayRateUpdateRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IPayRateUpdateRequestItemDto extends IPositionRequestItemDto {
    oldRate4?: string;
    oldRate5?: string;
    oldRate6?: string;
    oldRate7?: string;
    oldRate8?: string;
    oldRate9?: string;
    newRate4?: string;
    newRate5?: string;
    newRate6?: string;
    newRate7?: string;
    newRate8?: string;
    newRate9?: string;
}

/** full information about a single pay rate update */
export class PayRateUpdateOperationDto extends OperationStateDto implements IPayRateUpdateOperationDto {
    /** Start date of new pay rates. */
    from!: Date;
    tasks!: PayRateUpdateTaskDto[];

    constructor(data?: IPayRateUpdateOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(PayRateUpdateTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PayRateUpdateOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateUpdateOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PayRateUpdateOperationDto {
        const json = this.toJSON();
        let result = new PayRateUpdateOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single pay rate update */
export interface IPayRateUpdateOperationDto extends IOperationStateDto {
    /** Start date of new pay rates. */
    from: Date;
    tasks: PayRateUpdateTaskDto[];
}

export class PayRateUpdateTaskDto extends PayRateUpdateRequestItemDto implements IPayRateUpdateTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IPayRateUpdateTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): PayRateUpdateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateUpdateTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): PayRateUpdateTaskDto {
        const json = this.toJSON();
        let result = new PayRateUpdateTaskDto();
        result.init(json);
        return result;
    }
}

export interface IPayRateUpdateTaskDto extends IPayRateUpdateRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EmployeesForChangeManagerResponseDto implements IEmployeesForChangeManagerResponseDto {
    nextToken?: string;
    employees!: EmployeeForChangeManagerDto[];

    constructor(data?: IEmployeesForChangeManagerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employees = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeForChangeManagerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesForChangeManagerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesForChangeManagerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesForChangeManagerResponseDto {
        const json = this.toJSON();
        let result = new EmployeesForChangeManagerResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesForChangeManagerResponseDto {
    nextToken?: string;
    employees: EmployeeForChangeManagerDto[];
}

export class EmployeeForChangeManagerDto extends BaseRequestItemDto implements IEmployeeForChangeManagerDto {
    /** is mapped from employmentId of legacy employee structure. */
    id!: string;
    /** Not ordered */
    positions!: EmployeePositionForChangeManagerDto[];

    constructor(data?: IEmployeeForChangeManagerDto) {
        super(data);
        if (!data) {
            this.positions = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EmployeePositionForChangeManagerDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EmployeeForChangeManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForChangeManagerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeForChangeManagerDto {
        const json = this.toJSON();
        let result = new EmployeeForChangeManagerDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForChangeManagerDto extends IBaseRequestItemDto {
    /** is mapped from employmentId of legacy employee structure. */
    id: string;
    /** Not ordered */
    positions: EmployeePositionForChangeManagerDto[];
}

export class EmployeePositionForChangeManagerDto implements IEmployeePositionForChangeManagerDto {
    positionId!: string;
    activeStart!: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    /** The manager employeeId */
    managerId?: string;

    constructor(data?: IEmployeePositionForChangeManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.typeOfPosition = _data["typeOfPosition"];
            this.managerId = _data["managerId"];
        }
    }

    static fromJS(data: any): EmployeePositionForChangeManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionForChangeManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["typeOfPosition"] = this.typeOfPosition;
        data["managerId"] = this.managerId;
        return data;
    }

    clone(): EmployeePositionForChangeManagerDto {
        const json = this.toJSON();
        let result = new EmployeePositionForChangeManagerDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePositionForChangeManagerDto {
    positionId: string;
    activeStart: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
    /** The manager employeeId */
    managerId?: string;
}

export class ChangeManagerRequestDto extends BaseRequestDto implements IChangeManagerRequestDto {
    /** List of employees to change manager for */
    items!: ChangeManagerRequestItemDto[];

    constructor(data?: IChangeManagerRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangeManagerRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChangeManagerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeManagerRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChangeManagerRequestDto {
        const json = this.toJSON();
        let result = new ChangeManagerRequestDto();
        result.init(json);
        return result;
    }
}

export interface IChangeManagerRequestDto extends IBaseRequestDto {
    /** List of employees to change manager for */
    items: ChangeManagerRequestItemDto[];
}

export class ChangeManagerRequestItemDto extends PositionRequestItemDto implements IChangeManagerRequestItemDto {
    oldManagerId?: string;
    newManagerId?: string;
    activeStart?: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;

    constructor(data?: IChangeManagerRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldManagerId = _data["oldManagerId"];
            this.newManagerId = _data["newManagerId"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.typeOfPosition = _data["typeOfPosition"];
        }
    }

    static override fromJS(data: any): ChangeManagerRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeManagerRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldManagerId"] = this.oldManagerId;
        data["newManagerId"] = this.newManagerId;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["typeOfPosition"] = this.typeOfPosition;
        super.toJSON(data);
        return data;
    }

    clone(): ChangeManagerRequestItemDto {
        const json = this.toJSON();
        let result = new ChangeManagerRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IChangeManagerRequestItemDto extends IPositionRequestItemDto {
    oldManagerId?: string;
    newManagerId?: string;
    activeStart?: Date;
    activeEnd?: Date;
    typeOfPosition?: EmploymentTypeV3EnumDto;
}

/** full information about a single change manager operation */
export class ChangeManagerOperationDto extends OperationStateDto implements IChangeManagerOperationDto {
    /** List of change manager tasks being or having been updated */
    tasks!: ChangeManagerTaskDto[];

    constructor(data?: IChangeManagerOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ChangeManagerTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChangeManagerOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeManagerOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChangeManagerOperationDto {
        const json = this.toJSON();
        let result = new ChangeManagerOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single change manager operation */
export interface IChangeManagerOperationDto extends IOperationStateDto {
    /** List of change manager tasks being or having been updated */
    tasks: ChangeManagerTaskDto[];
}

export class ChangeManagerTaskDto extends ChangeManagerRequestItemDto implements IChangeManagerTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;

    constructor(data?: IChangeManagerTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
        }
    }

    static override fromJS(data: any): ChangeManagerTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeManagerTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        super.toJSON(data);
        return data;
    }

    clone(): ChangeManagerTaskDto {
        const json = this.toJSON();
        let result = new ChangeManagerTaskDto();
        result.init(json);
        return result;
    }
}

export interface IChangeManagerTaskDto extends IChangeManagerRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
}

export class EmployeesForAssignUserResponseDto implements IEmployeesForAssignUserResponseDto {
    nextToken?: string;
    employees!: EmployeeForAssignUserDto[];

    constructor(data?: IEmployeesForAssignUserResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employees = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeForAssignUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesForAssignUserResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesForAssignUserResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesForAssignUserResponseDto {
        const json = this.toJSON();
        let result = new EmployeesForAssignUserResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesForAssignUserResponseDto {
    nextToken?: string;
    employees: EmployeeForAssignUserDto[];
}

export class EmployeeForAssignUserDto extends BaseRequestItemDto implements IEmployeeForAssignUserDto {
    id!: string;
    /** Set when user has been fully created and assigned.
 */
    odpUserId?: string;
    /** Unordered list of addresses already assigned to the employee.

Note that this list may be empty (but it will always be set).

If the employee already has a user, the user's email is in this list.
If there are multiple addresses then it is unknown which of them is used for the user.
(The field engine knows, but not the Employee API).

An address is unique in the list and will not exist with two different types.
 */
    emails!: EmployeeForAssignUserEmailDto[];

    constructor(data?: IEmployeeForAssignUserDto) {
        super(data);
        if (!data) {
            this.emails = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.odpUserId = _data["odpUserId"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmployeeForAssignUserEmailDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EmployeeForAssignUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForAssignUserDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["odpUserId"] = this.odpUserId;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeForAssignUserDto {
        const json = this.toJSON();
        let result = new EmployeeForAssignUserDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForAssignUserDto extends IBaseRequestItemDto {
    id: string;
    /** Set when user has been fully created and assigned.
 */
    odpUserId?: string;
    /** Unordered list of addresses already assigned to the employee.

Note that this list may be empty (but it will always be set).

If the employee already has a user, the user's email is in this list.
If there are multiple addresses then it is unknown which of them is used for the user.
(The field engine knows, but not the Employee API).

An address is unique in the list and will not exist with two different types.
 */
    emails: EmployeeForAssignUserEmailDto[];
}

export class EmployeeForAssignUserEmailDto implements IEmployeeForAssignUserEmailDto {
    type!: EmailTypeV3EnumDto;
    address!: string;

    constructor(data?: IEmployeeForAssignUserEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): EmployeeForAssignUserEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeForAssignUserEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["address"] = this.address;
        return data;
    }

    clone(): EmployeeForAssignUserEmailDto {
        const json = this.toJSON();
        let result = new EmployeeForAssignUserEmailDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeForAssignUserEmailDto {
    type: EmailTypeV3EnumDto;
    address: string;
}

export class AssignUserRequestDto extends BaseRequestDto implements IAssignUserRequestDto {
    /** List of employees and e-mails to create/assign users for. */
    items!: AssignUserRequestItemDto[];

    constructor(data?: IAssignUserRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssignUserRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AssignUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AssignUserRequestDto {
        const json = this.toJSON();
        let result = new AssignUserRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAssignUserRequestDto extends IBaseRequestDto {
    /** List of employees and e-mails to create/assign users for. */
    items: AssignUserRequestItemDto[];
}

export class AssignUserRequestItemDto extends BaseRequestItemDto implements IAssignUserRequestItemDto {
    employeeId!: string;
    /** Must be set to odpUserId assigned to employee before this operation, if any.
 */
    oldOdpUserId?: string;
    /** Whether `emailAddress` is a new address that was added in the operation,
rather than an e-mail address already stored on the employee.
 */
    isNewEmail!: boolean;
    /** Whether this request is to unlink a user.
That could be derived from `emailAddress` not being set, but this property must
also be set to avoid accidentally unlinking a user from a bug where `emailAddress` is not.

When `true`:
- `oldOdpUserId` MUST have a value (but it's only used for logging)
- `emailAddress` must NOT have a value
- `isNewEmail` MUST be `false`

When `false`:
- `oldOdpUserId` MAY or MAY NOT have a value
  (depending on whether a user is being replaced or just created)
- `emailAddress` MUST have a value
- `isNewEmail` may have any value
 */
    isUnlinking!: boolean;
    /** E-mail address for the user.

If not set, user will be unassigned from employee.
If this employee was used as a manager, manager will also be unlinked (data loss).
If this employee has no user (eg. task already executed), nothing happens.

If a user already exists with this e-mail:
- If the user is already assigned to this employee, nothing is done but task succeeds.
- If the user is already assigned to another employee in this company it
  cannot be reused and the task will fail.
- Otherwise the user could be assigned to this employee if the administrator
  confirms it explicitly.
  - By setting `linkIfExistingUser`. Currently it is not known up front whether a user exists.
  - The problem with reusing users is that the e-mail could have been entered wrong now
    or it could have belonged to someone else previously.
  - In either case it can cause a privacy incident because payslips are stored for a user,
    not for an employee.
  - Note that the user's name will be set to this employee's name,
    so if the existing user is in use by another employee in another company,
    that employee will enter an error state unless its name matches this employee's name.

If no user exists with this e-mail, a new user will be created and then
assigned to this employee.

If the employee does not have this e-mail address already, it will be added
to the employee's emails when the user is created.

If employee already had a user assigned, that user will be unassigned.
If this employee was used as a manager, it will be unlinked (data loss).
Previous user will lose access to payslips.
 */
    emailAddress?: string;
    /** If true, the user will be assigned to the employee even if the user already exists.
If false or undefined, the task will fail if the user already exists.
 */
    linkIfExistingUser?: boolean;

    constructor(data?: IAssignUserRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.oldOdpUserId = _data["oldOdpUserId"];
            this.isNewEmail = _data["isNewEmail"];
            this.isUnlinking = _data["isUnlinking"];
            this.emailAddress = _data["emailAddress"];
            this.linkIfExistingUser = _data["linkIfExistingUser"];
        }
    }

    static override fromJS(data: any): AssignUserRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["oldOdpUserId"] = this.oldOdpUserId;
        data["isNewEmail"] = this.isNewEmail;
        data["isUnlinking"] = this.isUnlinking;
        data["emailAddress"] = this.emailAddress;
        data["linkIfExistingUser"] = this.linkIfExistingUser;
        super.toJSON(data);
        return data;
    }

    clone(): AssignUserRequestItemDto {
        const json = this.toJSON();
        let result = new AssignUserRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IAssignUserRequestItemDto extends IBaseRequestItemDto {
    employeeId: string;
    /** Must be set to odpUserId assigned to employee before this operation, if any.
 */
    oldOdpUserId?: string;
    /** Whether `emailAddress` is a new address that was added in the operation,
rather than an e-mail address already stored on the employee.
 */
    isNewEmail: boolean;
    /** Whether this request is to unlink a user.
That could be derived from `emailAddress` not being set, but this property must
also be set to avoid accidentally unlinking a user from a bug where `emailAddress` is not.

When `true`:
- `oldOdpUserId` MUST have a value (but it's only used for logging)
- `emailAddress` must NOT have a value
- `isNewEmail` MUST be `false`

When `false`:
- `oldOdpUserId` MAY or MAY NOT have a value
  (depending on whether a user is being replaced or just created)
- `emailAddress` MUST have a value
- `isNewEmail` may have any value
 */
    isUnlinking: boolean;
    /** E-mail address for the user.

If not set, user will be unassigned from employee.
If this employee was used as a manager, manager will also be unlinked (data loss).
If this employee has no user (eg. task already executed), nothing happens.

If a user already exists with this e-mail:
- If the user is already assigned to this employee, nothing is done but task succeeds.
- If the user is already assigned to another employee in this company it
  cannot be reused and the task will fail.
- Otherwise the user could be assigned to this employee if the administrator
  confirms it explicitly.
  - By setting `linkIfExistingUser`. Currently it is not known up front whether a user exists.
  - The problem with reusing users is that the e-mail could have been entered wrong now
    or it could have belonged to someone else previously.
  - In either case it can cause a privacy incident because payslips are stored for a user,
    not for an employee.
  - Note that the user's name will be set to this employee's name,
    so if the existing user is in use by another employee in another company,
    that employee will enter an error state unless its name matches this employee's name.

If no user exists with this e-mail, a new user will be created and then
assigned to this employee.

If the employee does not have this e-mail address already, it will be added
to the employee's emails when the user is created.

If employee already had a user assigned, that user will be unassigned.
If this employee was used as a manager, it will be unlinked (data loss).
Previous user will lose access to payslips.
 */
    emailAddress?: string;
    /** If true, the user will be assigned to the employee even if the user already exists.
If false or undefined, the task will fail if the user already exists.
 */
    linkIfExistingUser?: boolean;
}

/** full information about a single user assignment operation */
export class AssignUserOperationDto extends OperationStateDto implements IAssignUserOperationDto {
    /** List of employees being assigned user */
    tasks!: AssignUserTaskDto[];

    constructor(data?: IAssignUserOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AssignUserTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AssignUserOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AssignUserOperationDto {
        const json = this.toJSON();
        let result = new AssignUserOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single user assignment operation */
export interface IAssignUserOperationDto extends IOperationStateDto {
    /** List of employees being assigned user */
    tasks: AssignUserTaskDto[];
}

export class AssignUserTaskDto extends AssignUserRequestItemDto implements IAssignUserTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;
    /** Additional information about the state of the task. This is only set if the task is in a state where additional information is needed. The keys and values are specific to the task and state.
 */
    statusDetails?: AssignUserTaskStatusDetailsDto;

    constructor(data?: IAssignUserTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
            this.statusDetails = _data["statusDetails"] ? AssignUserTaskStatusDetailsDto.fromJS(_data["statusDetails"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AssignUserTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        data["statusDetails"] = this.statusDetails ? this.statusDetails.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssignUserTaskDto {
        const json = this.toJSON();
        let result = new AssignUserTaskDto();
        result.init(json);
        return result;
    }
}

export interface IAssignUserTaskDto extends IAssignUserRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
    /** Additional information about the state of the task. This is only set if the task is in a state where additional information is needed. The keys and values are specific to the task and state.
 */
    statusDetails?: AssignUserTaskStatusDetailsDto;
}

/** This is only set if the task is in a status where additional information is needed. */
export class AssignUserTaskStatusDetailsDto implements IAssignUserTaskStatusDetailsDto {
    /** If set, this is a code for an error that should be localized in the frontend and displayed instead of the `error` property.
 */
    errorCode?: string;

    constructor(data?: IAssignUserTaskStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): AssignUserTaskStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserTaskStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): AssignUserTaskStatusDetailsDto {
        const json = this.toJSON();
        let result = new AssignUserTaskStatusDetailsDto();
        result.init(json);
        return result;
    }
}

/** This is only set if the task is in a status where additional information is needed. */
export interface IAssignUserTaskStatusDetailsDto {
    /** If set, this is a code for an error that should be localized in the frontend and displayed instead of the `error` property.
 */
    errorCode?: string;
}

/** - `userExists`: A user already exists with this email and `linkIfExistingUser` was not set. - `alreadyUsedInCompany`: The user with this email is already used by another employee in this company. */
export enum AssignUserTaskStatusDetailsEnumDto {
    UserExists = "userExists",
    AlreadyUsedInCompany = "alreadyUsedInCompany",
}

/** A list of all cars that are used on or after the requested date. Car pools are included, to simplify retrieval. Usage by draft employees is also included. This is consistent with the vintage UI and the field engine, which both considers a car used by a draft employee as in use. To find available cars on `activeDate`: 1. Get all cars from item cache 2. For each car in `usage`  1. If the car is already in use by the employee on `activeDate`, it is available and     the remaining sub-items do not apply.  2. If the car is a car pool, it is available.  3. If non-pool and `usageTimeline[0].from <= activeDate`, it is unavailable.  4. If non-pool and `usageTimeline[0].from > activeDate`, it is available until the day before `from`. Tip: Report the number of current car pool users by counting `usageTimeline` items with ranges `activeDate` within their range. */
export class CarUsageResponseDto implements ICarUsageResponseDto {
    activeDate!: Date;
    usedCars!: UsedCarDto[];

    constructor(data?: ICarUsageResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.usedCars = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : undefined as any;
            if (Array.isArray(_data["usedCars"])) {
                this.usedCars = [] as any;
                for (let item of _data["usedCars"])
                    this.usedCars!.push(UsedCarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarUsageResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarUsageResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeDate"] = this.activeDate ? formatDate(this.activeDate) : undefined as any;
        if (Array.isArray(this.usedCars)) {
            data["usedCars"] = [];
            for (let item of this.usedCars)
                data["usedCars"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CarUsageResponseDto {
        const json = this.toJSON();
        let result = new CarUsageResponseDto();
        result.init(json);
        return result;
    }
}

/** A list of all cars that are used on or after the requested date. Car pools are included, to simplify retrieval. Usage by draft employees is also included. This is consistent with the vintage UI and the field engine, which both considers a car used by a draft employee as in use. To find available cars on `activeDate`: 1. Get all cars from item cache 2. For each car in `usage`  1. If the car is already in use by the employee on `activeDate`, it is available and     the remaining sub-items do not apply.  2. If the car is a car pool, it is available.  3. If non-pool and `usageTimeline[0].from <= activeDate`, it is unavailable.  4. If non-pool and `usageTimeline[0].from > activeDate`, it is available until the day before `from`. Tip: Report the number of current car pool users by counting `usageTimeline` items with ranges `activeDate` within their range. */
export interface ICarUsageResponseDto {
    activeDate: Date;
    usedCars: UsedCarDto[];
}

/** A car and a timeline of its usage on or after `activeDate`. Car pools will have overlap timelines, while non-pool cars will have gap timelines. `usageTimeline` is guaranteed to have at least one item. The first `from` date may be before `activeDate`, since the it is simply the link's `from` date. Only links with a `to` date equal to or after `activeDate` are included. */
export class UsedCarDto implements IUsedCarDto {
    /** Unique. */
    carId!: string;
    usageTimeline!: CarUsageItemDto[];

    constructor(data?: IUsedCarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.usageTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carId = _data["carId"];
            if (Array.isArray(_data["usageTimeline"])) {
                this.usageTimeline = [] as any;
                for (let item of _data["usageTimeline"])
                    this.usageTimeline!.push(CarUsageItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsedCarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsedCarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carId"] = this.carId;
        if (Array.isArray(this.usageTimeline)) {
            data["usageTimeline"] = [];
            for (let item of this.usageTimeline)
                data["usageTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UsedCarDto {
        const json = this.toJSON();
        let result = new UsedCarDto();
        result.init(json);
        return result;
    }
}

/** A car and a timeline of its usage on or after `activeDate`. Car pools will have overlap timelines, while non-pool cars will have gap timelines. `usageTimeline` is guaranteed to have at least one item. The first `from` date may be before `activeDate`, since the it is simply the link's `from` date. Only links with a `to` date equal to or after `activeDate` are included. */
export interface IUsedCarDto {
    /** Unique. */
    carId: string;
    usageTimeline: CarUsageItemDto[];
}

/** An item in an overlap timeline. An empty overlap timeline is the same as the timeline not being set. Any item's range may overlap with any other item, except specific timelines may require that a property within the value is unique on a given day. */
export class OverlapV3TimelineItemDto implements IOverlapV3TimelineItemDto {
    /** Inclusive start of range.

The list of timeline items must be sorted on `from`.

In principle optional, but currently mandatory both places an overlap timeline is used.
Not set mean since forever.

When set, it must:
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    from?: Date;
    /** Inclusive end of range.

Optional on all items (not set means until forever).

When set, it must:
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    to?: Date;

    constructor(data?: IOverlapV3TimelineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OverlapV3TimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverlapV3TimelineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }

    clone(): OverlapV3TimelineItemDto {
        const json = this.toJSON();
        let result = new OverlapV3TimelineItemDto();
        result.init(json);
        return result;
    }
}

/** An item in an overlap timeline. An empty overlap timeline is the same as the timeline not being set. Any item's range may overlap with any other item, except specific timelines may require that a property within the value is unique on a given day. */
export interface IOverlapV3TimelineItemDto {
    /** Inclusive start of range.

The list of timeline items must be sorted on `from`.

In principle optional, but currently mandatory both places an overlap timeline is used.
Not set mean since forever.

When set, it must:
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    from?: Date;
    /** Inclusive end of range.

Optional on all items (not set means until forever).

When set, it must:
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    to?: Date;
}

export class CarUsageItemDto extends OverlapV3TimelineItemDto implements ICarUsageItemDto {
    value!: CarUsageValueDto;

    constructor(data?: ICarUsageItemDto) {
        super(data);
        if (!data) {
            this.value = new CarUsageValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? CarUsageValueDto.fromJS(_data["value"]) : new CarUsageValueDto();
        }
    }

    static override fromJS(data: any): CarUsageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarUsageItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): CarUsageItemDto {
        const json = this.toJSON();
        let result = new CarUsageItemDto();
        result.init(json);
        return result;
    }
}

export interface ICarUsageItemDto extends IOverlapV3TimelineItemDto {
    value: CarUsageValueDto;
}

export class CarUsageValueDto implements ICarUsageValueDto {
    /** The employee the car is assigned to in this period.
 */
    employeeId!: string;

    constructor(data?: ICarUsageValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): CarUsageValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarUsageValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        return data;
    }

    clone(): CarUsageValueDto {
        const json = this.toJSON();
        let result = new CarUsageValueDto();
        result.init(json);
        return result;
    }
}

export interface ICarUsageValueDto {
    /** The employee the car is assigned to in this period.
 */
    employeeId: string;
}

export class OkEmployeeActionResponseDto implements IOkEmployeeActionResponseDto {
    /** Action v3 id, if not set the employee already has requested data and action was not created. */
    id?: string;
    /** `true` when existing data already matches request (response code 200), `false` when job has been submitted (response code 201).
 */
    hasNoWork?: boolean;
    /** List of next actions for the created action. */
    nextActions?: ActionV3NextActionType[];
    /** Correlation ID of the client instance that created the action */
    sessionCorrelationId!: string;
    /** Correlation ID of the client call that created the action */
    callCorrelationId!: string;

    constructor(data?: IOkEmployeeActionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasNoWork = _data["hasNoWork"];
            if (Array.isArray(_data["nextActions"])) {
                this.nextActions = [] as any;
                for (let item of _data["nextActions"])
                    this.nextActions!.push(item);
            }
            this.sessionCorrelationId = _data["sessionCorrelationId"];
            this.callCorrelationId = _data["callCorrelationId"];
        }
    }

    static fromJS(data: any): OkEmployeeActionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OkEmployeeActionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasNoWork"] = this.hasNoWork;
        if (Array.isArray(this.nextActions)) {
            data["nextActions"] = [];
            for (let item of this.nextActions)
                data["nextActions"].push(item);
        }
        data["sessionCorrelationId"] = this.sessionCorrelationId;
        data["callCorrelationId"] = this.callCorrelationId;
        return data;
    }

    clone(): OkEmployeeActionResponseDto {
        const json = this.toJSON();
        let result = new OkEmployeeActionResponseDto();
        result.init(json);
        return result;
    }
}

export interface IOkEmployeeActionResponseDto {
    /** Action v3 id, if not set the employee already has requested data and action was not created. */
    id?: string;
    /** `true` when existing data already matches request (response code 200), `false` when job has been submitted (response code 201).
 */
    hasNoWork?: boolean;
    /** List of next actions for the created action. */
    nextActions?: ActionV3NextActionType[];
    /** Correlation ID of the client instance that created the action */
    sessionCorrelationId: string;
    /** Correlation ID of the client call that created the action */
    callCorrelationId: string;
}

export class ActionV3EmployeeProperties implements IActionV3EmployeeProperties {
    additionalInformation?: ActionV3AdditionalInformationRequestDto;
    assignUser?: ActionV3AssignUserRequestDto;
    children?: ActionV3ChildrenRequestDto;
    chronicallyIll?: ActionV3ChronicallyIllRequestDto;
    emergencyContacts?: ActionV3EmergencyContactsRequestDto;
    payslipAndPayment?: ActionV3PayslipAndPaymentRequestDto;
    personalDetails?: ActionV3PersonalDetailsRequestDto;
    taxAndTaxCard?: ActionV3TaxAndTaxCardRequestDto;
    creditorClaims?: ActionV3CreditorClaimsRequestDto;
    cars?: ActionV3CarsRequestDto;
    pensionCompanies?: ActionV3PensionCompaniesRequestDto;
    unions?: ActionV3UnionsRequestDto;
    employmentAgreements?: ActionV3EmploymentAgreementsRequestDto;

    constructor(data?: IActionV3EmployeeProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalInformation = _data["additionalInformation"] ? ActionV3AdditionalInformationRequestDto.fromJS(_data["additionalInformation"]) : undefined as any;
            this.assignUser = _data["assignUser"] ? ActionV3AssignUserRequestDto.fromJS(_data["assignUser"]) : undefined as any;
            this.children = _data["children"] ? ActionV3ChildrenRequestDto.fromJS(_data["children"]) : undefined as any;
            this.chronicallyIll = _data["chronicallyIll"] ? ActionV3ChronicallyIllRequestDto.fromJS(_data["chronicallyIll"]) : undefined as any;
            this.emergencyContacts = _data["emergencyContacts"] ? ActionV3EmergencyContactsRequestDto.fromJS(_data["emergencyContacts"]) : undefined as any;
            this.payslipAndPayment = _data["payslipAndPayment"] ? ActionV3PayslipAndPaymentRequestDto.fromJS(_data["payslipAndPayment"]) : undefined as any;
            this.personalDetails = _data["personalDetails"] ? ActionV3PersonalDetailsRequestDto.fromJS(_data["personalDetails"]) : undefined as any;
            this.taxAndTaxCard = _data["taxAndTaxCard"] ? ActionV3TaxAndTaxCardRequestDto.fromJS(_data["taxAndTaxCard"]) : undefined as any;
            this.creditorClaims = _data["creditorClaims"] ? ActionV3CreditorClaimsRequestDto.fromJS(_data["creditorClaims"]) : undefined as any;
            this.cars = _data["cars"] ? ActionV3CarsRequestDto.fromJS(_data["cars"]) : undefined as any;
            this.pensionCompanies = _data["pensionCompanies"] ? ActionV3PensionCompaniesRequestDto.fromJS(_data["pensionCompanies"]) : undefined as any;
            this.unions = _data["unions"] ? ActionV3UnionsRequestDto.fromJS(_data["unions"]) : undefined as any;
            this.employmentAgreements = _data["employmentAgreements"] ? ActionV3EmploymentAgreementsRequestDto.fromJS(_data["employmentAgreements"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3EmployeeProperties {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeeProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInformation"] = this.additionalInformation ? this.additionalInformation.toJSON() : undefined as any;
        data["assignUser"] = this.assignUser ? this.assignUser.toJSON() : undefined as any;
        data["children"] = this.children ? this.children.toJSON() : undefined as any;
        data["chronicallyIll"] = this.chronicallyIll ? this.chronicallyIll.toJSON() : undefined as any;
        data["emergencyContacts"] = this.emergencyContacts ? this.emergencyContacts.toJSON() : undefined as any;
        data["payslipAndPayment"] = this.payslipAndPayment ? this.payslipAndPayment.toJSON() : undefined as any;
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : undefined as any;
        data["taxAndTaxCard"] = this.taxAndTaxCard ? this.taxAndTaxCard.toJSON() : undefined as any;
        data["creditorClaims"] = this.creditorClaims ? this.creditorClaims.toJSON() : undefined as any;
        data["cars"] = this.cars ? this.cars.toJSON() : undefined as any;
        data["pensionCompanies"] = this.pensionCompanies ? this.pensionCompanies.toJSON() : undefined as any;
        data["unions"] = this.unions ? this.unions.toJSON() : undefined as any;
        data["employmentAgreements"] = this.employmentAgreements ? this.employmentAgreements.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3EmployeeProperties {
        const json = this.toJSON();
        let result = new ActionV3EmployeeProperties();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeeProperties {
    additionalInformation?: ActionV3AdditionalInformationRequestDto;
    assignUser?: ActionV3AssignUserRequestDto;
    children?: ActionV3ChildrenRequestDto;
    chronicallyIll?: ActionV3ChronicallyIllRequestDto;
    emergencyContacts?: ActionV3EmergencyContactsRequestDto;
    payslipAndPayment?: ActionV3PayslipAndPaymentRequestDto;
    personalDetails?: ActionV3PersonalDetailsRequestDto;
    taxAndTaxCard?: ActionV3TaxAndTaxCardRequestDto;
    creditorClaims?: ActionV3CreditorClaimsRequestDto;
    cars?: ActionV3CarsRequestDto;
    pensionCompanies?: ActionV3PensionCompaniesRequestDto;
    unions?: ActionV3UnionsRequestDto;
    employmentAgreements?: ActionV3EmploymentAgreementsRequestDto;
}

export class ActionV3EmployeeCreateRequestDto extends ActionV3EmployeeProperties implements IActionV3EmployeeCreateRequestDto {
    isDraft!: boolean;
    employeeNumber!: string;
    position?: ActionV3EmployeePositionCreateRequestDto;

    constructor(data?: IActionV3EmployeeCreateRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDraft = _data["isDraft"];
            this.employeeNumber = _data["employeeNumber"];
            this.position = _data["position"] ? ActionV3EmployeePositionCreateRequestDto.fromJS(_data["position"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ActionV3EmployeeCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeeCreateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDraft"] = this.isDraft;
        data["employeeNumber"] = this.employeeNumber;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3EmployeeCreateRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmployeeCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeeCreateRequestDto extends IActionV3EmployeeProperties {
    isDraft: boolean;
    employeeNumber: string;
    position?: ActionV3EmployeePositionCreateRequestDto;
}

export class ActionV3EmployeeRehireRequestDto extends ActionV3EmployeeProperties implements IActionV3EmployeeRehireRequestDto {
    version!: string;
    employeeId!: string;
    employeeNumber!: string;
    newPosition!: ActionV3EmployeePositionCreateRequestDto;

    constructor(data?: IActionV3EmployeeRehireRequestDto) {
        super(data);
        if (!data) {
            this.newPosition = new ActionV3EmployeePositionCreateRequestDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.version = _data["version"];
            this.employeeId = _data["employeeId"];
            this.employeeNumber = _data["employeeNumber"];
            this.newPosition = _data["newPosition"] ? ActionV3EmployeePositionCreateRequestDto.fromJS(_data["newPosition"]) : new ActionV3EmployeePositionCreateRequestDto();
        }
    }

    static override fromJS(data: any): ActionV3EmployeeRehireRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeeRehireRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["employeeId"] = this.employeeId;
        data["employeeNumber"] = this.employeeNumber;
        data["newPosition"] = this.newPosition ? this.newPosition.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3EmployeeRehireRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmployeeRehireRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeeRehireRequestDto extends IActionV3EmployeeProperties {
    version: string;
    employeeId: string;
    employeeNumber: string;
    newPosition: ActionV3EmployeePositionCreateRequestDto;
}

/** Currently version is not used, but left in case necessary changes in employee API are made */
export class ActionV3EmployeeEditRequestDto extends ActionV3EmployeeProperties implements IActionV3EmployeeEditRequestDto {
    version!: string;
    isDraft!: boolean;
    employeeId!: string;
    employeeNumber!: string;
    positions?: ActionV3EmployeePositionEditRequestDto[];

    constructor(data?: IActionV3EmployeeEditRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.version = _data["version"];
            this.isDraft = _data["isDraft"];
            this.employeeId = _data["employeeId"];
            this.employeeNumber = _data["employeeNumber"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(ActionV3EmployeePositionEditRequestDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ActionV3EmployeeEditRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeeEditRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["isDraft"] = this.isDraft;
        data["employeeId"] = this.employeeId;
        data["employeeNumber"] = this.employeeNumber;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3EmployeeEditRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmployeeEditRequestDto();
        result.init(json);
        return result;
    }
}

/** Currently version is not used, but left in case necessary changes in employee API are made */
export interface IActionV3EmployeeEditRequestDto extends IActionV3EmployeeProperties {
    version: string;
    isDraft: boolean;
    employeeId: string;
    employeeNumber: string;
    positions?: ActionV3EmployeePositionEditRequestDto[];
}

export class ActionV3EmployeeDeleteRequestDto implements IActionV3EmployeeDeleteRequestDto {
    version!: string;
    employeeId!: string;
    employeeNumber!: string;

    constructor(data?: IActionV3EmployeeDeleteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.employeeId = _data["employeeId"];
            this.employeeNumber = _data["employeeNumber"];
        }
    }

    static fromJS(data: any): ActionV3EmployeeDeleteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeeDeleteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["employeeId"] = this.employeeId;
        data["employeeNumber"] = this.employeeNumber;
        return data;
    }

    clone(): ActionV3EmployeeDeleteRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmployeeDeleteRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeeDeleteRequestDto {
    version: string;
    employeeId: string;
    employeeNumber: string;
}

export class ActionV3EmployeePositionProperties implements IActionV3EmployeePositionProperties {
    costUnits?: ActionV3CostUnitsRequestDto;
    employment?: ActionV3EmploymentRequestDto;
    manager?: ActionV3ManagerRequestDto;
    nav?: ActionV3NavRequestDto;
    salary?: ActionV3SalaryRequestDto;
    tags?: ActionV3TagsRequestDto;

    constructor(data?: IActionV3EmployeePositionProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costUnits = _data["costUnits"] ? ActionV3CostUnitsRequestDto.fromJS(_data["costUnits"]) : undefined as any;
            this.employment = _data["employment"] ? ActionV3EmploymentRequestDto.fromJS(_data["employment"]) : undefined as any;
            this.manager = _data["manager"] ? ActionV3ManagerRequestDto.fromJS(_data["manager"]) : undefined as any;
            this.nav = _data["nav"] ? ActionV3NavRequestDto.fromJS(_data["nav"]) : undefined as any;
            this.salary = _data["salary"] ? ActionV3SalaryRequestDto.fromJS(_data["salary"]) : undefined as any;
            this.tags = _data["tags"] ? ActionV3TagsRequestDto.fromJS(_data["tags"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3EmployeePositionProperties {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeePositionProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costUnits"] = this.costUnits ? this.costUnits.toJSON() : undefined as any;
        data["employment"] = this.employment ? this.employment.toJSON() : undefined as any;
        data["manager"] = this.manager ? this.manager.toJSON() : undefined as any;
        data["nav"] = this.nav ? this.nav.toJSON() : undefined as any;
        data["salary"] = this.salary ? this.salary.toJSON() : undefined as any;
        data["tags"] = this.tags ? this.tags.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3EmployeePositionProperties {
        const json = this.toJSON();
        let result = new ActionV3EmployeePositionProperties();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeePositionProperties {
    costUnits?: ActionV3CostUnitsRequestDto;
    employment?: ActionV3EmploymentRequestDto;
    manager?: ActionV3ManagerRequestDto;
    nav?: ActionV3NavRequestDto;
    salary?: ActionV3SalaryRequestDto;
    tags?: ActionV3TagsRequestDto;
}

export class ActionV3EmployeePositionCreateRequestDto extends ActionV3EmployeePositionProperties implements IActionV3EmployeePositionCreateRequestDto {

    constructor(data?: IActionV3EmployeePositionCreateRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ActionV3EmployeePositionCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeePositionCreateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3EmployeePositionCreateRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmployeePositionCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeePositionCreateRequestDto extends IActionV3EmployeePositionProperties {
}

export class ActionV3EmployeePositionEditRequestDto extends ActionV3EmployeePositionProperties implements IActionV3EmployeePositionEditRequestDto {
    /** Required when editing an existing position.
Omit when creating a new position for a draft employee without positions.
 */
    positionId?: string;

    constructor(data?: IActionV3EmployeePositionEditRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.positionId = _data["positionId"];
        }
    }

    static override fromJS(data: any): ActionV3EmployeePositionEditRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmployeePositionEditRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3EmployeePositionEditRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmployeePositionEditRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmployeePositionEditRequestDto extends IActionV3EmployeePositionProperties {
    /** Required when editing an existing position.
Omit when creating a new position for a draft employee without positions.
 */
    positionId?: string;
}

/** Additional information consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export class ActionV3AdditionalInformationRequestDto implements IActionV3AdditionalInformationRequestDto {
    static!: ActionV3StaticAdditionalInformationDto;

    constructor(data?: IActionV3AdditionalInformationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticAdditionalInformationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticAdditionalInformationDto.fromJS(_data["static"]) : new ActionV3StaticAdditionalInformationDto();
        }
    }

    static fromJS(data: any): ActionV3AdditionalInformationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3AdditionalInformationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3AdditionalInformationRequestDto {
        const json = this.toJSON();
        let result = new ActionV3AdditionalInformationRequestDto();
        result.init(json);
        return result;
    }
}

/** Additional information consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export interface IActionV3AdditionalInformationRequestDto {
    static: ActionV3StaticAdditionalInformationDto;
}

export class ActionV3StaticAdditionalInformationDto implements IActionV3StaticAdditionalInformationDto {
    notes?: string;
    mergedCompanyStartDate?: Date;

    constructor(data?: IActionV3StaticAdditionalInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notes = _data["notes"];
            this.mergedCompanyStartDate = _data["mergedCompanyStartDate"] ? new Date(_data["mergedCompanyStartDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3StaticAdditionalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticAdditionalInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notes"] = this.notes;
        data["mergedCompanyStartDate"] = this.mergedCompanyStartDate ? formatDate(this.mergedCompanyStartDate) : undefined as any;
        return data;
    }

    clone(): ActionV3StaticAdditionalInformationDto {
        const json = this.toJSON();
        let result = new ActionV3StaticAdditionalInformationDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticAdditionalInformationDto {
    notes?: string;
    mergedCompanyStartDate?: Date;
}

/** If set an additional action will be initiated to assign a user to the newly created or an existing employee. If user creation fails, the assign user action will not be triggered. WebSocket messages `AssignUserActionCreated` and `AssignUserActionInitiated` will be sent when this action is created and when empman has accepted or rejected request. */
export class ActionV3AssignUserRequestDto implements IActionV3AssignUserRequestDto {
    static!: ActionV3StaticAssignUserRequestDto;

    constructor(data?: IActionV3AssignUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticAssignUserRequestDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticAssignUserRequestDto.fromJS(_data["static"]) : new ActionV3StaticAssignUserRequestDto();
        }
    }

    static fromJS(data: any): ActionV3AssignUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3AssignUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3AssignUserRequestDto {
        const json = this.toJSON();
        let result = new ActionV3AssignUserRequestDto();
        result.init(json);
        return result;
    }
}

/** If set an additional action will be initiated to assign a user to the newly created or an existing employee. If user creation fails, the assign user action will not be triggered. WebSocket messages `AssignUserActionCreated` and `AssignUserActionInitiated` will be sent when this action is created and when empman has accepted or rejected request. */
export interface IActionV3AssignUserRequestDto {
    static: ActionV3StaticAssignUserRequestDto;
}

export class ActionV3StaticAssignUserRequestDto implements IActionV3StaticAssignUserRequestDto {
    emailAddress?: string;
    linkIfExistingUser?: boolean;
    isUnlinking!: boolean;
    /** If set used to decide whether an existing user is already assigned. */
    oldOdpUserId?: string;

    constructor(data?: IActionV3StaticAssignUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.linkIfExistingUser = _data["linkIfExistingUser"];
            this.isUnlinking = _data["isUnlinking"];
            this.oldOdpUserId = _data["oldOdpUserId"];
        }
    }

    static fromJS(data: any): ActionV3StaticAssignUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticAssignUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["linkIfExistingUser"] = this.linkIfExistingUser;
        data["isUnlinking"] = this.isUnlinking;
        data["oldOdpUserId"] = this.oldOdpUserId;
        return data;
    }

    clone(): ActionV3StaticAssignUserRequestDto {
        const json = this.toJSON();
        let result = new ActionV3StaticAssignUserRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticAssignUserRequestDto {
    emailAddress?: string;
    linkIfExistingUser?: boolean;
    isUnlinking: boolean;
    /** If set used to decide whether an existing user is already assigned. */
    oldOdpUserId?: string;
}

/** Children group consist of list of children with both temporal and static properties. */
export class ActionV3ChildrenRequestDto implements IActionV3ChildrenRequestDto {
    childrenList!: ActionV3ChildrenRequestItemDto[];

    constructor(data?: IActionV3ChildrenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.childrenList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["childrenList"])) {
                this.childrenList = [] as any;
                for (let item of _data["childrenList"])
                    this.childrenList!.push(ActionV3ChildrenRequestItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3ChildrenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3ChildrenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenList)) {
            data["childrenList"] = [];
            for (let item of this.childrenList)
                data["childrenList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3ChildrenRequestDto {
        const json = this.toJSON();
        let result = new ActionV3ChildrenRequestDto();
        result.init(json);
        return result;
    }
}

/** Children group consist of list of children with both temporal and static properties. */
export interface IActionV3ChildrenRequestDto {
    childrenList: ActionV3ChildrenRequestItemDto[];
}

export class ActionV3ChildrenRequestItemDto implements IActionV3ChildrenRequestItemDto {
    static!: ActionV3StaticChildrenDto;

    constructor(data?: IActionV3ChildrenRequestItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticChildrenDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticChildrenDto.fromJS(_data["static"]) : new ActionV3StaticChildrenDto();
        }
    }

    static fromJS(data: any): ActionV3ChildrenRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3ChildrenRequestItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3ChildrenRequestItemDto {
        const json = this.toJSON();
        let result = new ActionV3ChildrenRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3ChildrenRequestItemDto {
    static: ActionV3StaticChildrenDto;
}

export class ActionV3StaticChildrenDto implements IActionV3StaticChildrenDto {
    firstName?: string;
    lastName?: string;
    birthYear?: string;
    isChronicallyIllTimeline?: BooleanV3TimelineItemDto[];
    hasSoleCustodyTimeline?: BooleanV3TimelineItemDto[];

    constructor(data?: IActionV3StaticChildrenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthYear = _data["birthYear"];
            if (Array.isArray(_data["isChronicallyIllTimeline"])) {
                this.isChronicallyIllTimeline = [] as any;
                for (let item of _data["isChronicallyIllTimeline"])
                    this.isChronicallyIllTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasSoleCustodyTimeline"])) {
                this.hasSoleCustodyTimeline = [] as any;
                for (let item of _data["hasSoleCustodyTimeline"])
                    this.hasSoleCustodyTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticChildrenDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticChildrenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthYear"] = this.birthYear;
        if (Array.isArray(this.isChronicallyIllTimeline)) {
            data["isChronicallyIllTimeline"] = [];
            for (let item of this.isChronicallyIllTimeline)
                data["isChronicallyIllTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasSoleCustodyTimeline)) {
            data["hasSoleCustodyTimeline"] = [];
            for (let item of this.hasSoleCustodyTimeline)
                data["hasSoleCustodyTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticChildrenDto {
        const json = this.toJSON();
        let result = new ActionV3StaticChildrenDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticChildrenDto {
    firstName?: string;
    lastName?: string;
    birthYear?: string;
    isChronicallyIllTimeline?: BooleanV3TimelineItemDto[];
    hasSoleCustodyTimeline?: BooleanV3TimelineItemDto[];
}

/** Chronically ill group consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export class ActionV3ChronicallyIllRequestDto implements IActionV3ChronicallyIllRequestDto {
    static!: ActionV3StaticChronicallyIllDto;

    constructor(data?: IActionV3ChronicallyIllRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticChronicallyIllDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticChronicallyIllDto.fromJS(_data["static"]) : new ActionV3StaticChronicallyIllDto();
        }
    }

    static fromJS(data: any): ActionV3ChronicallyIllRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3ChronicallyIllRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3ChronicallyIllRequestDto {
        const json = this.toJSON();
        let result = new ActionV3ChronicallyIllRequestDto();
        result.init(json);
        return result;
    }
}

/** Chronically ill group consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export interface IActionV3ChronicallyIllRequestDto {
    static: ActionV3StaticChronicallyIllDto;
}

export class ActionV3StaticChronicallyIllDto implements IActionV3StaticChronicallyIllDto {
    chronicallyIllTimeline?: BooleanV3TimelineItemDto[];

    constructor(data?: IActionV3StaticChronicallyIllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chronicallyIllTimeline"])) {
                this.chronicallyIllTimeline = [] as any;
                for (let item of _data["chronicallyIllTimeline"])
                    this.chronicallyIllTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticChronicallyIllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticChronicallyIllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chronicallyIllTimeline)) {
            data["chronicallyIllTimeline"] = [];
            for (let item of this.chronicallyIllTimeline)
                data["chronicallyIllTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticChronicallyIllDto {
        const json = this.toJSON();
        let result = new ActionV3StaticChronicallyIllDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticChronicallyIllDto {
    chronicallyIllTimeline?: BooleanV3TimelineItemDto[];
}

/** Has employment agreement group consists of only static properties. When the feature flag `enable-employment-agreements` is enabled,  replaces the automatic previousPeriods calculation. */
export class ActionV3EmploymentAgreementsRequestDto implements IActionV3EmploymentAgreementsRequestDto {
    static!: ActionV3StaticEmploymentAgreementsDto;

    constructor(data?: IActionV3EmploymentAgreementsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticEmploymentAgreementsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticEmploymentAgreementsDto.fromJS(_data["static"]) : new ActionV3StaticEmploymentAgreementsDto();
        }
    }

    static fromJS(data: any): ActionV3EmploymentAgreementsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmploymentAgreementsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3EmploymentAgreementsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmploymentAgreementsRequestDto();
        result.init(json);
        return result;
    }
}

/** Has employment agreement group consists of only static properties. When the feature flag `enable-employment-agreements` is enabled,  replaces the automatic previousPeriods calculation. */
export interface IActionV3EmploymentAgreementsRequestDto {
    static: ActionV3StaticEmploymentAgreementsDto;
}

export class ActionV3StaticEmploymentAgreementsDto implements IActionV3StaticEmploymentAgreementsDto {
    /** Employment agreement periods for the employee.
Only items where value is `true` are mapped to previousPeriods.

This must be a superset of all position dates.
 */
    hasEmploymentTimeline!: BooleanV3TimelineItemDto[];

    constructor(data?: IActionV3StaticEmploymentAgreementsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.hasEmploymentTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hasEmploymentTimeline"])) {
                this.hasEmploymentTimeline = [] as any;
                for (let item of _data["hasEmploymentTimeline"])
                    this.hasEmploymentTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticEmploymentAgreementsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticEmploymentAgreementsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hasEmploymentTimeline)) {
            data["hasEmploymentTimeline"] = [];
            for (let item of this.hasEmploymentTimeline)
                data["hasEmploymentTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticEmploymentAgreementsDto {
        const json = this.toJSON();
        let result = new ActionV3StaticEmploymentAgreementsDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticEmploymentAgreementsDto {
    /** Employment agreement periods for the employee.
Only items where value is `true` are mapped to previousPeriods.

This must be a superset of all position dates.
 */
    hasEmploymentTimeline: BooleanV3TimelineItemDto[];
}

/** Emergency contact group consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export class ActionV3EmergencyContactsRequestDto implements IActionV3EmergencyContactsRequestDto {
    static!: ActionV3StaticEmergencyContactsDto;

    constructor(data?: IActionV3EmergencyContactsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticEmergencyContactsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticEmergencyContactsDto.fromJS(_data["static"]) : new ActionV3StaticEmergencyContactsDto();
        }
    }

    static fromJS(data: any): ActionV3EmergencyContactsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmergencyContactsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3EmergencyContactsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmergencyContactsRequestDto();
        result.init(json);
        return result;
    }
}

/** Emergency contact group consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export interface IActionV3EmergencyContactsRequestDto {
    static: ActionV3StaticEmergencyContactsDto;
}

export class ActionV3StaticEmergencyContactsDto implements IActionV3StaticEmergencyContactsDto {
    contactList!: ActionV3EmergencyContactItemDto[];

    constructor(data?: IActionV3StaticEmergencyContactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contactList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contactList"])) {
                this.contactList = [] as any;
                for (let item of _data["contactList"])
                    this.contactList!.push(ActionV3EmergencyContactItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticEmergencyContactsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticEmergencyContactsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactList)) {
            data["contactList"] = [];
            for (let item of this.contactList)
                data["contactList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticEmergencyContactsDto {
        const json = this.toJSON();
        let result = new ActionV3StaticEmergencyContactsDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticEmergencyContactsDto {
    contactList: ActionV3EmergencyContactItemDto[];
}

export class ActionV3EmergencyContactItemDto implements IActionV3EmergencyContactItemDto {
    isMainContact?: boolean;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;

    constructor(data?: IActionV3EmergencyContactItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMainContact = _data["isMainContact"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ActionV3EmergencyContactItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmergencyContactItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMainContact"] = this.isMainContact;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }

    clone(): ActionV3EmergencyContactItemDto {
        const json = this.toJSON();
        let result = new ActionV3EmergencyContactItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmergencyContactItemDto {
    isMainContact?: boolean;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
}

/** Payslip and payment consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export class ActionV3PayslipAndPaymentRequestDto implements IActionV3PayslipAndPaymentRequestDto {
    static!: ActionV3StaticPayslipAndPaymentDto;

    constructor(data?: IActionV3PayslipAndPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticPayslipAndPaymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticPayslipAndPaymentDto.fromJS(_data["static"]) : new ActionV3StaticPayslipAndPaymentDto();
        }
    }

    static fromJS(data: any): ActionV3PayslipAndPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PayslipAndPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3PayslipAndPaymentRequestDto {
        const json = this.toJSON();
        let result = new ActionV3PayslipAndPaymentRequestDto();
        result.init(json);
        return result;
    }
}

/** Payslip and payment consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export interface IActionV3PayslipAndPaymentRequestDto {
    static: ActionV3StaticPayslipAndPaymentDto;
}

export class ActionV3StaticPayslipAndPaymentDto implements IActionV3StaticPayslipAndPaymentDto {
    paymentType?: PaymentTypeV3EnumDto;
    payslipLanguage?: string;
    payslipOnPaper?: boolean;
    norwegianAccountNumber?: string;
    internationalPayment?: EmployeeV3InternationalPaymentDto;
    extraPaymentsTimeline?: EmployeeV3ExtraPaymentItemDto[];

    constructor(data?: IActionV3StaticPayslipAndPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentType = _data["paymentType"];
            this.payslipLanguage = _data["payslipLanguage"];
            this.payslipOnPaper = _data["payslipOnPaper"];
            this.norwegianAccountNumber = _data["norwegianAccountNumber"];
            this.internationalPayment = _data["internationalPayment"] ? EmployeeV3InternationalPaymentDto.fromJS(_data["internationalPayment"]) : undefined as any;
            if (Array.isArray(_data["extraPaymentsTimeline"])) {
                this.extraPaymentsTimeline = [] as any;
                for (let item of _data["extraPaymentsTimeline"])
                    this.extraPaymentsTimeline!.push(EmployeeV3ExtraPaymentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticPayslipAndPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticPayslipAndPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["payslipLanguage"] = this.payslipLanguage;
        data["payslipOnPaper"] = this.payslipOnPaper;
        data["norwegianAccountNumber"] = this.norwegianAccountNumber;
        data["internationalPayment"] = this.internationalPayment ? this.internationalPayment.toJSON() : undefined as any;
        if (Array.isArray(this.extraPaymentsTimeline)) {
            data["extraPaymentsTimeline"] = [];
            for (let item of this.extraPaymentsTimeline)
                data["extraPaymentsTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticPayslipAndPaymentDto {
        const json = this.toJSON();
        let result = new ActionV3StaticPayslipAndPaymentDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticPayslipAndPaymentDto {
    paymentType?: PaymentTypeV3EnumDto;
    payslipLanguage?: string;
    payslipOnPaper?: boolean;
    norwegianAccountNumber?: string;
    internationalPayment?: EmployeeV3InternationalPaymentDto;
    extraPaymentsTimeline?: EmployeeV3ExtraPaymentItemDto[];
}

/** Personal details consist of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. */
export class ActionV3PersonalDetailsRequestDto implements IActionV3PersonalDetailsRequestDto {
    static!: ActionV3StaticPersonalDetailsDto;
    setTimeline?: ActionV3PersonalDetailsSetTimelineItemDto[];
    setFrom?: ActionV3PersonalDetailsSetFromDto;

    constructor(data?: IActionV3PersonalDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticPersonalDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticPersonalDetailsDto.fromJS(_data["static"]) : new ActionV3StaticPersonalDetailsDto();
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3PersonalDetailsSetTimelineItemDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3PersonalDetailsSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3PersonalDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PersonalDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3PersonalDetailsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3PersonalDetailsRequestDto();
        result.init(json);
        return result;
    }
}

/** Personal details consist of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. */
export interface IActionV3PersonalDetailsRequestDto {
    static: ActionV3StaticPersonalDetailsDto;
    setTimeline?: ActionV3PersonalDetailsSetTimelineItemDto[];
    setFrom?: ActionV3PersonalDetailsSetFromDto;
}

/** An item in a full timeline. If set, a full timeline cannot be empty and it must have exactly one value for every day. */
export class FullV3TimelineItemDto implements IFullV3TimelineItemDto {
    /** Inclusive start of range.

The list of timeline items must be sorted on `from`.

Mandatory on all items except the first, where it must not be set (which means since forever).

When set, it must:
- be the day after the previous item's `to`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    from?: Date;
    /** Inclusive end of range.

Mandatory on all items except the last, where it must not be set (which means until forever).

When set, it must:
- be the day before the next item's `from`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    to?: Date;

    constructor(data?: IFullV3TimelineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FullV3TimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullV3TimelineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }

    clone(): FullV3TimelineItemDto {
        const json = this.toJSON();
        let result = new FullV3TimelineItemDto();
        result.init(json);
        return result;
    }
}

/** An item in a full timeline. If set, a full timeline cannot be empty and it must have exactly one value for every day. */
export interface IFullV3TimelineItemDto {
    /** Inclusive start of range.

The list of timeline items must be sorted on `from`.

Mandatory on all items except the first, where it must not be set (which means since forever).

When set, it must:
- be the day after the previous item's `to`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    from?: Date;
    /** Inclusive end of range.

Mandatory on all items except the last, where it must not be set (which means until forever).

When set, it must:
- be the day before the next item's `from`
- be between `'1910-04-15'` and `'2089-09-17'`
- be between the encompassing timeline's `from` and `to`, if any (ie. if used in a position)

___
Monolith notes: (discrepancy) Allows explicit dates outside position range.
___
 */
    to?: Date;
}

export class ActionV3PersonalDetailsSetTimelineItemDto extends FullV3TimelineItemDto implements IActionV3PersonalDetailsSetTimelineItemDto {
    value!: ActionV3TemporalPersonalDetailsDto;

    constructor(data?: IActionV3PersonalDetailsSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3TemporalPersonalDetailsDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3TemporalPersonalDetailsDto.fromJS(_data["value"]) : new ActionV3TemporalPersonalDetailsDto();
        }
    }

    static override fromJS(data: any): ActionV3PersonalDetailsSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PersonalDetailsSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3PersonalDetailsSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3PersonalDetailsSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3PersonalDetailsSetTimelineItemDto extends IFullV3TimelineItemDto {
    value: ActionV3TemporalPersonalDetailsDto;
}

export class ActionV3PersonalDetailsSetFromDto implements IActionV3PersonalDetailsSetFromDto {
    from!: Date;
    value!: ActionV3TemporalPersonalDetailsDto;

    constructor(data?: IActionV3PersonalDetailsSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3TemporalPersonalDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3TemporalPersonalDetailsDto.fromJS(_data["value"]) : new ActionV3TemporalPersonalDetailsDto();
        }
    }

    static fromJS(data: any): ActionV3PersonalDetailsSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PersonalDetailsSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3PersonalDetailsSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3PersonalDetailsSetFromDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3PersonalDetailsSetFromDto {
    from: Date;
    value: ActionV3TemporalPersonalDetailsDto;
}

export class ActionV3StaticPersonalDetailsDto implements IActionV3StaticPersonalDetailsDto {
    firstName?: string;
    lastName?: string;
    birthDate?: Date;
    gender?: GenderV3EnumDto;
    phones!: EmployeeV3PhoneDto[];
    emails!: EmployeeV3EmailDto[];
    postalAddress?: EmployeeV3AddressDto;

    constructor(data?: IActionV3StaticPersonalDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.phones = [];
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.gender = _data["gender"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(EmployeeV3PhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmployeeV3EmailDto.fromJS(item));
            }
            this.postalAddress = _data["postalAddress"] ? EmployeeV3AddressDto.fromJS(_data["postalAddress"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3StaticPersonalDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticPersonalDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : undefined as any;
        data["gender"] = this.gender;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3StaticPersonalDetailsDto {
        const json = this.toJSON();
        let result = new ActionV3StaticPersonalDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticPersonalDetailsDto {
    firstName?: string;
    lastName?: string;
    birthDate?: Date;
    gender?: GenderV3EnumDto;
    phones: EmployeeV3PhoneDto[];
    emails: EmployeeV3EmailDto[];
    postalAddress?: EmployeeV3AddressDto;
}

export class ActionV3TemporalPersonalDetailsDto implements IActionV3TemporalPersonalDetailsDto {
    governmentId?: EmployeeV3GovernmentIdValueDto;

    constructor(data?: IActionV3TemporalPersonalDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.governmentId = _data["governmentId"] ? EmployeeV3GovernmentIdValueDto.fromJS(_data["governmentId"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3TemporalPersonalDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TemporalPersonalDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["governmentId"] = this.governmentId ? this.governmentId.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3TemporalPersonalDetailsDto {
        const json = this.toJSON();
        let result = new ActionV3TemporalPersonalDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TemporalPersonalDetailsDto {
    governmentId?: EmployeeV3GovernmentIdValueDto;
}

/** Tax and tax card consist of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. Currently only hasNetSalaryTimeline, hasNetSalarySeafarerTimeline, hasSeafarerDeductionTimeline, hasSvalbardTaxActTimeline can be edited. Changing other tax and tax card properties is not supported. */
export class ActionV3TaxAndTaxCardRequestDto implements IActionV3TaxAndTaxCardRequestDto {
    static!: ActionV3StaticTaxAndTaxCardDto;
    setTimeline?: ActionV3TaxAndTaxCardSetTimelineItemDto[];
    setFrom?: ActionV3TaxAndTaxCardSetFromDto;

    constructor(data?: IActionV3TaxAndTaxCardRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticTaxAndTaxCardDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticTaxAndTaxCardDto.fromJS(_data["static"]) : new ActionV3StaticTaxAndTaxCardDto();
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3TaxAndTaxCardSetTimelineItemDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3TaxAndTaxCardSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3TaxAndTaxCardRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TaxAndTaxCardRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3TaxAndTaxCardRequestDto {
        const json = this.toJSON();
        let result = new ActionV3TaxAndTaxCardRequestDto();
        result.init(json);
        return result;
    }
}

/** Tax and tax card consist of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. Currently only hasNetSalaryTimeline, hasNetSalarySeafarerTimeline, hasSeafarerDeductionTimeline, hasSvalbardTaxActTimeline can be edited. Changing other tax and tax card properties is not supported. */
export interface IActionV3TaxAndTaxCardRequestDto {
    static: ActionV3StaticTaxAndTaxCardDto;
    setTimeline?: ActionV3TaxAndTaxCardSetTimelineItemDto[];
    setFrom?: ActionV3TaxAndTaxCardSetFromDto;
}

export class ActionV3StaticTaxAndTaxCardDto implements IActionV3StaticTaxAndTaxCardDto {
    retrieveTaxCardOnWageRun?: boolean;
    hasNetSalaryTimeline?: BooleanV3TimelineItemDto[];
    hasNetSalarySeafarerTimeline?: BooleanV3TimelineItemDto[];
    hasSeafarerDeductionTimeline?: BooleanV3TimelineItemDto[];
    hasSvalbardTaxActTimeline?: BooleanV3TimelineItemDto[];

    constructor(data?: IActionV3StaticTaxAndTaxCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retrieveTaxCardOnWageRun = _data["retrieveTaxCardOnWageRun"];
            if (Array.isArray(_data["hasNetSalaryTimeline"])) {
                this.hasNetSalaryTimeline = [] as any;
                for (let item of _data["hasNetSalaryTimeline"])
                    this.hasNetSalaryTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasNetSalarySeafarerTimeline"])) {
                this.hasNetSalarySeafarerTimeline = [] as any;
                for (let item of _data["hasNetSalarySeafarerTimeline"])
                    this.hasNetSalarySeafarerTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasSeafarerDeductionTimeline"])) {
                this.hasSeafarerDeductionTimeline = [] as any;
                for (let item of _data["hasSeafarerDeductionTimeline"])
                    this.hasSeafarerDeductionTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasSvalbardTaxActTimeline"])) {
                this.hasSvalbardTaxActTimeline = [] as any;
                for (let item of _data["hasSvalbardTaxActTimeline"])
                    this.hasSvalbardTaxActTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticTaxAndTaxCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticTaxAndTaxCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retrieveTaxCardOnWageRun"] = this.retrieveTaxCardOnWageRun;
        if (Array.isArray(this.hasNetSalaryTimeline)) {
            data["hasNetSalaryTimeline"] = [];
            for (let item of this.hasNetSalaryTimeline)
                data["hasNetSalaryTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasNetSalarySeafarerTimeline)) {
            data["hasNetSalarySeafarerTimeline"] = [];
            for (let item of this.hasNetSalarySeafarerTimeline)
                data["hasNetSalarySeafarerTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasSeafarerDeductionTimeline)) {
            data["hasSeafarerDeductionTimeline"] = [];
            for (let item of this.hasSeafarerDeductionTimeline)
                data["hasSeafarerDeductionTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasSvalbardTaxActTimeline)) {
            data["hasSvalbardTaxActTimeline"] = [];
            for (let item of this.hasSvalbardTaxActTimeline)
                data["hasSvalbardTaxActTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticTaxAndTaxCardDto {
        const json = this.toJSON();
        let result = new ActionV3StaticTaxAndTaxCardDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticTaxAndTaxCardDto {
    retrieveTaxCardOnWageRun?: boolean;
    hasNetSalaryTimeline?: BooleanV3TimelineItemDto[];
    hasNetSalarySeafarerTimeline?: BooleanV3TimelineItemDto[];
    hasSeafarerDeductionTimeline?: BooleanV3TimelineItemDto[];
    hasSvalbardTaxActTimeline?: BooleanV3TimelineItemDto[];
}

export class ActionV3TaxAndTaxCardSetTimelineItemDto extends FullV3TimelineItemDto implements IActionV3TaxAndTaxCardSetTimelineItemDto {
    value!: ActionV3TemporalTaxAndTaxCardDto;

    constructor(data?: IActionV3TaxAndTaxCardSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3TemporalTaxAndTaxCardDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3TemporalTaxAndTaxCardDto.fromJS(_data["value"]) : new ActionV3TemporalTaxAndTaxCardDto();
        }
    }

    static override fromJS(data: any): ActionV3TaxAndTaxCardSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TaxAndTaxCardSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3TaxAndTaxCardSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3TaxAndTaxCardSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TaxAndTaxCardSetTimelineItemDto extends IFullV3TimelineItemDto {
    value: ActionV3TemporalTaxAndTaxCardDto;
}

export class ActionV3TaxAndTaxCardSetFromDto implements IActionV3TaxAndTaxCardSetFromDto {
    from!: Date;
    value!: ActionV3TemporalTaxAndTaxCardDto;

    constructor(data?: IActionV3TaxAndTaxCardSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3TemporalTaxAndTaxCardDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3TemporalTaxAndTaxCardDto.fromJS(_data["value"]) : new ActionV3TemporalTaxAndTaxCardDto();
        }
    }

    static fromJS(data: any): ActionV3TaxAndTaxCardSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TaxAndTaxCardSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3TaxAndTaxCardSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3TaxAndTaxCardSetFromDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TaxAndTaxCardSetFromDto {
    from: Date;
    value: ActionV3TemporalTaxAndTaxCardDto;
}

export class ActionV3TemporalTaxAndTaxCardDto implements IActionV3TemporalTaxAndTaxCardDto {
    isMainEmployer?: boolean;
    isFullyWithholdingChristmasTax?: boolean;
    isBorderCommuter?: boolean;
    isReceivingPension?: boolean;
    borderCommuterPercentage?: string;
    table?: string;
    percentage?: string;
    percentagePaye?: string;
    hasExemptionCard?: boolean;
    exemptionCardAmount?: string;
    pensionTable?: string;
    pensionPercentage?: string;
    pensionPercentagePaye?: string;
    hasPensionExemptionCard?: boolean;
    isPostedFromUsCanada?: boolean;
    taxFromFirstKroneForTaxFreeOrg?: boolean;

    constructor(data?: IActionV3TemporalTaxAndTaxCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMainEmployer = _data["isMainEmployer"];
            this.isFullyWithholdingChristmasTax = _data["isFullyWithholdingChristmasTax"];
            this.isBorderCommuter = _data["isBorderCommuter"];
            this.isReceivingPension = _data["isReceivingPension"];
            this.borderCommuterPercentage = _data["borderCommuterPercentage"];
            this.table = _data["table"];
            this.percentage = _data["percentage"];
            this.percentagePaye = _data["percentagePaye"];
            this.hasExemptionCard = _data["hasExemptionCard"];
            this.exemptionCardAmount = _data["exemptionCardAmount"];
            this.pensionTable = _data["pensionTable"];
            this.pensionPercentage = _data["pensionPercentage"];
            this.pensionPercentagePaye = _data["pensionPercentagePaye"];
            this.hasPensionExemptionCard = _data["hasPensionExemptionCard"];
            this.isPostedFromUsCanada = _data["isPostedFromUsCanada"];
            this.taxFromFirstKroneForTaxFreeOrg = _data["taxFromFirstKroneForTaxFreeOrg"];
        }
    }

    static fromJS(data: any): ActionV3TemporalTaxAndTaxCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TemporalTaxAndTaxCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMainEmployer"] = this.isMainEmployer;
        data["isFullyWithholdingChristmasTax"] = this.isFullyWithholdingChristmasTax;
        data["isBorderCommuter"] = this.isBorderCommuter;
        data["isReceivingPension"] = this.isReceivingPension;
        data["borderCommuterPercentage"] = this.borderCommuterPercentage;
        data["table"] = this.table;
        data["percentage"] = this.percentage;
        data["percentagePaye"] = this.percentagePaye;
        data["hasExemptionCard"] = this.hasExemptionCard;
        data["exemptionCardAmount"] = this.exemptionCardAmount;
        data["pensionTable"] = this.pensionTable;
        data["pensionPercentage"] = this.pensionPercentage;
        data["pensionPercentagePaye"] = this.pensionPercentagePaye;
        data["hasPensionExemptionCard"] = this.hasPensionExemptionCard;
        data["isPostedFromUsCanada"] = this.isPostedFromUsCanada;
        data["taxFromFirstKroneForTaxFreeOrg"] = this.taxFromFirstKroneForTaxFreeOrg;
        return data;
    }

    clone(): ActionV3TemporalTaxAndTaxCardDto {
        const json = this.toJSON();
        let result = new ActionV3TemporalTaxAndTaxCardDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TemporalTaxAndTaxCardDto {
    isMainEmployer?: boolean;
    isFullyWithholdingChristmasTax?: boolean;
    isBorderCommuter?: boolean;
    isReceivingPension?: boolean;
    borderCommuterPercentage?: string;
    table?: string;
    percentage?: string;
    percentagePaye?: string;
    hasExemptionCard?: boolean;
    exemptionCardAmount?: string;
    pensionTable?: string;
    pensionPercentage?: string;
    pensionPercentagePaye?: string;
    hasPensionExemptionCard?: boolean;
    isPostedFromUsCanada?: boolean;
    taxFromFirstKroneForTaxFreeOrg?: boolean;
}

/** Creditor claim group consists of an overlap timeline of all creditor claims. */
export class ActionV3CreditorClaimsRequestDto implements IActionV3CreditorClaimsRequestDto {
    setTimeline!: ActionV3CreditorClaimsSetTimelineItemDto[];

    constructor(data?: IActionV3CreditorClaimsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.setTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3CreditorClaimsSetTimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3CreditorClaimsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CreditorClaimsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3CreditorClaimsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3CreditorClaimsRequestDto();
        result.init(json);
        return result;
    }
}

/** Creditor claim group consists of an overlap timeline of all creditor claims. */
export interface IActionV3CreditorClaimsRequestDto {
    setTimeline: ActionV3CreditorClaimsSetTimelineItemDto[];
}

export class ActionV3CreditorClaimsSetTimelineItemDto extends OverlapV3TimelineItemDto implements IActionV3CreditorClaimsSetTimelineItemDto {
    value!: ActionV3CreditorClaimDto;

    constructor(data?: IActionV3CreditorClaimsSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3CreditorClaimDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3CreditorClaimDto.fromJS(_data["value"]) : new ActionV3CreditorClaimDto();
        }
    }

    static override fromJS(data: any): ActionV3CreditorClaimsSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CreditorClaimsSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3CreditorClaimsSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3CreditorClaimsSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CreditorClaimsSetTimelineItemDto extends IOverlapV3TimelineItemDto {
    value: ActionV3CreditorClaimDto;
}

export class ActionV3CreditorClaimDto implements IActionV3CreditorClaimDto {
    type?: CreditorClaimTypeV3EnumDto;
    creditorId?: string;
    taxIncomeYear?: string;
    initialAmount?: string;
    calculationMethod?: CreditorClaimCalculationMethodV3EnumDto;
    fixedAmount?: string;
    taxBasisPercentage?: string;
    description?: string;
    kidNumber?: string;

    constructor(data?: IActionV3CreditorClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.creditorId = _data["creditorId"];
            this.taxIncomeYear = _data["taxIncomeYear"];
            this.initialAmount = _data["initialAmount"];
            this.calculationMethod = _data["calculationMethod"];
            this.fixedAmount = _data["fixedAmount"];
            this.taxBasisPercentage = _data["taxBasisPercentage"];
            this.description = _data["description"];
            this.kidNumber = _data["kidNumber"];
        }
    }

    static fromJS(data: any): ActionV3CreditorClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CreditorClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["creditorId"] = this.creditorId;
        data["taxIncomeYear"] = this.taxIncomeYear;
        data["initialAmount"] = this.initialAmount;
        data["calculationMethod"] = this.calculationMethod;
        data["fixedAmount"] = this.fixedAmount;
        data["taxBasisPercentage"] = this.taxBasisPercentage;
        data["description"] = this.description;
        data["kidNumber"] = this.kidNumber;
        return data;
    }

    clone(): ActionV3CreditorClaimDto {
        const json = this.toJSON();
        let result = new ActionV3CreditorClaimDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CreditorClaimDto {
    type?: CreditorClaimTypeV3EnumDto;
    creditorId?: string;
    taxIncomeYear?: string;
    initialAmount?: string;
    calculationMethod?: CreditorClaimCalculationMethodV3EnumDto;
    fixedAmount?: string;
    taxBasisPercentage?: string;
    description?: string;
    kidNumber?: string;
}

/** Car group consists of a gap timeline of all cars. Either use `setFrom` to update the last timeline item / add a new item, or use `setTimeline` (in chronology) to edit any part of the timeline. Each car has timelines on some properties, yearly kilometrage and calculation method. Exactly one of them is used, according to the selected car's type. */
export class ActionV3CarsRequestDto implements IActionV3CarsRequestDto {
    setFrom?: ActionV3CarsSetFromDto;
    setTimeline?: ActionV3CarsSetTimelineItemDto[];

    constructor(data?: IActionV3CarsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setFrom = _data["setFrom"] ? ActionV3CarsSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3CarsSetTimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3CarsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3CarsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3CarsRequestDto();
        result.init(json);
        return result;
    }
}

/** Car group consists of a gap timeline of all cars. Either use `setFrom` to update the last timeline item / add a new item, or use `setTimeline` (in chronology) to edit any part of the timeline. Each car has timelines on some properties, yearly kilometrage and calculation method. Exactly one of them is used, according to the selected car's type. */
export interface IActionV3CarsRequestDto {
    setFrom?: ActionV3CarsSetFromDto;
    setTimeline?: ActionV3CarsSetTimelineItemDto[];
}

/** When setting value from a date, there are four possible cases: 1. Remove the car  - Just set `removeCar`  - `to`, `carId`, `yearlyKilometrage` and `calculationMethod` are prohibited  - `from` must be the day after the last day the car is used 2. Add a new car (no car link is active on `from`)  - `carId` is required  - `to` is optional, but may be required if the link cannot be valid until forever  - Exactly one of `yearlyKilometrage` and `calculationMethod` is required 3. Replace the car (a car link is active on `from`)  - `carId` is required  - `to` is optional  - Exactly one of `yearlyKilometrage` and `calculationMethod` is required  - A new link will be started on `from`  - The current link will be ended on the previous date 4. Change properties of the current link (a car link with the same id is active on `from`)  - `carId` is required (will be compared to id of the current link)  - `to` is intended for car links that must be added with a closed range    - when editing a car it should be set to the existing `car.to`    - it CAN be used as an alternative to case 1 for removing a car,      but that would be more complicated      - `to` is the last day the car is used      - but `from` must not be before any explicit date on any item in either        `yearlyKilometrage` or `calculationMethod`, to avoid overwriting old values there      - `from` could be safely set to the same date as `to`, which would be confusing but work  - Exactly one of `yearlyKilometrage` and `calculationMethod` is required  - Only the kilometrage or calculation method timeline will be changed */
export class ActionV3CarsSetFromDto implements IActionV3CarsSetFromDto {
    from!: Date;
    value!: ActionV3CarsSetFromValueDto;

    constructor(data?: IActionV3CarsSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3CarsSetFromValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3CarsSetFromValueDto.fromJS(_data["value"]) : new ActionV3CarsSetFromValueDto();
        }
    }

    static fromJS(data: any): ActionV3CarsSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarsSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3CarsSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3CarsSetFromDto();
        result.init(json);
        return result;
    }
}

/** When setting value from a date, there are four possible cases: 1. Remove the car  - Just set `removeCar`  - `to`, `carId`, `yearlyKilometrage` and `calculationMethod` are prohibited  - `from` must be the day after the last day the car is used 2. Add a new car (no car link is active on `from`)  - `carId` is required  - `to` is optional, but may be required if the link cannot be valid until forever  - Exactly one of `yearlyKilometrage` and `calculationMethod` is required 3. Replace the car (a car link is active on `from`)  - `carId` is required  - `to` is optional  - Exactly one of `yearlyKilometrage` and `calculationMethod` is required  - A new link will be started on `from`  - The current link will be ended on the previous date 4. Change properties of the current link (a car link with the same id is active on `from`)  - `carId` is required (will be compared to id of the current link)  - `to` is intended for car links that must be added with a closed range    - when editing a car it should be set to the existing `car.to`    - it CAN be used as an alternative to case 1 for removing a car,      but that would be more complicated      - `to` is the last day the car is used      - but `from` must not be before any explicit date on any item in either        `yearlyKilometrage` or `calculationMethod`, to avoid overwriting old values there      - `from` could be safely set to the same date as `to`, which would be confusing but work  - Exactly one of `yearlyKilometrage` and `calculationMethod` is required  - Only the kilometrage or calculation method timeline will be changed */
export interface IActionV3CarsSetFromDto {
    from: Date;
    value: ActionV3CarsSetFromValueDto;
}

export class ActionV3CarsSetFromValueDto implements IActionV3CarsSetFromValueDto {
    /** The last active date of the car link (inclusive).

If not set, the car link will be active until forever,
which is not valid when the car has an end date or
is used by another employee in the future.

Does not affect `yearlyKilometrage` or `calculationMethod`.
 */
    to?: Date;
    removeCar?: boolean;
    carId?: string;
    yearlyKilometrage?: string;
    calculationMethod?: CarCalculationMethodV3EnumDto;

    constructor(data?: IActionV3CarsSetFromValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.removeCar = _data["removeCar"];
            this.carId = _data["carId"];
            this.yearlyKilometrage = _data["yearlyKilometrage"];
            this.calculationMethod = _data["calculationMethod"];
        }
    }

    static fromJS(data: any): ActionV3CarsSetFromValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarsSetFromValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["removeCar"] = this.removeCar;
        data["carId"] = this.carId;
        data["yearlyKilometrage"] = this.yearlyKilometrage;
        data["calculationMethod"] = this.calculationMethod;
        return data;
    }

    clone(): ActionV3CarsSetFromValueDto {
        const json = this.toJSON();
        let result = new ActionV3CarsSetFromValueDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CarsSetFromValueDto {
    /** The last active date of the car link (inclusive).

If not set, the car link will be active until forever,
which is not valid when the car has an end date or
is used by another employee in the future.

Does not affect `yearlyKilometrage` or `calculationMethod`.
 */
    to?: Date;
    removeCar?: boolean;
    carId?: string;
    yearlyKilometrage?: string;
    calculationMethod?: CarCalculationMethodV3EnumDto;
}

export class ActionV3CarsSetTimelineItemDto extends GapV3TimelineItemDto implements IActionV3CarsSetTimelineItemDto {
    value!: ActionV3CarDto;

    constructor(data?: IActionV3CarsSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3CarDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3CarDto.fromJS(_data["value"]) : new ActionV3CarDto();
        }
    }

    static override fromJS(data: any): ActionV3CarsSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarsSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3CarsSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3CarsSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CarsSetTimelineItemDto extends IGapV3TimelineItemDto {
    value: ActionV3CarDto;
}

export class ActionV3CarDto implements IActionV3CarDto {
    carId?: string;
    yearlyKilometrageTimeline?: ActionV3CarYearlyKilometrageTimelineItemDto[];
    calculationMethodTimeline?: ActionV3CarCalculationMethodTimelineItemDto[];

    constructor(data?: IActionV3CarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carId = _data["carId"];
            if (Array.isArray(_data["yearlyKilometrageTimeline"])) {
                this.yearlyKilometrageTimeline = [] as any;
                for (let item of _data["yearlyKilometrageTimeline"])
                    this.yearlyKilometrageTimeline!.push(ActionV3CarYearlyKilometrageTimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["calculationMethodTimeline"])) {
                this.calculationMethodTimeline = [] as any;
                for (let item of _data["calculationMethodTimeline"])
                    this.calculationMethodTimeline!.push(ActionV3CarCalculationMethodTimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3CarDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carId"] = this.carId;
        if (Array.isArray(this.yearlyKilometrageTimeline)) {
            data["yearlyKilometrageTimeline"] = [];
            for (let item of this.yearlyKilometrageTimeline)
                data["yearlyKilometrageTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calculationMethodTimeline)) {
            data["calculationMethodTimeline"] = [];
            for (let item of this.calculationMethodTimeline)
                data["calculationMethodTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3CarDto {
        const json = this.toJSON();
        let result = new ActionV3CarDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CarDto {
    carId?: string;
    yearlyKilometrageTimeline?: ActionV3CarYearlyKilometrageTimelineItemDto[];
    calculationMethodTimeline?: ActionV3CarCalculationMethodTimelineItemDto[];
}

export class ActionV3CarYearlyKilometrageTimelineItemDto extends GapV3TimelineItemDto implements IActionV3CarYearlyKilometrageTimelineItemDto {
    value!: string;

    constructor(data?: IActionV3CarYearlyKilometrageTimelineItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ActionV3CarYearlyKilometrageTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarYearlyKilometrageTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3CarYearlyKilometrageTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3CarYearlyKilometrageTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CarYearlyKilometrageTimelineItemDto extends IGapV3TimelineItemDto {
    value: string;
}

export class ActionV3CarCalculationMethodTimelineItemDto extends GapV3TimelineItemDto implements IActionV3CarCalculationMethodTimelineItemDto {
    value!: CarCalculationMethodV3EnumDto;

    constructor(data?: IActionV3CarCalculationMethodTimelineItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ActionV3CarCalculationMethodTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CarCalculationMethodTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3CarCalculationMethodTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3CarCalculationMethodTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CarCalculationMethodTimelineItemDto extends IGapV3TimelineItemDto {
    value: CarCalculationMethodV3EnumDto;
}

/** Pension company group consists of a gap timeline of all pension companies. Either use `setFrom` to update the last timeline item / add a new item, or use `setTimeline` (in chronology) to edit any part of the timeline. */
export class ActionV3PensionCompaniesRequestDto implements IActionV3PensionCompaniesRequestDto {
    setTimeline?: ActionV3PensionCompaniesSetTimelineItemDto[];
    setFrom?: ActionV3PensionCompaniesSetFromDto;

    constructor(data?: IActionV3PensionCompaniesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3PensionCompaniesSetTimelineItemDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3PensionCompaniesSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3PensionCompaniesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PensionCompaniesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3PensionCompaniesRequestDto {
        const json = this.toJSON();
        let result = new ActionV3PensionCompaniesRequestDto();
        result.init(json);
        return result;
    }
}

/** Pension company group consists of a gap timeline of all pension companies. Either use `setFrom` to update the last timeline item / add a new item, or use `setTimeline` (in chronology) to edit any part of the timeline. */
export interface IActionV3PensionCompaniesRequestDto {
    setTimeline?: ActionV3PensionCompaniesSetTimelineItemDto[];
    setFrom?: ActionV3PensionCompaniesSetFromDto;
}

/** When setting value from a date, there are three possible cases: 1. Remove the pension company  - Just set `removePensionCompany`  - `to` and `pensionCompanyId` are prohibited  - `from` must be the day after the last day the pension company is used 2. Add a new pension company (no pension company link is active on `from`)  - `pensionCompanyId` is required  - `to` is optional, but may be required if the link cannot be valid until forever 3. Replace the pension company (a pension company link is active on `from`)  - `pensionCompanyId` is required  - `to` is optional  - A new link will be started on `from`  - The current link will be ended on the previous date */
export class ActionV3PensionCompaniesSetFromDto implements IActionV3PensionCompaniesSetFromDto {
    from!: Date;
    value!: ActionV3PensionCompaniesSetFromValueDto;

    constructor(data?: IActionV3PensionCompaniesSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3PensionCompaniesSetFromValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3PensionCompaniesSetFromValueDto.fromJS(_data["value"]) : new ActionV3PensionCompaniesSetFromValueDto();
        }
    }

    static fromJS(data: any): ActionV3PensionCompaniesSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PensionCompaniesSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3PensionCompaniesSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3PensionCompaniesSetFromDto();
        result.init(json);
        return result;
    }
}

/** When setting value from a date, there are three possible cases: 1. Remove the pension company  - Just set `removePensionCompany`  - `to` and `pensionCompanyId` are prohibited  - `from` must be the day after the last day the pension company is used 2. Add a new pension company (no pension company link is active on `from`)  - `pensionCompanyId` is required  - `to` is optional, but may be required if the link cannot be valid until forever 3. Replace the pension company (a pension company link is active on `from`)  - `pensionCompanyId` is required  - `to` is optional  - A new link will be started on `from`  - The current link will be ended on the previous date */
export interface IActionV3PensionCompaniesSetFromDto {
    from: Date;
    value: ActionV3PensionCompaniesSetFromValueDto;
}

export class ActionV3PensionCompaniesSetFromValueDto implements IActionV3PensionCompaniesSetFromValueDto {
    /** The last active date of the pension company link (inclusive).
If not set, the pension company link will be active until forever.
 */
    to?: Date;
    removePensionCompany?: boolean;
    pensionCompanyId?: string;

    constructor(data?: IActionV3PensionCompaniesSetFromValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.removePensionCompany = _data["removePensionCompany"];
            this.pensionCompanyId = _data["pensionCompanyId"];
        }
    }

    static fromJS(data: any): ActionV3PensionCompaniesSetFromValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PensionCompaniesSetFromValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["removePensionCompany"] = this.removePensionCompany;
        data["pensionCompanyId"] = this.pensionCompanyId;
        return data;
    }

    clone(): ActionV3PensionCompaniesSetFromValueDto {
        const json = this.toJSON();
        let result = new ActionV3PensionCompaniesSetFromValueDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3PensionCompaniesSetFromValueDto {
    /** The last active date of the pension company link (inclusive).
If not set, the pension company link will be active until forever.
 */
    to?: Date;
    removePensionCompany?: boolean;
    pensionCompanyId?: string;
}

export class ActionV3PensionCompaniesSetTimelineItemDto extends GapV3TimelineItemDto implements IActionV3PensionCompaniesSetTimelineItemDto {
    value!: ActionV3PensionCompanyDto;

    constructor(data?: IActionV3PensionCompaniesSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3PensionCompanyDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3PensionCompanyDto.fromJS(_data["value"]) : new ActionV3PensionCompanyDto();
        }
    }

    static override fromJS(data: any): ActionV3PensionCompaniesSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PensionCompaniesSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3PensionCompaniesSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3PensionCompaniesSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3PensionCompaniesSetTimelineItemDto extends IGapV3TimelineItemDto {
    value: ActionV3PensionCompanyDto;
}

export class ActionV3PensionCompanyDto implements IActionV3PensionCompanyDto {
    pensionCompanyId!: string;

    constructor(data?: IActionV3PensionCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pensionCompanyId = _data["pensionCompanyId"];
        }
    }

    static fromJS(data: any): ActionV3PensionCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3PensionCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pensionCompanyId"] = this.pensionCompanyId;
        return data;
    }

    clone(): ActionV3PensionCompanyDto {
        const json = this.toJSON();
        let result = new ActionV3PensionCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3PensionCompanyDto {
    pensionCompanyId: string;
}

/** Either use `setFrom` to update the last timeline item / add a new item, or use `setTimeline` (in chronology) to edit any part of the timeline. Each union has a timeline on all its properties except KID number. */
export class ActionV3UnionsRequestDto implements IActionV3UnionsRequestDto {
    setFrom?: ActionV3UnionsSetFromDto;
    setTimeline?: ActionV3UnionsSetTimelineItemDto[];

    constructor(data?: IActionV3UnionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setFrom = _data["setFrom"] ? ActionV3UnionsSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3UnionsSetTimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3UnionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3UnionsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3UnionsRequestDto();
        result.init(json);
        return result;
    }
}

/** Either use `setFrom` to update the last timeline item / add a new item, or use `setTimeline` (in chronology) to edit any part of the timeline. Each union has a timeline on all its properties except KID number. */
export interface IActionV3UnionsRequestDto {
    setFrom?: ActionV3UnionsSetFromDto;
    setTimeline?: ActionV3UnionsSetTimelineItemDto[];
}

/** When setting value from a date, there are four possible cases: 1. Remove the union  - Just set `removeUnion`  - Other properties are prohibited  - `from` must be the day after the last day the union is used 2. Add a new union (no union link is active on `from`)  - `unionId` is required  - `removeUnion` is prohibited  - Other properties are optional 3. Replace the union (a union link is active on `from`)  - `unionId` is required  - `removeUnion` is prohibited  - Other properties are optional  - A new link will be started on `from`  - The current link will be ended on the previous date 4. Change properties of the current link (a union link with the same id is active on `from`)  - `unionId` is required  - `removeUnion` is prohibited  - Other properties are optional */
export class ActionV3UnionsSetFromDto implements IActionV3UnionsSetFromDto {
    from!: Date;
    value!: ActionV3UnionsSetFromValueDto;

    constructor(data?: IActionV3UnionsSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3UnionsSetFromValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3UnionsSetFromValueDto.fromJS(_data["value"]) : new ActionV3UnionsSetFromValueDto();
        }
    }

    static fromJS(data: any): ActionV3UnionsSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionsSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3UnionsSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3UnionsSetFromDto();
        result.init(json);
        return result;
    }
}

/** When setting value from a date, there are four possible cases: 1. Remove the union  - Just set `removeUnion`  - Other properties are prohibited  - `from` must be the day after the last day the union is used 2. Add a new union (no union link is active on `from`)  - `unionId` is required  - `removeUnion` is prohibited  - Other properties are optional 3. Replace the union (a union link is active on `from`)  - `unionId` is required  - `removeUnion` is prohibited  - Other properties are optional  - A new link will be started on `from`  - The current link will be ended on the previous date 4. Change properties of the current link (a union link with the same id is active on `from`)  - `unionId` is required  - `removeUnion` is prohibited  - Other properties are optional */
export interface IActionV3UnionsSetFromDto {
    from: Date;
    value: ActionV3UnionsSetFromValueDto;
}

export class ActionV3UnionsSetFromValueDto implements IActionV3UnionsSetFromValueDto {
    /** The last active date of the union link (inclusive).

If not set, the union link will be active until forever.
 */
    to?: Date;
    removeUnion?: boolean;
    unionId?: string;
    kidNumber?: string;
    memberNumber?: string;
    hasCollectiveInsurance?: boolean;
    collectiveInsuranceEmployeeAmount?: string;
    hasUnionInsurance?: boolean;
    unionInsuranceEmployeeAmount?: string;

    constructor(data?: IActionV3UnionsSetFromValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.removeUnion = _data["removeUnion"];
            this.unionId = _data["unionId"];
            this.kidNumber = _data["kidNumber"];
            this.memberNumber = _data["memberNumber"];
            this.hasCollectiveInsurance = _data["hasCollectiveInsurance"];
            this.collectiveInsuranceEmployeeAmount = _data["collectiveInsuranceEmployeeAmount"];
            this.hasUnionInsurance = _data["hasUnionInsurance"];
            this.unionInsuranceEmployeeAmount = _data["unionInsuranceEmployeeAmount"];
        }
    }

    static fromJS(data: any): ActionV3UnionsSetFromValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionsSetFromValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["removeUnion"] = this.removeUnion;
        data["unionId"] = this.unionId;
        data["kidNumber"] = this.kidNumber;
        data["memberNumber"] = this.memberNumber;
        data["hasCollectiveInsurance"] = this.hasCollectiveInsurance;
        data["collectiveInsuranceEmployeeAmount"] = this.collectiveInsuranceEmployeeAmount;
        data["hasUnionInsurance"] = this.hasUnionInsurance;
        data["unionInsuranceEmployeeAmount"] = this.unionInsuranceEmployeeAmount;
        return data;
    }

    clone(): ActionV3UnionsSetFromValueDto {
        const json = this.toJSON();
        let result = new ActionV3UnionsSetFromValueDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3UnionsSetFromValueDto {
    /** The last active date of the union link (inclusive).

If not set, the union link will be active until forever.
 */
    to?: Date;
    removeUnion?: boolean;
    unionId?: string;
    kidNumber?: string;
    memberNumber?: string;
    hasCollectiveInsurance?: boolean;
    collectiveInsuranceEmployeeAmount?: string;
    hasUnionInsurance?: boolean;
    unionInsuranceEmployeeAmount?: string;
}

export class ActionV3UnionsSetTimelineItemDto extends GapV3TimelineItemDto implements IActionV3UnionsSetTimelineItemDto {
    value!: ActionV3UnionDto;

    constructor(data?: IActionV3UnionsSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3UnionDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3UnionDto.fromJS(_data["value"]) : new ActionV3UnionDto();
        }
    }

    static override fromJS(data: any): ActionV3UnionsSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionsSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3UnionsSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3UnionsSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3UnionsSetTimelineItemDto extends IGapV3TimelineItemDto {
    value: ActionV3UnionDto;
}

export class ActionV3UnionDto implements IActionV3UnionDto {
    kidNumber?: string;
    detailTimeline!: ActionV3UnionDetailTimelineItemDto[];

    constructor(data?: IActionV3UnionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.detailTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kidNumber = _data["kidNumber"];
            if (Array.isArray(_data["detailTimeline"])) {
                this.detailTimeline = [] as any;
                for (let item of _data["detailTimeline"])
                    this.detailTimeline!.push(ActionV3UnionDetailTimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3UnionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kidNumber"] = this.kidNumber;
        if (Array.isArray(this.detailTimeline)) {
            data["detailTimeline"] = [];
            for (let item of this.detailTimeline)
                data["detailTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3UnionDto {
        const json = this.toJSON();
        let result = new ActionV3UnionDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3UnionDto {
    kidNumber?: string;
    detailTimeline: ActionV3UnionDetailTimelineItemDto[];
}

export class ActionV3UnionDetailTimelineItemDto extends GapV3TimelineItemDto implements IActionV3UnionDetailTimelineItemDto {
    value!: ActionV3UnionDetailDto;

    constructor(data?: IActionV3UnionDetailTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3UnionDetailDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3UnionDetailDto.fromJS(_data["value"]) : new ActionV3UnionDetailDto();
        }
    }

    static override fromJS(data: any): ActionV3UnionDetailTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionDetailTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3UnionDetailTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3UnionDetailTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3UnionDetailTimelineItemDto extends IGapV3TimelineItemDto {
    value: ActionV3UnionDetailDto;
}

export class ActionV3UnionDetailDto implements IActionV3UnionDetailDto {
    unionId?: string;
    memberNumber?: string;
    hasCollectiveInsurance?: boolean;
    collectiveInsuranceEmployeeAmount?: string;
    hasUnionInsurance?: boolean;
    unionInsuranceEmployeeAmount?: string;

    constructor(data?: IActionV3UnionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.memberNumber = _data["memberNumber"];
            this.hasCollectiveInsurance = _data["hasCollectiveInsurance"];
            this.collectiveInsuranceEmployeeAmount = _data["collectiveInsuranceEmployeeAmount"];
            this.hasUnionInsurance = _data["hasUnionInsurance"];
            this.unionInsuranceEmployeeAmount = _data["unionInsuranceEmployeeAmount"];
        }
    }

    static fromJS(data: any): ActionV3UnionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3UnionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["memberNumber"] = this.memberNumber;
        data["hasCollectiveInsurance"] = this.hasCollectiveInsurance;
        data["collectiveInsuranceEmployeeAmount"] = this.collectiveInsuranceEmployeeAmount;
        data["hasUnionInsurance"] = this.hasUnionInsurance;
        data["unionInsuranceEmployeeAmount"] = this.unionInsuranceEmployeeAmount;
        return data;
    }

    clone(): ActionV3UnionDetailDto {
        const json = this.toJSON();
        let result = new ActionV3UnionDetailDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3UnionDetailDto {
    unionId?: string;
    memberNumber?: string;
    hasCollectiveInsurance?: boolean;
    collectiveInsuranceEmployeeAmount?: string;
    hasUnionInsurance?: boolean;
    unionInsuranceEmployeeAmount?: string;
}

/** Cost units consist of only temporal properties. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. Unlike other temporal properties, the cost unit schema is different either replacing timeline or setting a set of cost unit from a date, because the timeline is on the values, but the top level list is of types. */
export class ActionV3CostUnitsRequestDto implements IActionV3CostUnitsRequestDto {
    setTimeline?: EmployeeV3CostUnitTypeLinkDto[];
    setFrom?: ActionV3CostUnitsSetFromDto;

    constructor(data?: IActionV3CostUnitsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(EmployeeV3CostUnitTypeLinkDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3CostUnitsSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3CostUnitsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CostUnitsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3CostUnitsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3CostUnitsRequestDto();
        result.init(json);
        return result;
    }
}

/** Cost units consist of only temporal properties. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. Unlike other temporal properties, the cost unit schema is different either replacing timeline or setting a set of cost unit from a date, because the timeline is on the values, but the top level list is of types. */
export interface IActionV3CostUnitsRequestDto {
    setTimeline?: EmployeeV3CostUnitTypeLinkDto[];
    setFrom?: ActionV3CostUnitsSetFromDto;
}

export class ActionV3CostUnitsSetFromDto implements IActionV3CostUnitsSetFromDto {
    from!: Date;
    values!: ActionV3CostUnitsSetFromItemDto[];

    constructor(data?: IActionV3CostUnitsSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ActionV3CostUnitsSetFromItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3CostUnitsSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CostUnitsSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3CostUnitsSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3CostUnitsSetFromDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CostUnitsSetFromDto {
    from: Date;
    values: ActionV3CostUnitsSetFromItemDto[];
}

export class ActionV3CostUnitsSetFromItemDto implements IActionV3CostUnitsSetFromItemDto {
    typeCustomId!: string;
    valueCustomId!: string;

    constructor(data?: IActionV3CostUnitsSetFromItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            this.valueCustomId = _data["valueCustomId"];
        }
    }

    static fromJS(data: any): ActionV3CostUnitsSetFromItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3CostUnitsSetFromItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        data["valueCustomId"] = this.valueCustomId;
        return data;
    }

    clone(): ActionV3CostUnitsSetFromItemDto {
        const json = this.toJSON();
        let result = new ActionV3CostUnitsSetFromItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3CostUnitsSetFromItemDto {
    typeCustomId: string;
    valueCustomId: string;
}

/** Employment consists of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. */
export class ActionV3EmploymentRequestDto implements IActionV3EmploymentRequestDto {
    static!: ActionV3StaticEmploymentDto;
    setTimeline?: ActionV3EmploymentSetTimelineItemDto[];
    setFrom?: ActionV3EmploymentSetFromDto;

    constructor(data?: IActionV3EmploymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticEmploymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticEmploymentDto.fromJS(_data["static"]) : new ActionV3StaticEmploymentDto();
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3EmploymentSetTimelineItemDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3EmploymentSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3EmploymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmploymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3EmploymentRequestDto {
        const json = this.toJSON();
        let result = new ActionV3EmploymentRequestDto();
        result.init(json);
        return result;
    }
}

/** Employment consists of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. */
export interface IActionV3EmploymentRequestDto {
    static: ActionV3StaticEmploymentDto;
    setTimeline?: ActionV3EmploymentSetTimelineItemDto[];
    setFrom?: ActionV3EmploymentSetFromDto;
}

export class ActionV3StaticEmploymentDto implements IActionV3StaticEmploymentDto {
    /** cannot be changed to a later date */
    startDate?: Date;
    /** cannot be changed to an earlier date */
    endDate?: Date;
    endReason?: string;
    employmentType?: EmploymentTypeV3EnumDto;
    layoffPercentageTimeline!: EmployeeV3LayoffItemDto[];

    constructor(data?: IActionV3StaticEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.layoffPercentageTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.endReason = _data["endReason"];
            this.employmentType = _data["employmentType"];
            if (Array.isArray(_data["layoffPercentageTimeline"])) {
                this.layoffPercentageTimeline = [] as any;
                for (let item of _data["layoffPercentageTimeline"])
                    this.layoffPercentageTimeline!.push(EmployeeV3LayoffItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionV3StaticEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? formatDate(this.startDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["endReason"] = this.endReason;
        data["employmentType"] = this.employmentType;
        if (Array.isArray(this.layoffPercentageTimeline)) {
            data["layoffPercentageTimeline"] = [];
            for (let item of this.layoffPercentageTimeline)
                data["layoffPercentageTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActionV3StaticEmploymentDto {
        const json = this.toJSON();
        let result = new ActionV3StaticEmploymentDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticEmploymentDto {
    /** cannot be changed to a later date */
    startDate?: Date;
    /** cannot be changed to an earlier date */
    endDate?: Date;
    endReason?: string;
    employmentType?: EmploymentTypeV3EnumDto;
    layoffPercentageTimeline: EmployeeV3LayoffItemDto[];
}

export class ActionV3EmploymentSetTimelineItemDto extends FullV3TimelineItemDto implements IActionV3EmploymentSetTimelineItemDto {
    value!: ActionV3TemporalEmploymentDto;

    constructor(data?: IActionV3EmploymentSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3TemporalEmploymentDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3TemporalEmploymentDto.fromJS(_data["value"]) : new ActionV3TemporalEmploymentDto();
        }
    }

    static override fromJS(data: any): ActionV3EmploymentSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmploymentSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3EmploymentSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3EmploymentSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmploymentSetTimelineItemDto extends IFullV3TimelineItemDto {
    value: ActionV3TemporalEmploymentDto;
}

export class ActionV3EmploymentSetFromDto implements IActionV3EmploymentSetFromDto {
    from!: Date;
    value!: ActionV3TemporalEmploymentDto;

    constructor(data?: IActionV3EmploymentSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3TemporalEmploymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3TemporalEmploymentDto.fromJS(_data["value"]) : new ActionV3TemporalEmploymentDto();
        }
    }

    static fromJS(data: any): ActionV3EmploymentSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3EmploymentSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3EmploymentSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3EmploymentSetFromDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3EmploymentSetFromDto {
    from: Date;
    value: ActionV3TemporalEmploymentDto;
}

export class ActionV3TemporalEmploymentDto implements IActionV3TemporalEmploymentDto {
    taxUnitId?: string;
    maritimeValue?: EmployeeV3MaritimeValueDto;
    appointmentType?: AppointmentTypeV3EnumDto;
    occupationCode?: string;
    workTimeAgreementValue?: string;
    ftePercentageValue?: string;
    personType?: string;

    constructor(data?: IActionV3TemporalEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxUnitId = _data["taxUnitId"];
            this.maritimeValue = _data["maritimeValue"] ? EmployeeV3MaritimeValueDto.fromJS(_data["maritimeValue"]) : undefined as any;
            this.appointmentType = _data["appointmentType"];
            this.occupationCode = _data["occupationCode"];
            this.workTimeAgreementValue = _data["workTimeAgreementValue"];
            this.ftePercentageValue = _data["ftePercentageValue"];
            this.personType = _data["personType"];
        }
    }

    static fromJS(data: any): ActionV3TemporalEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TemporalEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxUnitId"] = this.taxUnitId;
        data["maritimeValue"] = this.maritimeValue ? this.maritimeValue.toJSON() : undefined as any;
        data["appointmentType"] = this.appointmentType;
        data["occupationCode"] = this.occupationCode;
        data["workTimeAgreementValue"] = this.workTimeAgreementValue;
        data["ftePercentageValue"] = this.ftePercentageValue;
        data["personType"] = this.personType;
        return data;
    }

    clone(): ActionV3TemporalEmploymentDto {
        const json = this.toJSON();
        let result = new ActionV3TemporalEmploymentDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TemporalEmploymentDto {
    taxUnitId?: string;
    maritimeValue?: EmployeeV3MaritimeValueDto;
    appointmentType?: AppointmentTypeV3EnumDto;
    occupationCode?: string;
    workTimeAgreementValue?: string;
    ftePercentageValue?: string;
    personType?: string;
}

/** Manager consists of static properties. Static properties have one value throughout the timeline, to change it post the new static values. */
export class ActionV3ManagerRequestDto implements IActionV3ManagerRequestDto {
    static!: ActionV3StaticManagerDto;

    constructor(data?: IActionV3ManagerRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticManagerDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticManagerDto.fromJS(_data["static"]) : new ActionV3StaticManagerDto();
        }
    }

    static fromJS(data: any): ActionV3ManagerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3ManagerRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3ManagerRequestDto {
        const json = this.toJSON();
        let result = new ActionV3ManagerRequestDto();
        result.init(json);
        return result;
    }
}

/** Manager consists of static properties. Static properties have one value throughout the timeline, to change it post the new static values. */
export interface IActionV3ManagerRequestDto {
    static: ActionV3StaticManagerDto;
}

export class ActionV3StaticManagerDto implements IActionV3StaticManagerDto {
    managerId?: string;

    constructor(data?: IActionV3StaticManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managerId = _data["managerId"];
        }
    }

    static fromJS(data: any): ActionV3StaticManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerId"] = this.managerId;
        return data;
    }

    clone(): ActionV3StaticManagerDto {
        const json = this.toJSON();
        let result = new ActionV3StaticManagerDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticManagerDto {
    managerId?: string;
}

/** NAV group consists of only temporal properties. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. All properties in this group have a gap timeline, to set a value for a period where it has no value, set the properties to undefined. */
export class ActionV3NavRequestDto implements IActionV3NavRequestDto {
    setTimeline?: ActionV3NavSetTimelineItemDto[];
    setFrom?: ActionV3NavSetFromDto;

    constructor(data?: IActionV3NavRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3NavSetTimelineItemDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3NavSetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3NavRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3NavRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3NavRequestDto {
        const json = this.toJSON();
        let result = new ActionV3NavRequestDto();
        result.init(json);
        return result;
    }
}

/** NAV group consists of only temporal properties. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. All properties in this group have a gap timeline, to set a value for a period where it has no value, set the properties to undefined. */
export interface IActionV3NavRequestDto {
    setTimeline?: ActionV3NavSetTimelineItemDto[];
    setFrom?: ActionV3NavSetFromDto;
}

export class ActionV3NavSetTimelineItemDto extends FullV3TimelineItemDto implements IActionV3NavSetTimelineItemDto {
    value!: ActionV3TemporalNavDto;

    constructor(data?: IActionV3NavSetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3TemporalNavDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3TemporalNavDto.fromJS(_data["value"]) : new ActionV3TemporalNavDto();
        }
    }

    static override fromJS(data: any): ActionV3NavSetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3NavSetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3NavSetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3NavSetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3NavSetTimelineItemDto extends IFullV3TimelineItemDto {
    value: ActionV3TemporalNavDto;
}

export class ActionV3NavSetFromDto implements IActionV3NavSetFromDto {
    from!: Date;
    value!: ActionV3TemporalNavDto;

    constructor(data?: IActionV3NavSetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3TemporalNavDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3TemporalNavDto.fromJS(_data["value"]) : new ActionV3TemporalNavDto();
        }
    }

    static fromJS(data: any): ActionV3NavSetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3NavSetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3NavSetFromDto {
        const json = this.toJSON();
        let result = new ActionV3NavSetFromDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3NavSetFromDto {
    from: Date;
    value: ActionV3TemporalNavDto;
}

export class ActionV3TemporalNavDto implements IActionV3TemporalNavDto {
    hasPrepaidSicknessBenefit?: boolean;
    hasPrepaidOtherBenefit?: boolean;

    constructor(data?: IActionV3TemporalNavDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasPrepaidSicknessBenefit = _data["hasPrepaidSicknessBenefit"];
            this.hasPrepaidOtherBenefit = _data["hasPrepaidOtherBenefit"];
        }
    }

    static fromJS(data: any): ActionV3TemporalNavDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TemporalNavDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPrepaidSicknessBenefit"] = this.hasPrepaidSicknessBenefit;
        data["hasPrepaidOtherBenefit"] = this.hasPrepaidOtherBenefit;
        return data;
    }

    clone(): ActionV3TemporalNavDto {
        const json = this.toJSON();
        let result = new ActionV3TemporalNavDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TemporalNavDto {
    hasPrepaidSicknessBenefit?: boolean;
    hasPrepaidOtherBenefit?: boolean;
}

/** Salary consists of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. */
export class ActionV3SalaryRequestDto implements IActionV3SalaryRequestDto {
    setTimeline?: ActionV3SalarySetTimelineItemDto[];
    setFrom?: ActionV3SalarySetFromDto;

    constructor(data?: IActionV3SalaryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["setTimeline"])) {
                this.setTimeline = [] as any;
                for (let item of _data["setTimeline"])
                    this.setTimeline!.push(ActionV3SalarySetTimelineItemDto.fromJS(item));
            }
            this.setFrom = _data["setFrom"] ? ActionV3SalarySetFromDto.fromJS(_data["setFrom"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActionV3SalaryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3SalaryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.setTimeline)) {
            data["setTimeline"] = [];
            for (let item of this.setTimeline)
                data["setTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["setFrom"] = this.setFrom ? this.setFrom.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3SalaryRequestDto {
        const json = this.toJSON();
        let result = new ActionV3SalaryRequestDto();
        result.init(json);
        return result;
    }
}

/** Salary consists of static and temporal properties. Static properties have one value throughout the timeline, to change them post the new static values. Temporal properties have a timeline and it is possible to change them either by replacing the timeline with a new one or by setting the new value starting from date. */
export interface IActionV3SalaryRequestDto {
    setTimeline?: ActionV3SalarySetTimelineItemDto[];
    setFrom?: ActionV3SalarySetFromDto;
}

export class ActionV3SalarySetTimelineItemDto extends FullV3TimelineItemDto implements IActionV3SalarySetTimelineItemDto {
    value!: ActionV3TemporalSalaryDto;

    constructor(data?: IActionV3SalarySetTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new ActionV3TemporalSalaryDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ActionV3TemporalSalaryDto.fromJS(_data["value"]) : new ActionV3TemporalSalaryDto();
        }
    }

    static override fromJS(data: any): ActionV3SalarySetTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3SalarySetTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActionV3SalarySetTimelineItemDto {
        const json = this.toJSON();
        let result = new ActionV3SalarySetTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3SalarySetTimelineItemDto extends IFullV3TimelineItemDto {
    value: ActionV3TemporalSalaryDto;
}

export class ActionV3SalarySetFromDto implements IActionV3SalarySetFromDto {
    from!: Date;
    value!: ActionV3TemporalSalaryDto;

    constructor(data?: IActionV3SalarySetFromDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = new ActionV3TemporalSalaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.value = _data["value"] ? ActionV3TemporalSalaryDto.fromJS(_data["value"]) : new ActionV3TemporalSalaryDto();
        }
    }

    static fromJS(data: any): ActionV3SalarySetFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3SalarySetFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3SalarySetFromDto {
        const json = this.toJSON();
        let result = new ActionV3SalarySetFromDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3SalarySetFromDto {
    from: Date;
    value: ActionV3TemporalSalaryDto;
}

export class ActionV3TemporalSalaryDto implements IActionV3TemporalSalaryDto {
    salaryType?: SalaryTypeV3EnumDto;
    inputType?: BasePayInputTypeV3EnumDto;
    hourlyWage?: string;
    fullTimeMonthlySalary?: string;
    fullTimeYearlySalary?: string;
    payRate4?: string;
    payRate5?: string;
    payRate6?: string;
    payRate7?: string;
    payRate8?: string;
    payRate9?: string;
    setOfAccount?: string;

    constructor(data?: IActionV3TemporalSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryType = _data["salaryType"];
            this.inputType = _data["inputType"];
            this.hourlyWage = _data["hourlyWage"];
            this.fullTimeMonthlySalary = _data["fullTimeMonthlySalary"];
            this.fullTimeYearlySalary = _data["fullTimeYearlySalary"];
            this.payRate4 = _data["payRate4"];
            this.payRate5 = _data["payRate5"];
            this.payRate6 = _data["payRate6"];
            this.payRate7 = _data["payRate7"];
            this.payRate8 = _data["payRate8"];
            this.payRate9 = _data["payRate9"];
            this.setOfAccount = _data["setOfAccount"];
        }
    }

    static fromJS(data: any): ActionV3TemporalSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TemporalSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryType"] = this.salaryType;
        data["inputType"] = this.inputType;
        data["hourlyWage"] = this.hourlyWage;
        data["fullTimeMonthlySalary"] = this.fullTimeMonthlySalary;
        data["fullTimeYearlySalary"] = this.fullTimeYearlySalary;
        data["payRate4"] = this.payRate4;
        data["payRate5"] = this.payRate5;
        data["payRate6"] = this.payRate6;
        data["payRate7"] = this.payRate7;
        data["payRate8"] = this.payRate8;
        data["payRate9"] = this.payRate9;
        data["setOfAccount"] = this.setOfAccount;
        return data;
    }

    clone(): ActionV3TemporalSalaryDto {
        const json = this.toJSON();
        let result = new ActionV3TemporalSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3TemporalSalaryDto {
    salaryType?: SalaryTypeV3EnumDto;
    inputType?: BasePayInputTypeV3EnumDto;
    hourlyWage?: string;
    fullTimeMonthlySalary?: string;
    fullTimeYearlySalary?: string;
    payRate4?: string;
    payRate5?: string;
    payRate6?: string;
    payRate7?: string;
    payRate8?: string;
    payRate9?: string;
    setOfAccount?: string;
}

/** Tags consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export class ActionV3TagsRequestDto implements IActionV3TagsRequestDto {
    static!: ActionV3StaticTagsDto;

    constructor(data?: IActionV3TagsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.static = new ActionV3StaticTagsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.static = _data["static"] ? ActionV3StaticTagsDto.fromJS(_data["static"]) : new ActionV3StaticTagsDto();
        }
    }

    static fromJS(data: any): ActionV3TagsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3TagsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["static"] = this.static ? this.static.toJSON() : undefined as any;
        return data;
    }

    clone(): ActionV3TagsRequestDto {
        const json = this.toJSON();
        let result = new ActionV3TagsRequestDto();
        result.init(json);
        return result;
    }
}

/** Tags consist of only static properties. Static properties have one value throughout the timeline, to change them post the new static values. */
export interface IActionV3TagsRequestDto {
    static: ActionV3StaticTagsDto;
}

export class ActionV3StaticTagsDto implements IActionV3StaticTagsDto {
    /** List of GUIDs. Array can be empty. */
    tagIds!: string[];

    constructor(data?: IActionV3StaticTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ActionV3StaticTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionV3StaticTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }

    clone(): ActionV3StaticTagsDto {
        const json = this.toJSON();
        let result = new ActionV3StaticTagsDto();
        result.init(json);
        return result;
    }
}

export interface IActionV3StaticTagsDto {
    /** List of GUIDs. Array can be empty. */
    tagIds: string[];
}

export enum ActionV3EmployeeActionType {
    AdditionalInformation = "additionalInformation",
    Children = "children",
    ChronicallyIll = "chronicallyIll",
    CostUnits = "costUnits",
    EmergencyContacts = "emergencyContacts",
    EmployeeDelete = "employeeDelete",
    EmployeeNumber = "employeeNumber",
    Employment = "employment",
    EmploymentAgreements = "employmentAgreements",
    Manager = "manager",
    Nav = "nav",
    PayslipAndPayment = "payslipAndPayment",
    PersonalDetails = "personalDetails",
    PromoteDraft = "promoteDraft",
    Salary = "salary",
    Tags = "tags",
    TaxAndTaxCard = "taxAndTaxCard",
    CreditorClaims = "creditorClaims",
    Cars = "cars",
    PensionCompanies = "pensionCompanies",
    Unions = "unions",
}

export enum ActionV3NextActionType {
    AssignUser = "assignUser",
}

/** Mandatory when a `governmentIdTimeline` entry uses type `governmentIdTypeV3EnumDto.foreign`. Generated and overwritten if there is also an entry with another type. ___ Monolith notes: Mapping to values in reference table 10030 Gender: - `female`: `Female` - `male`: `Male` Field "Gender" (97188622-bb4a-431e-9081-bfe36ffa8b36). Generated based on `nationalId` or `dNumber` in `employeeV3GovernmentIdValueDto` if the ID is of the corresponding type. If there are multiple entries, it is not straight forward to determine which will be used. Known issue: The gender entered for foreign ID should not change, but does change if the birth date in a D number or national ID is different. Known issue: Starting 2032-01-01 the gender will no longer be encoded in the D number or national ID: https://www.skatteetaten.no/deling/folkeregisteret/pid/ ___ */
export enum GenderV3EnumDto {
    Female = "female",
    Male = "male",
}

/** AKA type of id. Mandatory. ___ Monolith notes: Mapping to values in reference table 20160 Type ID: - `national`: `NationalID` - `dNumber`: `DNumber` - `foreign`: `InternationalID` ___ */
export enum GovernmentIdTypeV3EnumDto {
    National = "national",
    DNumber = "dNumber",
    Foreign = "foreign",
}

/** AKA type of international ID. Mandatory. ___ Monolith notes: Mapping to values in reference table 20150 Type international ID: - `passport`: `Pass` - `socialSecurityNumber`: `SocialSecurity` - `taxNumber`: `TaxNo` - `valueAddedTaxNumber`: `ValueAddedTaxNo` ___ */
export enum ForeignGovernmentIdTypeV3EnumDto {
    Passport = "passport",
    SocialSecurityNumber = "socialSecurityNumber",
    TaxNumber = "taxNumber",
    ValueAddedTaxNumber = "valueAddedTaxNumber",
}

/** ___ Monolith notes: Mapping to values in reference table 10020 Phone type: - `work`: `Business`   - `BusinessMobile` was valid until 2019-09-22 but will be changed to `work` when mapping between field engine   - Invalid values stored in field engine will also be mapped to `work` - `private`: `Private`  - `PrivateMobile` was valid until 2019-09-22 but will be changed to `private` when mapping between field engine Field "Phone type" (2c72cfda-b51f-4a25-90eb-0f94335574ad). ___ */
export enum PhoneTypeV3EnumDto {
    Work = "work",
    Private = "private",
}

/** Mandatory. ___ Monolith notes: Mapping to values in reference table 10010 Email Type: - `work`: `Business`   - `Other` was valid until 2019-09-22 but will be changed to `work` when mapping between field engine   - Invalid values stored in field engine will also be mapped to `work` - `private`: `Private` Field "E-mail type" (944688a4-d88a-433b-a0b3-80de190daa9a). Known issue: The user's email type may be missing. See monolith notes on `user.emailAddress`. ___ */
export enum EmailTypeV3EnumDto {
    Work = "work",
    Private = "private",
}

/** Extensible. ___ Monolith notes: Mapping to values in reference table 10040 No / Yes: - `norwegian`: `No` (or anything which is not `Yes`) - `english`: `Yes` Field "Payslip in English" (31fa9f89-18f0-4a62-8da4-889d7e95faee). ___ */
export enum PayslipLanguageV3EnumDto {
    Norwegian = "norwegian",
    English = "english",
}

/** All values are allowed for `defaultPayment.type`. Only `norwegianBank` is allowed for `extraPaymentsTimeline[].value.payment.type`. ___ Monolith notes: Mapping to values in reference table 20110 Payment type: - `external`: `cash` (falsely implies that payment happens in physical currency) - `norwegianBank`: `bank` - `foreignBank`: `bank` - n/a: `creditor` - n/a: `union` Field "Payment type" (4cb435ed-9f81-413c-befe-d06141665bf2) Combines with field "International bank account" (ce2416b0-b4c6-412e-99d5-8e79a7f560d2) using values from reference table 10040 No / Yes: - `norwegianBank`: `No` (or anything which is not `Yes`) - `foreignBank`: `Yes` ___ */
export enum PaymentTypeV3EnumDto {
    External = "external",
    NorwegianBank = "norwegianBank",
    ForeignBank = "foreignBank",
}

/** AKA additional accounts deduction method. ___ Monolith notes: Mapping to values in reference table 21010 Deduction method: - `fixedAmount`: `amount` - `paycode`: `paycode` - n/a: `percentage` Field "Deduction method" (103dca57-eacb-439d-9349-52075b626941). ___ */
export enum ExtraPaymentCalculationMethodV3EnumDto {
    FixedAmount = "fixedAmount",
    Paycode = "paycode",
}

/** Mandatory. ___ Monolith notes: Mapping to values in reference table 80140 Type of deduction: - `childSupport`: `child` (Child support) - `legalOffence`: `legaloffence` (Compensation legal offence) - `tax`: `unpaidtax` (Unpaid tax) - `governmentClaim`: `claimsstate` (Claims from State-owned Company) - `coordinated`: `coordinated` (Coordinated attachment of earnings) - `userDefined`: `other` (Other) Field: "Creditor payment type" (4697d649-b786-49f4-a052-5df6d8f4495d). ___ */
export enum CreditorClaimTypeV3EnumDto {
    ChildSupport = "childSupport",
    LegalOffence = "legalOffence",
    Tax = "tax",
    GovernmentClaim = "governmentClaim",
    Coordinated = "coordinated",
    UserDefined = "userDefined",
}

/** Mandatory. When `employeeV3CreditorClaimValueDto.type` is `childSupport`, only `fixedAmount` is allowed. ___ Monolith notes: Mapping to values in reference table 21010 Deduction method: - `fixedAmount`: `amount` - `taxBasisPercentage`: `percentage` - n/a: `paycode` Field "Deduction method" (103dca57-eacb-439d-9349-52075b626941). ___ */
export enum CreditorClaimCalculationMethodV3EnumDto {
    FixedAmount = "fixedAmount",
    TaxBasisPercentage = "taxBasisPercentage",
}

/** Extensible. ___ Monolith notes: Mapping to values in reference table 20030 Category of employee: - `whiteCollar`: `White` - `blueCollar`: `Blue` - `other`: `Other` ___ */
export enum SetOfAccountV3EnumDto {
    WhiteCollar = "whiteCollar",
    BlueCollar = "blueCollar",
    Other = "other",
}

/** Extensible. ___ Monolith notes: Mapping to values in reference table 20200 Position end reason: - `dataEntryMistake`: `arbeidsforholdetSkulleAldriVaertRapportert`  (The employment should never have been reported) - `employerTermination`: `arbeidsgiverHarSagtOppArbeidstaker`  (The employer has terminated the employment relationship) - `employeeResignation`: `arbeidstakerHarSagtOppSelv`  (The employee has resigned from his/her position) - `technical`: `byttetLoenssystemEllerRegnskapsfoerer`  (Changed payroll system or accountant) - `organizational`: `endringIOrganisasjonsstrukturEllerByttetJobbInternt`  (Changes in organisational structure or internal job swap) - `hiringTermsExpiration`: `kontraktEngasjementEllerVikariatErUtloept`  (Contract, temporary appointment or temporary position has been terminated) ___ */
export enum PositionEndReasonV3EnumDto {
    DataEntryMistake = "dataEntryMistake",
    EmployerTermination = "employerTermination",
    EmployeeResignation = "employeeResignation",
    Technical = "technical",
    Organizational = "organizational",
    HiringTermsExpiration = "hiringTermsExpiration",
}

/** AKA type of position. Norwegian: type arbeidsforhold. Mandatory. `maritime` is only allowed if position has a start date of 2021-01-01 or later. https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/type-of-employment/select-the-applicable-employment-type/ ___ Monolith notes: Mapping to values in reference table 20020 Contract Type: - `ordinary`: `Ordinary` (Ordinary contract) - `maritime`: `maritimtArbeidsforhold` (Maritime employment) - `freelancer`: `Freelancer` (Freelancer, Contractors, Only receiving honorarium) - `pension`: `Pension` (Pension and other remunerations without employment) - `permanentlyAdaptedWork`: `Pension2` (PAW / VTA) Field "Type of position" (e7b5dcb2-11cb-401c-9332-89fc645e4ec6). There is another field engine field on Employment called "Type of employment". This is an unfortunate naming collision, perhaps further confused by that field not being in the new schema at all. It is redundant because it only has one possible value in reference table 20120 Type of Employment - n/a: `Employee` ___ */
export enum EmploymentTypeV3EnumDto {
    Ordinary = "ordinary",
    Maritime = "maritime",
    Freelancer = "freelancer",
    Pension = "pension",
    PermanentlyAdaptedWork = "permanentlyAdaptedWork",
}

/** Mandatory. Norwegian: skipsregister. ___ Monolith notes: Mapping to values in reference table 90100 Ship register: - `norwegian`: `nor` (Norwegian Ship Register) - `norwegianInternational`: `nis` (Norwegian International Ship Register) - `foreign`: `utl` (International ship register) ___ */
export enum ShipRegisterV3EnumDto {
    Norwegian = "norwegian",
    NorwegianInternational = "norwegianInternational",
    Foreign = "foreign",
}

/** Mandatory. Norwegian: skipstype. ___ Monolith notes: Mapping to values in reference table 90200 Vessel type: - `tourist`: `turist` (A cruise ship) - `drillingPlatform`: `boreplattform` (A drilling platform) - `other`: `annet` (Other type of vessel) ___ */
export enum VesselTypeV3EnumDto {
    Tourist = "tourist",
    DrillingPlatform = "drillingPlatform",
    Other = "other",
}

/** Mandatory. Norwegian: fartsområde. ___ Monolith notes: Mapping to values in reference table 90300 Shipping area: - `domestic`: `innenriks` - `international`: `utenriks` ___ */
export enum ShippingAreaV3EnumDto {
    Domestic = "domestic",
    International = "international",
}

/** AKA employment form. `temporaryHiredOut`, `temporaryOnCall` and `permanentHiredOut` are only allowed if timeline item or position has a start date of 2025-01-01 or later. ___ Monolith notes: Mapping to values in reference table 20210 Employment form: - `temporary`: `midlertidig` - `temporaryHiredOut`: `midlertidigAnsattUtleid` - `temporaryOnCall`: `midlertidigAnsattSomTilkallingsvikar` - `permanent`: `fast` - `permanentHiredOut`: `fastAnsattUtleid` ___ */
export enum AppointmentTypeV3EnumDto {
    Temporary = "temporary",
    TemporaryHiredOut = "temporaryHiredOut",
    TemporaryOnCall = "temporaryOnCall",
    Permanent = "permanent",
    PermanentHiredOut = "permanentHiredOut",
}

/** `honorarium`, `commission` and `straightPieceWork` are only allowed if timeline item or position has an end date of 2018-12-31 or earlier. ___ Monolith notes: Mapping to values in reference table 20010 Salary Type: - `hourly`: `Hourly` (Variable salary) - `fixed`: `Period` (Fixed salary) - `honorarium`: `Honorarium` (Fee) - `commission`: `Commission` (Commission/Percentage) - `straightPieceWork`: `StraightPieceWork` (Payment by results) Known issue (discrepancy): The vintage UI allows using the outdated values after a warning. ___ */
export enum SalaryTypeV3EnumDto {
    Hourly = "hourly",
    Fixed = "fixed",
    Honorarium = "honorarium",
    Commission = "commission",
    StraightPieceWork = "straightPieceWork",
}

/** AKA. contract salary type. ___ Monolith notes: Mapping to values in reference table 90400 Contract Salary Type: - `hourly`: `Hourly` - `fullTimeMonthly`: `Monthly` - `fullTimeYearly`: `Yearly` Field "Contract salary type" (43368bbd-e463-479d-8015-3351fff67272). The monolith naming could be confused with "Salary type", which decides how the pay is calculated whereas "Contract salary type" decides how the input for the calculation is specified. ___ */
export enum BasePayInputTypeV3EnumDto {
    Hourly = "hourly",
    FullTimeMonthly = "fullTimeMonthly",
    FullTimeYearly = "fullTimeYearly",
}

/** Extensible. ___ Monolith notes: Mapping to values in reference table 80090 Type of Person: - `commuterNorwegian`: `Commuter` (Norwegian commuter) - `commuterForeign`: `CommuterForeign` (Foreign commuter) - `commuterForeignTaxCardNoDeduction`: `CommuterForeignTaxcard` (Foreign commuter with taxcard without standard deduction) - `expatriateInNorway`: `ExpatNorway` (Expatriate in Norway) - `offshoreWorker`: `Offshore` (Offshore worker) ___ */
export enum PersonTypeV3EnumDto {
    CommuterNorwegian = "commuterNorwegian",
    CommuterForeign = "commuterForeign",
    CommuterForeignTaxCardNoDeduction = "commuterForeignTaxCardNoDeduction",
    ExpatriateInNorway = "expatriateInNorway",
    OffshoreWorker = "offshoreWorker",
}

/** Extensible. `otherShift` is only allowed if timeline item or work time agreement has a start date of 2019-01-01 or later. ___ Monolith notes: Mapping to values in reference table 80030 Working time arrangement: - `offshore336`: `Offshore336` (Work offshore - 33,6 h/w) - `shift355`: `RoundTheClockShift355` (Round the clock shift worker - 35,5 h/w) - `shift336`: `ContinuousShift336` (Continuous shift worker 33,6 h/w) - `shift365`: `Shift365` (Not a shift worker) - `otherShift`: `OtherShift` (Shift worker - 36,5 h/w) - `notShift`: `NotShift` (Other Shift) ___ */
export enum WorkingTimeArrangementV3EnumDto {
    Offshore336 = "offshore336",
    Shift355 = "shift355",
    Shift336 = "shift336",
    Shift365 = "shift365",
    OtherShift = "otherShift",
    NotShift = "notShift",
}

/** ___ Monolith notes: Mapping to values in reference table 83100 CarCalculationMethod: - `listPrice`: `listprice` - `kilometers`: `kilometers` ___ */
export enum CarCalculationMethodV3EnumDto {
    ListPrice = "listPrice",
    Kilometers = "kilometers",
}

/** https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/salary-and-benefits/overview-of-salary-and-other-benefits/free-use-of-car-standard-rule/ https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/salary-and-benefits/overview-of-salary-and-other-benefits/car-allowances-subject-to-withholding-tax/ https://www.skatteetaten.no/en/rettskilder/type/handboker/skatte-abc/2021/bil--privat-bruk/B-7.038/B-7.040/ https://www.skatteetaten.no/en/rates/car-rates---company-cars/ https://www.skatteetaten.no/en/rates/car-rates---company-car-category-2-vans-and-small-trucks/ https://www.skatteetaten.no/en/rates/car-rates---company-cars-where-the-benefit-is-not-in-proportion-to-the-list-price/ ___ Monolith notes: Mapping to values in reference table 40000 Car types: - `standard`: `regularCar` - `category2`: `vans2TruckBelow7501` - `disproportionate`: `disproportionateCar` Field "Car type" (974d7bea-35d4-4aba-8efc-e28a086d694a). ___ */
export enum CarReportingRuleV3EnumDto {
    Standard = "standard",
    Category2 = "category2",
    Disproportionate = "disproportionate",
}

/** Special conditions for earnings. `oceanMineralRenewableCarbon` is only allowed if position has a start date of 2025-01-01 or later. ___  Monolith notes: Mapping to values in reference table 41000 Special conditions for earnings:  - `childUnder13`: `skattefriArbeidsinntektBarnUnderTrettenAar` (Tax-free income from employment for children under the age of 13)  - `seafarer`: `hyreTilMannskapPaaFiskeSmaahvalfangstOgSelfangstfartoey` (Seafarers wages earned onboard (fishing, whaling, sealing))  - `nonTaxable`: `loennOgAnnenGodtgjoerelseSomIkkeErSkattepliktig` (Salary and others not liable for tax (border commuter))  - `labourMarketScheme`: `loennVedArbeidsmarkedstiltak` (Salary - Labour Market schemes)  - `wageGuarantee`: `loennVedKonkursEllerStatsgarantiOsv` (Salary - company bankrupt)  - `foreignSeafarer`: `utenlandskeSjoefolkSomIkkeErSkattepliktig` (Foreign seafarers - no tax)  - `oceanMineralRenewableCarbon`: `havMineralFornybarKarbon` (Ocean Mineral Renewable Carbon) ___ */
export enum EarningSpecialConditionV3EnumDto {
    ChildUnder13 = "childUnder13",
    Seafarer = "seafarer",
    NonTaxable = "nonTaxable",
    LabourMarketScheme = "labourMarketScheme",
    WageGuarantee = "wageGuarantee",
    ForeignSeafarer = "foreignSeafarer",
    OceanMineralRenewableCarbon = "oceanMineralRenewableCarbon",
}

export class EmployeeV3ForCardResponseDto implements IEmployeeV3ForCardResponseDto {
    employee!: EmployeeV3ForCardDto;

    constructor(data?: IEmployeeV3ForCardResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employee = new EmployeeV3ForCardDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeV3ForCardDto.fromJS(_data["employee"]) : new EmployeeV3ForCardDto();
        }
    }

    static fromJS(data: any): EmployeeV3ForCardResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ForCardResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }

    clone(): EmployeeV3ForCardResponseDto {
        const json = this.toJSON();
        let result = new EmployeeV3ForCardResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3ForCardResponseDto {
    employee: EmployeeV3ForCardDto;
}

/** This schema uses strings to convey all numbers.  - A value can break any of of the following rules (except it must be a string),    but it will then have validation errors.  - These rules ensure that any precision aware numeric value    only has a single possible string representation.    - Meaning string comparison can be used to determine whether a value has changed.  - Numbers may start with a single dash (`-`) as a minus sign to indicate that it's negative,    where negative values are allowed (currently nowhere).  - The decimal separator is a period (`.`).  - If used, the decimal separator must always have at least one digit before and after.  - Other than `-` and `.` a number may only contain digits 0-9.  - There may be at most 15 digits in total.  - When custom format is `integer-15`    - Text must match pattern `^(-?[1-9][0-9]{0,14}|0)$`  - When custom format is `decimal-13-2`    - Text must match pattern `^-?([1-9][0-9]{0,12}|0)(\.[0-9]{1,2})?$`    - Except minus zero is disallowed (ie. `-0`, `-0.0` and `-0.00`)  - When custom format is `decimal-13-1`    - Text must match pattern `^-?([1-9][0-9]{0,12}|0)(\.[0-9])?$`    - Except minus zero is disallowed (ie. `-0` and `-0.0`)  - Calculated numbers are rounded to maximum number of decimals allowed by the field. Because - Arbitrary numbers cannot generally be safely serialized and deserialized in JSON. - Checking the number of digits after the decimal point is not generally possible in numeric types. - Numbers used in financial operations should retain the exact user input. - Clients must ensure user input is conveyed without changing accuracy or precision.  - Eg. 1.0 and 1.00 are different (precision).  - Eg. 12.345 as a user input cannot be rounded to 12.35 (accuracy and precision).  - Especially JavaScript clients should be careful about using the native number support. String format specifiers: - `date`  - OpenAPI standard.  - full-date in https://tools.ietf.org/html/rfc3339#section-5.6  - `'yyyy-MM-dd'` - `date-time`  - OpenAPI standard, but with time offset restricted to `'Z'`.  - date-time in https://tools.ietf.org/html/rfc3339#section-5.6    - Except only `'Z'` is allowed as time-offset, not time-numoffset. - `uuid`  - Custom.  - AKA GUID.  - https://en.wikipedia.org/wiki/Universally_unique_identifier  - Only lower case 8-4-4-4-12 format is allowed.    - Eg. `'56723616-3598-453d-8eb5-9f768813a5de'`  - There is no guarantee on the UUID format except length.    - Ie. it is not necessarily a specific version / variant, or even a known variant.      All bits could be set arbitrarily. - `decimal-13-2`  - Custom.  - See explanation about numbers above. - `decimal-13-1`  - Custom.  - See explanation about numbers above. - `integer-15`  - Custom.  - See explanation about numbers above. ___ Monolith notes: First, a note on these notes. They explain how this schema has been mapped from the monolith's API schema. The monolith (AKA the field engine or empman) has the EmployeeDto as the root object for an employee. EmployeeDto contains a couple of other object types (see the monolith notes on `id` for an overview of their relationship), but mostly contains generically defined 'fields' (thus 'field engine'). The fields are configured in 'DevUI' (Development UI) and used in the vintage Employee UI which is built using a 'Screen designer' that can specify which fields are used where. DevUI and Screen designer are only available for business analysts and rule developers, to define and configure fields and other rules. The original intention was for fields to be customizable on customer/company level -- and they technically are -- but fortunately this was never done. The Screen designer also places a lot of restrictions on the fields which are not part of the field configuration used by the monolith's API for EmployeeDto. Screen designer is loaded when validating an employee and used to restrict which fields can be set. Restrictions by Screen designer have been included in this API specification, but only by clicking through the UI, not analyzing the Screen designer configuration. Screen designer restrictions are built to hide. All is visible by default and when some value is set, something is hidden/limited/made readonly. The restrictions imposed by the Screen Designer are typically: - Fields are hidden based on values of other fields.  - This can also clear the value of the field (hidden vs hiddenbutvalueretained) - Fields are set to read-only based on values of other fields. - Field values (eg. dropdowns) are filtered based on values of other fields. The source of truth for an employee is currently EmployeeDto, but many simplifications have been done in order to arrive at this schema instead. To easily cross reference with the source of truth, monolith notes details which source fields (or plain properties) have been used and how. This schema's validations are sometimes different from those in the monolith. That is indicated with a "Known issue (discrepancy)" note. Mostly this schema is stricter. The only exception is email addresses where the monolith is stricter. Floating point numbers are validated and processed (but not stored) as [.NET Decimal](https://learn.microsoft.com/en-us/dotnet/api/system.decimal?view=netframework-4.7.1). - The validation is done with  [decimal.TryParse](https://learn.microsoft.com/en-us/dotnet/api/system.decimal.tryparse?view=netframework-4.7.1)  using parameters `CultureInfo.InvariantCulture` and  `NumberStyles.AllowLeadingSign` for  [number styles](https://learn.microsoft.com/en-us/dotnet/api/system.globalization.numberstyles?view=netframework-4.7.1). - It can accurately represent integers in the range -(2^96 - 1) to 2^96 - 1.  - 79 228 162 514 264 337 593 543 950 335 - It can accurately represent any floating point number with the a maximum total of 28 digits  - Or a number with 29 digits if it is between positive and negative 79 228 162 514 264 337 593 543 950 335    with a decimal point in the same place. - All fields are strings in the EmployeeDto and the numbers are stored as the original text.  - Known issue: Identical numbers might have different string values,    eg. `.1` and `0.1` or `1.` and `1`. - Known issue: Numbers inside the accepted integer range and numbers that are inside it when rounded  are allowed to have more digits.  - Ie. 79228162514264337593543950335.1111111111111111111111111111111111111111111111 can be stored    - If used in a calculation, it will be rounded to 28 or 29 digits, eg. 79228162514264337593543950335. - Known vintage UI issue: Numbers are parsed as JavaScript number and  the parsed value is  [serialized](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString)  and sent in the EmployeeDto.  - Numbers of 10^21 or more and less than 10^-6 are serialized with scientific notation.  - Ie. the maximum safe integer value in the backend will be sent as 7.922816251426434e+28    which is not accepted because AllowExponent is not used in the validation. - Known vintage UI issue: Numbers are parsed as JavaScript number and  the parsed value is serialized and displayed to the user. JavaScript's [number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) is inferior to .NET Decimal for the financial numbers we are handling, where the exact user input should be retained as much as possible. - number has a precision of 15 to 17 digits, far fewer than Decimal's 28 to 29. - number's safe integer range is -(2^53 - 1) to 2^53 - 1  - 9 007 199 254 740 991 - number serialization can use scientific notation  - whereas the monolith does not allow scientific notation To avoid conversion issues, numbers will be treated as string by the mapper, but they could yield validation errors (this has been known to happen for imported data): - The vintage UI prevents a number starting with the decimal separator,  but if any has come from other sources the user will have to be prepended it with 0. - The vintage UI prevents a number ending with the decimal separator,  but if any has come from other sources the user will have to remove the separator. - The vintage UI prevents additional leading zeroes,  but if any has come from other sources the user will have to remove them. - The vintage UI prevents minus zero,  but if it has come from other sources the user will have to change to simply zero. - If there are more than 15 digits in total, there will be a validation error.  - Any number with 15 or fewer digits (regardless of the decimal point placement)    can be accurately represented in a double (64-bit binary format IEEE 754).  - Known issue: The supported decimal range is -9 999 999 999 999.99    to 9 999 999 999 999.99. This is the same order of magnitude as Norway's 2023 GDP. - Except for edge cases, the monolith API prevents more than 2 digits after the decimal point.  Any edge case will yield a validation error the user has to fix. Known issue: Monolith is using the built-in script `String.IsNumeric` to validate non-decimal numbers stored in string type fields. The implementation accepts matches for pattern `^-?(\d+\.?\d*|\.\d+)$`. This is because -- sometimes after a length check -- validation is done with [decimal.TryParse](https://learn.microsoft.com/en-us/dotnet/api/system.decimal.tryparse?view=netframework-4.7.1) using parameters `CultureInfo.InvariantCulture` and `NumberStyles.AllowLeadingSign | NumberStyles.AllowDecimalPoint` for [number styles](https://learn.microsoft.com/en-us/dotnet/api/system.globalization.numberstyles?view=netframework-4.7.1). This yields the very strange pattern for integer values, accepting eg. `-1.2` which is obviously not a Norwegian postal code, tax table or similar. Fields of integer type does not suffer from this. ___ */
export class EmployeeV3ForCardDto implements IEmployeeV3ForCardDto {
    /** Changed whenever something changes on the employee (including any of the positions).
Do not make assumptions on format/ordering, but use `updatedAt` to determine which
of two employee instances is the newest.

Prohibited when creating a new employee.

The current value must be supplied when changing an employee.

___
Monolith notes: `EmployeeDto.RowVersion`.
___
 */
    readonly version!: string;
    /** Prohibited when creating a new employee.

So that comparison is easier, the time-offset will always be `'Z'`
rather than a time-numoffset.

___
Monolith notes: `EmployeeDto.LastChange`.
___
 */
    readonly updatedAt!: Date;
    /** Indicates whether the employee is in the draft state, which has special behavior:
- Only newly created employees and draft employees can be saved as drafts
  (meaning this field cannot change from `false` to `true`).
- Draft employees can be hard deleted.
- (TBD: verify) Draft employees are not available in wage runs and reports.
- Draft employees can be saved even with validation errors.
  - Technical schema guarantees have to be fulfilled (see list in `validationErrors`).
  - Select business validations also apply to draft employees
    - `customId` must be unique within the company (but it can be changed)

___
Monolith notes: Mapping to values in enum `Visma.Odp.Services.EmpMan.DTOs.Enums.EnumEmployeeStatus`
stored in `EmployeeDto.EntityStatus`:
- `false`: `1` (Active)
- `false`: `2` (Inactive)
- `false`: `3` (Future)
- `true`: `4` (Draft)

In V3 the non-draft values have to be calculated from `positionTimeline`:
1. Traverse the timeline in reverse order.
   1. If `from` is larger than today, mark as possibly future.
   2. Else
      1. If `to` is today or larger, status is 'active'.
      2. Else
         1. If marked as possibly future, status is 'future'.
         2. Else, status is 'inactive'.
2. If traversal completed without returning a status, status is 'inactive'
   (and there will be a validation error on `positionTimeline`).
___
 */
    isDraft!: boolean;
    /** Prohibited when creating a new employee.

AKA "employee id".
Do not confuse with the "Employee ID" field in the vintage UI,
which could have been labeled "Employee number" (from the Norwegian label Ansattnummer)
and is represented in this schema as `customId`.

___
Monolith notes: `EmploymentDto.Id`.

The original field engine design called for a one-to-many
relationship between employee and employment.
An employee would be a system wide representation of a person
which could have an employment with many companies.
This could cause data leak issues and was abandoned.
Actual data only has a one-to-one relationship between employee and employment,
meaning the ID of either uniquely identifies both.

When public APIs were introduced, employee and employment properties
were merged into "employee" and the employment's ID was picked as the
public ID of the new "employee". This can cause confusion for those used to
monolith terminology, so to be clear, this is the mapping:
- `employeeV3ForCardDto.id`: `EmploymentDto.Id`
- `employeeV3ForCardDto.legacyId`: `EmployeeDto.Id`
- `employeeV3PositionValueDto.id`: `ContractDto.Id`

The terminology is further confused when compared to a-messages.
See comments on `positionTimeline`.
___
 */
    readonly id!: string;
    /** Prohibited when creating a new employee.

___
Monolith notes: `Employee.Id`.

See also monolith notes on `id`.
___
 */
    readonly legacyId!: string;
    validationErrors?: EmployeeV3ValidationErrorDto[];
    user?: EmployeeV3UserDetailDto;
    /** AKA employee number (or even the more ambiguous employee ID).
Note that the string is not restricted to numeric values,
unlike what "employee number" implies.

This must be a company level unique value.
This restriction applies even to draft employees.

This cannot be changed and if trying the entire change will be rejected.
Draft employees are exempt from this restriction.

___
Monolith notes: Field "_Employee ID" (00000000-0000-4002-0101-000000000000).
___
 */
    customId?: string;
    /** Mandatory.

If `user` is set, this must be the same as `user.firstName` (case-insensitive).
See monolith notes.

Cannot start with a white space character, but otherwise accepts
any white space, letter and number as well as these characters:

```
- _ . ' : ~ ! @ # $ ^ & * + ( )
```

Any period (.) -- unless it is the last or second last character in the name --
must be followed by a period/space in the next or second next character.
Ie. "John Doe Jr.", "John D. Doe" and "M.C Hammer" are allowed
(along with many other less likely names),
but "D.Doe" and "M.CHammer" are disallowed.
A name is invalid if it matches the regex `\.[^ .]{2}`.

___
Monolith notes: Field "First name" (dcc429af-7941-4362-8b94-5a6dd68e5dff).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

The employee's name is used when creating users in ODP/Connect, so the restrictions on
this field attempt to be the same as restrictions on the names of users.

Naturally, the user's name SHOULD thereafter be the same as the employee's name.
The reason it MUST be the same is to avoid an incident where an employee instance
is repurposed for another actual person, thereby allowing
the original person with a user created to log in as somebody they are not.

Known issue: A name cannot be longer than 50 characters in Connect users,
but this is not validated by the monolith.
It used to be validated, but somebody requested the restriction be removed.
___
 */
    firstName?: string;
    /** Mandatory.

Same restrictions as `firstName`.

If `user` is set, this must be the same as `user.lastName` (case-insensitive).
See monolith notes in `firstName`.

___
Monolith notes: Field "Last name" (a97ae111-d6cc-4a80-b180-4e902d9f3b3d).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Possible known issue: A name cannot be longer than 50 characters in Connect users,
but this is not validated by the monolith.
It used to be validated, but somebody requested the restriction be removed.
___
 */
    lastName?: string;
    gender?: GenderV3EnumDto;
    /** Mandatory when a `governmentIdTimeline` entry uses
type `governmentIdTypeV3EnumDto.foreign`.
Generated and overwritten if there is also an entry with another type
(see monolith notes -- it is not guaranteed to be set because of a known issue).

Must be today or earlier.

___
Monolith notes: Field "Date of birth" (15b47abb-6cf7-41fe-bfe9-ff252e498962).

Generated based on `nationalId` or `dNumber` in
`employeeV3GovernmentIdValueDto` if the ID is of the corresponding type.
If there are multiple entries, it is not straight forward to determine which will be used.

Known issue: The birth date entered for foreign ID should not change,
but does change if the date in a D number or national ID is different.

Known issue: The monolith does not validate that the date part of
`nationalId` and `dNumber` is a valid date.
If it is invalid this field will be set to nothing.

Known issue: Neither national ID nor D number is guaranteed to contain the birth date,
and overriding the generated value is not possible.
Both type of numbers can lack available person digits on the correct date,
in which case another date will be used.
This also means the birth date derived from either is not necessarily consistent,
as just one of them could be out of available numbers.

Known issue: Starting 2024-02-01 (although it actually started earlier),
person digits in a `dNumber` no longer specify the century of birth.
On the assumption that 0 year olds are much more likely to be employed (eg. for commercials)
than 100 year olds, especially ones that do not have a national ID,
the script will only generates dates in the year range [current year - 99, current year].
___
 */
    birthDate?: Date;
    governmentIdTimeline!: EmployeeV3GovernmentIdItemDto[];
    phones!: EmployeeV3PhoneDto[];
    emails!: EmployeeV3EmailDto[];
    postalAddress!: EmployeeV3AddressDto;
    contacts!: EmployeeV3ContactDto[];
    children!: EmployeeV3ChildDto[];
    /** The range for each item on this timeline indicates when there is
a valid doctor's certificate for chronic illness.

It is mandatory to specify both `from` and `to`.

___
Monolith notes: Based on three mostly independent timelines:
- Field "Chronically ill" (0546c71c-3a0e-40f2-923a-8e48c1218577)
- Field "Chronically ill from date" (66c1c63d-9732-4fa2-a027-fdfae3a8a321)
- Field "Chronically ill valid to date" (20d77ed7-15dc-4118-8c74-3acf692c0028)

The mapping fully disregards the boolean field,
merges the timelines for the two date fields and
then uses only the date values (not the timeline's dates):
- If neither FROM nor TO is set, skip the merged item.
- If only one of FROM and TO is set, yield an error
  (the monolith has validation to prevent this).
- If FROM is later than TO, yield an error
  (the monolith has validation to prevent this).
- If FROM is before the previous FROM, yield an error
  (the monolith does NOT prevent this).
- Else
  - If FROM is the same or before the previous TO,
    update the TO value of the previous entry.
  - Else, add a new entry with FROM and TO as the timeline item's range.
___
 */
    isChronicallyIllTimeline?: BooleanV3TimelineItemDto[];
    payslipConfig!: EmployeeV3PayslipConfigDto;
    defaultPayment!: EmployeeV3DefaultPaymentDto;
    extraPaymentsTimeline?: EmployeeV3ExtraPaymentItemDto[];
    creditorClaimsTimeline?: EmployeeV3CreditorClaimItemDto[];
    taxationRules!: EmployeeV3TaxationRulesDto;
    carTimeline?: EmployeeV3CarLinkItemDto[];
    /** AKA. Ask for tax information.

When `true`, the tax card for this employee is automatically updated from Altinn
as the first step in a wage run.
TBD verify: Any changes are applied for that wage run and onwards,
not retroactively for previous wage runs.

Employers are required to obtain the tax card before the start of every year and
to use updated tax card information for every wage run.
Skatteetaten claims tax cards must be fetched electronically.
Neither is imposed by Payroll.

TBD: When is it legal to have the value `false`?

References:
- Law on fetching tax cards: https://lovdata.no/lov/2005-06-17-67/§5-1
- Regulation on fetching tax cards: https://lovdata.no/forskrift/2007-12-21-1766/§5-1-3
- How to on tax deduction: https://www.skatteetaten.no/en/business-and-organisation/employer/tax-deduction-cards-and-tax-deductions/how-to-deduct-the-correct-amount-of-tax/
- Must fetch cards electronically: https://www.skatteetaten.no/en/business-and-organisation/employer/tax-deduction-cards-and-tax-deductions/tax-deduction-cards/about-tax-deduction-cards-for-you-as-an-employer/
- Tax cards for payroll systems: https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/skattekort-og-skattetrekk/skattekort/hent-skattekort-via-lonnssystem/
- Technical documentation: https://www.altinndigital.no/produkter/altinn-api-for-datasystem/tjenesteoversikt/skatteetaten---skattekort-til-arbeidsgiver/

___
Monolith notes: Field "Ask for tax information" (8a639555-584e-4e62-a014-ac6091e178e3).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No`
- `true`: `Yes` (or anything which is not `No`)

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.
Tax cards have either been fetched or they haven't;
there is nothing to be done if this is changed retroactively.
___
 */
    retrieveTaxCardOnWageRun?: boolean;
    taxConfigTimeline?: EmployeeV3TaxConfigItemDto[];
    /** Prohibited when creating a new employee.

TBD: What is this field used for in an a-message?

Generated based on `customId`.

___
Monolith notes: Field "Employee pension ID" (807c9237-4b3f-43b2-927b-ada000d5b805)

Generated only when the employee is first saved.

Set to the same as `customId` if its length is 10 or less and
no other `customIdForPension` in the same company already has that value.
Otherwise set to the lowest available number
that is at least 1 and at most 9 999 999 999.

Known issue: Not regenerated if `customId` is changed (as is allowed for draft employees).
___
 */
    readonly customIdForPension?: string;
    pensionCompanyTimeline?: EmployeeV3PensionCompanyLinkItemDto[];
    unionTimeline?: EmployeeV3UnionLinkItemDto[];
    /** Hide from end user unless company setting `showMergedCompanyDate` is `true`.

TBD: What is the relationship with `hasEmploymentTimeline`?

___
Monolith notes: Field "Employee start date in merged company" (0c036557-11a2-4d23-b059-c6b2ce530d4f).

(data loss) The mapper will only set this value if
field "Employee came from merged company" (23e18780-bc8e-49ca-b397-a1e00728a804)
which has a values from reference table 10040 No / Yes is `Yes`.

Field "Employee start date in merged company" is mandatory if that field is `Yes`.
___
 */
    mergedCompanyStartDate?: Date;
    /** Required to be a superset of all position dates, populated from Employee API previousPeriods.

`from` is mandatory.

It's uncertain what this is used for. See:
https://jira.visma.com/browse/VHDI-3751
https://jira.visma.com/browse/VHDI-3762

___
Monolith notes: Field "Employment agreement period" (f76b7037-54e8-4091-9b61-4cfbcb7b6180).

This is a complex field with the following subfields:
- `from`: "Start date" (d532323f-99d0-40b6-a4dd-ee8d59c3ca46)
- `to`: "End date" (23bd177b-4a69-48dd-81cf-1e32baa8be4a)
- n/a: "Phantom value" (1ccc2418-7f77-4479-b0d0-0f44a68a094f)

The monolith validates that no two items have overlapping date ranges.

The monolith validates that there is at least one entry and
that lowest "Start date" value is at least as low
as the lowest `positionTimeline.from` value.

When creating a new employee the vintage UI automatically adds one entry.

"Start date" is generated based on `positionTimeline.from`.
If "Start date" is empty, it is set to the lowest `positionTimeline.from` value.
Otherwise it is unchanged.

When this field is not actively maintained, the
employee will have one employee agreement period that
starts when the first positions starts and never ends.

The mapper excludes time periods covered by positions, so an employee that was
employed two summers will most likely have an entry for between these summers
and then another entry for after the last summer until forever.
This is probably not what is desired, but it should be trivial to fix
in the new schema by simply deleting both entries.
___
 */
    hasEmploymentTimeline?: BooleanV3TimelineItemDto[];
    /** Administrator notes about the process of entering data for this employee.
Must not contain personal data and especially not sensitive data.

___
Monolith notes: Field "Notes" (c911e43b-1856-416a-a7a2-88e3e9639226).

Known issue: There is no length restriction.
___
 */
    notes?: string;
    positionTimeline!: EmployeeV3PositionItemDto[];

    constructor(data?: IEmployeeV3ForCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.governmentIdTimeline = [];
            this.phones = [];
            this.emails = [];
            this.postalAddress = new EmployeeV3AddressDto();
            this.contacts = [];
            this.children = [];
            this.payslipConfig = new EmployeeV3PayslipConfigDto();
            this.defaultPayment = new EmployeeV3DefaultPaymentDto();
            this.taxationRules = new EmployeeV3TaxationRulesDto();
            this.positionTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).version = _data["version"];
            (this as any).updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.isDraft = _data["isDraft"];
            (this as any).id = _data["id"];
            (this as any).legacyId = _data["legacyId"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(EmployeeV3ValidationErrorDto.fromJS(item));
            }
            this.user = _data["user"] ? EmployeeV3UserDetailDto.fromJS(_data["user"]) : undefined as any;
            this.customId = _data["customId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            if (Array.isArray(_data["governmentIdTimeline"])) {
                this.governmentIdTimeline = [] as any;
                for (let item of _data["governmentIdTimeline"])
                    this.governmentIdTimeline!.push(EmployeeV3GovernmentIdItemDto.fromJS(item));
            }
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(EmployeeV3PhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmployeeV3EmailDto.fromJS(item));
            }
            this.postalAddress = _data["postalAddress"] ? EmployeeV3AddressDto.fromJS(_data["postalAddress"]) : new EmployeeV3AddressDto();
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(EmployeeV3ContactDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(EmployeeV3ChildDto.fromJS(item));
            }
            if (Array.isArray(_data["isChronicallyIllTimeline"])) {
                this.isChronicallyIllTimeline = [] as any;
                for (let item of _data["isChronicallyIllTimeline"])
                    this.isChronicallyIllTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            this.payslipConfig = _data["payslipConfig"] ? EmployeeV3PayslipConfigDto.fromJS(_data["payslipConfig"]) : new EmployeeV3PayslipConfigDto();
            this.defaultPayment = _data["defaultPayment"] ? EmployeeV3DefaultPaymentDto.fromJS(_data["defaultPayment"]) : new EmployeeV3DefaultPaymentDto();
            if (Array.isArray(_data["extraPaymentsTimeline"])) {
                this.extraPaymentsTimeline = [] as any;
                for (let item of _data["extraPaymentsTimeline"])
                    this.extraPaymentsTimeline!.push(EmployeeV3ExtraPaymentItemDto.fromJS(item));
            }
            if (Array.isArray(_data["creditorClaimsTimeline"])) {
                this.creditorClaimsTimeline = [] as any;
                for (let item of _data["creditorClaimsTimeline"])
                    this.creditorClaimsTimeline!.push(EmployeeV3CreditorClaimItemDto.fromJS(item));
            }
            this.taxationRules = _data["taxationRules"] ? EmployeeV3TaxationRulesDto.fromJS(_data["taxationRules"]) : new EmployeeV3TaxationRulesDto();
            if (Array.isArray(_data["carTimeline"])) {
                this.carTimeline = [] as any;
                for (let item of _data["carTimeline"])
                    this.carTimeline!.push(EmployeeV3CarLinkItemDto.fromJS(item));
            }
            this.retrieveTaxCardOnWageRun = _data["retrieveTaxCardOnWageRun"];
            if (Array.isArray(_data["taxConfigTimeline"])) {
                this.taxConfigTimeline = [] as any;
                for (let item of _data["taxConfigTimeline"])
                    this.taxConfigTimeline!.push(EmployeeV3TaxConfigItemDto.fromJS(item));
            }
            (this as any).customIdForPension = _data["customIdForPension"];
            if (Array.isArray(_data["pensionCompanyTimeline"])) {
                this.pensionCompanyTimeline = [] as any;
                for (let item of _data["pensionCompanyTimeline"])
                    this.pensionCompanyTimeline!.push(EmployeeV3PensionCompanyLinkItemDto.fromJS(item));
            }
            if (Array.isArray(_data["unionTimeline"])) {
                this.unionTimeline = [] as any;
                for (let item of _data["unionTimeline"])
                    this.unionTimeline!.push(EmployeeV3UnionLinkItemDto.fromJS(item));
            }
            this.mergedCompanyStartDate = _data["mergedCompanyStartDate"] ? new Date(_data["mergedCompanyStartDate"].toString()) : undefined as any;
            if (Array.isArray(_data["hasEmploymentTimeline"])) {
                this.hasEmploymentTimeline = [] as any;
                for (let item of _data["hasEmploymentTimeline"])
                    this.hasEmploymentTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["positionTimeline"])) {
                this.positionTimeline = [] as any;
                for (let item of _data["positionTimeline"])
                    this.positionTimeline!.push(EmployeeV3PositionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3ForCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ForCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["isDraft"] = this.isDraft;
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item ? item.toJSON() : undefined as any);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["customId"] = this.customId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : undefined as any;
        if (Array.isArray(this.governmentIdTimeline)) {
            data["governmentIdTimeline"] = [];
            for (let item of this.governmentIdTimeline)
                data["governmentIdTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : undefined as any;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isChronicallyIllTimeline)) {
            data["isChronicallyIllTimeline"] = [];
            for (let item of this.isChronicallyIllTimeline)
                data["isChronicallyIllTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["payslipConfig"] = this.payslipConfig ? this.payslipConfig.toJSON() : undefined as any;
        data["defaultPayment"] = this.defaultPayment ? this.defaultPayment.toJSON() : undefined as any;
        if (Array.isArray(this.extraPaymentsTimeline)) {
            data["extraPaymentsTimeline"] = [];
            for (let item of this.extraPaymentsTimeline)
                data["extraPaymentsTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.creditorClaimsTimeline)) {
            data["creditorClaimsTimeline"] = [];
            for (let item of this.creditorClaimsTimeline)
                data["creditorClaimsTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["taxationRules"] = this.taxationRules ? this.taxationRules.toJSON() : undefined as any;
        if (Array.isArray(this.carTimeline)) {
            data["carTimeline"] = [];
            for (let item of this.carTimeline)
                data["carTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["retrieveTaxCardOnWageRun"] = this.retrieveTaxCardOnWageRun;
        if (Array.isArray(this.taxConfigTimeline)) {
            data["taxConfigTimeline"] = [];
            for (let item of this.taxConfigTimeline)
                data["taxConfigTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["customIdForPension"] = this.customIdForPension;
        if (Array.isArray(this.pensionCompanyTimeline)) {
            data["pensionCompanyTimeline"] = [];
            for (let item of this.pensionCompanyTimeline)
                data["pensionCompanyTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unionTimeline)) {
            data["unionTimeline"] = [];
            for (let item of this.unionTimeline)
                data["unionTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["mergedCompanyStartDate"] = this.mergedCompanyStartDate ? formatDate(this.mergedCompanyStartDate) : undefined as any;
        if (Array.isArray(this.hasEmploymentTimeline)) {
            data["hasEmploymentTimeline"] = [];
            for (let item of this.hasEmploymentTimeline)
                data["hasEmploymentTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.positionTimeline)) {
            data["positionTimeline"] = [];
            for (let item of this.positionTimeline)
                data["positionTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3ForCardDto {
        const json = this.toJSON();
        let result = new EmployeeV3ForCardDto();
        result.init(json);
        return result;
    }
}

/** This schema uses strings to convey all numbers.  - A value can break any of of the following rules (except it must be a string),    but it will then have validation errors.  - These rules ensure that any precision aware numeric value    only has a single possible string representation.    - Meaning string comparison can be used to determine whether a value has changed.  - Numbers may start with a single dash (`-`) as a minus sign to indicate that it's negative,    where negative values are allowed (currently nowhere).  - The decimal separator is a period (`.`).  - If used, the decimal separator must always have at least one digit before and after.  - Other than `-` and `.` a number may only contain digits 0-9.  - There may be at most 15 digits in total.  - When custom format is `integer-15`    - Text must match pattern `^(-?[1-9][0-9]{0,14}|0)$`  - When custom format is `decimal-13-2`    - Text must match pattern `^-?([1-9][0-9]{0,12}|0)(\.[0-9]{1,2})?$`    - Except minus zero is disallowed (ie. `-0`, `-0.0` and `-0.00`)  - When custom format is `decimal-13-1`    - Text must match pattern `^-?([1-9][0-9]{0,12}|0)(\.[0-9])?$`    - Except minus zero is disallowed (ie. `-0` and `-0.0`)  - Calculated numbers are rounded to maximum number of decimals allowed by the field. Because - Arbitrary numbers cannot generally be safely serialized and deserialized in JSON. - Checking the number of digits after the decimal point is not generally possible in numeric types. - Numbers used in financial operations should retain the exact user input. - Clients must ensure user input is conveyed without changing accuracy or precision.  - Eg. 1.0 and 1.00 are different (precision).  - Eg. 12.345 as a user input cannot be rounded to 12.35 (accuracy and precision).  - Especially JavaScript clients should be careful about using the native number support. String format specifiers: - `date`  - OpenAPI standard.  - full-date in https://tools.ietf.org/html/rfc3339#section-5.6  - `'yyyy-MM-dd'` - `date-time`  - OpenAPI standard, but with time offset restricted to `'Z'`.  - date-time in https://tools.ietf.org/html/rfc3339#section-5.6    - Except only `'Z'` is allowed as time-offset, not time-numoffset. - `uuid`  - Custom.  - AKA GUID.  - https://en.wikipedia.org/wiki/Universally_unique_identifier  - Only lower case 8-4-4-4-12 format is allowed.    - Eg. `'56723616-3598-453d-8eb5-9f768813a5de'`  - There is no guarantee on the UUID format except length.    - Ie. it is not necessarily a specific version / variant, or even a known variant.      All bits could be set arbitrarily. - `decimal-13-2`  - Custom.  - See explanation about numbers above. - `decimal-13-1`  - Custom.  - See explanation about numbers above. - `integer-15`  - Custom.  - See explanation about numbers above. ___ Monolith notes: First, a note on these notes. They explain how this schema has been mapped from the monolith's API schema. The monolith (AKA the field engine or empman) has the EmployeeDto as the root object for an employee. EmployeeDto contains a couple of other object types (see the monolith notes on `id` for an overview of their relationship), but mostly contains generically defined 'fields' (thus 'field engine'). The fields are configured in 'DevUI' (Development UI) and used in the vintage Employee UI which is built using a 'Screen designer' that can specify which fields are used where. DevUI and Screen designer are only available for business analysts and rule developers, to define and configure fields and other rules. The original intention was for fields to be customizable on customer/company level -- and they technically are -- but fortunately this was never done. The Screen designer also places a lot of restrictions on the fields which are not part of the field configuration used by the monolith's API for EmployeeDto. Screen designer is loaded when validating an employee and used to restrict which fields can be set. Restrictions by Screen designer have been included in this API specification, but only by clicking through the UI, not analyzing the Screen designer configuration. Screen designer restrictions are built to hide. All is visible by default and when some value is set, something is hidden/limited/made readonly. The restrictions imposed by the Screen Designer are typically: - Fields are hidden based on values of other fields.  - This can also clear the value of the field (hidden vs hiddenbutvalueretained) - Fields are set to read-only based on values of other fields. - Field values (eg. dropdowns) are filtered based on values of other fields. The source of truth for an employee is currently EmployeeDto, but many simplifications have been done in order to arrive at this schema instead. To easily cross reference with the source of truth, monolith notes details which source fields (or plain properties) have been used and how. This schema's validations are sometimes different from those in the monolith. That is indicated with a "Known issue (discrepancy)" note. Mostly this schema is stricter. The only exception is email addresses where the monolith is stricter. Floating point numbers are validated and processed (but not stored) as [.NET Decimal](https://learn.microsoft.com/en-us/dotnet/api/system.decimal?view=netframework-4.7.1). - The validation is done with  [decimal.TryParse](https://learn.microsoft.com/en-us/dotnet/api/system.decimal.tryparse?view=netframework-4.7.1)  using parameters `CultureInfo.InvariantCulture` and  `NumberStyles.AllowLeadingSign` for  [number styles](https://learn.microsoft.com/en-us/dotnet/api/system.globalization.numberstyles?view=netframework-4.7.1). - It can accurately represent integers in the range -(2^96 - 1) to 2^96 - 1.  - 79 228 162 514 264 337 593 543 950 335 - It can accurately represent any floating point number with the a maximum total of 28 digits  - Or a number with 29 digits if it is between positive and negative 79 228 162 514 264 337 593 543 950 335    with a decimal point in the same place. - All fields are strings in the EmployeeDto and the numbers are stored as the original text.  - Known issue: Identical numbers might have different string values,    eg. `.1` and `0.1` or `1.` and `1`. - Known issue: Numbers inside the accepted integer range and numbers that are inside it when rounded  are allowed to have more digits.  - Ie. 79228162514264337593543950335.1111111111111111111111111111111111111111111111 can be stored    - If used in a calculation, it will be rounded to 28 or 29 digits, eg. 79228162514264337593543950335. - Known vintage UI issue: Numbers are parsed as JavaScript number and  the parsed value is  [serialized](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString)  and sent in the EmployeeDto.  - Numbers of 10^21 or more and less than 10^-6 are serialized with scientific notation.  - Ie. the maximum safe integer value in the backend will be sent as 7.922816251426434e+28    which is not accepted because AllowExponent is not used in the validation. - Known vintage UI issue: Numbers are parsed as JavaScript number and  the parsed value is serialized and displayed to the user. JavaScript's [number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) is inferior to .NET Decimal for the financial numbers we are handling, where the exact user input should be retained as much as possible. - number has a precision of 15 to 17 digits, far fewer than Decimal's 28 to 29. - number's safe integer range is -(2^53 - 1) to 2^53 - 1  - 9 007 199 254 740 991 - number serialization can use scientific notation  - whereas the monolith does not allow scientific notation To avoid conversion issues, numbers will be treated as string by the mapper, but they could yield validation errors (this has been known to happen for imported data): - The vintage UI prevents a number starting with the decimal separator,  but if any has come from other sources the user will have to be prepended it with 0. - The vintage UI prevents a number ending with the decimal separator,  but if any has come from other sources the user will have to remove the separator. - The vintage UI prevents additional leading zeroes,  but if any has come from other sources the user will have to remove them. - The vintage UI prevents minus zero,  but if it has come from other sources the user will have to change to simply zero. - If there are more than 15 digits in total, there will be a validation error.  - Any number with 15 or fewer digits (regardless of the decimal point placement)    can be accurately represented in a double (64-bit binary format IEEE 754).  - Known issue: The supported decimal range is -9 999 999 999 999.99    to 9 999 999 999 999.99. This is the same order of magnitude as Norway's 2023 GDP. - Except for edge cases, the monolith API prevents more than 2 digits after the decimal point.  Any edge case will yield a validation error the user has to fix. Known issue: Monolith is using the built-in script `String.IsNumeric` to validate non-decimal numbers stored in string type fields. The implementation accepts matches for pattern `^-?(\d+\.?\d*|\.\d+)$`. This is because -- sometimes after a length check -- validation is done with [decimal.TryParse](https://learn.microsoft.com/en-us/dotnet/api/system.decimal.tryparse?view=netframework-4.7.1) using parameters `CultureInfo.InvariantCulture` and `NumberStyles.AllowLeadingSign | NumberStyles.AllowDecimalPoint` for [number styles](https://learn.microsoft.com/en-us/dotnet/api/system.globalization.numberstyles?view=netframework-4.7.1). This yields the very strange pattern for integer values, accepting eg. `-1.2` which is obviously not a Norwegian postal code, tax table or similar. Fields of integer type does not suffer from this. ___ */
export interface IEmployeeV3ForCardDto {
    /** Changed whenever something changes on the employee (including any of the positions).
Do not make assumptions on format/ordering, but use `updatedAt` to determine which
of two employee instances is the newest.

Prohibited when creating a new employee.

The current value must be supplied when changing an employee.

___
Monolith notes: `EmployeeDto.RowVersion`.
___
 */
    version: string;
    /** Prohibited when creating a new employee.

So that comparison is easier, the time-offset will always be `'Z'`
rather than a time-numoffset.

___
Monolith notes: `EmployeeDto.LastChange`.
___
 */
    updatedAt: Date;
    /** Indicates whether the employee is in the draft state, which has special behavior:
- Only newly created employees and draft employees can be saved as drafts
  (meaning this field cannot change from `false` to `true`).
- Draft employees can be hard deleted.
- (TBD: verify) Draft employees are not available in wage runs and reports.
- Draft employees can be saved even with validation errors.
  - Technical schema guarantees have to be fulfilled (see list in `validationErrors`).
  - Select business validations also apply to draft employees
    - `customId` must be unique within the company (but it can be changed)

___
Monolith notes: Mapping to values in enum `Visma.Odp.Services.EmpMan.DTOs.Enums.EnumEmployeeStatus`
stored in `EmployeeDto.EntityStatus`:
- `false`: `1` (Active)
- `false`: `2` (Inactive)
- `false`: `3` (Future)
- `true`: `4` (Draft)

In V3 the non-draft values have to be calculated from `positionTimeline`:
1. Traverse the timeline in reverse order.
   1. If `from` is larger than today, mark as possibly future.
   2. Else
      1. If `to` is today or larger, status is 'active'.
      2. Else
         1. If marked as possibly future, status is 'future'.
         2. Else, status is 'inactive'.
2. If traversal completed without returning a status, status is 'inactive'
   (and there will be a validation error on `positionTimeline`).
___
 */
    isDraft: boolean;
    /** Prohibited when creating a new employee.

AKA "employee id".
Do not confuse with the "Employee ID" field in the vintage UI,
which could have been labeled "Employee number" (from the Norwegian label Ansattnummer)
and is represented in this schema as `customId`.

___
Monolith notes: `EmploymentDto.Id`.

The original field engine design called for a one-to-many
relationship between employee and employment.
An employee would be a system wide representation of a person
which could have an employment with many companies.
This could cause data leak issues and was abandoned.
Actual data only has a one-to-one relationship between employee and employment,
meaning the ID of either uniquely identifies both.

When public APIs were introduced, employee and employment properties
were merged into "employee" and the employment's ID was picked as the
public ID of the new "employee". This can cause confusion for those used to
monolith terminology, so to be clear, this is the mapping:
- `employeeV3ForCardDto.id`: `EmploymentDto.Id`
- `employeeV3ForCardDto.legacyId`: `EmployeeDto.Id`
- `employeeV3PositionValueDto.id`: `ContractDto.Id`

The terminology is further confused when compared to a-messages.
See comments on `positionTimeline`.
___
 */
    id: string;
    /** Prohibited when creating a new employee.

___
Monolith notes: `Employee.Id`.

See also monolith notes on `id`.
___
 */
    legacyId: string;
    validationErrors?: EmployeeV3ValidationErrorDto[];
    user?: EmployeeV3UserDetailDto;
    /** AKA employee number (or even the more ambiguous employee ID).
Note that the string is not restricted to numeric values,
unlike what "employee number" implies.

This must be a company level unique value.
This restriction applies even to draft employees.

This cannot be changed and if trying the entire change will be rejected.
Draft employees are exempt from this restriction.

___
Monolith notes: Field "_Employee ID" (00000000-0000-4002-0101-000000000000).
___
 */
    customId?: string;
    /** Mandatory.

If `user` is set, this must be the same as `user.firstName` (case-insensitive).
See monolith notes.

Cannot start with a white space character, but otherwise accepts
any white space, letter and number as well as these characters:

```
- _ . ' : ~ ! @ # $ ^ & * + ( )
```

Any period (.) -- unless it is the last or second last character in the name --
must be followed by a period/space in the next or second next character.
Ie. "John Doe Jr.", "John D. Doe" and "M.C Hammer" are allowed
(along with many other less likely names),
but "D.Doe" and "M.CHammer" are disallowed.
A name is invalid if it matches the regex `\.[^ .]{2}`.

___
Monolith notes: Field "First name" (dcc429af-7941-4362-8b94-5a6dd68e5dff).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

The employee's name is used when creating users in ODP/Connect, so the restrictions on
this field attempt to be the same as restrictions on the names of users.

Naturally, the user's name SHOULD thereafter be the same as the employee's name.
The reason it MUST be the same is to avoid an incident where an employee instance
is repurposed for another actual person, thereby allowing
the original person with a user created to log in as somebody they are not.

Known issue: A name cannot be longer than 50 characters in Connect users,
but this is not validated by the monolith.
It used to be validated, but somebody requested the restriction be removed.
___
 */
    firstName?: string;
    /** Mandatory.

Same restrictions as `firstName`.

If `user` is set, this must be the same as `user.lastName` (case-insensitive).
See monolith notes in `firstName`.

___
Monolith notes: Field "Last name" (a97ae111-d6cc-4a80-b180-4e902d9f3b3d).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Possible known issue: A name cannot be longer than 50 characters in Connect users,
but this is not validated by the monolith.
It used to be validated, but somebody requested the restriction be removed.
___
 */
    lastName?: string;
    gender?: GenderV3EnumDto;
    /** Mandatory when a `governmentIdTimeline` entry uses
type `governmentIdTypeV3EnumDto.foreign`.
Generated and overwritten if there is also an entry with another type
(see monolith notes -- it is not guaranteed to be set because of a known issue).

Must be today or earlier.

___
Monolith notes: Field "Date of birth" (15b47abb-6cf7-41fe-bfe9-ff252e498962).

Generated based on `nationalId` or `dNumber` in
`employeeV3GovernmentIdValueDto` if the ID is of the corresponding type.
If there are multiple entries, it is not straight forward to determine which will be used.

Known issue: The birth date entered for foreign ID should not change,
but does change if the date in a D number or national ID is different.

Known issue: The monolith does not validate that the date part of
`nationalId` and `dNumber` is a valid date.
If it is invalid this field will be set to nothing.

Known issue: Neither national ID nor D number is guaranteed to contain the birth date,
and overriding the generated value is not possible.
Both type of numbers can lack available person digits on the correct date,
in which case another date will be used.
This also means the birth date derived from either is not necessarily consistent,
as just one of them could be out of available numbers.

Known issue: Starting 2024-02-01 (although it actually started earlier),
person digits in a `dNumber` no longer specify the century of birth.
On the assumption that 0 year olds are much more likely to be employed (eg. for commercials)
than 100 year olds, especially ones that do not have a national ID,
the script will only generates dates in the year range [current year - 99, current year].
___
 */
    birthDate?: Date;
    governmentIdTimeline: EmployeeV3GovernmentIdItemDto[];
    phones: EmployeeV3PhoneDto[];
    emails: EmployeeV3EmailDto[];
    postalAddress: EmployeeV3AddressDto;
    contacts: EmployeeV3ContactDto[];
    children: EmployeeV3ChildDto[];
    /** The range for each item on this timeline indicates when there is
a valid doctor's certificate for chronic illness.

It is mandatory to specify both `from` and `to`.

___
Monolith notes: Based on three mostly independent timelines:
- Field "Chronically ill" (0546c71c-3a0e-40f2-923a-8e48c1218577)
- Field "Chronically ill from date" (66c1c63d-9732-4fa2-a027-fdfae3a8a321)
- Field "Chronically ill valid to date" (20d77ed7-15dc-4118-8c74-3acf692c0028)

The mapping fully disregards the boolean field,
merges the timelines for the two date fields and
then uses only the date values (not the timeline's dates):
- If neither FROM nor TO is set, skip the merged item.
- If only one of FROM and TO is set, yield an error
  (the monolith has validation to prevent this).
- If FROM is later than TO, yield an error
  (the monolith has validation to prevent this).
- If FROM is before the previous FROM, yield an error
  (the monolith does NOT prevent this).
- Else
  - If FROM is the same or before the previous TO,
    update the TO value of the previous entry.
  - Else, add a new entry with FROM and TO as the timeline item's range.
___
 */
    isChronicallyIllTimeline?: BooleanV3TimelineItemDto[];
    payslipConfig: EmployeeV3PayslipConfigDto;
    defaultPayment: EmployeeV3DefaultPaymentDto;
    extraPaymentsTimeline?: EmployeeV3ExtraPaymentItemDto[];
    creditorClaimsTimeline?: EmployeeV3CreditorClaimItemDto[];
    taxationRules: EmployeeV3TaxationRulesDto;
    carTimeline?: EmployeeV3CarLinkItemDto[];
    /** AKA. Ask for tax information.

When `true`, the tax card for this employee is automatically updated from Altinn
as the first step in a wage run.
TBD verify: Any changes are applied for that wage run and onwards,
not retroactively for previous wage runs.

Employers are required to obtain the tax card before the start of every year and
to use updated tax card information for every wage run.
Skatteetaten claims tax cards must be fetched electronically.
Neither is imposed by Payroll.

TBD: When is it legal to have the value `false`?

References:
- Law on fetching tax cards: https://lovdata.no/lov/2005-06-17-67/§5-1
- Regulation on fetching tax cards: https://lovdata.no/forskrift/2007-12-21-1766/§5-1-3
- How to on tax deduction: https://www.skatteetaten.no/en/business-and-organisation/employer/tax-deduction-cards-and-tax-deductions/how-to-deduct-the-correct-amount-of-tax/
- Must fetch cards electronically: https://www.skatteetaten.no/en/business-and-organisation/employer/tax-deduction-cards-and-tax-deductions/tax-deduction-cards/about-tax-deduction-cards-for-you-as-an-employer/
- Tax cards for payroll systems: https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/skattekort-og-skattetrekk/skattekort/hent-skattekort-via-lonnssystem/
- Technical documentation: https://www.altinndigital.no/produkter/altinn-api-for-datasystem/tjenesteoversikt/skatteetaten---skattekort-til-arbeidsgiver/

___
Monolith notes: Field "Ask for tax information" (8a639555-584e-4e62-a014-ac6091e178e3).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No`
- `true`: `Yes` (or anything which is not `No`)

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.
Tax cards have either been fetched or they haven't;
there is nothing to be done if this is changed retroactively.
___
 */
    retrieveTaxCardOnWageRun?: boolean;
    taxConfigTimeline?: EmployeeV3TaxConfigItemDto[];
    /** Prohibited when creating a new employee.

TBD: What is this field used for in an a-message?

Generated based on `customId`.

___
Monolith notes: Field "Employee pension ID" (807c9237-4b3f-43b2-927b-ada000d5b805)

Generated only when the employee is first saved.

Set to the same as `customId` if its length is 10 or less and
no other `customIdForPension` in the same company already has that value.
Otherwise set to the lowest available number
that is at least 1 and at most 9 999 999 999.

Known issue: Not regenerated if `customId` is changed (as is allowed for draft employees).
___
 */
    customIdForPension?: string;
    pensionCompanyTimeline?: EmployeeV3PensionCompanyLinkItemDto[];
    unionTimeline?: EmployeeV3UnionLinkItemDto[];
    /** Hide from end user unless company setting `showMergedCompanyDate` is `true`.

TBD: What is the relationship with `hasEmploymentTimeline`?

___
Monolith notes: Field "Employee start date in merged company" (0c036557-11a2-4d23-b059-c6b2ce530d4f).

(data loss) The mapper will only set this value if
field "Employee came from merged company" (23e18780-bc8e-49ca-b397-a1e00728a804)
which has a values from reference table 10040 No / Yes is `Yes`.

Field "Employee start date in merged company" is mandatory if that field is `Yes`.
___
 */
    mergedCompanyStartDate?: Date;
    /** Required to be a superset of all position dates, populated from Employee API previousPeriods.

`from` is mandatory.

It's uncertain what this is used for. See:
https://jira.visma.com/browse/VHDI-3751
https://jira.visma.com/browse/VHDI-3762

___
Monolith notes: Field "Employment agreement period" (f76b7037-54e8-4091-9b61-4cfbcb7b6180).

This is a complex field with the following subfields:
- `from`: "Start date" (d532323f-99d0-40b6-a4dd-ee8d59c3ca46)
- `to`: "End date" (23bd177b-4a69-48dd-81cf-1e32baa8be4a)
- n/a: "Phantom value" (1ccc2418-7f77-4479-b0d0-0f44a68a094f)

The monolith validates that no two items have overlapping date ranges.

The monolith validates that there is at least one entry and
that lowest "Start date" value is at least as low
as the lowest `positionTimeline.from` value.

When creating a new employee the vintage UI automatically adds one entry.

"Start date" is generated based on `positionTimeline.from`.
If "Start date" is empty, it is set to the lowest `positionTimeline.from` value.
Otherwise it is unchanged.

When this field is not actively maintained, the
employee will have one employee agreement period that
starts when the first positions starts and never ends.

The mapper excludes time periods covered by positions, so an employee that was
employed two summers will most likely have an entry for between these summers
and then another entry for after the last summer until forever.
This is probably not what is desired, but it should be trivial to fix
in the new schema by simply deleting both entries.
___
 */
    hasEmploymentTimeline?: BooleanV3TimelineItemDto[];
    /** Administrator notes about the process of entering data for this employee.
Must not contain personal data and especially not sensitive data.

___
Monolith notes: Field "Notes" (c911e43b-1856-416a-a7a2-88e3e9639226).

Known issue: There is no length restriction.
___
 */
    notes?: string;
    positionTimeline: EmployeeV3PositionItemDto[];
}

export class EmployeeV3ValidationErrorDto implements IEmployeeV3ValidationErrorDto {
    /** Period separated list of groups, property names and indexes.
Group and field names are as documented in this specification.

The first field name is `employee` so that this string will never be empty.

A path can point to
- a group, for example
  - `employee`
  - `employee.user`
  - `employee.positionTimeline.0.value.ftePercentageTimeline.3.value`
- a list, for example
  - `employee.positionTimeline`
  - `employee.phones`
- a list item, for example
  - `employee.positionTimeline.0`
  - `employee.positionTimeline.0.value.ftePercentageTimeline.3`
- a specific field, for example
  - `employee.customId`
  - `employee.positionTimeline.0.from`
  - `employee.positionTimeline.0.value.ftePercentageTimeline.3.value.percentage`
 */
    path!: string;
    message!: LocalizedStringDto;

    constructor(data?: IEmployeeV3ValidationErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.message = new LocalizedStringDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.message = _data["message"] ? LocalizedStringDto.fromJS(_data["message"]) : new LocalizedStringDto();
        }
    }

    static fromJS(data: any): EmployeeV3ValidationErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ValidationErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["message"] = this.message ? this.message.toJSON() : undefined as any;
        return data;
    }

    clone(): EmployeeV3ValidationErrorDto {
        const json = this.toJSON();
        let result = new EmployeeV3ValidationErrorDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3ValidationErrorDto {
    /** Period separated list of groups, property names and indexes.
Group and field names are as documented in this specification.

The first field name is `employee` so that this string will never be empty.

A path can point to
- a group, for example
  - `employee`
  - `employee.user`
  - `employee.positionTimeline.0.value.ftePercentageTimeline.3.value`
- a list, for example
  - `employee.positionTimeline`
  - `employee.phones`
- a list item, for example
  - `employee.positionTimeline.0`
  - `employee.positionTimeline.0.value.ftePercentageTimeline.3`
- a specific field, for example
  - `employee.customId`
  - `employee.positionTimeline.0.from`
  - `employee.positionTimeline.0.value.ftePercentageTimeline.3.value.percentage`
 */
    path: string;
    message: LocalizedStringDto;
}

/** Only set when a Connect/ODP user a been fully created. In progress user creation cannot be viewed here. None of these properties or the object can be edited and any values on POST/PUT will be disregarded. Except `emailType`. */
export class EmployeeV3UserDetailDto implements IEmployeeV3UserDetailDto {
    /** ___
Monolith notes: This is a 64-bit integer in the EmployeeDTO.
IDs that are 2^53 or more will be converted to `'UnsupportedOdpUserId'`
and yield a validation error.

- https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isSafeInteger
- https://www.techempower.com/blog/2016/07/05/mangling-json-numbers/
___
 */
    readonly odpUserId?: string;
    emailType?: EmailTypeV3EnumDto;
    /** The ODP/Connect e-mail address.

This should be displayed as one of the employee's email addresses,
as it will not appear in the employee's `emails` list.

The accompanying `emailType` is the only user property which can be changed.
The address itself can only be changed from the Admin module.

___
Monolith notes: Field "User e-mail address" (1caaa128-9935-46ef-bd8a-14532707860c).

Duplicated in field "E-mail address" (85207403-6a69-48c8-a444-5ac71d331331) in list item
"E-mail" (22169f84-07b3-41c4-9522-4025d94aac07), which also contains field
"E-mail type" (944688a4-d88a-433b-a0b3-80de190daa9a).
The address must be in that list initially, in order to create the user from the monolith's UI.
If the address is updated in the Admin module,
both the user address field and list item duplicate are updated by the monolith.

In the mapping, the list item is removed from the employee's `emails` and
its type mapped to `user.emailType`.

Known issue: When migrating data, the user e-mail is sometimes missing from the `emails` list.
This is not an issue in the new UI, which will use `user.emailAddress` as the source,
but it is an issue in the vintage UI, which will use the `emails` list as the source,
and in the monolith where the data is inconsistent.
To support fixing this scenario, `emailType` is optional, but will have a validation error.
Setting the user's `emailType` will correct the the monolith data when mapping back.
(Another fix is to change the user's email address in the Admin module,
after which the monolith will add a list item with the updated address and type `private`.)
___
 */
    readonly emailAddress?: string;
    /** DEPRECATED. No longer provided in item cache because it is absent from Employee API v3.

Whether the user has confirmed `email` after ODP/Connect sent them an e-mail.

Many user do not confirm, and it appears the value of this field
has no practical effect anywhere.
 */
    readonly isConfirmedEmail?: boolean;
    readonly firstName?: string;
    readonly lastName?: string;

    constructor(data?: IEmployeeV3UserDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).odpUserId = _data["odpUserId"];
            this.emailType = _data["emailType"];
            (this as any).emailAddress = _data["emailAddress"];
            (this as any).isConfirmedEmail = _data["isConfirmedEmail"];
            (this as any).firstName = _data["firstName"];
            (this as any).lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): EmployeeV3UserDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3UserDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odpUserId"] = this.odpUserId;
        data["emailType"] = this.emailType;
        data["emailAddress"] = this.emailAddress;
        data["isConfirmedEmail"] = this.isConfirmedEmail;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }

    clone(): EmployeeV3UserDetailDto {
        const json = this.toJSON();
        let result = new EmployeeV3UserDetailDto();
        result.init(json);
        return result;
    }
}

/** Only set when a Connect/ODP user a been fully created. In progress user creation cannot be viewed here. None of these properties or the object can be edited and any values on POST/PUT will be disregarded. Except `emailType`. */
export interface IEmployeeV3UserDetailDto {
    /** ___
Monolith notes: This is a 64-bit integer in the EmployeeDTO.
IDs that are 2^53 or more will be converted to `'UnsupportedOdpUserId'`
and yield a validation error.

- https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isSafeInteger
- https://www.techempower.com/blog/2016/07/05/mangling-json-numbers/
___
 */
    odpUserId?: string;
    emailType?: EmailTypeV3EnumDto;
    /** The ODP/Connect e-mail address.

This should be displayed as one of the employee's email addresses,
as it will not appear in the employee's `emails` list.

The accompanying `emailType` is the only user property which can be changed.
The address itself can only be changed from the Admin module.

___
Monolith notes: Field "User e-mail address" (1caaa128-9935-46ef-bd8a-14532707860c).

Duplicated in field "E-mail address" (85207403-6a69-48c8-a444-5ac71d331331) in list item
"E-mail" (22169f84-07b3-41c4-9522-4025d94aac07), which also contains field
"E-mail type" (944688a4-d88a-433b-a0b3-80de190daa9a).
The address must be in that list initially, in order to create the user from the monolith's UI.
If the address is updated in the Admin module,
both the user address field and list item duplicate are updated by the monolith.

In the mapping, the list item is removed from the employee's `emails` and
its type mapped to `user.emailType`.

Known issue: When migrating data, the user e-mail is sometimes missing from the `emails` list.
This is not an issue in the new UI, which will use `user.emailAddress` as the source,
but it is an issue in the vintage UI, which will use the `emails` list as the source,
and in the monolith where the data is inconsistent.
To support fixing this scenario, `emailType` is optional, but will have a validation error.
Setting the user's `emailType` will correct the the monolith data when mapping back.
(Another fix is to change the user's email address in the Admin module,
after which the monolith will add a list item with the updated address and type `private`.)
___
 */
    emailAddress?: string;
    /** DEPRECATED. No longer provided in item cache because it is absent from Employee API v3.

Whether the user has confirmed `email` after ODP/Connect sent them an e-mail.

Many user do not confirm, and it appears the value of this field
has no practical effect anywhere.
 */
    isConfirmedEmail?: boolean;
    firstName?: string;
    lastName?: string;
}

export class EmployeeV3GovernmentIdItemDto extends FullV3TimelineItemDto implements IEmployeeV3GovernmentIdItemDto {
    value!: EmployeeV3GovernmentIdValueDto;

    constructor(data?: IEmployeeV3GovernmentIdItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3GovernmentIdValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3GovernmentIdValueDto.fromJS(_data["value"]) : new EmployeeV3GovernmentIdValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3GovernmentIdItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3GovernmentIdItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3GovernmentIdItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3GovernmentIdItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3GovernmentIdItemDto extends IFullV3TimelineItemDto {
    value: EmployeeV3GovernmentIdValueDto;
}

/** ___ Monolith notes: Merged from ungrouped fields with different timelines, and no timelines for the field for `foreign`. - `type`: "Type of ID" (541b476d-6b0b-458d-a34b-39e9aedd9804) - `nationalId` or `dNumber`: "National ID" (723bcb38-7cf2-4c66-9686-856ef50d952c) - `foreign.type`: "Type of international ID" (3d316bc9-1fbe-4cdb-b0f0-3c9380b9b966) - `foreign.countryCode`:  "Country" (30be8bc5-513d-4d0e-9282-edddc52621ac) - `foreign.id`: "International ID" (fca073ca-2829-42f1-b7f7-7bd0d0b6afc3) ___ */
export class EmployeeV3GovernmentIdValueDto implements IEmployeeV3GovernmentIdValueDto {
    type?: GovernmentIdTypeV3EnumDto;
    /** Mandatory if `type` is `national`, otherwise prohibited.

End user clients should format this as
6 digits, space and 5 digits.
Keep in mind that the current value might be invalid (both length and content).
The server does not accept spaces.

The first 6 digits must be a valid date between 1911 and 2088 on the format ddMMyy.
Except for
[altinn test companies in tenor](https://skatteetaten.github.io/folkeregisteret-api-dokumentasjon/test-for-konsumenter/),
where 80 is added to the month value (ie. 138786 means 13th of July '86).
The date is usually the birth date of the person, but not always.
Starting 2032-01-01 the birth date must not be derived from the national id.

The next 3 digits are the
[person digits](https://lovdata.no/dokument/SF/forskrift/2017-07-14-1201/KAPITTEL_2#%C2%A72-2-1).

Depending on birth year, these are the valid person digits:
- 1854-1899: 500-749
- 1900-1939: 000-499
- 1940-1999: 000-499 and 900-999
- 2000-2039: 500-999

Depending on 2 digit birth year, these are the valid person digits:
- 00-39: 000-499 and 500-999 (ie. any)
- 40-53: 000-499 and 900-999 (ie. not 500-899)
- 54-99: 000-499 and 500-749 and 900-999 (ie. not 750-899)

Starting 2032-01-01, the person digits will no longer indicate the birth century.

Known issue: There are bugs in the person digits validation because
this API reimplements the monolith bugs (see monolith notes).
Real employees could only be affected if they are a female born in 19xx and
have been assigned a date's very last available person digits,
which may start to happen for D numbers near the end of the 2020 decade and later for national IDs.
Clients should not reimplement the validation bugs, so this description is without them.

The 10th digit is the first check digit.
Sum of the below modulo 11 must be 0, 1, 2 or 3 (before 2032-01-01 it could only be 0):
- 3 times digit 1
- 7 times digit 2
- 6 times digit 3
- 1 times digit 4
- 8 times digit 5
- 9 times digit 6
- 4 times digit 7
- 5 times digit 8
- 2 times digit 9
- 1 times digit 10

The 11th digit is the second check digit.
Sum of the below modulo 11 must be 0:
- 5 times digit 1
- 4 times digit 2
- 3 times digit 3
- 2 times digit 4
- 7 times digit 5
- 6 times digit 6
- 5 times digit 7
- 4 times digit 8
- 3 times digit 9
- 2 times digit 10
- 1 times digit 11

References:
- https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/national-identity-number-d-number-or-international-id-income-recipient/
- https://www.skatteetaten.no/en/person/national-registry/identitetsnummer/fodselsnummer/
- https://lovdata.no/forskrift/2017-07-14-1201/§2-2-1
- https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
- Change 2032-01-01: https://www.skatteetaten.no/deling/folkeregisteret/pid/
  https://skatteetaten.github.io/folkeregisteret-api-dokumentasjon/nytt-fodselsnummer-fra-2032/
- https://www.sprakradet.no/sprakhjelp/Skriveregler/Dato/#bank

___
Monolith notes:

Known issue: There are a number of bugs in the algorithm in the script NationalIDNEW.Norway.
These are documented in getOpenApiDateFromNationalId and its tests.
They are unlikely to affect real persons with real employments,
but may affect unrealistic test data.

Known issue (discrepancy): Monolith does not check whether the date part is a valid date
(it only validates that the day is between 1 and 31).

Known issue: Starting 2032-01-01 the current validation will not work
https://www.skatteetaten.no/deling/folkeregisteret/pid/
___
 */
    nationalId?: string;
    /** Mandatory if `type` is `dNumber`, otherwise prohibited.

The first 6 digits must be a valid date between 1911 and 2088 on the format ddMMyy,
except 40 is added to the day (ie. 530786 means 13th of July '86).
Except for
[altinn test companies in tenor](https://skatteetaten.github.io/folkeregisteret-api-dokumentasjon/test-for-konsumenter/),
where 80 is added to the month value (ie. 538786 means 13th of July '86).
The date is usually the birth date of the person, but not always.
Starting 2032-01-01 the birth date must not be derived from the national id.

The next 3 digits are the
[person digits](https://lovdata.no/dokument/SF/forskrift/2017-07-14-1201/KAPITTEL_2#%C2%A72-2-2).

Starting 2024-02-01 (although the government illegally started issue these number earlier),
any person digit can be used regardless of birth year.
It is therefore impossible to differentiate
between a 100 year old and 0 year old based on D-number.

Check digits are validated the same as for `nationalId`.

References:
- https://www.skatteetaten.no/en/person/national-registry/identitetsnummer/d-nummer/
- see `nationalId`

___
Monolith notes: See `nationalId`, which uses the same source field.
___
 */
    dNumber?: string;
    foreign?: EmployeeV3ForeignGovernmentIdDto;

    constructor(data?: IEmployeeV3GovernmentIdValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.nationalId = _data["nationalId"];
            this.dNumber = _data["dNumber"];
            this.foreign = _data["foreign"] ? EmployeeV3ForeignGovernmentIdDto.fromJS(_data["foreign"]) : undefined as any;
        }
    }

    static fromJS(data: any): EmployeeV3GovernmentIdValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3GovernmentIdValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["nationalId"] = this.nationalId;
        data["dNumber"] = this.dNumber;
        data["foreign"] = this.foreign ? this.foreign.toJSON() : undefined as any;
        return data;
    }

    clone(): EmployeeV3GovernmentIdValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3GovernmentIdValueDto();
        result.init(json);
        return result;
    }
}

/** ___ Monolith notes: Merged from ungrouped fields with different timelines, and no timelines for the field for `foreign`. - `type`: "Type of ID" (541b476d-6b0b-458d-a34b-39e9aedd9804) - `nationalId` or `dNumber`: "National ID" (723bcb38-7cf2-4c66-9686-856ef50d952c) - `foreign.type`: "Type of international ID" (3d316bc9-1fbe-4cdb-b0f0-3c9380b9b966) - `foreign.countryCode`:  "Country" (30be8bc5-513d-4d0e-9282-edddc52621ac) - `foreign.id`: "International ID" (fca073ca-2829-42f1-b7f7-7bd0d0b6afc3) ___ */
export interface IEmployeeV3GovernmentIdValueDto {
    type?: GovernmentIdTypeV3EnumDto;
    /** Mandatory if `type` is `national`, otherwise prohibited.

End user clients should format this as
6 digits, space and 5 digits.
Keep in mind that the current value might be invalid (both length and content).
The server does not accept spaces.

The first 6 digits must be a valid date between 1911 and 2088 on the format ddMMyy.
Except for
[altinn test companies in tenor](https://skatteetaten.github.io/folkeregisteret-api-dokumentasjon/test-for-konsumenter/),
where 80 is added to the month value (ie. 138786 means 13th of July '86).
The date is usually the birth date of the person, but not always.
Starting 2032-01-01 the birth date must not be derived from the national id.

The next 3 digits are the
[person digits](https://lovdata.no/dokument/SF/forskrift/2017-07-14-1201/KAPITTEL_2#%C2%A72-2-1).

Depending on birth year, these are the valid person digits:
- 1854-1899: 500-749
- 1900-1939: 000-499
- 1940-1999: 000-499 and 900-999
- 2000-2039: 500-999

Depending on 2 digit birth year, these are the valid person digits:
- 00-39: 000-499 and 500-999 (ie. any)
- 40-53: 000-499 and 900-999 (ie. not 500-899)
- 54-99: 000-499 and 500-749 and 900-999 (ie. not 750-899)

Starting 2032-01-01, the person digits will no longer indicate the birth century.

Known issue: There are bugs in the person digits validation because
this API reimplements the monolith bugs (see monolith notes).
Real employees could only be affected if they are a female born in 19xx and
have been assigned a date's very last available person digits,
which may start to happen for D numbers near the end of the 2020 decade and later for national IDs.
Clients should not reimplement the validation bugs, so this description is without them.

The 10th digit is the first check digit.
Sum of the below modulo 11 must be 0, 1, 2 or 3 (before 2032-01-01 it could only be 0):
- 3 times digit 1
- 7 times digit 2
- 6 times digit 3
- 1 times digit 4
- 8 times digit 5
- 9 times digit 6
- 4 times digit 7
- 5 times digit 8
- 2 times digit 9
- 1 times digit 10

The 11th digit is the second check digit.
Sum of the below modulo 11 must be 0:
- 5 times digit 1
- 4 times digit 2
- 3 times digit 3
- 2 times digit 4
- 7 times digit 5
- 6 times digit 6
- 5 times digit 7
- 4 times digit 8
- 3 times digit 9
- 2 times digit 10
- 1 times digit 11

References:
- https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/national-identity-number-d-number-or-international-id-income-recipient/
- https://www.skatteetaten.no/en/person/national-registry/identitetsnummer/fodselsnummer/
- https://lovdata.no/forskrift/2017-07-14-1201/§2-2-1
- https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
- Change 2032-01-01: https://www.skatteetaten.no/deling/folkeregisteret/pid/
  https://skatteetaten.github.io/folkeregisteret-api-dokumentasjon/nytt-fodselsnummer-fra-2032/
- https://www.sprakradet.no/sprakhjelp/Skriveregler/Dato/#bank

___
Monolith notes:

Known issue: There are a number of bugs in the algorithm in the script NationalIDNEW.Norway.
These are documented in getOpenApiDateFromNationalId and its tests.
They are unlikely to affect real persons with real employments,
but may affect unrealistic test data.

Known issue (discrepancy): Monolith does not check whether the date part is a valid date
(it only validates that the day is between 1 and 31).

Known issue: Starting 2032-01-01 the current validation will not work
https://www.skatteetaten.no/deling/folkeregisteret/pid/
___
 */
    nationalId?: string;
    /** Mandatory if `type` is `dNumber`, otherwise prohibited.

The first 6 digits must be a valid date between 1911 and 2088 on the format ddMMyy,
except 40 is added to the day (ie. 530786 means 13th of July '86).
Except for
[altinn test companies in tenor](https://skatteetaten.github.io/folkeregisteret-api-dokumentasjon/test-for-konsumenter/),
where 80 is added to the month value (ie. 538786 means 13th of July '86).
The date is usually the birth date of the person, but not always.
Starting 2032-01-01 the birth date must not be derived from the national id.

The next 3 digits are the
[person digits](https://lovdata.no/dokument/SF/forskrift/2017-07-14-1201/KAPITTEL_2#%C2%A72-2-2).

Starting 2024-02-01 (although the government illegally started issue these number earlier),
any person digit can be used regardless of birth year.
It is therefore impossible to differentiate
between a 100 year old and 0 year old based on D-number.

Check digits are validated the same as for `nationalId`.

References:
- https://www.skatteetaten.no/en/person/national-registry/identitetsnummer/d-nummer/
- see `nationalId`

___
Monolith notes: See `nationalId`, which uses the same source field.
___
 */
    dNumber?: string;
    foreign?: EmployeeV3ForeignGovernmentIdDto;
}

/** Mandatory if `employeeV3GovernmentIdValueDto.type` is `foreign`, otherwise prohibited. Used to create a unique person identifier in a-messages. The identifier is made up of the following fields: - `firstName` - `lastName` - `birthDate` - `customId` (optional, TBD: is this actually used?) - `id` - `type` - `countryCode` This must not change after being used in an a-message, or the next a-message won't be linked to the same employee. The a-message guide is silent on what to do if an employee without a national ID or D number change their name or gets new identification. https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/national-identity-number-d-number-or-international-id-income-recipient/ ___ Monolith notes: Most fields that make up an international id are not allowed to have a timeline. Known issue: The field values can still be changed (regardless of not having a timeline). Known issue: First name and last name do have timelines in the monolith. ___ */
export class EmployeeV3ForeignGovernmentIdDto implements IEmployeeV3ForeignGovernmentIdDto {
    type?: ForeignGovernmentIdTypeV3EnumDto;
    /** Mandatory.
 */
    id?: string;
    countryCode?: string;

    constructor(data?: IEmployeeV3ForeignGovernmentIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): EmployeeV3ForeignGovernmentIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ForeignGovernmentIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): EmployeeV3ForeignGovernmentIdDto {
        const json = this.toJSON();
        let result = new EmployeeV3ForeignGovernmentIdDto();
        result.init(json);
        return result;
    }
}

/** Mandatory if `employeeV3GovernmentIdValueDto.type` is `foreign`, otherwise prohibited. Used to create a unique person identifier in a-messages. The identifier is made up of the following fields: - `firstName` - `lastName` - `birthDate` - `customId` (optional, TBD: is this actually used?) - `id` - `type` - `countryCode` This must not change after being used in an a-message, or the next a-message won't be linked to the same employee. The a-message guide is silent on what to do if an employee without a national ID or D number change their name or gets new identification. https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/national-identity-number-d-number-or-international-id-income-recipient/ ___ Monolith notes: Most fields that make up an international id are not allowed to have a timeline. Known issue: The field values can still be changed (regardless of not having a timeline). Known issue: First name and last name do have timelines in the monolith. ___ */
export interface IEmployeeV3ForeignGovernmentIdDto {
    type?: ForeignGovernmentIdTypeV3EnumDto;
    /** Mandatory.
 */
    id?: string;
    countryCode?: string;
}

export class EmployeeV3PhoneDto implements IEmployeeV3PhoneDto {
    type!: PhoneTypeV3EnumDto;
    /** Must be unique for this employee.

The pattern must match the full string
(note that the pattern does not include ^ and $ so it may match parts of the string).

___
Monolith notes: Field "Phone number" (423116d0-2a8e-4844-bef2-56d15028d8b9).

Known issue: The monolith appears to want to match 4 groups with dashes,
but the last group will only be matched if a space is used a separator
due to the way the regular expression is written.
`\s*` will match a zero-length string and then `\d*` will match a zero-length string
and thus the match will be less than the full value and rejected
(eg. only `11-2-3-4` will be matched from `11-2-3-4-5`).
Also, the pattern will match eg. `11---2   3` which also seems unintended.
Maybe the pattern should have been `^\+?(\d+[-\s]?){4}\d+$`,
but changing to that could invalidate existing data.
___
 */
    number!: string;

    constructor(data?: IEmployeeV3PhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): EmployeeV3PhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["number"] = this.number;
        return data;
    }

    clone(): EmployeeV3PhoneDto {
        const json = this.toJSON();
        let result = new EmployeeV3PhoneDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PhoneDto {
    type: PhoneTypeV3EnumDto;
    /** Must be unique for this employee.

The pattern must match the full string
(note that the pattern does not include ^ and $ so it may match parts of the string).

___
Monolith notes: Field "Phone number" (423116d0-2a8e-4844-bef2-56d15028d8b9).

Known issue: The monolith appears to want to match 4 groups with dashes,
but the last group will only be matched if a space is used a separator
due to the way the regular expression is written.
`\s*` will match a zero-length string and then `\d*` will match a zero-length string
and thus the match will be less than the full value and rejected
(eg. only `11-2-3-4` will be matched from `11-2-3-4-5`).
Also, the pattern will match eg. `11---2   3` which also seems unintended.
Maybe the pattern should have been `^\+?(\d+[-\s]?){4}\d+$`,
but changing to that could invalidate existing data.
___
 */
    number: string;
}

export class EmployeeV3EmailDto implements IEmployeeV3EmailDto {
    type!: EmailTypeV3EnumDto;
    /** Must be unique\* for this employee, including `user.emailAddress`.

\*The domain name is not case sensitive,
but must be stored with case preservation.
Ref [RFC on address parts](https://datatracker.ietf.org/doc/html/rfc5322#section-3.4.1)
and [RFC on domain names](https://datatracker.ietf.org/doc/html/rfc1034#section-3.1)

Must be a valid e-mail address, as per this textual explanation of the pattern:
- local-part@domain
- Must contain exactly one @.
  - Except if the local-part is in double quotes, ie. "quoted-local-part"@domain.
- Whitespace is only allowed in a quoted-local-part.
  - This is more restrictive than the specification (and the monolith),
    but allowing whitespace does not make as much sense in a e-mail address book
    as in an actual e-mail.
- local-part must be non-empty.
  - quoted-local-part must also be non-empty.
- domain must be non-empty.
- This validation is much more permissive than the RFC.
  - No attempt to limit the character set (beyond whitespace and " and @).
  - The monolith is as strict as the RFC and may reject invalid addresses.

___
Monolith notes: Field "E-mail address" (85207403-6a69-48c8-a444-5ac71d331331)

Draft employees may have an entry with only e-mail type set.
Such entries will be filtered out while mapping,
in order to have the actual address required in the new schema.

Known issue (discrepancy): The monolith accepts equal e-mail addresses that differ
in domain name casing only (but domain names are case-insensitive).

Known vintage UI issue (discrepancy): Any address with a case insensitive match
of the full `user.emailAddress` is treated as the user email,
even though addresses with a casing difference in the local part
(the part before the last @) cannot be guaranteed to be the same address.

Known vintage UI issue (discrepancy): Some valid e-mail addresses
(eg a quoted local-part, "b@rista"@baristas.com)
are not accepted, even though the monolith backend does accept them.

Known issue (discrepancy): The monolith implements much stricter validation,
but so long as the value is actually a valid address it makes no difference.
___
 */
    address!: string;

    constructor(data?: IEmployeeV3EmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): EmployeeV3EmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3EmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["address"] = this.address;
        return data;
    }

    clone(): EmployeeV3EmailDto {
        const json = this.toJSON();
        let result = new EmployeeV3EmailDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3EmailDto {
    type: EmailTypeV3EnumDto;
    /** Must be unique\* for this employee, including `user.emailAddress`.

\*The domain name is not case sensitive,
but must be stored with case preservation.
Ref [RFC on address parts](https://datatracker.ietf.org/doc/html/rfc5322#section-3.4.1)
and [RFC on domain names](https://datatracker.ietf.org/doc/html/rfc1034#section-3.1)

Must be a valid e-mail address, as per this textual explanation of the pattern:
- local-part@domain
- Must contain exactly one @.
  - Except if the local-part is in double quotes, ie. "quoted-local-part"@domain.
- Whitespace is only allowed in a quoted-local-part.
  - This is more restrictive than the specification (and the monolith),
    but allowing whitespace does not make as much sense in a e-mail address book
    as in an actual e-mail.
- local-part must be non-empty.
  - quoted-local-part must also be non-empty.
- domain must be non-empty.
- This validation is much more permissive than the RFC.
  - No attempt to limit the character set (beyond whitespace and " and @).
  - The monolith is as strict as the RFC and may reject invalid addresses.

___
Monolith notes: Field "E-mail address" (85207403-6a69-48c8-a444-5ac71d331331)

Draft employees may have an entry with only e-mail type set.
Such entries will be filtered out while mapping,
in order to have the actual address required in the new schema.

Known issue (discrepancy): The monolith accepts equal e-mail addresses that differ
in domain name casing only (but domain names are case-insensitive).

Known vintage UI issue (discrepancy): Any address with a case insensitive match
of the full `user.emailAddress` is treated as the user email,
even though addresses with a casing difference in the local part
(the part before the last @) cannot be guaranteed to be the same address.

Known vintage UI issue (discrepancy): Some valid e-mail addresses
(eg a quoted local-part, "b@rista"@baristas.com)
are not accepted, even though the monolith backend does accept them.

Known issue (discrepancy): The monolith implements much stricter validation,
but so long as the value is actually a valid address it makes no difference.
___
 */
    address: string;
}

/** `countryCode` is mandatory. ___ Monolith notes: Field "Address" (5b44bc35-a983-488c-b787-5d50d8fb7a76). Complex field subfields: - n/a: "Address type" (652746d8-d828-4228-8d65-26806debc5b3) - `address1`: "Street" (deec92a7-64e8-47da-abfd-31cb8a8ec526) - n/a: "Street 2" (f791788d-8234-44d9-9db5-abb75cfce8c7) - `postalCode`: "Zipcode" (ac6d6caf-48a4-4696-8a67-a33a851f47b1) - `postalLocation`: "City" (47364cf6-17c0-4b4a-afdc-6fe1ca7d0362) - `countryCode`: "Country" (b085eef6-8912-473b-bee1-e8bda3472835) The "Address type" is always 'Home'. The vintage UI does not support `address2` and a validation script ensures it is not set if "Address type" is set. The mapper fails if it has a value, rather than losing the value when writing back. ___ */
export class EmployeeV3AddressDto implements IEmployeeV3AddressDto {
    address1?: string;
    postalCode?: string;
    /** City/place corresponding to `postalCode`.

___
Monolith notes: If `countryCode` is `NO` (Norway) and `postalCode` is a value known by field engine,
field engine will replace this value with the name from reference table 82020 Norway zip code.

Known issue: These names do not align exactly with [postalCodeV3Enum](#models-postalCodeV3Enum),
which use a better algorithm for casing and character decoding.
___
 */
    postalLocation?: string;
    countryCode?: string;

    constructor(data?: IEmployeeV3AddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.postalCode = _data["postalCode"];
            this.postalLocation = _data["postalLocation"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): EmployeeV3AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["postalCode"] = this.postalCode;
        data["postalLocation"] = this.postalLocation;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): EmployeeV3AddressDto {
        const json = this.toJSON();
        let result = new EmployeeV3AddressDto();
        result.init(json);
        return result;
    }
}

/** `countryCode` is mandatory. ___ Monolith notes: Field "Address" (5b44bc35-a983-488c-b787-5d50d8fb7a76). Complex field subfields: - n/a: "Address type" (652746d8-d828-4228-8d65-26806debc5b3) - `address1`: "Street" (deec92a7-64e8-47da-abfd-31cb8a8ec526) - n/a: "Street 2" (f791788d-8234-44d9-9db5-abb75cfce8c7) - `postalCode`: "Zipcode" (ac6d6caf-48a4-4696-8a67-a33a851f47b1) - `postalLocation`: "City" (47364cf6-17c0-4b4a-afdc-6fe1ca7d0362) - `countryCode`: "Country" (b085eef6-8912-473b-bee1-e8bda3472835) The "Address type" is always 'Home'. The vintage UI does not support `address2` and a validation script ensures it is not set if "Address type" is set. The mapper fails if it has a value, rather than losing the value when writing back. ___ */
export interface IEmployeeV3AddressDto {
    address1?: string;
    postalCode?: string;
    /** City/place corresponding to `postalCode`.

___
Monolith notes: If `countryCode` is `NO` (Norway) and `postalCode` is a value known by field engine,
field engine will replace this value with the name from reference table 82020 Norway zip code.

Known issue: These names do not align exactly with [postalCodeV3Enum](#models-postalCodeV3Enum),
which use a better algorithm for casing and character decoding.
___
 */
    postalLocation?: string;
    countryCode?: string;
}

export class EmployeeV3ContactDto implements IEmployeeV3ContactDto {
    /** Used by administrator to get the main emergency contacts.

There is no restriction on the number of contacts that can
be marked as a main contact.

___
Monolith notes: Field "Main contact" (50546799-59b4-46e6-a77c-e91220eb6a57).
___
 */
    isMainContact!: boolean;
    /** Mandatory.

___
Monolith notes: Field "First name" (8760f996-ac90-4823-9c5e-e4248a61e47f).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    firstName?: string;
    /** Mandatory.

___
Monolith notes: Field "Last name" (9a14b378-9703-444f-a287-664b654716bf).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    lastName?: string;
    /** The pattern must match the full string.

___
Monolith notes: Field "Phone" (c5ef653f-ca37-4d6a-92bf-ba1c483cc6a5),
subfield "Phone number" (423116d0-2a8e-4844-bef2-56d15028d8b9).

Data loss: The subfield "Phone type" (2c72cfda-b51f-4a25-90eb-0f94335574ad) is
not used in the mapping and will be set to private when mapping back.

Known issue: See monolith notes on employee phone number.
___
 */
    phone?: string;
    /** If set, this must be a valid e-mail address, as per the pattern.
See `employeeV3EmailDto.address` for an explanation of it.

___
Monolith notes: Field "E-mail" (02e0254d-c7e5-4c01-b95c-9d47de03ff3b),
subfield "E-mail address" (85207403-6a69-48c8-a444-5ac71d331331).

Data loss: The subfield "E-mail type" (944688a4-d88a-433b-a0b3-80de190daa9a) is
not used in the mapping and will be set to private when mapping back.
___
 */
    email?: string;

    constructor(data?: IEmployeeV3ContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMainContact = _data["isMainContact"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmployeeV3ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMainContact"] = this.isMainContact;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }

    clone(): EmployeeV3ContactDto {
        const json = this.toJSON();
        let result = new EmployeeV3ContactDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3ContactDto {
    /** Used by administrator to get the main emergency contacts.

There is no restriction on the number of contacts that can
be marked as a main contact.

___
Monolith notes: Field "Main contact" (50546799-59b4-46e6-a77c-e91220eb6a57).
___
 */
    isMainContact: boolean;
    /** Mandatory.

___
Monolith notes: Field "First name" (8760f996-ac90-4823-9c5e-e4248a61e47f).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    firstName?: string;
    /** Mandatory.

___
Monolith notes: Field "Last name" (9a14b378-9703-444f-a287-664b654716bf).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    lastName?: string;
    /** The pattern must match the full string.

___
Monolith notes: Field "Phone" (c5ef653f-ca37-4d6a-92bf-ba1c483cc6a5),
subfield "Phone number" (423116d0-2a8e-4844-bef2-56d15028d8b9).

Data loss: The subfield "Phone type" (2c72cfda-b51f-4a25-90eb-0f94335574ad) is
not used in the mapping and will be set to private when mapping back.

Known issue: See monolith notes on employee phone number.
___
 */
    phone?: string;
    /** If set, this must be a valid e-mail address, as per the pattern.
See `employeeV3EmailDto.address` for an explanation of it.

___
Monolith notes: Field "E-mail" (02e0254d-c7e5-4c01-b95c-9d47de03ff3b),
subfield "E-mail address" (85207403-6a69-48c8-a444-5ac71d331331).

Data loss: The subfield "E-mail type" (944688a4-d88a-433b-a0b3-80de190daa9a) is
not used in the mapping and will be set to private when mapping back.
___
 */
    email?: string;
}

export class EmployeeV3ChildDto implements IEmployeeV3ChildDto {
    /** Mandatory.

___
Monolith notes: Field "First name" (8760f996-ac90-4823-9c5e-e4248a61e47f).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    firstName?: string;
    /** Mandatory.

___
Monolith notes: Field "Last name" (9a14b378-9703-444f-a287-664b654716bf)

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    lastName?: string;
    /** Mandatory.

Used by calendar to determine right to care leave.

https://www.nav.no/omsorgspenger

___
Monolith notes: Field "Date of birth" (9fc9af3a-38d5-4f07-8ddc-ea1e0fdadef2).

The minimum and maximum values are the next and previous year for the
start and end of the monolith's supported date range.

The monolith is storing the exact date, but under Norwegian rules only the
birth year is necessary. When mapping back the month and day will be set to 1.
___
 */
    birthYear?: string;
    /** Used by calendar to determine right to care leave.

___
Monolith notes: Field "Sole custody" (1ea5f79b-567a-4ac5-bbc9-71d4e5b92fd8).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    hasSoleCustodyTimeline?: BooleanV3TimelineItemDto[];
    /** The range for each item on this timeline indicates when there is
a valid doctor's certificate for chronic illness.

It is mandatory to specify both `from` and `to`.

___
Monolith notes: Based on three mostly independent timelines:
- Field "Chronically, long-term ill or disabled child" (81d238b7-b65c-4e4f-8514-3c8f5c92f888)
- Field "Chronically ill from date" (dd15c9cf-fc34-4d0b-a22f-dec1ce35553f)
- Field "Chronically ill valid to date" (b37b7be6-b92c-47a4-8285-1052d050e3b6)

The mapping is the same as for the employee's `isChronicallyIllTimeline`.
___
 */
    isChronicallyIllTimeline?: BooleanV3TimelineItemDto[];

    constructor(data?: IEmployeeV3ChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthYear = _data["birthYear"];
            if (Array.isArray(_data["hasSoleCustodyTimeline"])) {
                this.hasSoleCustodyTimeline = [] as any;
                for (let item of _data["hasSoleCustodyTimeline"])
                    this.hasSoleCustodyTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["isChronicallyIllTimeline"])) {
                this.isChronicallyIllTimeline = [] as any;
                for (let item of _data["isChronicallyIllTimeline"])
                    this.isChronicallyIllTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3ChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthYear"] = this.birthYear;
        if (Array.isArray(this.hasSoleCustodyTimeline)) {
            data["hasSoleCustodyTimeline"] = [];
            for (let item of this.hasSoleCustodyTimeline)
                data["hasSoleCustodyTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isChronicallyIllTimeline)) {
            data["isChronicallyIllTimeline"] = [];
            for (let item of this.isChronicallyIllTimeline)
                data["isChronicallyIllTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3ChildDto {
        const json = this.toJSON();
        let result = new EmployeeV3ChildDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3ChildDto {
    /** Mandatory.

___
Monolith notes: Field "First name" (8760f996-ac90-4823-9c5e-e4248a61e47f).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    firstName?: string;
    /** Mandatory.

___
Monolith notes: Field "Last name" (9a14b378-9703-444f-a287-664b654716bf)

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    lastName?: string;
    /** Mandatory.

Used by calendar to determine right to care leave.

https://www.nav.no/omsorgspenger

___
Monolith notes: Field "Date of birth" (9fc9af3a-38d5-4f07-8ddc-ea1e0fdadef2).

The minimum and maximum values are the next and previous year for the
start and end of the monolith's supported date range.

The monolith is storing the exact date, but under Norwegian rules only the
birth year is necessary. When mapping back the month and day will be set to 1.
___
 */
    birthYear?: string;
    /** Used by calendar to determine right to care leave.

___
Monolith notes: Field "Sole custody" (1ea5f79b-567a-4ac5-bbc9-71d4e5b92fd8).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    hasSoleCustodyTimeline?: BooleanV3TimelineItemDto[];
    /** The range for each item on this timeline indicates when there is
a valid doctor's certificate for chronic illness.

It is mandatory to specify both `from` and `to`.

___
Monolith notes: Based on three mostly independent timelines:
- Field "Chronically, long-term ill or disabled child" (81d238b7-b65c-4e4f-8514-3c8f5c92f888)
- Field "Chronically ill from date" (dd15c9cf-fc34-4d0b-a22f-dec1ce35553f)
- Field "Chronically ill valid to date" (b37b7be6-b92c-47a4-8285-1052d050e3b6)

The mapping is the same as for the employee's `isChronicallyIllTimeline`.
___
 */
    isChronicallyIllTimeline?: BooleanV3TimelineItemDto[];
}

export class EmployeeV3PayslipConfigDto implements IEmployeeV3PayslipConfigDto {
    /** Known values are listed in [payslipLanguageV3EnumDto](#model-payslipLanguageV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.
 */
    language!: string;
    /** Whether to include this employee's payslip in the PDF that can be generated thus:
1. Complete a wage run
2. In the vintage Payroll UI, go to the wage run's Reports step
3. In the Payslips section, select "Payslips that are not delivered electronically"
   (as opposed to the default "All payslips")
4. Click the "Print" button

___
Monolith notes: Mapping to values in reference table 20170 Payslip:
- `false`: `No` (Electronic payslip only)
- `true`: `Yes` (Printed and electronic payslip)

Field "Print payslip" (730ab2a0-c6d5-40ed-ba03-0c39bc45d058).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

The labels for the vintage Employee UI selection and the vintage Payroll UI button
are misleading, as there isn't necessarily any printing involved.
It's just about generating a PDF, which may or may not be printed.
___
 */
    payslipOnPaper!: boolean;

    constructor(data?: IEmployeeV3PayslipConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.payslipOnPaper = _data["payslipOnPaper"];
        }
    }

    static fromJS(data: any): EmployeeV3PayslipConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PayslipConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["payslipOnPaper"] = this.payslipOnPaper;
        return data;
    }

    clone(): EmployeeV3PayslipConfigDto {
        const json = this.toJSON();
        let result = new EmployeeV3PayslipConfigDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PayslipConfigDto {
    /** Known values are listed in [payslipLanguageV3EnumDto](#model-payslipLanguageV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.
 */
    language: string;
    /** Whether to include this employee's payslip in the PDF that can be generated thus:
1. Complete a wage run
2. In the vintage Payroll UI, go to the wage run's Reports step
3. In the Payslips section, select "Payslips that are not delivered electronically"
   (as opposed to the default "All payslips")
4. Click the "Print" button

___
Monolith notes: Mapping to values in reference table 20170 Payslip:
- `false`: `No` (Electronic payslip only)
- `true`: `Yes` (Printed and electronic payslip)

Field "Print payslip" (730ab2a0-c6d5-40ed-ba03-0c39bc45d058).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

The labels for the vintage Employee UI selection and the vintage Payroll UI button
are misleading, as there isn't necessarily any printing involved.
It's just about generating a PDF, which may or may not be printed.
___
 */
    payslipOnPaper: boolean;
}

export class EmployeeV3PaymentDetailDto implements IEmployeeV3PaymentDetailDto {
    type?: PaymentTypeV3EnumDto;
    /** Mandatory when `type` is `norwegianBank`, otherwise prohibited.

End user clients should format this as
4 digits, space, 2 digits, space and 5 digits.
Keep in mind that the current value might be invalid (both length and content).
The server does not accept spaces.

The 11th digit is a check digit.
Sum of the below modulo 11 must be 0:
- 5 times digit 1
- 4 times digit 2
- 3 times digit 3
- 2 times digit 4
- 7 times digit 5
- 6 times digit 6
- 5 times digit 7
- 4 times digit 8
- 3 times digit 9
- 2 times digit 10
- 1 times digit 11

The first 4 digits indicate is the bank office code.
This code existence should not be validated by the client,
but clients must gracefully handle if the server choose to validate it.

References:
- https://www.sprakradet.no/sprakhjelp/Skriveregler/Dato/#bank
- https://no.wikipedia.org/wiki/MOD11
- https://no.wikipedia.org/wiki/Kontonummer
- Bank office codes: https://bits.no/iban

___
Monolith notes: Field "Bank account number" (5c7e8234-cd7c-4e3f-b64d-6dba4ac3a239)
___
 */
    norwegianAccountNumber?: string;
    internationalPayment?: EmployeeV3InternationalPaymentDto;

    constructor(data?: IEmployeeV3PaymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.norwegianAccountNumber = _data["norwegianAccountNumber"];
            this.internationalPayment = _data["internationalPayment"] ? EmployeeV3InternationalPaymentDto.fromJS(_data["internationalPayment"]) : undefined as any;
        }
    }

    static fromJS(data: any): EmployeeV3PaymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PaymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["norwegianAccountNumber"] = this.norwegianAccountNumber;
        data["internationalPayment"] = this.internationalPayment ? this.internationalPayment.toJSON() : undefined as any;
        return data;
    }

    clone(): EmployeeV3PaymentDetailDto {
        const json = this.toJSON();
        let result = new EmployeeV3PaymentDetailDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PaymentDetailDto {
    type?: PaymentTypeV3EnumDto;
    /** Mandatory when `type` is `norwegianBank`, otherwise prohibited.

End user clients should format this as
4 digits, space, 2 digits, space and 5 digits.
Keep in mind that the current value might be invalid (both length and content).
The server does not accept spaces.

The 11th digit is a check digit.
Sum of the below modulo 11 must be 0:
- 5 times digit 1
- 4 times digit 2
- 3 times digit 3
- 2 times digit 4
- 7 times digit 5
- 6 times digit 6
- 5 times digit 7
- 4 times digit 8
- 3 times digit 9
- 2 times digit 10
- 1 times digit 11

The first 4 digits indicate is the bank office code.
This code existence should not be validated by the client,
but clients must gracefully handle if the server choose to validate it.

References:
- https://www.sprakradet.no/sprakhjelp/Skriveregler/Dato/#bank
- https://no.wikipedia.org/wiki/MOD11
- https://no.wikipedia.org/wiki/Kontonummer
- Bank office codes: https://bits.no/iban

___
Monolith notes: Field "Bank account number" (5c7e8234-cd7c-4e3f-b64d-6dba4ac3a239)
___
 */
    norwegianAccountNumber?: string;
    internationalPayment?: EmployeeV3InternationalPaymentDto;
}

/** AKA salary account. Mandatory. Changes to this field will only affect future payments. The remainder of the salary is calculated for payment here. If AutoPay is used and payment type is `norwegianBank` or `foreignBank`, the payment will be made automatically (after approval). Otherwise there is a manual element involved in performing the payment. A high level overview of how the calculation works: 1. For a given wage run's period 2. With active position on `positionTimeline`, calculate net salary (see `basePayTimeline`). 3. Pay out creditor claims based on   1. `creditorClaimsTimeline`   2. Creditor claims are processed in prioritized order base on `type`.      1. `childSupport`      2. `legalOffence`      3. `tax`      4. `governmentClaim`      5. `userDefined` 4. Pay out union fee based on   1. Union settings   2. `unionTimeline` 5. Pay out to active destinations on `extraPaymentsTimeline` 6. The remainder goes to `defaultPayment` ___ Monolith notes: Field "Salary account" (9a3cffd5-d2d8-4373-9a35-6f8017a4e819). The creditor claim and union deductions and the extra and default payments, are all represented by complex fields of the same class, "Payment Rule (new)". To prioritize instances of the class in payment rule engine, it uses the field "Sequence" (06c87b67-f575-4f38-9718-c2710d10637c) with the following possible values: - Creditor claim of type `child`: 1-10 - Creditor claim of type `legaloffence`: 11-20 - Creditor claim of type `unpaidtax`: 21-30 - Creditor claim of type `claimsstate`: 31-40 - Creditor claim of type `other`: 41-50 - Union: 51-60 - Additional account (extra payments) : 61-70 - Salary account (default payment): 100 The number of possible values per priority group (10) limits the maximum instances the user can create with overlapping date ranges. Except unions, which cannot have overlapping date ranges and is limited in its total count (10). The total count is a limitation of the monolith, not the payment rule engine, which should even support equal sequence values. Known issue: Exceeding the number of allowed instances causes a 500 Internal Server Error and vintage UI message "An error has occurred." ___ */
export class EmployeeV3DefaultPaymentDto extends EmployeeV3PaymentDetailDto implements IEmployeeV3DefaultPaymentDto {

    constructor(data?: IEmployeeV3DefaultPaymentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EmployeeV3DefaultPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3DefaultPaymentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3DefaultPaymentDto {
        const json = this.toJSON();
        let result = new EmployeeV3DefaultPaymentDto();
        result.init(json);
        return result;
    }
}

/** AKA salary account. Mandatory. Changes to this field will only affect future payments. The remainder of the salary is calculated for payment here. If AutoPay is used and payment type is `norwegianBank` or `foreignBank`, the payment will be made automatically (after approval). Otherwise there is a manual element involved in performing the payment. A high level overview of how the calculation works: 1. For a given wage run's period 2. With active position on `positionTimeline`, calculate net salary (see `basePayTimeline`). 3. Pay out creditor claims based on   1. `creditorClaimsTimeline`   2. Creditor claims are processed in prioritized order base on `type`.      1. `childSupport`      2. `legalOffence`      3. `tax`      4. `governmentClaim`      5. `userDefined` 4. Pay out union fee based on   1. Union settings   2. `unionTimeline` 5. Pay out to active destinations on `extraPaymentsTimeline` 6. The remainder goes to `defaultPayment` ___ Monolith notes: Field "Salary account" (9a3cffd5-d2d8-4373-9a35-6f8017a4e819). The creditor claim and union deductions and the extra and default payments, are all represented by complex fields of the same class, "Payment Rule (new)". To prioritize instances of the class in payment rule engine, it uses the field "Sequence" (06c87b67-f575-4f38-9718-c2710d10637c) with the following possible values: - Creditor claim of type `child`: 1-10 - Creditor claim of type `legaloffence`: 11-20 - Creditor claim of type `unpaidtax`: 21-30 - Creditor claim of type `claimsstate`: 31-40 - Creditor claim of type `other`: 41-50 - Union: 51-60 - Additional account (extra payments) : 61-70 - Salary account (default payment): 100 The number of possible values per priority group (10) limits the maximum instances the user can create with overlapping date ranges. Except unions, which cannot have overlapping date ranges and is limited in its total count (10). The total count is a limitation of the monolith, not the payment rule engine, which should even support equal sequence values. Known issue: Exceeding the number of allowed instances causes a 500 Internal Server Error and vintage UI message "An error has occurred." ___ */
export interface IEmployeeV3DefaultPaymentDto extends IEmployeeV3PaymentDetailDto {
}

/** Mandatory when `employeeV3PaymentDetailDto.type` is `foreignBank`, otherwise prohibited. */
export class EmployeeV3InternationalPaymentDto implements IEmployeeV3InternationalPaymentDto {
    /** A SWIFT BIC (business identifier code, formerly known as bank identifier code).

Mandatory.

Validation:
- Format: `BBBBCCLL[RRR]`
- `BBBB`
  - Bank/business code in 4 upper case letters.
  - Existence must not be validated because it changes too frequently.
- `CC`
  - Country code in 2 upper case letters (ISO 3166-1 alpha-2).
  - Client must not validate existence because it changes.
  - Note that the IBAN country can differ from the BIC country.
- `LL`
  - location code in 2 digits or upper case letters (ISO 3166-2).
  - Existence must not be validated because it changes too frequently.
- `[RRR]`
  - Optional.
  - Branch code in 3 digits or uppers case letters.
  - Existence cannot be validated.

References:
- ISO 9362:2022: https://www.iso.org/standard/84108.html
- https://en.wikipedia.org/wiki/ISO_9362
- https://www.swift.com/standards/data-standards/bic-business-identifier-code
- https://stripe.com/it/resources/more/swift-code-and-bic

___
Monolith notes: Field "BIC/SWIFT" (86eb677f-ed9d-461d-92a2-1f41ac896179).

Known issue (discrepancy): The monolith does not validate this value, not even its length.
___
 */
    swiftBic?: string;
    /** AKA IBAN (International Bank Account Number).

Mandatory.

End user clients should format this in groups of 4 characters separated by a space.
Keeping in mind that the length of the last group varies and even
that the current value might be invalid.
The server does not accept spaces.

Validation:
- Format: `CCKKA{1,30}`
- `CC`
  - Country code in 2 upper case letters (ISO 3166-1 alpha-2).
  - Clients must not validate IBAN usage per country because it changes
    (86 countries as of 2023-29-11).
  - Note that the IBAN country can differ from the BIC country.
- `KK`
  - Two check digits.
- `A{1,30}`
  - BBAN (Basic Bank Account Number) in 1 to 30 digits or upper case letters.
  - Validation is optional because of its complexity.
    - Length per country is known.
    - Otherwise each national authority controls its BBAN format.
- The below modulo 97 must be 1:
  - Move the 4 first characters last (ie. `A{1,30}CCKK`)
  - Replace 'A' with 10, 'B' with 11 and so forth until 'Z' with 35.

Known country specific metadata is available as
[ibanRegistryJsonFile](https://static-json.no.visma.net/?urls.primaryName=IBAN+registry).
IBAN length for known countries must match,
but unknown countries are allowed.

References:
- ISO 13616:2020: https://www.iso.org/standard/81090.html
- https://en.wikipedia.org/wiki/International_Bank_Account_Number
- https://www.remitfinder.com/blog/what-are-iban-swift-and-bic-codes
  (note that the examples here are not valid IBANs)
- https://github.com/securancy/iban/blob/master/Javascript/checkiban.js
- https://www.iban.com/iban-checker
- https://www.swift.com/standards/data-standards/iban-international-bank-account-number
- https://www.swift.com/resource/iban-registry-pdf
- IBAN and BIC country code can differ: https://blog.coaster.de/wordpress/?p=34128

___
Monolith notes: Field "IBAN" (fc1cd10a-f7d8-4312-97f1-5231f9fe1f3e).

Known issue (discrepancy): The monolith allows a maxLength of 39.

Known issue (discrepancy): The monolith does not validate this value.
___
 */
    accountNumber?: string;
    bankCountryCode?: string;
    remittanceCountryCode?: string;

    constructor(data?: IEmployeeV3InternationalPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.swiftBic = _data["swiftBic"];
            this.accountNumber = _data["accountNumber"];
            this.bankCountryCode = _data["bankCountryCode"];
            this.remittanceCountryCode = _data["remittanceCountryCode"];
        }
    }

    static fromJS(data: any): EmployeeV3InternationalPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3InternationalPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swiftBic"] = this.swiftBic;
        data["accountNumber"] = this.accountNumber;
        data["bankCountryCode"] = this.bankCountryCode;
        data["remittanceCountryCode"] = this.remittanceCountryCode;
        return data;
    }

    clone(): EmployeeV3InternationalPaymentDto {
        const json = this.toJSON();
        let result = new EmployeeV3InternationalPaymentDto();
        result.init(json);
        return result;
    }
}

/** Mandatory when `employeeV3PaymentDetailDto.type` is `foreignBank`, otherwise prohibited. */
export interface IEmployeeV3InternationalPaymentDto {
    /** A SWIFT BIC (business identifier code, formerly known as bank identifier code).

Mandatory.

Validation:
- Format: `BBBBCCLL[RRR]`
- `BBBB`
  - Bank/business code in 4 upper case letters.
  - Existence must not be validated because it changes too frequently.
- `CC`
  - Country code in 2 upper case letters (ISO 3166-1 alpha-2).
  - Client must not validate existence because it changes.
  - Note that the IBAN country can differ from the BIC country.
- `LL`
  - location code in 2 digits or upper case letters (ISO 3166-2).
  - Existence must not be validated because it changes too frequently.
- `[RRR]`
  - Optional.
  - Branch code in 3 digits or uppers case letters.
  - Existence cannot be validated.

References:
- ISO 9362:2022: https://www.iso.org/standard/84108.html
- https://en.wikipedia.org/wiki/ISO_9362
- https://www.swift.com/standards/data-standards/bic-business-identifier-code
- https://stripe.com/it/resources/more/swift-code-and-bic

___
Monolith notes: Field "BIC/SWIFT" (86eb677f-ed9d-461d-92a2-1f41ac896179).

Known issue (discrepancy): The monolith does not validate this value, not even its length.
___
 */
    swiftBic?: string;
    /** AKA IBAN (International Bank Account Number).

Mandatory.

End user clients should format this in groups of 4 characters separated by a space.
Keeping in mind that the length of the last group varies and even
that the current value might be invalid.
The server does not accept spaces.

Validation:
- Format: `CCKKA{1,30}`
- `CC`
  - Country code in 2 upper case letters (ISO 3166-1 alpha-2).
  - Clients must not validate IBAN usage per country because it changes
    (86 countries as of 2023-29-11).
  - Note that the IBAN country can differ from the BIC country.
- `KK`
  - Two check digits.
- `A{1,30}`
  - BBAN (Basic Bank Account Number) in 1 to 30 digits or upper case letters.
  - Validation is optional because of its complexity.
    - Length per country is known.
    - Otherwise each national authority controls its BBAN format.
- The below modulo 97 must be 1:
  - Move the 4 first characters last (ie. `A{1,30}CCKK`)
  - Replace 'A' with 10, 'B' with 11 and so forth until 'Z' with 35.

Known country specific metadata is available as
[ibanRegistryJsonFile](https://static-json.no.visma.net/?urls.primaryName=IBAN+registry).
IBAN length for known countries must match,
but unknown countries are allowed.

References:
- ISO 13616:2020: https://www.iso.org/standard/81090.html
- https://en.wikipedia.org/wiki/International_Bank_Account_Number
- https://www.remitfinder.com/blog/what-are-iban-swift-and-bic-codes
  (note that the examples here are not valid IBANs)
- https://github.com/securancy/iban/blob/master/Javascript/checkiban.js
- https://www.iban.com/iban-checker
- https://www.swift.com/standards/data-standards/iban-international-bank-account-number
- https://www.swift.com/resource/iban-registry-pdf
- IBAN and BIC country code can differ: https://blog.coaster.de/wordpress/?p=34128

___
Monolith notes: Field "IBAN" (fc1cd10a-f7d8-4312-97f1-5231f9fe1f3e).

Known issue (discrepancy): The monolith allows a maxLength of 39.

Known issue (discrepancy): The monolith does not validate this value.
___
 */
    accountNumber?: string;
    bankCountryCode?: string;
    remittanceCountryCode?: string;
}

export class EmployeeV3ExtraPaymentItemDto extends OverlapV3TimelineItemDto implements IEmployeeV3ExtraPaymentItemDto {
    value!: EmployeeV3ExtraPaymentValueDto;

    constructor(data?: IEmployeeV3ExtraPaymentItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3ExtraPaymentValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3ExtraPaymentValueDto.fromJS(_data["value"]) : new EmployeeV3ExtraPaymentValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3ExtraPaymentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ExtraPaymentItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3ExtraPaymentItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3ExtraPaymentItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3ExtraPaymentItemDto extends IOverlapV3TimelineItemDto {
    value: EmployeeV3ExtraPaymentValueDto;
}

/** Changes will only affect future payments, there is no retroactive calculation. The client should indicate this to the end user. ___ Known vintage UI issue: Immediately after saving, the following fields become read-only, but the monolith API will accept changes: - `calculationMethod` - `accountHolder` - `fixedAmount` - `paycodeId` - `payment.norwegianAccountNumber` These are editable: - `from` - `to` - `description` ___ */
export class EmployeeV3ExtraPaymentValueDto implements IEmployeeV3ExtraPaymentValueDto {
    calculationMethod?: ExtraPaymentCalculationMethodV3EnumDto;
    /** Mandatory if `calculationMethod` is `fixedAmount`, otherwise prohibited.

___
Monolith notes: Field "Amount" (6c3fb0d6-5193-4ba0-872f-b4dcb082d6f1).

Known issue: There is no maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    fixedAmount?: string;
    /** Mandatory if `calculationMethod` is `paycode`, otherwise prohibited.

Foreign key:
- Must be the id for a paycode from Payroll API (available in `/icLookup`).
- The paycode must have a `PaymentRule` type.
- `from` must be on or after the paycode's `from`.
- `to` must be on or before the paycode's `to`.
- Clients must gracefully handle an invalid key and
  should encourage (but not require) that the end user fixes it.
- Integrity can be broken.
  - The Payroll API does not track employee usage.
  - A paycode can be deleted.
  - A paycode's date range can be changed.

___
Monolith notes: Field "Paycode" (663c3975-4422-4929-9d9d-d2f33840bc26).

In the vintage UI, a paycode is shown in grey if
its `to` is less than the extra payment's `from` or
its `from` is more than the extra payment's `from`.

Known issue (discrepancy): The extra payment's `to` is not checked.

Known issue: Invalid paycodes are only discouraged from being used,
but using them could cause issues where they are attempted used.
___
 */
    paycodeId?: string;
    /** ___
Monolith notes: Field "Description" (989e8ef6-c262-4ff1-8bc8-835f33339b4e).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    description?: string;
    /** Mandatory.

___
Monolith notes: Field "Bankholder name" (227f152c-3cf0-46dc-8099-f33a8511ed90).
___
 */
    accountHolder?: string;
    payment!: EmployeeV3PaymentDetailDto;

    constructor(data?: IEmployeeV3ExtraPaymentValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.payment = new EmployeeV3PaymentDetailDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationMethod = _data["calculationMethod"];
            this.fixedAmount = _data["fixedAmount"];
            this.paycodeId = _data["paycodeId"];
            this.description = _data["description"];
            this.accountHolder = _data["accountHolder"];
            this.payment = _data["payment"] ? EmployeeV3PaymentDetailDto.fromJS(_data["payment"]) : new EmployeeV3PaymentDetailDto();
        }
    }

    static fromJS(data: any): EmployeeV3ExtraPaymentValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ExtraPaymentValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationMethod"] = this.calculationMethod;
        data["fixedAmount"] = this.fixedAmount;
        data["paycodeId"] = this.paycodeId;
        data["description"] = this.description;
        data["accountHolder"] = this.accountHolder;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        return data;
    }

    clone(): EmployeeV3ExtraPaymentValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3ExtraPaymentValueDto();
        result.init(json);
        return result;
    }
}

/** Changes will only affect future payments, there is no retroactive calculation. The client should indicate this to the end user. ___ Known vintage UI issue: Immediately after saving, the following fields become read-only, but the monolith API will accept changes: - `calculationMethod` - `accountHolder` - `fixedAmount` - `paycodeId` - `payment.norwegianAccountNumber` These are editable: - `from` - `to` - `description` ___ */
export interface IEmployeeV3ExtraPaymentValueDto {
    calculationMethod?: ExtraPaymentCalculationMethodV3EnumDto;
    /** Mandatory if `calculationMethod` is `fixedAmount`, otherwise prohibited.

___
Monolith notes: Field "Amount" (6c3fb0d6-5193-4ba0-872f-b4dcb082d6f1).

Known issue: There is no maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    fixedAmount?: string;
    /** Mandatory if `calculationMethod` is `paycode`, otherwise prohibited.

Foreign key:
- Must be the id for a paycode from Payroll API (available in `/icLookup`).
- The paycode must have a `PaymentRule` type.
- `from` must be on or after the paycode's `from`.
- `to` must be on or before the paycode's `to`.
- Clients must gracefully handle an invalid key and
  should encourage (but not require) that the end user fixes it.
- Integrity can be broken.
  - The Payroll API does not track employee usage.
  - A paycode can be deleted.
  - A paycode's date range can be changed.

___
Monolith notes: Field "Paycode" (663c3975-4422-4929-9d9d-d2f33840bc26).

In the vintage UI, a paycode is shown in grey if
its `to` is less than the extra payment's `from` or
its `from` is more than the extra payment's `from`.

Known issue (discrepancy): The extra payment's `to` is not checked.

Known issue: Invalid paycodes are only discouraged from being used,
but using them could cause issues where they are attempted used.
___
 */
    paycodeId?: string;
    /** ___
Monolith notes: Field "Description" (989e8ef6-c262-4ff1-8bc8-835f33339b4e).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    description?: string;
    /** Mandatory.

___
Monolith notes: Field "Bankholder name" (227f152c-3cf0-46dc-8099-f33a8511ed90).
___
 */
    accountHolder?: string;
    payment: EmployeeV3PaymentDetailDto;
}

export class EmployeeV3CreditorClaimItemDto extends OverlapV3TimelineItemDto implements IEmployeeV3CreditorClaimItemDto {
    value!: EmployeeV3CreditorClaimValueDto;

    constructor(data?: IEmployeeV3CreditorClaimItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3CreditorClaimValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3CreditorClaimValueDto.fromJS(_data["value"]) : new EmployeeV3CreditorClaimValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3CreditorClaimItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CreditorClaimItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3CreditorClaimItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3CreditorClaimItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3CreditorClaimItemDto extends IOverlapV3TimelineItemDto {
    value: EmployeeV3CreditorClaimValueDto;
}

/** Changes will only affect future payments, there is no retroactive calculation. The client should indicate this to the end user. ___ Known vintage UI issue: Immediately after saving, the following fields become read-only, but the monolith API will accept changes: - `creditorId` - `taxIncomeYear` - `initialAmount` - `calculationMethod` - `fixedAmount` - `taxBasisPercentage` ___ */
export class EmployeeV3CreditorClaimValueDto implements IEmployeeV3CreditorClaimValueDto {
    type?: CreditorClaimTypeV3EnumDto;
    /** Mandatory.

Foreign key:
- Must be the id for a creditor from Org API (available in `/icLookup`).
- The creditor's `type` must be the same as `type`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a creditor.
  - The monolith API only allows `type` being `other` (except for system defined creditors).
  - The UI does not allow setting date range on a creditor.

___
Monolith notes: Field "Creditor" (5f7c9e6a-8c04-40d3-80b7-04287ae4a694).

The validation script claims this is not mandatory when `type` is `tax`,
but it is automatically set to `'8/0'`, so it might as well always be mandatory.

When `type` is `childSupport`, `legalOffence`, `tax`, `governmentClaim` or `coordinated`
this will be overridden by the monolith.
To ensure consistency for the end user, the new schema requires that
the same value is specified here.

The monolith verifies that the value is correct by looking at the value itself,
not the creditor's type:
- `childSupport`: `'2/0'`
- `legalOffence`: `'3/0'`
- `tax`: `'8/0'`
- `governmentClaim`: `'4/0'`
- `coordinated`: `'10/0'`
- `userDefined`: None of the above

Known issue (discrepancy): When `type` is `userDefined` only user defined creditors should be allowed.
The vintage UI only displays user defined creditors as options,
but the monolith API does not prevent a built-in creditor being used.
The only recourse in the vintage UI is to remove the creditor claim.
The mapper will issue a validation error.

Known issue: Monolith API allows settings a date range on a creditor.
The mapper will ignore creditor date ranges,
but the monolith will disallow using a creditor outside its date range.
___
 */
    creditorId?: string;
    /** Optional when `type` is `tax`, otherwise prohibited.

___
Monolith notes: Field "Income year" (837d9c6c-0c4b-47c9-93c4-96d7c17640f9).

Known issue: Future years are allowed, but there is no business case for it.
___
 */
    taxIncomeYear?: string;
    /** AKA. start amount.

Optional when `type` is
`legalOffence`, `tax`, `governmentClaim` or `userDefined`,
otherwise prohibited.

___
Monolith notes: Field "Start amount" (b5253714-9650-42d6-88a4-6468109f6652).

Known issue: There is no maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    initialAmount?: string;
    calculationMethod?: CreditorClaimCalculationMethodV3EnumDto;
    /** Mandatory when `calculationMethod` is `fixedAmount`, otherwise prohibited.

___
Monolith notes: Field "Amount" (6c3fb0d6-5193-4ba0-872f-b4dcb082d6f1).

Known issue: There is no maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    fixedAmount?: string;
    /** Mandatory when `calculationMethod` is `taxBasisPercentage`, otherwise prohibited.

___
Monolith notes: Field "Percentage" (20837836-1af4-4afa-a7df-27c8661e16e7).
___
 */
    taxBasisPercentage?: string;
    /** Prohibited when `type` is `coordinated`, otherwise optional.

___
Monolith notes: Field "Description" (989e8ef6-c262-4ff1-8bc8-835f33339b4e).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    description?: string;
    /** Mandatory when `type` is `coordinated`, otherwise optional.

A reference number used by Norwegian creditors
to connect a payment from or on behalf of the debtor
to a customer (the debtor), a specific invoice or similar.
Norwegian banks will accept this as input when performing a payment and
transfer it as a property on the payment in the recipient's account.

The Norwegian term "KID-nummer" is short for "kundeidentifikasjonsnummer"
(customer identification number), but both the words "customer" and "number" are misleading.
"Customer" because the value can contain other information than a customer id,
like invoice id, issuer month, or just about anything.
"Number" because it isn't purely numeric, but can end with a dash (-)
if the MOD11 check digit is 10.

The last character is the check digit.

EITHER sum of the below modulo 11 must be 0:
- 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7 times, and so forth, to the beginning of the value
- 2 times digit in 8th last character
- 7 times digit in 7th last character
- 6 times digit in 6th last character
- 5 times digit in 5th last character
- 4 times digit in 4th last character
- 3 times digit in 3rd last character
- 2 times digit in 2nd last character
- 1 times digit in last character, or 10 if the last character is - (ASCII 45)

OR sum of the below modulo 10 must be 0 (read from bottom up):
- and so forth, to the beginning of the value
- digit sum of 2 times digit in 6th last character
- 1 times digit in 5th last character
- digit sum of 2 times digit in 4th last character
- 1 times digit in 3rd last character
- digit sum of 2 times digit in 2nd last character
- 1 times digit in last character

References:
- [Systemspesifikasjon OCR giro](https://www.nets.eu/no-nb/PublishingImages/Lists/Accordion%20%20OCR%20giro/AllItems/OCR%20giro%20Systemspesifikasjon.pdf)
- https://no.wikipedia.org/wiki/KID-nummer
- https://www.nets.eu/no-nb/nyheter/Pages/KID-nummer-.aspx

___
Monolith notes: Field "Reference number" (f3313acd-5720-4a07-8de2-23421afd8fd3).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.
___
 */
    kidNumber?: string;

    constructor(data?: IEmployeeV3CreditorClaimValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.creditorId = _data["creditorId"];
            this.taxIncomeYear = _data["taxIncomeYear"];
            this.initialAmount = _data["initialAmount"];
            this.calculationMethod = _data["calculationMethod"];
            this.fixedAmount = _data["fixedAmount"];
            this.taxBasisPercentage = _data["taxBasisPercentage"];
            this.description = _data["description"];
            this.kidNumber = _data["kidNumber"];
        }
    }

    static fromJS(data: any): EmployeeV3CreditorClaimValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CreditorClaimValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["creditorId"] = this.creditorId;
        data["taxIncomeYear"] = this.taxIncomeYear;
        data["initialAmount"] = this.initialAmount;
        data["calculationMethod"] = this.calculationMethod;
        data["fixedAmount"] = this.fixedAmount;
        data["taxBasisPercentage"] = this.taxBasisPercentage;
        data["description"] = this.description;
        data["kidNumber"] = this.kidNumber;
        return data;
    }

    clone(): EmployeeV3CreditorClaimValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3CreditorClaimValueDto();
        result.init(json);
        return result;
    }
}

/** Changes will only affect future payments, there is no retroactive calculation. The client should indicate this to the end user. ___ Known vintage UI issue: Immediately after saving, the following fields become read-only, but the monolith API will accept changes: - `creditorId` - `taxIncomeYear` - `initialAmount` - `calculationMethod` - `fixedAmount` - `taxBasisPercentage` ___ */
export interface IEmployeeV3CreditorClaimValueDto {
    type?: CreditorClaimTypeV3EnumDto;
    /** Mandatory.

Foreign key:
- Must be the id for a creditor from Org API (available in `/icLookup`).
- The creditor's `type` must be the same as `type`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a creditor.
  - The monolith API only allows `type` being `other` (except for system defined creditors).
  - The UI does not allow setting date range on a creditor.

___
Monolith notes: Field "Creditor" (5f7c9e6a-8c04-40d3-80b7-04287ae4a694).

The validation script claims this is not mandatory when `type` is `tax`,
but it is automatically set to `'8/0'`, so it might as well always be mandatory.

When `type` is `childSupport`, `legalOffence`, `tax`, `governmentClaim` or `coordinated`
this will be overridden by the monolith.
To ensure consistency for the end user, the new schema requires that
the same value is specified here.

The monolith verifies that the value is correct by looking at the value itself,
not the creditor's type:
- `childSupport`: `'2/0'`
- `legalOffence`: `'3/0'`
- `tax`: `'8/0'`
- `governmentClaim`: `'4/0'`
- `coordinated`: `'10/0'`
- `userDefined`: None of the above

Known issue (discrepancy): When `type` is `userDefined` only user defined creditors should be allowed.
The vintage UI only displays user defined creditors as options,
but the monolith API does not prevent a built-in creditor being used.
The only recourse in the vintage UI is to remove the creditor claim.
The mapper will issue a validation error.

Known issue: Monolith API allows settings a date range on a creditor.
The mapper will ignore creditor date ranges,
but the monolith will disallow using a creditor outside its date range.
___
 */
    creditorId?: string;
    /** Optional when `type` is `tax`, otherwise prohibited.

___
Monolith notes: Field "Income year" (837d9c6c-0c4b-47c9-93c4-96d7c17640f9).

Known issue: Future years are allowed, but there is no business case for it.
___
 */
    taxIncomeYear?: string;
    /** AKA. start amount.

Optional when `type` is
`legalOffence`, `tax`, `governmentClaim` or `userDefined`,
otherwise prohibited.

___
Monolith notes: Field "Start amount" (b5253714-9650-42d6-88a4-6468109f6652).

Known issue: There is no maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    initialAmount?: string;
    calculationMethod?: CreditorClaimCalculationMethodV3EnumDto;
    /** Mandatory when `calculationMethod` is `fixedAmount`, otherwise prohibited.

___
Monolith notes: Field "Amount" (6c3fb0d6-5193-4ba0-872f-b4dcb082d6f1).

Known issue: There is no maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    fixedAmount?: string;
    /** Mandatory when `calculationMethod` is `taxBasisPercentage`, otherwise prohibited.

___
Monolith notes: Field "Percentage" (20837836-1af4-4afa-a7df-27c8661e16e7).
___
 */
    taxBasisPercentage?: string;
    /** Prohibited when `type` is `coordinated`, otherwise optional.

___
Monolith notes: Field "Description" (989e8ef6-c262-4ff1-8bc8-835f33339b4e).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.

Known issue: There is no length restriction.
___
 */
    description?: string;
    /** Mandatory when `type` is `coordinated`, otherwise optional.

A reference number used by Norwegian creditors
to connect a payment from or on behalf of the debtor
to a customer (the debtor), a specific invoice or similar.
Norwegian banks will accept this as input when performing a payment and
transfer it as a property on the payment in the recipient's account.

The Norwegian term "KID-nummer" is short for "kundeidentifikasjonsnummer"
(customer identification number), but both the words "customer" and "number" are misleading.
"Customer" because the value can contain other information than a customer id,
like invoice id, issuer month, or just about anything.
"Number" because it isn't purely numeric, but can end with a dash (-)
if the MOD11 check digit is 10.

The last character is the check digit.

EITHER sum of the below modulo 11 must be 0:
- 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7 times, and so forth, to the beginning of the value
- 2 times digit in 8th last character
- 7 times digit in 7th last character
- 6 times digit in 6th last character
- 5 times digit in 5th last character
- 4 times digit in 4th last character
- 3 times digit in 3rd last character
- 2 times digit in 2nd last character
- 1 times digit in last character, or 10 if the last character is - (ASCII 45)

OR sum of the below modulo 10 must be 0 (read from bottom up):
- and so forth, to the beginning of the value
- digit sum of 2 times digit in 6th last character
- 1 times digit in 5th last character
- digit sum of 2 times digit in 4th last character
- 1 times digit in 3rd last character
- digit sum of 2 times digit in 2nd last character
- 1 times digit in last character

References:
- [Systemspesifikasjon OCR giro](https://www.nets.eu/no-nb/PublishingImages/Lists/Accordion%20%20OCR%20giro/AllItems/OCR%20giro%20Systemspesifikasjon.pdf)
- https://no.wikipedia.org/wiki/KID-nummer
- https://www.nets.eu/no-nb/nyheter/Pages/KID-nummer-.aspx

___
Monolith notes: Field "Reference number" (f3313acd-5720-4a07-8de2-23421afd8fd3).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.
___
 */
    kidNumber?: string;
}

/** AKA. tax and contribution rules. `from` is mandatory. ___ Monolith notes: Field "Tax and contribution rule" (2665fba9-2de6-47e6-b31c-3a5336f74865). This is a complex timeline field with a single subfield that specified the rule type. Overlapping timeline items are allowed, but the subfield has a restriction that its value cannot be the same as that in an overlapping timeline item. The mapper splits the overlap timeline into one gap timeline per rule type. ___ */
export class EmployeeV3TaxationRulesDto implements IEmployeeV3TaxationRulesDto {
    /** `from` is mandatory.

Cannot have items with entries that overlap with `hasNetSalarySeafarerTimeline`.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/net-salary/

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `nettoloenn` (Net salary)
___
 */
    hasNetSalaryTimeline?: BooleanV3TimelineItemDto[];
    /** `from` is mandatory.

This timeline could have been computed from overlapping entries from
`hasNetSalaryTimeline` and `hasSeafarerDeductionTimeline`,
as that is the government's logic for when it should apply.
However, HAPPY-727 chose to implement a new rule value that corresponds to the new government value.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/special-allowance-for-seafarers/#Combination-of-special-allowance-for-seafarers-and-net-salary
https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/net-salary/#Net-pay-for-seafarers

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `nettoloennForSjoefolk` (Net salary for seafarers)
___
 */
    hasNetSalarySeafarerTimeline?: BooleanV3TimelineItemDto[];
    /** `from` is mandatory.

Cannot have overlapping entries with `hasNetSalarySeafarerTimeline`.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/special-allowance-for-seafarers/

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `saerskiltFradragForSjoefolk` (Special allowance for seafarers)
___
 */
    hasSeafarerDeductionTimeline?: BooleanV3TimelineItemDto[];
    /** `from` is mandatory.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/svalbard/

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `Svalbard` (Svalbard)
___
 */
    hasSvalbardTaxActTimeline?: BooleanV3TimelineItemDto[];

    constructor(data?: IEmployeeV3TaxationRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hasNetSalaryTimeline"])) {
                this.hasNetSalaryTimeline = [] as any;
                for (let item of _data["hasNetSalaryTimeline"])
                    this.hasNetSalaryTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasNetSalarySeafarerTimeline"])) {
                this.hasNetSalarySeafarerTimeline = [] as any;
                for (let item of _data["hasNetSalarySeafarerTimeline"])
                    this.hasNetSalarySeafarerTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasSeafarerDeductionTimeline"])) {
                this.hasSeafarerDeductionTimeline = [] as any;
                for (let item of _data["hasSeafarerDeductionTimeline"])
                    this.hasSeafarerDeductionTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasSvalbardTaxActTimeline"])) {
                this.hasSvalbardTaxActTimeline = [] as any;
                for (let item of _data["hasSvalbardTaxActTimeline"])
                    this.hasSvalbardTaxActTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3TaxationRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3TaxationRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hasNetSalaryTimeline)) {
            data["hasNetSalaryTimeline"] = [];
            for (let item of this.hasNetSalaryTimeline)
                data["hasNetSalaryTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasNetSalarySeafarerTimeline)) {
            data["hasNetSalarySeafarerTimeline"] = [];
            for (let item of this.hasNetSalarySeafarerTimeline)
                data["hasNetSalarySeafarerTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasSeafarerDeductionTimeline)) {
            data["hasSeafarerDeductionTimeline"] = [];
            for (let item of this.hasSeafarerDeductionTimeline)
                data["hasSeafarerDeductionTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasSvalbardTaxActTimeline)) {
            data["hasSvalbardTaxActTimeline"] = [];
            for (let item of this.hasSvalbardTaxActTimeline)
                data["hasSvalbardTaxActTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3TaxationRulesDto {
        const json = this.toJSON();
        let result = new EmployeeV3TaxationRulesDto();
        result.init(json);
        return result;
    }
}

/** AKA. tax and contribution rules. `from` is mandatory. ___ Monolith notes: Field "Tax and contribution rule" (2665fba9-2de6-47e6-b31c-3a5336f74865). This is a complex timeline field with a single subfield that specified the rule type. Overlapping timeline items are allowed, but the subfield has a restriction that its value cannot be the same as that in an overlapping timeline item. The mapper splits the overlap timeline into one gap timeline per rule type. ___ */
export interface IEmployeeV3TaxationRulesDto {
    /** `from` is mandatory.

Cannot have items with entries that overlap with `hasNetSalarySeafarerTimeline`.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/net-salary/

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `nettoloenn` (Net salary)
___
 */
    hasNetSalaryTimeline?: BooleanV3TimelineItemDto[];
    /** `from` is mandatory.

This timeline could have been computed from overlapping entries from
`hasNetSalaryTimeline` and `hasSeafarerDeductionTimeline`,
as that is the government's logic for when it should apply.
However, HAPPY-727 chose to implement a new rule value that corresponds to the new government value.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/special-allowance-for-seafarers/#Combination-of-special-allowance-for-seafarers-and-net-salary
https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/net-salary/#Net-pay-for-seafarers

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `nettoloennForSjoefolk` (Net salary for seafarers)
___
 */
    hasNetSalarySeafarerTimeline?: BooleanV3TimelineItemDto[];
    /** `from` is mandatory.

Cannot have overlapping entries with `hasNetSalarySeafarerTimeline`.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/special-allowance-for-seafarers/

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `saerskiltFradragForSjoefolk` (Special allowance for seafarers)
___
 */
    hasSeafarerDeductionTimeline?: BooleanV3TimelineItemDto[];
    /** `from` is mandatory.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/svalbard/

___
Monolith notes: Field "Tax and contribution rule type" (ac7c9f8d-517e-4d9d-ad20-72a885208c46).

Mapping to values in reference table 81010 Tax and contribution rule type:
- `true`: `Svalbard` (Svalbard)
___
 */
    hasSvalbardTaxActTimeline?: BooleanV3TimelineItemDto[];
}

export class EmployeeV3CarLinkItemDto extends GapV3TimelineItemDto implements IEmployeeV3CarLinkItemDto {
    value!: EmployeeV3CarLinkValueDto;

    constructor(data?: IEmployeeV3CarLinkItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3CarLinkValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3CarLinkValueDto.fromJS(_data["value"]) : new EmployeeV3CarLinkValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3CarLinkItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CarLinkItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3CarLinkItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3CarLinkItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3CarLinkItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3CarLinkValueDto;
}

/** TBD: When are changes allowed? ___ Monolith notes: Immediately after saving, `carId` becomes read-only in the vintage UI, but it can be changed from the monolith API. Known issue?: Car links in the past cannot be changed from the vintage UI, but they can be changed from the monolith API. ___ */
export class EmployeeV3CarLinkValueDto implements IEmployeeV3CarLinkValueDto {
    /** Mandatory.

Foreign key:
- Must be the id for a car from Org API (available in `/icLookup`).
- `from` must be on or after the car's `from`.
- `to` must be on or before the car's `to`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a car.
  - The monolith API does not allow removing a car's date range in use on an employee.

Unless the referenced car is in a car pool,
`carId` must not be used by another employee in an overlapping date range.

___
Monolith notes: Field "Car" (2e960c43-041a-4041-9b25-f6c5174f7d25).

Known issue: The monolith API allows changing whether a car is in a car pool.
___
 */
    carId?: string;
    yearlyKilometrageTimeline?: EmployeeV3YearlyKilometrageItemDto[];
    calculationMethodTimeline?: EmployeeV3CarCalculationMethodItemDto[];

    constructor(data?: IEmployeeV3CarLinkValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carId = _data["carId"];
            if (Array.isArray(_data["yearlyKilometrageTimeline"])) {
                this.yearlyKilometrageTimeline = [] as any;
                for (let item of _data["yearlyKilometrageTimeline"])
                    this.yearlyKilometrageTimeline!.push(EmployeeV3YearlyKilometrageItemDto.fromJS(item));
            }
            if (Array.isArray(_data["calculationMethodTimeline"])) {
                this.calculationMethodTimeline = [] as any;
                for (let item of _data["calculationMethodTimeline"])
                    this.calculationMethodTimeline!.push(EmployeeV3CarCalculationMethodItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3CarLinkValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CarLinkValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carId"] = this.carId;
        if (Array.isArray(this.yearlyKilometrageTimeline)) {
            data["yearlyKilometrageTimeline"] = [];
            for (let item of this.yearlyKilometrageTimeline)
                data["yearlyKilometrageTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calculationMethodTimeline)) {
            data["calculationMethodTimeline"] = [];
            for (let item of this.calculationMethodTimeline)
                data["calculationMethodTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3CarLinkValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3CarLinkValueDto();
        result.init(json);
        return result;
    }
}

/** TBD: When are changes allowed? ___ Monolith notes: Immediately after saving, `carId` becomes read-only in the vintage UI, but it can be changed from the monolith API. Known issue?: Car links in the past cannot be changed from the vintage UI, but they can be changed from the monolith API. ___ */
export interface IEmployeeV3CarLinkValueDto {
    /** Mandatory.

Foreign key:
- Must be the id for a car from Org API (available in `/icLookup`).
- `from` must be on or after the car's `from`.
- `to` must be on or before the car's `to`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a car.
  - The monolith API does not allow removing a car's date range in use on an employee.

Unless the referenced car is in a car pool,
`carId` must not be used by another employee in an overlapping date range.

___
Monolith notes: Field "Car" (2e960c43-041a-4041-9b25-f6c5174f7d25).

Known issue: The monolith API allows changing whether a car is in a car pool.
___
 */
    carId?: string;
    yearlyKilometrageTimeline?: EmployeeV3YearlyKilometrageItemDto[];
    calculationMethodTimeline?: EmployeeV3CarCalculationMethodItemDto[];
}

export class EmployeeV3YearlyKilometrageItemDto extends GapV3TimelineItemDto implements IEmployeeV3YearlyKilometrageItemDto {
    value!: string;

    constructor(data?: IEmployeeV3YearlyKilometrageItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3YearlyKilometrageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3YearlyKilometrageItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3YearlyKilometrageItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3YearlyKilometrageItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3YearlyKilometrageItemDto extends IGapV3TimelineItemDto {
    value: string;
}

export class EmployeeV3CarCalculationMethodItemDto extends GapV3TimelineItemDto implements IEmployeeV3CarCalculationMethodItemDto {
    value!: CarCalculationMethodV3EnumDto;

    constructor(data?: IEmployeeV3CarCalculationMethodItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3CarCalculationMethodItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CarCalculationMethodItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3CarCalculationMethodItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3CarCalculationMethodItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3CarCalculationMethodItemDto extends IGapV3TimelineItemDto {
    value: CarCalculationMethodV3EnumDto;
}

export class EmployeeV3TaxConfigItemDto extends FullV3TimelineItemDto implements IEmployeeV3TaxConfigItemDto {
    value!: EmployeeV3TaxConfigValueDto;

    constructor(data?: IEmployeeV3TaxConfigItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3TaxConfigValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3TaxConfigValueDto.fromJS(_data["value"]) : new EmployeeV3TaxConfigValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3TaxConfigItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3TaxConfigItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3TaxConfigItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3TaxConfigItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3TaxConfigItemDto extends IFullV3TimelineItemDto {
    value: EmployeeV3TaxConfigValueDto;
}

/** The following properties are only set manually:  - `isMainEmployer`  - `isFullyWithholdingChristmasTax`  - `isBorderCommuter`  - `isReceivingPension` `digitalTaxCard` can only be set by an update from Altinn, but it can be reset by manual changes. When `retrieveTaxCardOnWageRun` is `true`, the following properties will be updated from Altinn and end users should be discouraged from editing the values. But retro corrections should be allowed. - `borderCommuterPercentage` - `table` - `percentage` - `percentagePaye` - `hasExemptionCard` - `exemptionCardAmount` - `pensionTable` - `pensionPercentage` - `pensionPercentagePaye` - `hasPensionExemptionCard` */
export class EmployeeV3TaxConfigValueDto implements IEmployeeV3TaxConfigValueDto {
    /** Clients should default to `true`.

Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Main employer" (a2cf27eb-e1f4-44d3-8cd7-e15016ff433c).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isMainEmployer?: boolean;
    /** AKA. Full tax in Nov/Dec.

Only `true` is accepted. Absence of value implies `false`.

By law, employers can exempt their employees from withholding taxes
for a period "before Christmas".
They do so by default.

When this property is active, the Christmas exemption will not apply and
taxes before Christmas will be fully withheld.

Employers in Norway are required to withhold their employees' taxes on behalf of the government.
Tax card parameters are normally set so the expected tax is withheld in 10.5 months of the year,
so the remaining 1.5 months are exempt from withholding tax.
By law, the periods are 4 weeks of vacation and approximately 2 weeks for Christmas.
(Note that other rules may apply, eg. for pensions.)
(Note that some tax cards have a 12 month period for withholding tax.)

Some employees must always have their tax withheld by law or regulation.
Other employees may elect not use the exemption
-- ie they want their taxes before Christmas fully withheld --
for a variety of reasons, for example:
- Higher than normal salary in the exemption period.
- Too little tax withheld earlier in the year.
- Change of employer on eg. December 1st.
  - From an employer that had an early exemption of withheld taxes
  - To an employer that will have a late exemption of withholding taxes.
  - Employee wants to avoid two exemptions in withholding taxes with a resulting underpaid tax.

By regulation, the employer can choose an early or late period for Christmas tax exemption.
This is controlled by the company setting `periodForChristmasTaxWithholdingExemption`.
The exact period for the Christmas tax withholding exemption depends on
- `salaryTypeTimeline`
- whether payment happens every 14 days (not currently supported)
- `employmentType` (whether it's `pension`) (TBD: or `isReceivingPension`?)

References:
- Law on withholding taxes: https://lovdata.no/lov/2005-06-17-67/§5-7
- Regulation on withholding taxes: https://lovdata.no/forskrift/2007-12-21-1766/§5-7-2

___
Monolith notes: Field "Full tax in Nov/Dec" (d066796a-26d4-473b-bf52-edf13d90b130).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isFullyWithholdingChristmasTax?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Border commuter employee" (0a4247ee-64c5-490f-871d-fb247eefa4d5).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isBorderCommuter?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Pension benefits paid out to this person" (0b674566-0004-479e-a735-a86aff426964).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isReceivingPension?: boolean;
    digitalCard?: EmployeeV3DigitalTaxCardDto;
    /** Depending on `retrieveTaxCardOnWageRun` and `isBorderCommuter`:
- `true` and `true`: optional
- `false` and `true`: mandatory
- `true` and `false`: prohibited
- `false` and `false`: prohibited

Skatteetaten schema: `prosentsats` where
`trekkode` is `loennKunTrygdeavgiftTilUtenlandskBorgerSomGrensegjenger`

___
Monolith notes: Field "Border commuter tax percentage" (c37085f5-8d19-4792-8338-06c4ee13147a).
___
 */
    borderCommuterPercentage?: string;
    /** It is not validated whether this is a real deduction table number.

Skatteetaten schema: `tabellnummer` where
`trekkode` is `loennFraHovedarbeidsgiver` (TBD: verify).

In one particular scenario, `'0000'` is a correct value. See comments on the timeline.

References:
- https://www.skatteetaten.no/en/rates/deduction-tables-in-text-format/

___
Monolith notes: Field "Tax table" (48148e6a-1864-40e8-9172-b3f5edee9d48).

Known issue: Monolith validates using script `String.IsNumeric` which accepts decimals.

Known issue: It is not validated whether this is an actual tax table.
___
 */
    table?: string;
    /** Mandatory if `taxTable` is set, otherwise optional.

If no explicit value is set and a value is required, use 50.

Skatteetaten schema: `prosentsats` where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` (TBD: verify).

___
Monolith notes: Field "Tax percentage" (d06a1507-ca8e-4c12-9188-23a7fb612f4b).
___
 */
    percentage?: string;
    /** Skatteetaten schema: `prosentsats` where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` and
a `tilleggsopplysning` is `kildeskattPaaLoenn`. (TBD: verify).

https://www.skatteetaten.no/en/person/foreign/are-you-intending-to-work-in-norway/tax-deduction-cards/paye/

___
Monolith notes: Field "PAYE tax percentage" (c4d57402-34be-4fba-8876-8820ea4ffe3f).
___
 */
    percentagePaye?: string;
    /** Only `true` is accepted. Absence of value implies `false`.

Skatteetaten schema: `true` if `frikortbeloep` is set where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` (TBD: verify).

https://www.skatteetaten.no/en/person/taxes/tax-deduction-card-and-advance-tax/exemption-card/exemption-card-or-tax-deduction-card/

___
Monolith notes: Field "Freecard" (554d7abb-679b-4d71-8a7d-2e19ce09ae8b).
___
 */
    hasExemptionCard?: boolean;
    /** Mandatory if `hasExemptionCard` is `true`, otherwise prohibited.

Skatteetaten schema: `frikortbeloep` where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` (TBD: verify).

https://www.skatteetaten.no/en/person/taxes/tax-deduction-card-and-advance-tax/exemption-card/exemption-card-or-tax-deduction-card/

___
Monolith notes: Field "Freecard amount" (ffdc30d2-f067-4ceb-a816-ef5b32b2eb01).

Known issue: There is neither minimum nor maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    exemptionCardAmount?: string;
    /** It is not validated whether this is a real deduction table number.

Skatteetaten schema: `tabellnummer` where
`trekkode` is `pensjon` (TBD: verify).

References:
- https://www.skatteetaten.no/en/rates/deduction-tables-in-text-format/

___
Monolith notes: Field "Pension tax table" (86f929f0-6780-4eb2-9518-c5a787a21c78).

Known issue: It is not validated whether this is an actual tax table.

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    pensionTable?: string;
    /** Mandatory if `pensionTaxTable` is set, otherwise optional.

If no explicit value is set and a value is required, use 30.

Skatteetaten schema: `prosentsats` where
`trekkode` is `pensjon` (TBD: verify).

___
Monolith notes: Field "Pension tax percentage" (65a40dd9-4d88-43fe-a21a-e916e0365db0).

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    pensionPercentage?: string;
    /** Skatteetaten schema: `prosentsats` where
`trekkode` is `pensjon` and
a `tilleggsopplysning` is `kildeskattpensjonist`. (TBD: verify).

Note: A maximum of 1 digit after the decimal separator is allowed,
unlike other decimal values.

___
Monolith notes: Field "Pension PAYE tax percentage" (58f48566-6b6b-47db-a8c8-4df82de4b345).

Known issue (discrepancy): Minimum and maximum are not defined, unlike all other percentages.

Known issue (TBD: possibly): Only allows a 1 digit after the decimal separator,
unlike all other fields with of type decimal (which allow 2 digits).

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    pensionPercentagePaye?: string;
    /** Only `true` is accepted. Absence of value implies `false`.

Skatteetaten schema: `true` if `frikortbeloep` is set where
`trekkode` is `pensjon` (TBD: verify).

___
Monolith notes: Field "Pension freecard" (ad3a4a83-748b-4ac5-8e0c-8f34e06fac40).

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    hasPensionExemptionCard?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Posted from US/Canada" (9f437c4b-0bc6-44b0-9160-3b7b37e1afb9).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isPostedFromUsCanada?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

Field should only be shown for tax free organizations.
Note that payroll always reports from first krone,
using tax and contribution rule "Tax-free organisation".
This field is used to deduct tax for the employee from the first payment, to avoid
withholding much the month that total payments exceed 10 000 and/or
the employee having underpaid tax.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/tax-free-organisations/

___
Monolith notes: Field "Tax from the 1st NOK" (954b6779-4c16-45f4-bcc0-b75dfab081e4).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    taxFromFirstKroneForTaxFreeOrg?: boolean;

    constructor(data?: IEmployeeV3TaxConfigValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMainEmployer = _data["isMainEmployer"];
            this.isFullyWithholdingChristmasTax = _data["isFullyWithholdingChristmasTax"];
            this.isBorderCommuter = _data["isBorderCommuter"];
            this.isReceivingPension = _data["isReceivingPension"];
            this.digitalCard = _data["digitalCard"] ? EmployeeV3DigitalTaxCardDto.fromJS(_data["digitalCard"]) : undefined as any;
            this.borderCommuterPercentage = _data["borderCommuterPercentage"];
            this.table = _data["table"];
            this.percentage = _data["percentage"];
            this.percentagePaye = _data["percentagePaye"];
            this.hasExemptionCard = _data["hasExemptionCard"];
            this.exemptionCardAmount = _data["exemptionCardAmount"];
            this.pensionTable = _data["pensionTable"];
            this.pensionPercentage = _data["pensionPercentage"];
            this.pensionPercentagePaye = _data["pensionPercentagePaye"];
            this.hasPensionExemptionCard = _data["hasPensionExemptionCard"];
            this.isPostedFromUsCanada = _data["isPostedFromUsCanada"];
            this.taxFromFirstKroneForTaxFreeOrg = _data["taxFromFirstKroneForTaxFreeOrg"];
        }
    }

    static fromJS(data: any): EmployeeV3TaxConfigValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3TaxConfigValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMainEmployer"] = this.isMainEmployer;
        data["isFullyWithholdingChristmasTax"] = this.isFullyWithholdingChristmasTax;
        data["isBorderCommuter"] = this.isBorderCommuter;
        data["isReceivingPension"] = this.isReceivingPension;
        data["digitalCard"] = this.digitalCard ? this.digitalCard.toJSON() : undefined as any;
        data["borderCommuterPercentage"] = this.borderCommuterPercentage;
        data["table"] = this.table;
        data["percentage"] = this.percentage;
        data["percentagePaye"] = this.percentagePaye;
        data["hasExemptionCard"] = this.hasExemptionCard;
        data["exemptionCardAmount"] = this.exemptionCardAmount;
        data["pensionTable"] = this.pensionTable;
        data["pensionPercentage"] = this.pensionPercentage;
        data["pensionPercentagePaye"] = this.pensionPercentagePaye;
        data["hasPensionExemptionCard"] = this.hasPensionExemptionCard;
        data["isPostedFromUsCanada"] = this.isPostedFromUsCanada;
        data["taxFromFirstKroneForTaxFreeOrg"] = this.taxFromFirstKroneForTaxFreeOrg;
        return data;
    }

    clone(): EmployeeV3TaxConfigValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3TaxConfigValueDto();
        result.init(json);
        return result;
    }
}

/** The following properties are only set manually:  - `isMainEmployer`  - `isFullyWithholdingChristmasTax`  - `isBorderCommuter`  - `isReceivingPension` `digitalTaxCard` can only be set by an update from Altinn, but it can be reset by manual changes. When `retrieveTaxCardOnWageRun` is `true`, the following properties will be updated from Altinn and end users should be discouraged from editing the values. But retro corrections should be allowed. - `borderCommuterPercentage` - `table` - `percentage` - `percentagePaye` - `hasExemptionCard` - `exemptionCardAmount` - `pensionTable` - `pensionPercentage` - `pensionPercentagePaye` - `hasPensionExemptionCard` */
export interface IEmployeeV3TaxConfigValueDto {
    /** Clients should default to `true`.

Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Main employer" (a2cf27eb-e1f4-44d3-8cd7-e15016ff433c).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isMainEmployer?: boolean;
    /** AKA. Full tax in Nov/Dec.

Only `true` is accepted. Absence of value implies `false`.

By law, employers can exempt their employees from withholding taxes
for a period "before Christmas".
They do so by default.

When this property is active, the Christmas exemption will not apply and
taxes before Christmas will be fully withheld.

Employers in Norway are required to withhold their employees' taxes on behalf of the government.
Tax card parameters are normally set so the expected tax is withheld in 10.5 months of the year,
so the remaining 1.5 months are exempt from withholding tax.
By law, the periods are 4 weeks of vacation and approximately 2 weeks for Christmas.
(Note that other rules may apply, eg. for pensions.)
(Note that some tax cards have a 12 month period for withholding tax.)

Some employees must always have their tax withheld by law or regulation.
Other employees may elect not use the exemption
-- ie they want their taxes before Christmas fully withheld --
for a variety of reasons, for example:
- Higher than normal salary in the exemption period.
- Too little tax withheld earlier in the year.
- Change of employer on eg. December 1st.
  - From an employer that had an early exemption of withheld taxes
  - To an employer that will have a late exemption of withholding taxes.
  - Employee wants to avoid two exemptions in withholding taxes with a resulting underpaid tax.

By regulation, the employer can choose an early or late period for Christmas tax exemption.
This is controlled by the company setting `periodForChristmasTaxWithholdingExemption`.
The exact period for the Christmas tax withholding exemption depends on
- `salaryTypeTimeline`
- whether payment happens every 14 days (not currently supported)
- `employmentType` (whether it's `pension`) (TBD: or `isReceivingPension`?)

References:
- Law on withholding taxes: https://lovdata.no/lov/2005-06-17-67/§5-7
- Regulation on withholding taxes: https://lovdata.no/forskrift/2007-12-21-1766/§5-7-2

___
Monolith notes: Field "Full tax in Nov/Dec" (d066796a-26d4-473b-bf52-edf13d90b130).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isFullyWithholdingChristmasTax?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Border commuter employee" (0a4247ee-64c5-490f-871d-fb247eefa4d5).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isBorderCommuter?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Pension benefits paid out to this person" (0b674566-0004-479e-a735-a86aff426964).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isReceivingPension?: boolean;
    digitalCard?: EmployeeV3DigitalTaxCardDto;
    /** Depending on `retrieveTaxCardOnWageRun` and `isBorderCommuter`:
- `true` and `true`: optional
- `false` and `true`: mandatory
- `true` and `false`: prohibited
- `false` and `false`: prohibited

Skatteetaten schema: `prosentsats` where
`trekkode` is `loennKunTrygdeavgiftTilUtenlandskBorgerSomGrensegjenger`

___
Monolith notes: Field "Border commuter tax percentage" (c37085f5-8d19-4792-8338-06c4ee13147a).
___
 */
    borderCommuterPercentage?: string;
    /** It is not validated whether this is a real deduction table number.

Skatteetaten schema: `tabellnummer` where
`trekkode` is `loennFraHovedarbeidsgiver` (TBD: verify).

In one particular scenario, `'0000'` is a correct value. See comments on the timeline.

References:
- https://www.skatteetaten.no/en/rates/deduction-tables-in-text-format/

___
Monolith notes: Field "Tax table" (48148e6a-1864-40e8-9172-b3f5edee9d48).

Known issue: Monolith validates using script `String.IsNumeric` which accepts decimals.

Known issue: It is not validated whether this is an actual tax table.
___
 */
    table?: string;
    /** Mandatory if `taxTable` is set, otherwise optional.

If no explicit value is set and a value is required, use 50.

Skatteetaten schema: `prosentsats` where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` (TBD: verify).

___
Monolith notes: Field "Tax percentage" (d06a1507-ca8e-4c12-9188-23a7fb612f4b).
___
 */
    percentage?: string;
    /** Skatteetaten schema: `prosentsats` where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` and
a `tilleggsopplysning` is `kildeskattPaaLoenn`. (TBD: verify).

https://www.skatteetaten.no/en/person/foreign/are-you-intending-to-work-in-norway/tax-deduction-cards/paye/

___
Monolith notes: Field "PAYE tax percentage" (c4d57402-34be-4fba-8876-8820ea4ffe3f).
___
 */
    percentagePaye?: string;
    /** Only `true` is accepted. Absence of value implies `false`.

Skatteetaten schema: `true` if `frikortbeloep` is set where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` (TBD: verify).

https://www.skatteetaten.no/en/person/taxes/tax-deduction-card-and-advance-tax/exemption-card/exemption-card-or-tax-deduction-card/

___
Monolith notes: Field "Freecard" (554d7abb-679b-4d71-8a7d-2e19ce09ae8b).
___
 */
    hasExemptionCard?: boolean;
    /** Mandatory if `hasExemptionCard` is `true`, otherwise prohibited.

Skatteetaten schema: `frikortbeloep` where
`trekkode` is `loennFraHovedarbeidsgiver` or `loennFraBiarbeidsgiver` (TBD: verify).

https://www.skatteetaten.no/en/person/taxes/tax-deduction-card-and-advance-tax/exemption-card/exemption-card-or-tax-deduction-card/

___
Monolith notes: Field "Freecard amount" (ffdc30d2-f067-4ceb-a816-ef5b32b2eb01).

Known issue: There is neither minimum nor maximum value.

Known issue (discrepancy): The monolith allows larger numbers than JavaScript can handle accurately.
___
 */
    exemptionCardAmount?: string;
    /** It is not validated whether this is a real deduction table number.

Skatteetaten schema: `tabellnummer` where
`trekkode` is `pensjon` (TBD: verify).

References:
- https://www.skatteetaten.no/en/rates/deduction-tables-in-text-format/

___
Monolith notes: Field "Pension tax table" (86f929f0-6780-4eb2-9518-c5a787a21c78).

Known issue: It is not validated whether this is an actual tax table.

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    pensionTable?: string;
    /** Mandatory if `pensionTaxTable` is set, otherwise optional.

If no explicit value is set and a value is required, use 30.

Skatteetaten schema: `prosentsats` where
`trekkode` is `pensjon` (TBD: verify).

___
Monolith notes: Field "Pension tax percentage" (65a40dd9-4d88-43fe-a21a-e916e0365db0).

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    pensionPercentage?: string;
    /** Skatteetaten schema: `prosentsats` where
`trekkode` is `pensjon` and
a `tilleggsopplysning` is `kildeskattpensjonist`. (TBD: verify).

Note: A maximum of 1 digit after the decimal separator is allowed,
unlike other decimal values.

___
Monolith notes: Field "Pension PAYE tax percentage" (58f48566-6b6b-47db-a8c8-4df82de4b345).

Known issue (discrepancy): Minimum and maximum are not defined, unlike all other percentages.

Known issue (TBD: possibly): Only allows a 1 digit after the decimal separator,
unlike all other fields with of type decimal (which allow 2 digits).

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    pensionPercentagePaye?: string;
    /** Only `true` is accepted. Absence of value implies `false`.

Skatteetaten schema: `true` if `frikortbeloep` is set where
`trekkode` is `pensjon` (TBD: verify).

___
Monolith notes: Field "Pension freecard" (ad3a4a83-748b-4ac5-8e0c-8f34e06fac40).

Vintage UI hides this field if `isReceivingPension` is `false`.
___
 */
    hasPensionExemptionCard?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

___
Monolith notes: Field "Posted from US/Canada" (9f437c4b-0bc6-44b0-9160-3b7b37e1afb9).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isPostedFromUsCanada?: boolean;
    /** Only `true` is accepted. Absence of value implies `false`.

Field should only be shown for tax free organizations.
Note that payroll always reports from first krone,
using tax and contribution rule "Tax-free organisation".
This field is used to deduct tax for the employee from the first payment, to avoid
withholding much the month that total payments exceed 10 000 and/or
the employee having underpaid tax.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/special-groups/tax-free-organisations/

___
Monolith notes: Field "Tax from the 1st NOK" (954b6779-4c16-45f4-bcc0-b75dfab081e4).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    taxFromFirstKroneForTaxFreeOrg?: boolean;
}

/** Meta information set when the tax card is fetched digitally. See also `retrieveTaxCardOnWageRun`. This can be misleading because it can be set when tax card has been manually changed, due to how the timelines from the monolith are reset/merged. None of the properties can be required, because the timeline mapped from the monolith can be inaccurate. ___ Monolith notes: Based on independent timelines. The `retrievedDate` gets a new timeline item every time the tax card is fetched (ie. at least every wage run when `retrieveTaxCardOnWageRun` was `true`), approximately 12 times every year. This would cause a needlessly large timeline when merged with tax card information. Data loss: The mapper only keeps the `retrievedDate` with the highest `from` date within a period where none of the `id`, `incomeYear` or `issuedDate` values change. These fields are set by the monolith when a tax card request returns a tax card. `id`, `issuedDate` and `retrievedDate` (but not `incomeYear`) are also generated based on - `taxTable` - `taxPercentage` - `hasExemptionCard` - `exemptionCardAmount` - `pensionTaxTable` - `pensionTaxPercentage` - `hasPensionExemptionCard` But not on - `borderCommuterTaxPercentage` - `taxPercentagePaye` - `pensionTaxPercentagePaye` The generated value is calculated thus: - if any of the source fields have changed:  - null - otherwise:  - the target field's old value  - Known issue: see monolith notes on `retrievedDate` Known issue: The monolith API does not prevent the client from modifying these fields. ___ */
export class EmployeeV3DigitalTaxCardDto implements IEmployeeV3DigitalTaxCardDto {
    /** Skatteetaten's ID for this tax card.

Skatteetaten schema: `skattekortidentifikator`

___
Monolith notes: Field "Taxcard ID" (dee3ab67-ab4e-449c-95b2-33f647bb387e).
___
 */
    readonly id?: string;
    /** The year this tax card is issued for.

Skatteetaten schema: `inntektsaar`

___
Monolith notes: Field "Taxcard income year" (a7bbec91-15d2-403c-8727-f2c675ddd6eb).
___
 */
    readonly incomeYear?: string;
    /** The date Skatteetaten issued this tax card.

This may be misleading because the parent object's values could have been changed
manually since then.

Skatteetaten schema: `utstedtDato`

___
Monolith notes: Field "Taxcard date" (1ca9b054-e960-462f-b7eb-431d2d6bb764).
___
 */
    readonly issuedDate?: Date;
    /** The last date Payroll fetched this tax card from Altinn.

Known issue: May instead contain the same value as `issuedDate`.

This may be misleading because the parent object's values could have been changed
manually since then.

___
Monolith notes: Field "Change date taxcard" (231489ef-578e-43cd-a736-fe113c0a831b).

Known issue: As mentioned in the object's monolith notes,
this value is calculated based on other fields.
But the same computation script is used for both
`issuedDate` and `retrievedDate` and if there is no change
then the former fields value is used in both cases.
TBD: Verify that this issue can actually occur
(it has only been seen in script code analysis).
___
 */
    readonly retrievedDate?: Date;

    constructor(data?: IEmployeeV3DigitalTaxCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).id = _data["id"];
            (this as any).incomeYear = _data["incomeYear"];
            (this as any).issuedDate = _data["issuedDate"] ? new Date(_data["issuedDate"].toString()) : undefined as any;
            (this as any).retrievedDate = _data["retrievedDate"] ? new Date(_data["retrievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmployeeV3DigitalTaxCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3DigitalTaxCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomeYear"] = this.incomeYear;
        data["issuedDate"] = this.issuedDate ? formatDate(this.issuedDate) : undefined as any;
        data["retrievedDate"] = this.retrievedDate ? formatDate(this.retrievedDate) : undefined as any;
        return data;
    }

    clone(): EmployeeV3DigitalTaxCardDto {
        const json = this.toJSON();
        let result = new EmployeeV3DigitalTaxCardDto();
        result.init(json);
        return result;
    }
}

/** Meta information set when the tax card is fetched digitally. See also `retrieveTaxCardOnWageRun`. This can be misleading because it can be set when tax card has been manually changed, due to how the timelines from the monolith are reset/merged. None of the properties can be required, because the timeline mapped from the monolith can be inaccurate. ___ Monolith notes: Based on independent timelines. The `retrievedDate` gets a new timeline item every time the tax card is fetched (ie. at least every wage run when `retrieveTaxCardOnWageRun` was `true`), approximately 12 times every year. This would cause a needlessly large timeline when merged with tax card information. Data loss: The mapper only keeps the `retrievedDate` with the highest `from` date within a period where none of the `id`, `incomeYear` or `issuedDate` values change. These fields are set by the monolith when a tax card request returns a tax card. `id`, `issuedDate` and `retrievedDate` (but not `incomeYear`) are also generated based on - `taxTable` - `taxPercentage` - `hasExemptionCard` - `exemptionCardAmount` - `pensionTaxTable` - `pensionTaxPercentage` - `hasPensionExemptionCard` But not on - `borderCommuterTaxPercentage` - `taxPercentagePaye` - `pensionTaxPercentagePaye` The generated value is calculated thus: - if any of the source fields have changed:  - null - otherwise:  - the target field's old value  - Known issue: see monolith notes on `retrievedDate` Known issue: The monolith API does not prevent the client from modifying these fields. ___ */
export interface IEmployeeV3DigitalTaxCardDto {
    /** Skatteetaten's ID for this tax card.

Skatteetaten schema: `skattekortidentifikator`

___
Monolith notes: Field "Taxcard ID" (dee3ab67-ab4e-449c-95b2-33f647bb387e).
___
 */
    id?: string;
    /** The year this tax card is issued for.

Skatteetaten schema: `inntektsaar`

___
Monolith notes: Field "Taxcard income year" (a7bbec91-15d2-403c-8727-f2c675ddd6eb).
___
 */
    incomeYear?: string;
    /** The date Skatteetaten issued this tax card.

This may be misleading because the parent object's values could have been changed
manually since then.

Skatteetaten schema: `utstedtDato`

___
Monolith notes: Field "Taxcard date" (1ca9b054-e960-462f-b7eb-431d2d6bb764).
___
 */
    issuedDate?: Date;
    /** The last date Payroll fetched this tax card from Altinn.

Known issue: May instead contain the same value as `issuedDate`.

This may be misleading because the parent object's values could have been changed
manually since then.

___
Monolith notes: Field "Change date taxcard" (231489ef-578e-43cd-a736-fe113c0a831b).

Known issue: As mentioned in the object's monolith notes,
this value is calculated based on other fields.
But the same computation script is used for both
`issuedDate` and `retrievedDate` and if there is no change
then the former fields value is used in both cases.
TBD: Verify that this issue can actually occur
(it has only been seen in script code analysis).
___
 */
    retrievedDate?: Date;
}

export class EmployeeV3PensionCompanyLinkItemDto extends GapV3TimelineItemDto implements IEmployeeV3PensionCompanyLinkItemDto {
    value!: EmployeeV3PensionCompanyLinkValueDto;

    constructor(data?: IEmployeeV3PensionCompanyLinkItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3PensionCompanyLinkValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3PensionCompanyLinkValueDto.fromJS(_data["value"]) : new EmployeeV3PensionCompanyLinkValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3PensionCompanyLinkItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PensionCompanyLinkItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3PensionCompanyLinkItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3PensionCompanyLinkItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PensionCompanyLinkItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3PensionCompanyLinkValueDto;
}

/** TBD: When are changes allowed? ___ Monolith notes: In the vintage UI, all of the following are editable when `to` is equal or larger than today. Otherwise, none are editable. - `from` - `to` - `pensionCompanyId` Known issue: The monolith API does not prevent changing either of these values, possibly allowing unintended retroactive changes. Known vintage UI issue: If you accidentally set `to` to a past date, you cannot fix your mistake except by deleting the entry and re-adding a similar one (possibly causing a slew of retroactive changes that cancel each other out). ___ */
export class EmployeeV3PensionCompanyLinkValueDto implements IEmployeeV3PensionCompanyLinkValueDto {
    /** Mandatory.

Foreign key:
- Must be the id for a pension company from Org API (available in `/icLookup`).
- `from` must be on or after the pension company's `from`.
- `to` must be on or before the pension company's `to`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a pension company in use by an employee.
  - The monolith API does not allow removing a pension company's date range in use on an employee.

___
Monolith notes: Field "Pension company" (8ecd6a2c-418e-4347-8884-ba5b9d46d8f8).
___
 */
    pensionCompanyId!: string;

    constructor(data?: IEmployeeV3PensionCompanyLinkValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pensionCompanyId = _data["pensionCompanyId"];
        }
    }

    static fromJS(data: any): EmployeeV3PensionCompanyLinkValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PensionCompanyLinkValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pensionCompanyId"] = this.pensionCompanyId;
        return data;
    }

    clone(): EmployeeV3PensionCompanyLinkValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3PensionCompanyLinkValueDto();
        result.init(json);
        return result;
    }
}

/** TBD: When are changes allowed? ___ Monolith notes: In the vintage UI, all of the following are editable when `to` is equal or larger than today. Otherwise, none are editable. - `from` - `to` - `pensionCompanyId` Known issue: The monolith API does not prevent changing either of these values, possibly allowing unintended retroactive changes. Known vintage UI issue: If you accidentally set `to` to a past date, you cannot fix your mistake except by deleting the entry and re-adding a similar one (possibly causing a slew of retroactive changes that cancel each other out). ___ */
export interface IEmployeeV3PensionCompanyLinkValueDto {
    /** Mandatory.

Foreign key:
- Must be the id for a pension company from Org API (available in `/icLookup`).
- `from` must be on or after the pension company's `from`.
- `to` must be on or before the pension company's `to`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a pension company in use by an employee.
  - The monolith API does not allow removing a pension company's date range in use on an employee.

___
Monolith notes: Field "Pension company" (8ecd6a2c-418e-4347-8884-ba5b9d46d8f8).
___
 */
    pensionCompanyId: string;
}

export class EmployeeV3UnionLinkItemDto extends GapV3TimelineItemDto implements IEmployeeV3UnionLinkItemDto {
    value!: EmployeeV3UnionLinkValueDto;

    constructor(data?: IEmployeeV3UnionLinkItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3UnionLinkValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3UnionLinkValueDto.fromJS(_data["value"]) : new EmployeeV3UnionLinkValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3UnionLinkItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3UnionLinkItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3UnionLinkItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3UnionLinkItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3UnionLinkItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3UnionLinkValueDto;
}

export class EmployeeV3UnionLinkValueDto implements IEmployeeV3UnionLinkValueDto {
    /** Same requirements as `employeeV3CreditorClaimValueDto.kidNumber`.

___
Monolith notes: Field "Employee reference number" (eaeb3157-4f41-4f1c-ac30-ee10d7da4d2f).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.
___
 */
    kidNumber?: string;
    detailTimeline!: EmployeeV3UnionLinkDetailItemDto[];

    constructor(data?: IEmployeeV3UnionLinkValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.detailTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kidNumber = _data["kidNumber"];
            if (Array.isArray(_data["detailTimeline"])) {
                this.detailTimeline = [] as any;
                for (let item of _data["detailTimeline"])
                    this.detailTimeline!.push(EmployeeV3UnionLinkDetailItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3UnionLinkValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3UnionLinkValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kidNumber"] = this.kidNumber;
        if (Array.isArray(this.detailTimeline)) {
            data["detailTimeline"] = [];
            for (let item of this.detailTimeline)
                data["detailTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3UnionLinkValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3UnionLinkValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3UnionLinkValueDto {
    /** Same requirements as `employeeV3CreditorClaimValueDto.kidNumber`.

___
Monolith notes: Field "Employee reference number" (eaeb3157-4f41-4f1c-ac30-ee10d7da4d2f).

Data loss: This field has a timeline, but the mapper picks the item with the highest `from` value.
When mapping back the entire timeline will be overwritten.
___
 */
    kidNumber?: string;
    detailTimeline: EmployeeV3UnionLinkDetailItemDto[];
}

export class EmployeeV3UnionLinkDetailItemDto extends GapV3TimelineItemDto implements IEmployeeV3UnionLinkDetailItemDto {
    value!: EmployeeV3UnionLinkDetailValueDto;

    constructor(data?: IEmployeeV3UnionLinkDetailItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3UnionLinkDetailValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3UnionLinkDetailValueDto.fromJS(_data["value"]) : new EmployeeV3UnionLinkDetailValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3UnionLinkDetailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3UnionLinkDetailItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3UnionLinkDetailItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3UnionLinkDetailItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3UnionLinkDetailItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3UnionLinkDetailValueDto;
}

export class EmployeeV3UnionLinkDetailValueDto implements IEmployeeV3UnionLinkDetailValueDto {
    /** Mandatory.

Foreign key:
- Must be the id for a union from Org API (available in `/icLookup`).
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The UI does not allow deleting a union.
  - The UI does not allow setting a date range on a union.

___
Monolith notes: Field "Union" (c04a62bd-ef2b-4348-8722-ac77bca76095).

Known issue: Monolith API allows settings a date range on a union.
The mapper will ignore union date ranges,
but the monolith will disallow using a union outside its date range.

Known issue: Monolith API allows deleting a union.
___
 */
    unionId?: string;
    /** ___
Monolith notes: Field "Union member number" (19760b35-bbaa-41ee-a85d-71527214a47b).
___
 */
    memberNumber?: string;
    /** ___
Monolith notes: Field "Included in collective insurance" (aa29af9c-8b86-4e4b-a4a2-ea1a31e69ff2).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No`
- `true`: `Yes` (or anything which is not `No`)
___
 */
    hasCollectiveInsurance!: boolean;
    /** The maximum depends on the number of digits after the decimal point and is either
9 999 999, 99 999.9 or 9 999.99.

___
Monolith notes: Field "Employee amount for collective insurance" (56bf59d1-904a-454a-af23-ebc6809331ae).

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    collectiveInsuranceEmployeeAmount?: string;
    /** ___
Monolith notes: Field "Included in unions insurance" (0ba1f7ed-4b4f-4ed7-a2d1-179063917888).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No`
- `true`: `Yes` (or anything which is not `No`)
___
 */
    hasUnionInsurance!: boolean;
    /** The maximum depends on the number of digits after the decimal point and is either
9 999 999, 99 999.9 or 9 999.99.

___
Monolith notes: Field "Employee amount for unions insurance" (2f7d11ca-7107-4fa1-8602-170745980acb).

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    unionInsuranceEmployeeAmount?: string;

    constructor(data?: IEmployeeV3UnionLinkDetailValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.memberNumber = _data["memberNumber"];
            this.hasCollectiveInsurance = _data["hasCollectiveInsurance"];
            this.collectiveInsuranceEmployeeAmount = _data["collectiveInsuranceEmployeeAmount"];
            this.hasUnionInsurance = _data["hasUnionInsurance"];
            this.unionInsuranceEmployeeAmount = _data["unionInsuranceEmployeeAmount"];
        }
    }

    static fromJS(data: any): EmployeeV3UnionLinkDetailValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3UnionLinkDetailValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["memberNumber"] = this.memberNumber;
        data["hasCollectiveInsurance"] = this.hasCollectiveInsurance;
        data["collectiveInsuranceEmployeeAmount"] = this.collectiveInsuranceEmployeeAmount;
        data["hasUnionInsurance"] = this.hasUnionInsurance;
        data["unionInsuranceEmployeeAmount"] = this.unionInsuranceEmployeeAmount;
        return data;
    }

    clone(): EmployeeV3UnionLinkDetailValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3UnionLinkDetailValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3UnionLinkDetailValueDto {
    /** Mandatory.

Foreign key:
- Must be the id for a union from Org API (available in `/icLookup`).
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The UI does not allow deleting a union.
  - The UI does not allow setting a date range on a union.

___
Monolith notes: Field "Union" (c04a62bd-ef2b-4348-8722-ac77bca76095).

Known issue: Monolith API allows settings a date range on a union.
The mapper will ignore union date ranges,
but the monolith will disallow using a union outside its date range.

Known issue: Monolith API allows deleting a union.
___
 */
    unionId?: string;
    /** ___
Monolith notes: Field "Union member number" (19760b35-bbaa-41ee-a85d-71527214a47b).
___
 */
    memberNumber?: string;
    /** ___
Monolith notes: Field "Included in collective insurance" (aa29af9c-8b86-4e4b-a4a2-ea1a31e69ff2).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No`
- `true`: `Yes` (or anything which is not `No`)
___
 */
    hasCollectiveInsurance: boolean;
    /** The maximum depends on the number of digits after the decimal point and is either
9 999 999, 99 999.9 or 9 999.99.

___
Monolith notes: Field "Employee amount for collective insurance" (56bf59d1-904a-454a-af23-ebc6809331ae).

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    collectiveInsuranceEmployeeAmount?: string;
    /** ___
Monolith notes: Field "Included in unions insurance" (0ba1f7ed-4b4f-4ed7-a2d1-179063917888).

Mapping to values in reference table 10040 No / Yes:
- `false`: `No`
- `true`: `Yes` (or anything which is not `No`)
___
 */
    hasUnionInsurance: boolean;
    /** The maximum depends on the number of digits after the decimal point and is either
9 999 999, 99 999.9 or 9 999.99.

___
Monolith notes: Field "Employee amount for unions insurance" (2f7d11ca-7107-4fa1-8602-170745980acb).

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    unionInsuranceEmployeeAmount?: string;
}

export class EmployeeV3PositionItemDto extends GapV3TimelineItemDto implements IEmployeeV3PositionItemDto {
    value!: EmployeeV3PositionValueDto;

    constructor(data?: IEmployeeV3PositionItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3PositionValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3PositionValueDto.fromJS(_data["value"]) : new EmployeeV3PositionValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3PositionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PositionItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3PositionItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3PositionItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PositionItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3PositionValueDto;
}

export class EmployeeV3PositionValueDto implements IEmployeeV3PositionValueDto {
    /** Prohibited when adding a new position.

___
Monolith notes: `ContractDto.Id`.

For an overview of relationship between various IDs, see the monolith notes on employee `id`.
___
 */
    readonly id?: string;
    taxUnitTimeline!: EmployeeV3TaxUnitLinkItemDto[];
    /** Depends on `employmentType`:
- `ordinary`: optional
- `maritime`: optional
- `freelancer`: optional
- `pension`: prohibited
- `permanentlyAdaptedWork`: optional

Foreign key:
- Must be an id for an employee that has a user (available in `/icLookup`).
- Can even be this employee (needed for approval flow for directors).
- If this position is active or future (`to` is today or later or `from` is later than today).
  - The manager should also have an active or future position.
- Clients must gracefully handle an invalid key and
  encourage the end user to fix it.
- Integrity is normally ensured.
  - The vintage UI only allows using existing values.
    - But it also allows using inactive managers on active/future positions.
    - But it also allows using an employee as its own manager.
  - If manager's email is changed from Admin UI the `odpUserId` remains unchanged
    (manager's `user.emailAddress` is updated when monolith is notified).
  - If manager's `user.emailAddress` is changed from the vintage UI
    a new user with a new `odpUserId` is created and
    the `managerId` value is unset from all positions where it is used.

___
Monolith notes: Field "Manager" (e82bbb69-937f-4f67-b667-0629bd6cf860).

Known issue (discrepancy): The monolith API does not validate this value.

Known issue (discrepancy): The vintage UI allows selecting a manager with only inactive positions.

Known issue: The manager is linked to an ODP user rather than an employee,
and the managerId is removed rather than replaced if the manager's user is replaced.
___
 */
    managerId?: string;
    costUnits!: EmployeeV3CostUnitTypeLinkDto[];
    setOfAccountTimeline?: EmployeeV3SetOfAccountItemDto[];
    /** ___
Monolith notes: Field "Employee Tag" (41789393-709d-4fda-9ac3-13447ad3cad2).
___
 */
    tagIds!: string[];
    /** Depends on `employmentType`:
- `ordinary`:
  - must not be  set if `to` is not set
  - mandatory if `to` is `'2020-10-07'` or more
  - otherwise optional
- `maritime`:
  - must not be  set if `to` is not set
  - mandatory if `to` is `'2020-10-07'` or more
  - otherwise optional
- `freelancer`: prohibited
- `pension`: prohibited
- `permanentlyAdaptedWork`: prohibited

Known values are listed in [positionEndReasonV3EnumDto](#model-positionEndReasonV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.

References:
- https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/information-on-employment/cause-of-end-date/

___
Monolith notes: Field "Position end reason" (51dbd5a3-b28b-4522-b2df-38fb1ad3c447).
___
 */
    endReason?: string;
    employmentType?: EmploymentTypeV3EnumDto;
    maritimeTimeline?: EmployeeV3MaritimeItemDto[];
    appointmentTypeTimeline?: EmployeeV3AppointmentTypeItemDto[];
    occupationCodeTimeline?: EmployeeV3OccupationCodeItemDto[];
    workTimeAgreementIdTimeline?: EmployeeV3WorkTimeAgreementIdItemDto[];
    reimbursement!: EmployeeV3ReimbursementDto;
    layoffTimeline?: EmployeeV3LayoffItemDto[];
    ftePercentageTimeline?: EmployeeV3FtePercentageItemDto[];
    salaryTypeTimeline?: EmployeeV3SalaryTypeItemDto[];
    basePayTimeline?: EmployeeV3BasePayItemDto[];
    payRateTimeline?: EmployeeV3PayRateItemDto[];
    personTypeTimeline?: EmployeeV3PersonTypeItem[];

    constructor(data?: IEmployeeV3PositionValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.taxUnitTimeline = [];
            this.costUnits = [];
            this.tagIds = [];
            this.reimbursement = new EmployeeV3ReimbursementDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).id = _data["id"];
            if (Array.isArray(_data["taxUnitTimeline"])) {
                this.taxUnitTimeline = [] as any;
                for (let item of _data["taxUnitTimeline"])
                    this.taxUnitTimeline!.push(EmployeeV3TaxUnitLinkItemDto.fromJS(item));
            }
            this.managerId = _data["managerId"];
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(EmployeeV3CostUnitTypeLinkDto.fromJS(item));
            }
            if (Array.isArray(_data["setOfAccountTimeline"])) {
                this.setOfAccountTimeline = [] as any;
                for (let item of _data["setOfAccountTimeline"])
                    this.setOfAccountTimeline!.push(EmployeeV3SetOfAccountItemDto.fromJS(item));
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.endReason = _data["endReason"];
            this.employmentType = _data["employmentType"];
            if (Array.isArray(_data["maritimeTimeline"])) {
                this.maritimeTimeline = [] as any;
                for (let item of _data["maritimeTimeline"])
                    this.maritimeTimeline!.push(EmployeeV3MaritimeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["appointmentTypeTimeline"])) {
                this.appointmentTypeTimeline = [] as any;
                for (let item of _data["appointmentTypeTimeline"])
                    this.appointmentTypeTimeline!.push(EmployeeV3AppointmentTypeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["occupationCodeTimeline"])) {
                this.occupationCodeTimeline = [] as any;
                for (let item of _data["occupationCodeTimeline"])
                    this.occupationCodeTimeline!.push(EmployeeV3OccupationCodeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["workTimeAgreementIdTimeline"])) {
                this.workTimeAgreementIdTimeline = [] as any;
                for (let item of _data["workTimeAgreementIdTimeline"])
                    this.workTimeAgreementIdTimeline!.push(EmployeeV3WorkTimeAgreementIdItemDto.fromJS(item));
            }
            this.reimbursement = _data["reimbursement"] ? EmployeeV3ReimbursementDto.fromJS(_data["reimbursement"]) : new EmployeeV3ReimbursementDto();
            if (Array.isArray(_data["layoffTimeline"])) {
                this.layoffTimeline = [] as any;
                for (let item of _data["layoffTimeline"])
                    this.layoffTimeline!.push(EmployeeV3LayoffItemDto.fromJS(item));
            }
            if (Array.isArray(_data["ftePercentageTimeline"])) {
                this.ftePercentageTimeline = [] as any;
                for (let item of _data["ftePercentageTimeline"])
                    this.ftePercentageTimeline!.push(EmployeeV3FtePercentageItemDto.fromJS(item));
            }
            if (Array.isArray(_data["salaryTypeTimeline"])) {
                this.salaryTypeTimeline = [] as any;
                for (let item of _data["salaryTypeTimeline"])
                    this.salaryTypeTimeline!.push(EmployeeV3SalaryTypeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["basePayTimeline"])) {
                this.basePayTimeline = [] as any;
                for (let item of _data["basePayTimeline"])
                    this.basePayTimeline!.push(EmployeeV3BasePayItemDto.fromJS(item));
            }
            if (Array.isArray(_data["payRateTimeline"])) {
                this.payRateTimeline = [] as any;
                for (let item of _data["payRateTimeline"])
                    this.payRateTimeline!.push(EmployeeV3PayRateItemDto.fromJS(item));
            }
            if (Array.isArray(_data["personTypeTimeline"])) {
                this.personTypeTimeline = [] as any;
                for (let item of _data["personTypeTimeline"])
                    this.personTypeTimeline!.push(EmployeeV3PersonTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3PositionValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PositionValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.taxUnitTimeline)) {
            data["taxUnitTimeline"] = [];
            for (let item of this.taxUnitTimeline)
                data["taxUnitTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["managerId"] = this.managerId;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.setOfAccountTimeline)) {
            data["setOfAccountTimeline"] = [];
            for (let item of this.setOfAccountTimeline)
                data["setOfAccountTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["endReason"] = this.endReason;
        data["employmentType"] = this.employmentType;
        if (Array.isArray(this.maritimeTimeline)) {
            data["maritimeTimeline"] = [];
            for (let item of this.maritimeTimeline)
                data["maritimeTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointmentTypeTimeline)) {
            data["appointmentTypeTimeline"] = [];
            for (let item of this.appointmentTypeTimeline)
                data["appointmentTypeTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.occupationCodeTimeline)) {
            data["occupationCodeTimeline"] = [];
            for (let item of this.occupationCodeTimeline)
                data["occupationCodeTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workTimeAgreementIdTimeline)) {
            data["workTimeAgreementIdTimeline"] = [];
            for (let item of this.workTimeAgreementIdTimeline)
                data["workTimeAgreementIdTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["reimbursement"] = this.reimbursement ? this.reimbursement.toJSON() : undefined as any;
        if (Array.isArray(this.layoffTimeline)) {
            data["layoffTimeline"] = [];
            for (let item of this.layoffTimeline)
                data["layoffTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ftePercentageTimeline)) {
            data["ftePercentageTimeline"] = [];
            for (let item of this.ftePercentageTimeline)
                data["ftePercentageTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salaryTypeTimeline)) {
            data["salaryTypeTimeline"] = [];
            for (let item of this.salaryTypeTimeline)
                data["salaryTypeTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.basePayTimeline)) {
            data["basePayTimeline"] = [];
            for (let item of this.basePayTimeline)
                data["basePayTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.payRateTimeline)) {
            data["payRateTimeline"] = [];
            for (let item of this.payRateTimeline)
                data["payRateTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.personTypeTimeline)) {
            data["personTypeTimeline"] = [];
            for (let item of this.personTypeTimeline)
                data["personTypeTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3PositionValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3PositionValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PositionValueDto {
    /** Prohibited when adding a new position.

___
Monolith notes: `ContractDto.Id`.

For an overview of relationship between various IDs, see the monolith notes on employee `id`.
___
 */
    id?: string;
    taxUnitTimeline: EmployeeV3TaxUnitLinkItemDto[];
    /** Depends on `employmentType`:
- `ordinary`: optional
- `maritime`: optional
- `freelancer`: optional
- `pension`: prohibited
- `permanentlyAdaptedWork`: optional

Foreign key:
- Must be an id for an employee that has a user (available in `/icLookup`).
- Can even be this employee (needed for approval flow for directors).
- If this position is active or future (`to` is today or later or `from` is later than today).
  - The manager should also have an active or future position.
- Clients must gracefully handle an invalid key and
  encourage the end user to fix it.
- Integrity is normally ensured.
  - The vintage UI only allows using existing values.
    - But it also allows using inactive managers on active/future positions.
    - But it also allows using an employee as its own manager.
  - If manager's email is changed from Admin UI the `odpUserId` remains unchanged
    (manager's `user.emailAddress` is updated when monolith is notified).
  - If manager's `user.emailAddress` is changed from the vintage UI
    a new user with a new `odpUserId` is created and
    the `managerId` value is unset from all positions where it is used.

___
Monolith notes: Field "Manager" (e82bbb69-937f-4f67-b667-0629bd6cf860).

Known issue (discrepancy): The monolith API does not validate this value.

Known issue (discrepancy): The vintage UI allows selecting a manager with only inactive positions.

Known issue: The manager is linked to an ODP user rather than an employee,
and the managerId is removed rather than replaced if the manager's user is replaced.
___
 */
    managerId?: string;
    costUnits: EmployeeV3CostUnitTypeLinkDto[];
    setOfAccountTimeline?: EmployeeV3SetOfAccountItemDto[];
    /** ___
Monolith notes: Field "Employee Tag" (41789393-709d-4fda-9ac3-13447ad3cad2).
___
 */
    tagIds: string[];
    /** Depends on `employmentType`:
- `ordinary`:
  - must not be  set if `to` is not set
  - mandatory if `to` is `'2020-10-07'` or more
  - otherwise optional
- `maritime`:
  - must not be  set if `to` is not set
  - mandatory if `to` is `'2020-10-07'` or more
  - otherwise optional
- `freelancer`: prohibited
- `pension`: prohibited
- `permanentlyAdaptedWork`: prohibited

Known values are listed in [positionEndReasonV3EnumDto](#model-positionEndReasonV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.

References:
- https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/information-on-employment/cause-of-end-date/

___
Monolith notes: Field "Position end reason" (51dbd5a3-b28b-4522-b2df-38fb1ad3c447).
___
 */
    endReason?: string;
    employmentType?: EmploymentTypeV3EnumDto;
    maritimeTimeline?: EmployeeV3MaritimeItemDto[];
    appointmentTypeTimeline?: EmployeeV3AppointmentTypeItemDto[];
    occupationCodeTimeline?: EmployeeV3OccupationCodeItemDto[];
    workTimeAgreementIdTimeline?: EmployeeV3WorkTimeAgreementIdItemDto[];
    reimbursement: EmployeeV3ReimbursementDto;
    layoffTimeline?: EmployeeV3LayoffItemDto[];
    ftePercentageTimeline?: EmployeeV3FtePercentageItemDto[];
    salaryTypeTimeline?: EmployeeV3SalaryTypeItemDto[];
    basePayTimeline?: EmployeeV3BasePayItemDto[];
    payRateTimeline?: EmployeeV3PayRateItemDto[];
    personTypeTimeline?: EmployeeV3PersonTypeItem[];
}

export class EmployeeV3TaxUnitLinkItemDto extends FullV3TimelineItemDto implements IEmployeeV3TaxUnitLinkItemDto {
    value!: EmployeeV3TaxUnitLinkValueDto;

    constructor(data?: IEmployeeV3TaxUnitLinkItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3TaxUnitLinkValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3TaxUnitLinkValueDto.fromJS(_data["value"]) : new EmployeeV3TaxUnitLinkValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3TaxUnitLinkItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3TaxUnitLinkItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3TaxUnitLinkItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3TaxUnitLinkItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3TaxUnitLinkItemDto extends IFullV3TimelineItemDto {
    value: EmployeeV3TaxUnitLinkValueDto;
}

export class EmployeeV3TaxUnitLinkValueDto implements IEmployeeV3TaxUnitLinkValueDto {
    /** Foreign key:
- Must be the id for a tax unit from Org API (available in `/icLookup`).
- `from` must be on or after the tax unit's `from`.
- `to` must be on or before the tax unit's `to`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a tax unit that is in use on an employee.
  - The monolith API does not allow removing a tax unit's date range in use on an employee.

Known issue: Skatteetaten requires that the `aMessageEmploymentId` changes whenever
`taxUnitId` changes, but `aMessageEmploymentId` is generated by the monolith and
doesn't change as required.

TBD: When is it allowed to change this?
End users should not be allowed to change `taxUnitId` for a time range where an
a-message has already been sent.

Known issue: There is no API to easily find what time period was
covered by the last sent a-message for an employee.

___
Monolith notes: Field "Tax unit" (2e47c155-d9cd-44cb-a31d-be2004a6f231).

Known issue: The vintage UI allows changing the tax unit retroactively after a standard warning.
However, in an a-message an employment can only be linked to a single tax unit.
If an a-message has already been reported, the next a-message might fail.
The correct approach might have been to deliver correction a-messages to cancel
out the old tax unit and then correction a-messages for the new tax unit.
But `aMessageEmploymentId` isn't changed, so this is not possible.
___
 */
    taxUnitId?: string;
    /** Used to set the a-message property "Employment ID".
This is part of the composite primary key for an employment,
the other parts being employee ID and company ID (the overall company, not a tax unit).

Must not be set when adding a tax unit link item.

Generated when a new timeline item is added.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/information-on-employment/employment-id/

___
Monolith notes: Field "Reported position ID" (a90b0e8c-2d3c-46ca-b000-68565f0d6934).

Calculated from
- Contract field "_Position number" (00000000-0000-4002-0106-000000000000)
- Tax unit link field "Tax unit position counter" (e3bc08c8-2f39-46b0-8a33-a3b220fcf114)

Calculated value is `positionNumber + '_' + counter`.
The calculation of `counter` is complicated.
TBD: The calculation of `positionNumber`.
___
 */
    readonly aMessageEmploymentId?: string;

    constructor(data?: IEmployeeV3TaxUnitLinkValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxUnitId = _data["taxUnitId"];
            (this as any).aMessageEmploymentId = _data["aMessageEmploymentId"];
        }
    }

    static fromJS(data: any): EmployeeV3TaxUnitLinkValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3TaxUnitLinkValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxUnitId"] = this.taxUnitId;
        data["aMessageEmploymentId"] = this.aMessageEmploymentId;
        return data;
    }

    clone(): EmployeeV3TaxUnitLinkValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3TaxUnitLinkValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3TaxUnitLinkValueDto {
    /** Foreign key:
- Must be the id for a tax unit from Org API (available in `/icLookup`).
- `from` must be on or after the tax unit's `from`.
- `to` must be on or before the tax unit's `to`.
- Clients must gracefully handle an invalid key and
  require that the end user fixes it.
- Integrity is normally ensured.
  - The monolith API does not allow deleting a tax unit that is in use on an employee.
  - The monolith API does not allow removing a tax unit's date range in use on an employee.

Known issue: Skatteetaten requires that the `aMessageEmploymentId` changes whenever
`taxUnitId` changes, but `aMessageEmploymentId` is generated by the monolith and
doesn't change as required.

TBD: When is it allowed to change this?
End users should not be allowed to change `taxUnitId` for a time range where an
a-message has already been sent.

Known issue: There is no API to easily find what time period was
covered by the last sent a-message for an employee.

___
Monolith notes: Field "Tax unit" (2e47c155-d9cd-44cb-a31d-be2004a6f231).

Known issue: The vintage UI allows changing the tax unit retroactively after a standard warning.
However, in an a-message an employment can only be linked to a single tax unit.
If an a-message has already been reported, the next a-message might fail.
The correct approach might have been to deliver correction a-messages to cancel
out the old tax unit and then correction a-messages for the new tax unit.
But `aMessageEmploymentId` isn't changed, so this is not possible.
___
 */
    taxUnitId?: string;
    /** Used to set the a-message property "Employment ID".
This is part of the composite primary key for an employment,
the other parts being employee ID and company ID (the overall company, not a tax unit).

Must not be set when adding a tax unit link item.

Generated when a new timeline item is added.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/information-on-employment/employment-id/

___
Monolith notes: Field "Reported position ID" (a90b0e8c-2d3c-46ca-b000-68565f0d6934).

Calculated from
- Contract field "_Position number" (00000000-0000-4002-0106-000000000000)
- Tax unit link field "Tax unit position counter" (e3bc08c8-2f39-46b0-8a33-a3b220fcf114)

Calculated value is `positionNumber + '_' + counter`.
The calculation of `counter` is complicated.
TBD: The calculation of `positionNumber`.
___
 */
    aMessageEmploymentId?: string;
}

export class EmployeeV3CostUnitTypeLinkDto implements IEmployeeV3CostUnitTypeLinkDto {
    /** AKA dimension definition identifier.

Foreign key:
- Must be the custom id (aka `Identifier`) for a cost unit type from Accounts API (available in `/icLookup`).
- First `from` in `valueCustomIdTimeline` must be on or after the cost unit type's `from`.
- Last `to` in `valueCustomIdTimeline` must be on or before the cost unit type's `to`.
- Clients must gracefully handle an invalid key and
  should encourage (but not require) that the end user fixes it.
- Integrity can be broken.
  - The Accounts API does not track employee usage.
  - A cost unit type can be deleted.
  - A cost unit type's date range can be changed.

Must be unique in the list.

___
Monolith notes: Field "Dimension Defintion" [sic] (e8943812-d263-4e57-988a-dd7eb912bcc3).

Known issue (discrepancy): The monolith does no validation beyond requiring uniqueness.
___
 */
    typeCustomId!: string;
    /** Must have at least one item.

For cost unit types with fewer than 1000 values, existing id is always available in `/icLookup`.

For large cost unit types (`hasMoreValue=true`), only newly created values and
values that could be used in the employee list are cached.
Also cache are non-existing ids used in the employee list (see VHDI-3245).

If the id for a value in a large type is not available from /icLookup,
it must be queried from `/costUnit/type/{id}/value/{id}` (see VHDI-3293).

When assigning values for a large type, search must be provided with
`/costUnit/type/{id}/values?search={partialIdOrName}`.
It is better to require a more specific search string than to use the `cursor` parameter.
But if the search does not return an exact match for the value id,
then an additional query to `/costUnit/type/{id}/value/{id}` should be made.

___
Monolith notes: "Dimension value" (bf361163-80a2-40d6-8963-7c46a4346c57).
___
 */
    valueCustomIdTimeline!: EmployeeV3CostUnitValueCustomIdItemDto[];

    constructor(data?: IEmployeeV3CostUnitTypeLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.valueCustomIdTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            if (Array.isArray(_data["valueCustomIdTimeline"])) {
                this.valueCustomIdTimeline = [] as any;
                for (let item of _data["valueCustomIdTimeline"])
                    this.valueCustomIdTimeline!.push(EmployeeV3CostUnitValueCustomIdItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3CostUnitTypeLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CostUnitTypeLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        if (Array.isArray(this.valueCustomIdTimeline)) {
            data["valueCustomIdTimeline"] = [];
            for (let item of this.valueCustomIdTimeline)
                data["valueCustomIdTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3CostUnitTypeLinkDto {
        const json = this.toJSON();
        let result = new EmployeeV3CostUnitTypeLinkDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3CostUnitTypeLinkDto {
    /** AKA dimension definition identifier.

Foreign key:
- Must be the custom id (aka `Identifier`) for a cost unit type from Accounts API (available in `/icLookup`).
- First `from` in `valueCustomIdTimeline` must be on or after the cost unit type's `from`.
- Last `to` in `valueCustomIdTimeline` must be on or before the cost unit type's `to`.
- Clients must gracefully handle an invalid key and
  should encourage (but not require) that the end user fixes it.
- Integrity can be broken.
  - The Accounts API does not track employee usage.
  - A cost unit type can be deleted.
  - A cost unit type's date range can be changed.

Must be unique in the list.

___
Monolith notes: Field "Dimension Defintion" [sic] (e8943812-d263-4e57-988a-dd7eb912bcc3).

Known issue (discrepancy): The monolith does no validation beyond requiring uniqueness.
___
 */
    typeCustomId: string;
    /** Must have at least one item.

For cost unit types with fewer than 1000 values, existing id is always available in `/icLookup`.

For large cost unit types (`hasMoreValue=true`), only newly created values and
values that could be used in the employee list are cached.
Also cache are non-existing ids used in the employee list (see VHDI-3245).

If the id for a value in a large type is not available from /icLookup,
it must be queried from `/costUnit/type/{id}/value/{id}` (see VHDI-3293).

When assigning values for a large type, search must be provided with
`/costUnit/type/{id}/values?search={partialIdOrName}`.
It is better to require a more specific search string than to use the `cursor` parameter.
But if the search does not return an exact match for the value id,
then an additional query to `/costUnit/type/{id}/value/{id}` should be made.

___
Monolith notes: "Dimension value" (bf361163-80a2-40d6-8963-7c46a4346c57).
___
 */
    valueCustomIdTimeline: EmployeeV3CostUnitValueCustomIdItemDto[];
}

export class EmployeeV3CostUnitValueCustomIdItemDto extends GapV3TimelineItemDto implements IEmployeeV3CostUnitValueCustomIdItemDto {
    /** AKA dimension value identifier.

Foreign key:
  - Must be the custom id (aka `Identifier`) for a cost unit value from Accounts API.
    - The cost unit value must be associated with the cost unit type (`typeCustomId`).
  - `from` must be on or after the cost unit value's `from`.
  - `to` must be on or before the cost unit values's `to`.
  - Clients must gracefully handle an invalid key and
    should encourage (but not require) that the end user fixes it.
  - Integrity can be broken.
    - The Accounts API does not track employee usage.
    - A cost unit value can be deleted.
    - A cost unit value's date range can be changed.

___
Monolith notes: Field "Value" (041229f2-1f49-4e89-b2c7-521de610c356).

Known issue (discrepancy): The monolith does no validation.

Monolith also has field "Percentage" (f61a08ea-8245-48d7-9360-202a615e7ac6),
which the vintage UI sets to 100.
The mapper ignores this field because splitting cost units on position level is not supported.
The monolith requires that the complex field is a full timeline,
so the percentage must be present so that the value can be a gap timeline.
___
 */
    value!: string;

    constructor(data?: IEmployeeV3CostUnitValueCustomIdItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3CostUnitValueCustomIdItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3CostUnitValueCustomIdItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3CostUnitValueCustomIdItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3CostUnitValueCustomIdItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3CostUnitValueCustomIdItemDto extends IGapV3TimelineItemDto {
    /** AKA dimension value identifier.

Foreign key:
  - Must be the custom id (aka `Identifier`) for a cost unit value from Accounts API.
    - The cost unit value must be associated with the cost unit type (`typeCustomId`).
  - `from` must be on or after the cost unit value's `from`.
  - `to` must be on or before the cost unit values's `to`.
  - Clients must gracefully handle an invalid key and
    should encourage (but not require) that the end user fixes it.
  - Integrity can be broken.
    - The Accounts API does not track employee usage.
    - A cost unit value can be deleted.
    - A cost unit value's date range can be changed.

___
Monolith notes: Field "Value" (041229f2-1f49-4e89-b2c7-521de610c356).

Known issue (discrepancy): The monolith does no validation.

Monolith also has field "Percentage" (f61a08ea-8245-48d7-9360-202a615e7ac6),
which the vintage UI sets to 100.
The mapper ignores this field because splitting cost units on position level is not supported.
The monolith requires that the complex field is a full timeline,
so the percentage must be present so that the value can be a gap timeline.
___
 */
    value: string;
}

export class EmployeeV3SetOfAccountItemDto extends GapV3TimelineItemDto implements IEmployeeV3SetOfAccountItemDto {
    /** Known values are listed in [setOfAccountV3Enum](#model-setOfAccountV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.
 */
    value!: string;

    constructor(data?: IEmployeeV3SetOfAccountItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3SetOfAccountItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3SetOfAccountItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3SetOfAccountItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3SetOfAccountItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3SetOfAccountItemDto extends IGapV3TimelineItemDto {
    /** Known values are listed in [setOfAccountV3Enum](#model-setOfAccountV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.
 */
    value: string;
}

export class EmployeeV3MaritimeItemDto extends FullV3TimelineItemDto implements IEmployeeV3MaritimeItemDto {
    value!: EmployeeV3MaritimeValueDto;

    constructor(data?: IEmployeeV3MaritimeItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3MaritimeValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3MaritimeValueDto.fromJS(_data["value"]) : new EmployeeV3MaritimeValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3MaritimeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3MaritimeItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3MaritimeItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3MaritimeItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3MaritimeItemDto extends IFullV3TimelineItemDto {
    value: EmployeeV3MaritimeValueDto;
}

export class EmployeeV3MaritimeValueDto implements IEmployeeV3MaritimeValueDto {
    shipRegister?: ShipRegisterV3EnumDto;
    vesselType?: VesselTypeV3EnumDto;
    shippingArea?: ShippingAreaV3EnumDto;

    constructor(data?: IEmployeeV3MaritimeValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipRegister = _data["shipRegister"];
            this.vesselType = _data["vesselType"];
            this.shippingArea = _data["shippingArea"];
        }
    }

    static fromJS(data: any): EmployeeV3MaritimeValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3MaritimeValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipRegister"] = this.shipRegister;
        data["vesselType"] = this.vesselType;
        data["shippingArea"] = this.shippingArea;
        return data;
    }

    clone(): EmployeeV3MaritimeValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3MaritimeValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3MaritimeValueDto {
    shipRegister?: ShipRegisterV3EnumDto;
    vesselType?: VesselTypeV3EnumDto;
    shippingArea?: ShippingAreaV3EnumDto;
}

export class EmployeeV3AppointmentTypeItemDto extends FullV3TimelineItemDto implements IEmployeeV3AppointmentTypeItemDto {
    value!: AppointmentTypeV3EnumDto;

    constructor(data?: IEmployeeV3AppointmentTypeItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3AppointmentTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3AppointmentTypeItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3AppointmentTypeItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3AppointmentTypeItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3AppointmentTypeItemDto extends IFullV3TimelineItemDto {
    value: AppointmentTypeV3EnumDto;
}

export class EmployeeV3OccupationCodeItemDto extends FullV3TimelineItemDto implements IEmployeeV3OccupationCodeItemDto {
    value!: string;

    constructor(data?: IEmployeeV3OccupationCodeItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3OccupationCodeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3OccupationCodeItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3OccupationCodeItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3OccupationCodeItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3OccupationCodeItemDto extends IFullV3TimelineItemDto {
    value: string;
}

export class EmployeeV3WorkTimeAgreementIdItemDto extends FullV3TimelineItemDto implements IEmployeeV3WorkTimeAgreementIdItemDto {
    /** Foreign key:
  - Must be the legacy id for a work time agreement (WTA) from Org API.
  - `from` must be on or after the WTA's `from`.
  - `to` must be on or before the WTA's `to`.
  - Clients must gracefully handle an invalid key and
    require that the end user fixes it.
  - Integrity is normally ensured.
    - The monolith API does not allow deleting a WTA that is in use on an employee.
    - The monolith API does not allow removing a WTA's date range in use on an employee.

___
Monolith notes: Field "Work time agreement" (2382efa5-524e-47c1-8e6f-ccc0ec97a1cf).
___
 */
    value!: string;

    constructor(data?: IEmployeeV3WorkTimeAgreementIdItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3WorkTimeAgreementIdItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3WorkTimeAgreementIdItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3WorkTimeAgreementIdItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3WorkTimeAgreementIdItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3WorkTimeAgreementIdItemDto extends IFullV3TimelineItemDto {
    /** Foreign key:
  - Must be the legacy id for a work time agreement (WTA) from Org API.
  - `from` must be on or after the WTA's `from`.
  - `to` must be on or before the WTA's `to`.
  - Clients must gracefully handle an invalid key and
    require that the end user fixes it.
  - Integrity is normally ensured.
    - The monolith API does not allow deleting a WTA that is in use on an employee.
    - The monolith API does not allow removing a WTA's date range in use on an employee.

___
Monolith notes: Field "Work time agreement" (2382efa5-524e-47c1-8e6f-ccc0ec97a1cf).
___
 */
    value: string;
}

export class EmployeeV3ReimbursementDto implements IEmployeeV3ReimbursementDto {
    /** Used to indicate that the company pays the employee in advance on
behalf of NAV and then seeks reimbursement from NAV
when the employee is sick beyond the (normally) 16 days for which the employer is liable.

TBD: How does this affect calculations and payments in Payroll?

The reimbursement process is fully manual.

https://www.nav.no/arbeidsgiver/forskuttere-sykepenger

___
Monolith notes: Field "Prepaid sickness" (a39dbd0f-ee89-4f84-88fb-dd3963ec2433).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`

This field is placed on the position rather than the employee in
preparation for multiple positions and in case an employee holds
such different positions that one is prepaid and the other is not.
That scenario seems somewhat contrived and it is not clear that it
is allowed by the regulations to pay in advance for only one
of an employee's positions.
___
 */
    hasPrepaidSicknessBenefitTimeline?: BooleanV3TimelineItemDto[];
    /** Used to indicate that the company pays the employee in advance on
behalf of NAV and then seeks reimbursement from NAV when:
- on parental leave
- taking care of a child
- taking care of someone nearing their end of life
- attending training for care taking

TBD: How does this affect calculations and payments in Payroll?

The reimbursement process is fully manual.

Taking care of others that are sick is not covered monetarily by the government.
Some employers may still pay for the 10 days off the law provides.
This is not supported in Payroll and so must be handled manually.

References:
- https://www.helsedirektoratet.no/veiledere/sykmelderveileder/alternativer-til-sykmelding-tilrettelegging-egenmelding-pleiepenger-mfl/pleiepenger-og-omsorgspenger-ved-barnsbarnepassers-sykdom-og-pleie-ved-livets-slutt
- https://www.nav.no/arbeidsgiver/ansatt-venter-barn#refusjon
- https://www.nav.no/omsorgspenger
- https://www.nav.no/pleiepenger-sluttfase
- https://www.nav.no/opplaringspenger
- https://lovdata.no/lov/2005-06-17-62/§12-10

___
Monolith notes: Field "Prepaid other absence" (2534dd2f-ff2e-41d9-aecc-b0bafa44acfb).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`

This field is placed on the position rather than the employee in
preparation for multiple positions and in case an employee holds
such different positions that one is prepaid and the other is not.
That scenario seems somewhat contrived and it is not clear that it
is allowed by the regulations to pay in advance for only one
of an employee's positions.
___
 */
    hasPrepaidOtherBenefitTimeline?: BooleanV3TimelineItemDto[];

    constructor(data?: IEmployeeV3ReimbursementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hasPrepaidSicknessBenefitTimeline"])) {
                this.hasPrepaidSicknessBenefitTimeline = [] as any;
                for (let item of _data["hasPrepaidSicknessBenefitTimeline"])
                    this.hasPrepaidSicknessBenefitTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["hasPrepaidOtherBenefitTimeline"])) {
                this.hasPrepaidOtherBenefitTimeline = [] as any;
                for (let item of _data["hasPrepaidOtherBenefitTimeline"])
                    this.hasPrepaidOtherBenefitTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeV3ReimbursementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3ReimbursementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hasPrepaidSicknessBenefitTimeline)) {
            data["hasPrepaidSicknessBenefitTimeline"] = [];
            for (let item of this.hasPrepaidSicknessBenefitTimeline)
                data["hasPrepaidSicknessBenefitTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hasPrepaidOtherBenefitTimeline)) {
            data["hasPrepaidOtherBenefitTimeline"] = [];
            for (let item of this.hasPrepaidOtherBenefitTimeline)
                data["hasPrepaidOtherBenefitTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeeV3ReimbursementDto {
        const json = this.toJSON();
        let result = new EmployeeV3ReimbursementDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3ReimbursementDto {
    /** Used to indicate that the company pays the employee in advance on
behalf of NAV and then seeks reimbursement from NAV
when the employee is sick beyond the (normally) 16 days for which the employer is liable.

TBD: How does this affect calculations and payments in Payroll?

The reimbursement process is fully manual.

https://www.nav.no/arbeidsgiver/forskuttere-sykepenger

___
Monolith notes: Field "Prepaid sickness" (a39dbd0f-ee89-4f84-88fb-dd3963ec2433).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`

This field is placed on the position rather than the employee in
preparation for multiple positions and in case an employee holds
such different positions that one is prepaid and the other is not.
That scenario seems somewhat contrived and it is not clear that it
is allowed by the regulations to pay in advance for only one
of an employee's positions.
___
 */
    hasPrepaidSicknessBenefitTimeline?: BooleanV3TimelineItemDto[];
    /** Used to indicate that the company pays the employee in advance on
behalf of NAV and then seeks reimbursement from NAV when:
- on parental leave
- taking care of a child
- taking care of someone nearing their end of life
- attending training for care taking

TBD: How does this affect calculations and payments in Payroll?

The reimbursement process is fully manual.

Taking care of others that are sick is not covered monetarily by the government.
Some employers may still pay for the 10 days off the law provides.
This is not supported in Payroll and so must be handled manually.

References:
- https://www.helsedirektoratet.no/veiledere/sykmelderveileder/alternativer-til-sykmelding-tilrettelegging-egenmelding-pleiepenger-mfl/pleiepenger-og-omsorgspenger-ved-barnsbarnepassers-sykdom-og-pleie-ved-livets-slutt
- https://www.nav.no/arbeidsgiver/ansatt-venter-barn#refusjon
- https://www.nav.no/omsorgspenger
- https://www.nav.no/pleiepenger-sluttfase
- https://www.nav.no/opplaringspenger
- https://lovdata.no/lov/2005-06-17-62/§12-10

___
Monolith notes: Field "Prepaid other absence" (2534dd2f-ff2e-41d9-aecc-b0bafa44acfb).

Mapping to values in reference table 10040 No / Yes:
- (not set): `No` (or anything which is not `Yes`)
- `true`: `Yes`

This field is placed on the position rather than the employee in
preparation for multiple positions and in case an employee holds
such different positions that one is prepaid and the other is not.
That scenario seems somewhat contrived and it is not clear that it
is allowed by the regulations to pay in advance for only one
of an employee's positions.
___
 */
    hasPrepaidOtherBenefitTimeline?: BooleanV3TimelineItemDto[];
}

export class EmployeeV3LayoffItemDto extends GapV3TimelineItemDto implements IEmployeeV3LayoffItemDto {
    value!: EmployeeV3LayoffValueDto;

    constructor(data?: IEmployeeV3LayoffItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3LayoffValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3LayoffValueDto.fromJS(_data["value"]) : new EmployeeV3LayoffValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3LayoffItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3LayoffItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3LayoffItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3LayoffItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3LayoffItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3LayoffValueDto;
}

export class EmployeeV3LayoffValueDto implements IEmployeeV3LayoffValueDto {
    /** Mandatory.

The percentage of the expected work time the employee will not be working.
Ie. if the FTE percentage (`ftePercentageTimeline`) is 50% of an expected 40 hours/week
the employee will usually be working 20 hours/week.
If there is a 10% temporary layoff, the employee is expected to work 18 hours/week.
Note that `actualHoursPerWeek` is not affected by a layoff and
would still be calculated to 20 hours/week in this example.

___
Monolith notes: Field "Leave percentage" (8becccbb-ac4a-445b-9bf9-37d53cf55a18).
___
 */
    percentage?: string;

    constructor(data?: IEmployeeV3LayoffValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): EmployeeV3LayoffValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3LayoffValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): EmployeeV3LayoffValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3LayoffValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3LayoffValueDto {
    /** Mandatory.

The percentage of the expected work time the employee will not be working.
Ie. if the FTE percentage (`ftePercentageTimeline`) is 50% of an expected 40 hours/week
the employee will usually be working 20 hours/week.
If there is a 10% temporary layoff, the employee is expected to work 18 hours/week.
Note that `actualHoursPerWeek` is not affected by a layoff and
would still be calculated to 20 hours/week in this example.

___
Monolith notes: Field "Leave percentage" (8becccbb-ac4a-445b-9bf9-37d53cf55a18).
___
 */
    percentage?: string;
}

export class EmployeeV3FtePercentageItemDto extends FullV3TimelineItemDto implements IEmployeeV3FtePercentageItemDto {
    value!: EmployeeV3FtePercentageValueDto;

    constructor(data?: IEmployeeV3FtePercentageItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3FtePercentageValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3FtePercentageValueDto.fromJS(_data["value"]) : new EmployeeV3FtePercentageValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3FtePercentageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3FtePercentageItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3FtePercentageItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3FtePercentageItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3FtePercentageItemDto extends IFullV3TimelineItemDto {
    value: EmployeeV3FtePercentageValueDto;
}

export class EmployeeV3FtePercentageValueDto implements IEmployeeV3FtePercentageValueDto {
    /** Mandatory.

Used to to calculate actual salary and hours per week,
specified as a percentage of a full-time equivalent (FTE).

The FTE salary is specified in `fullTimeMonthlySalary` or `fullTimeYearlySalary`.

The FTE hours per week is specified by WTA.normalWeeklyHours on
the WTA set on `workTimeAgreementIdTimeline`.

To calculate the actual hours per week, merge these timelines:
- `ftePercentageTimeline` (fte)
- `workTimeAgreementIdTimeline` (wta)
- `icLookupWtaDataDto.normalWeeklyHoursTimeline` where `wta.id = icLookupWtaItemDto.id` (weeklyHours)

Then set:
```
mergedItem.actualHoursPerWeek = weeklyHours.hourlyWage * (fte.percentage / 100)
// also round to 2 decimal places
```

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/information-on-employment/percentage-employment/

___
Monolith notes: Field "Part-time factor" (71778e37-6f41-49e0-b094-c8cb721f9bb2).

Monolith has companion field "Working hours a week" (df224c37-5efc-4b07-864a-12658cc478a2).
Long term this should be removed, to avoid changing thousands of employees if a WTA changes.
Front end must now calculate as described above.
___
 */
    percentage?: string;

    constructor(data?: IEmployeeV3FtePercentageValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): EmployeeV3FtePercentageValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3FtePercentageValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): EmployeeV3FtePercentageValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3FtePercentageValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3FtePercentageValueDto {
    /** Mandatory.

Used to to calculate actual salary and hours per week,
specified as a percentage of a full-time equivalent (FTE).

The FTE salary is specified in `fullTimeMonthlySalary` or `fullTimeYearlySalary`.

The FTE hours per week is specified by WTA.normalWeeklyHours on
the WTA set on `workTimeAgreementIdTimeline`.

To calculate the actual hours per week, merge these timelines:
- `ftePercentageTimeline` (fte)
- `workTimeAgreementIdTimeline` (wta)
- `icLookupWtaDataDto.normalWeeklyHoursTimeline` where `wta.id = icLookupWtaItemDto.id` (weeklyHours)

Then set:
```
mergedItem.actualHoursPerWeek = weeklyHours.hourlyWage * (fte.percentage / 100)
// also round to 2 decimal places
```

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/employment/information-on-employment/percentage-employment/

___
Monolith notes: Field "Part-time factor" (71778e37-6f41-49e0-b094-c8cb721f9bb2).

Monolith has companion field "Working hours a week" (df224c37-5efc-4b07-864a-12658cc478a2).
Long term this should be removed, to avoid changing thousands of employees if a WTA changes.
Front end must now calculate as described above.
___
 */
    percentage?: string;
}

export class EmployeeV3SalaryTypeItemDto extends FullV3TimelineItemDto implements IEmployeeV3SalaryTypeItemDto {
    value!: SalaryTypeV3EnumDto;

    constructor(data?: IEmployeeV3SalaryTypeItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3SalaryTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3SalaryTypeItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3SalaryTypeItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3SalaryTypeItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3SalaryTypeItemDto extends IFullV3TimelineItemDto {
    value: SalaryTypeV3EnumDto;
}

export class EmployeeV3BasePayItemDto extends FullV3TimelineItemDto implements IEmployeeV3BasePayItemDto {
    value!: EmployeeV3BasePayValueDto;

    constructor(data?: IEmployeeV3BasePayItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3BasePayValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3BasePayValueDto.fromJS(_data["value"]) : new EmployeeV3BasePayValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3BasePayItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3BasePayItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3BasePayItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3BasePayItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3BasePayItemDto extends IFullV3TimelineItemDto {
    value: EmployeeV3BasePayValueDto;
}

/** Only two properties are used, `inputType` and the correspondingly named property. The frontend has the WTA lookup, so it must calculate the other two properties. If the WTA lookup is updated, the calculation must be re-applied. To calculate, merge these timelines: - `basePayTimeline` [default] - `ftePercentageTimeline` (fte) - `workTimeAgreementIdTimeline` (wta) - `icLookupWtaDataDto.normalWeeklyHoursTimeline` where `wta.id = icLookupWtaItemDto.id` (weeklyHours) Then set: ``` if inputType === hourly  mergedItem.fullTimeMonthlySalary = hourlyWage * (weeklyHours.hourlyWage * 52) / 12  mergedItem.fullTimeYearlySalary = hourlyWage * (weeklyHours.hourlyWage * 52) if inputType === fullTimeMonthly  mergedItem.hourlyWage = (fullTimeMonthlySalary * 12) / (weeklyHours.hourlyWage * 52)  mergedItem.fullTimeYearlySalary = fullTimeMonthlySalary * 12 if inputType === fullTimeYearly  mergedItem.hourlyWage = fullTimeYearlySalary / (weeklyHours.hourlyWage * 52)  mergedItem.fullTimeMonthlySalary = fullTimeYearlySalary / 12 // also round to 2 decimal places, after ALL calculations have been done ``` Additionally, some helper properties should be calculated: - `actualMonthlySalary` (AKA "Calculated monthly salary") - `actualYearlySalary` (AKA "Calculated yearly salary") - `overtimeRateBasis` (AKA "Hourly overtime salary")  - Normally `overtimeRateBasis` is identical to `hourlyWage`.  - But some agreements use a different number of yearly working hours    when calculating the basis for overtime pay as opposed to normal wage. - `rate2Basis` (AKA "Hourly rate 2")  - Used as input for paycodes for rate 2.    The paycode can specify a percentage of this basis.  - Used when there is an agreement that uses a different number of yearly working hours    when calculating this rate, as opposed to the working hours used to calculate    hourly wage or hourly rate basis. - `rate3Basis` (AKA "Hourly rate 3")  - Used as input for paycodes for rate 3.    The paycode can specify a percentage of this basis.  - Used when there is an agreement that uses a different number of yearly working hours    when calculating this rate, as opposed to the working hours used to calculate    hourly wage, hourly rate basis or rate 2. Use the merged timeline from above, then set: ``` mergedItem.actualMonthlySalary = fullTimeMonthlySalary * (fte.percentage / 100) mergedItem.actualYearlySalary = fullTimeYearlySalary * (fte.percentage / 100) mergedItem.overtimeRateBasis = fullTimeYearlySalary / (weeklyHours.overtimeBasis * 52) mergedItem.rate2Basis = fullTimeYearlySalary / (weeklyHours.rate2Basis * 52) mergedItem.rate3Basis = fullTimeYearlySalary / (weeklyHours.rate3Basis * 52) // also round to 2 decimal places ``` ___ Monolith notes: There are several companies fields: - "Calculated monthly salary" (66a5cea0-7474-4372-8a7c-65c46edaa822) - "Calculated yearly salary" (8e38ac10-fa7e-4e58-9920-269991039f24) - "Hourly overtime salary" (2575809f-4278-44ff-8690-a467d7230964) - "Hourly rate 2" (92d88e96-1a6f-4cf7-879d-55988f1e3290) - "Hourly rate 3" (7fbffaa5-e757-4c7f-92a7-b3fd6e96be06) Long term these should be removed, to avoid changing thousands of employees if a WTA changes. Front end must now calculate as described above. ___ */
export class EmployeeV3BasePayValueDto implements IEmployeeV3BasePayValueDto {
    inputType?: BasePayInputTypeV3EnumDto;
    /** Mandatory if `inputType` is `hourly`, otherwise ignored.
Calculate if another input type is selected, see `employeeV3BasePayValueDto`.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

Note that this could theoretically be used as input for paycodes
instead of `overtimeRateBasis` and then used as a basis with a percentage specified
by the paycode. But this configuration should not exist in practice,
so this value is only used as is and not as a basis.

___
Monolith notes: Field "Hourly salary" (f9d00ecd-ae37-42f0-8768-416570b29c2c).

If another input type is selected, this field is calculated.
Long term the calculation should be removed, to avoid changing thousands of employees if a WTA changes.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    hourlyWage?: string;
    /** Mandatory if `inputType` is `fullTimeMonthly`, otherwise ignored.
Calculate if another input type is selected, see `employeeV3BasePayValueDto`.

___
Monolith notes: Field "Monthly salary" (a7d2628e-e52f-491e-a1bb-1616595d5913).

If another input type is selected, this field is calculated.

Monolith has companion field "Calculated monthly salary" (66a5cea0-7474-4372-8a7c-65c46edaa822).

Long term both calculations should be removed, to avoid changing thousands of employees if a WTA changes.
___
 */
    fullTimeMonthlySalary?: string;
    /** Mandatory if `inputType` is `fullTimeYearly`, otherwise ignored.
Calculate if another input type is selected, see `employeeV3BasePayValueDto`.

___
Monolith notes: Field "Yearly salary" (1bf17d28-faf7-480b-ae86-0519396da64d).

If another input type is selected, this field is calculated.

Monolith has companion field "Calculated yearly salary" (8e38ac10-fa7e-4e58-9920-269991039f24).

Long term both calculations should be removed, to avoid changing thousands of employees if a WTA changes.
___
 */
    fullTimeYearlySalary?: string;

    constructor(data?: IEmployeeV3BasePayValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputType = _data["inputType"];
            this.hourlyWage = _data["hourlyWage"];
            this.fullTimeMonthlySalary = _data["fullTimeMonthlySalary"];
            this.fullTimeYearlySalary = _data["fullTimeYearlySalary"];
        }
    }

    static fromJS(data: any): EmployeeV3BasePayValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3BasePayValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputType"] = this.inputType;
        data["hourlyWage"] = this.hourlyWage;
        data["fullTimeMonthlySalary"] = this.fullTimeMonthlySalary;
        data["fullTimeYearlySalary"] = this.fullTimeYearlySalary;
        return data;
    }

    clone(): EmployeeV3BasePayValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3BasePayValueDto();
        result.init(json);
        return result;
    }
}

/** Only two properties are used, `inputType` and the correspondingly named property. The frontend has the WTA lookup, so it must calculate the other two properties. If the WTA lookup is updated, the calculation must be re-applied. To calculate, merge these timelines: - `basePayTimeline` [default] - `ftePercentageTimeline` (fte) - `workTimeAgreementIdTimeline` (wta) - `icLookupWtaDataDto.normalWeeklyHoursTimeline` where `wta.id = icLookupWtaItemDto.id` (weeklyHours) Then set: ``` if inputType === hourly  mergedItem.fullTimeMonthlySalary = hourlyWage * (weeklyHours.hourlyWage * 52) / 12  mergedItem.fullTimeYearlySalary = hourlyWage * (weeklyHours.hourlyWage * 52) if inputType === fullTimeMonthly  mergedItem.hourlyWage = (fullTimeMonthlySalary * 12) / (weeklyHours.hourlyWage * 52)  mergedItem.fullTimeYearlySalary = fullTimeMonthlySalary * 12 if inputType === fullTimeYearly  mergedItem.hourlyWage = fullTimeYearlySalary / (weeklyHours.hourlyWage * 52)  mergedItem.fullTimeMonthlySalary = fullTimeYearlySalary / 12 // also round to 2 decimal places, after ALL calculations have been done ``` Additionally, some helper properties should be calculated: - `actualMonthlySalary` (AKA "Calculated monthly salary") - `actualYearlySalary` (AKA "Calculated yearly salary") - `overtimeRateBasis` (AKA "Hourly overtime salary")  - Normally `overtimeRateBasis` is identical to `hourlyWage`.  - But some agreements use a different number of yearly working hours    when calculating the basis for overtime pay as opposed to normal wage. - `rate2Basis` (AKA "Hourly rate 2")  - Used as input for paycodes for rate 2.    The paycode can specify a percentage of this basis.  - Used when there is an agreement that uses a different number of yearly working hours    when calculating this rate, as opposed to the working hours used to calculate    hourly wage or hourly rate basis. - `rate3Basis` (AKA "Hourly rate 3")  - Used as input for paycodes for rate 3.    The paycode can specify a percentage of this basis.  - Used when there is an agreement that uses a different number of yearly working hours    when calculating this rate, as opposed to the working hours used to calculate    hourly wage, hourly rate basis or rate 2. Use the merged timeline from above, then set: ``` mergedItem.actualMonthlySalary = fullTimeMonthlySalary * (fte.percentage / 100) mergedItem.actualYearlySalary = fullTimeYearlySalary * (fte.percentage / 100) mergedItem.overtimeRateBasis = fullTimeYearlySalary / (weeklyHours.overtimeBasis * 52) mergedItem.rate2Basis = fullTimeYearlySalary / (weeklyHours.rate2Basis * 52) mergedItem.rate3Basis = fullTimeYearlySalary / (weeklyHours.rate3Basis * 52) // also round to 2 decimal places ``` ___ Monolith notes: There are several companies fields: - "Calculated monthly salary" (66a5cea0-7474-4372-8a7c-65c46edaa822) - "Calculated yearly salary" (8e38ac10-fa7e-4e58-9920-269991039f24) - "Hourly overtime salary" (2575809f-4278-44ff-8690-a467d7230964) - "Hourly rate 2" (92d88e96-1a6f-4cf7-879d-55988f1e3290) - "Hourly rate 3" (7fbffaa5-e757-4c7f-92a7-b3fd6e96be06) Long term these should be removed, to avoid changing thousands of employees if a WTA changes. Front end must now calculate as described above. ___ */
export interface IEmployeeV3BasePayValueDto {
    inputType?: BasePayInputTypeV3EnumDto;
    /** Mandatory if `inputType` is `hourly`, otherwise ignored.
Calculate if another input type is selected, see `employeeV3BasePayValueDto`.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

Note that this could theoretically be used as input for paycodes
instead of `overtimeRateBasis` and then used as a basis with a percentage specified
by the paycode. But this configuration should not exist in practice,
so this value is only used as is and not as a basis.

___
Monolith notes: Field "Hourly salary" (f9d00ecd-ae37-42f0-8768-416570b29c2c).

If another input type is selected, this field is calculated.
Long term the calculation should be removed, to avoid changing thousands of employees if a WTA changes.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    hourlyWage?: string;
    /** Mandatory if `inputType` is `fullTimeMonthly`, otherwise ignored.
Calculate if another input type is selected, see `employeeV3BasePayValueDto`.

___
Monolith notes: Field "Monthly salary" (a7d2628e-e52f-491e-a1bb-1616595d5913).

If another input type is selected, this field is calculated.

Monolith has companion field "Calculated monthly salary" (66a5cea0-7474-4372-8a7c-65c46edaa822).

Long term both calculations should be removed, to avoid changing thousands of employees if a WTA changes.
___
 */
    fullTimeMonthlySalary?: string;
    /** Mandatory if `inputType` is `fullTimeYearly`, otherwise ignored.
Calculate if another input type is selected, see `employeeV3BasePayValueDto`.

___
Monolith notes: Field "Yearly salary" (1bf17d28-faf7-480b-ae86-0519396da64d).

If another input type is selected, this field is calculated.

Monolith has companion field "Calculated yearly salary" (8e38ac10-fa7e-4e58-9920-269991039f24).

Long term both calculations should be removed, to avoid changing thousands of employees if a WTA changes.
___
 */
    fullTimeYearlySalary?: string;
}

export class EmployeeV3PayRateItemDto extends GapV3TimelineItemDto implements IEmployeeV3PayRateItemDto {
    value!: EmployeeV3PayRateValueDto;

    constructor(data?: IEmployeeV3PayRateItemDto) {
        super(data);
        if (!data) {
            this.value = new EmployeeV3PayRateValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EmployeeV3PayRateValueDto.fromJS(_data["value"]) : new EmployeeV3PayRateValueDto();
        }
    }

    static override fromJS(data: any): EmployeeV3PayRateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PayRateItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3PayRateItemDto {
        const json = this.toJSON();
        let result = new EmployeeV3PayRateItemDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PayRateItemDto extends IGapV3TimelineItemDto {
    value: EmployeeV3PayRateValueDto;
}

export class EmployeeV3PayRateValueDto implements IEmployeeV3PayRateValueDto {
    /** Used as input for paycode that use rate 4.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 4" (efd20632-0c3d-45f3-a830-5c90fe50b600).

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate4?: string;
    /** Used as input for paycode that use rate 5.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 5" (ff353df2-f569-48db-9437-1621793d0578).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate5?: string;
    /** Used as input for paycode that use rate 6.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 6" (61527c31-13c2-42b8-90d9-4c679b41506f).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate6?: string;
    /** Used as input for paycode that use rate 7.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 7" (517b603c-e71b-49b7-b87a-52e62f7e37a8).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate7?: string;
    /** Used as input for paycode that use rate 8.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 8" (3653b0fa-ee03-4e79-9938-66875ca6441f).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate8?: string;
    /** Used as input for paycode that use rate 9.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 9" (63bcdead-854b-4369-bcf2-99e0f4b31bea).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate9?: string;

    constructor(data?: IEmployeeV3PayRateValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payRate4 = _data["payRate4"];
            this.payRate5 = _data["payRate5"];
            this.payRate6 = _data["payRate6"];
            this.payRate7 = _data["payRate7"];
            this.payRate8 = _data["payRate8"];
            this.payRate9 = _data["payRate9"];
        }
    }

    static fromJS(data: any): EmployeeV3PayRateValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PayRateValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payRate4"] = this.payRate4;
        data["payRate5"] = this.payRate5;
        data["payRate6"] = this.payRate6;
        data["payRate7"] = this.payRate7;
        data["payRate8"] = this.payRate8;
        data["payRate9"] = this.payRate9;
        return data;
    }

    clone(): EmployeeV3PayRateValueDto {
        const json = this.toJSON();
        let result = new EmployeeV3PayRateValueDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PayRateValueDto {
    /** Used as input for paycode that use rate 4.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 4" (efd20632-0c3d-45f3-a830-5c90fe50b600).

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate4?: string;
    /** Used as input for paycode that use rate 5.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 5" (ff353df2-f569-48db-9437-1621793d0578).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate5?: string;
    /** Used as input for paycode that use rate 6.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 6" (61527c31-13c2-42b8-90d9-4c679b41506f).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate6?: string;
    /** Used as input for paycode that use rate 7.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 7" (517b603c-e71b-49b7-b87a-52e62f7e37a8).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate7?: string;
    /** Used as input for paycode that use rate 8.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 8" (3653b0fa-ee03-4e79-9938-66875ca6441f).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate8?: string;
    /** Used as input for paycode that use rate 9.

Note that this could theoretically be used as input for paycodes
that specify a percentage so that this is only a basis for the actual rate.
But that is most likely only done with `hourlyRateBasis`, `rate2Basis` and `rate3Basis`,
so this value is only used as is and not as a basis.

The maximum depends on the number of digits after the decimal point and is either
999 999 999, 9 999 999.9 or 999 999.99.

___
Monolith notes: Field "Rate 9" (63bcdead-854b-4369-bcf2-99e0f4b31bea).

Known issue: The vintage UI hides this field when `employmentType` is `pension`, but
the monolith API always allows it to have a value.

Known issue: The maximum value depends on the number of decimal digits.
___
 */
    payRate9?: string;
}

export class EmployeeV3PersonTypeItem extends GapV3TimelineItemDto implements IEmployeeV3PersonTypeItem {
    /** Known values are listed in [personTypeV3EnumDto](#model-personTypeV3EnumDto)
but client must also gracefully accept other values and not modify them unless the user requests it.

Used for a-message reporting, in some rarely used special cases.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/salary-and-benefits/overview-of-salary-and-other-benefits/housing-commuter/
 */
    value!: string;

    constructor(data?: IEmployeeV3PersonTypeItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): EmployeeV3PersonTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV3PersonTypeItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeV3PersonTypeItem {
        const json = this.toJSON();
        let result = new EmployeeV3PersonTypeItem();
        result.init(json);
        return result;
    }
}

export interface IEmployeeV3PersonTypeItem extends IGapV3TimelineItemDto {
    /** Known values are listed in [personTypeV3EnumDto](#model-personTypeV3EnumDto)
but client must also gracefully accept other values and not modify them unless the user requests it.

Used for a-message reporting, in some rarely used special cases.

https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/salary-and-benefits/overview-of-salary-and-other-benefits/housing-commuter/
 */
    value: string;
}

/** Employee and position information are stored and updated separately, but combined when initially retrieving the employee list. `position` is chosen in this order: 1. If there is a position from UTC today, use that. 2. Otherwise, choose the position with the highest from date. For all other fields where the source is a timelines, the value with the highest from date is used. This could be a future value even if there is a value from today. If the employee is a draft and has no positions, `position` will be absent. Non-draft employees without positions are filtered out (this is an error state that should be investigated if observed). When receiving a WS message about employee upsert (`WsServerPayloadEnum.IcEmployeeUpserted`), replace the employee part if the lookup is set. When receiving a WS message about position upserts (`WsServerPayloadEnum.IcPositionUpserted`), the frontend must decide whether to discard it or replace this position (see algorithm in WS schema). Employee status is based on both employee and position information and is therefore hard to pass along in a WsIcUpserted without potential inconsistency when both the employee and position parts are updated simultaneously. Therefore, the frontend must calculate it with following algorithm: 1. If `employee.isDraft`, the status is `draft`. 2. If `position.from ?? '0000-00-00' > today`, the status is `future`. 3. If `position.to ?? '9999-99-99' < today, the status is `inactive`. 4. Otherwise the status is `active`. */
export class IcLookupEmployeeDataDto implements IIcLookupEmployeeDataDto {
    employee!: IcLookupEmployeeDto;
    position?: IcLookupPositionDto;

    constructor(data?: IIcLookupEmployeeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employee = new IcLookupEmployeeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? IcLookupEmployeeDto.fromJS(_data["employee"]) : new IcLookupEmployeeDto();
            this.position = _data["position"] ? IcLookupPositionDto.fromJS(_data["position"]) : undefined as any;
        }
    }

    static fromJS(data: any): IcLookupEmployeeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupEmployeeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        return data;
    }

    clone(): IcLookupEmployeeDataDto {
        const json = this.toJSON();
        let result = new IcLookupEmployeeDataDto();
        result.init(json);
        return result;
    }
}

/** Employee and position information are stored and updated separately, but combined when initially retrieving the employee list. `position` is chosen in this order: 1. If there is a position from UTC today, use that. 2. Otherwise, choose the position with the highest from date. For all other fields where the source is a timelines, the value with the highest from date is used. This could be a future value even if there is a value from today. If the employee is a draft and has no positions, `position` will be absent. Non-draft employees without positions are filtered out (this is an error state that should be investigated if observed). When receiving a WS message about employee upsert (`WsServerPayloadEnum.IcEmployeeUpserted`), replace the employee part if the lookup is set. When receiving a WS message about position upserts (`WsServerPayloadEnum.IcPositionUpserted`), the frontend must decide whether to discard it or replace this position (see algorithm in WS schema). Employee status is based on both employee and position information and is therefore hard to pass along in a WsIcUpserted without potential inconsistency when both the employee and position parts are updated simultaneously. Therefore, the frontend must calculate it with following algorithm: 1. If `employee.isDraft`, the status is `draft`. 2. If `position.from ?? '0000-00-00' > today`, the status is `future`. 3. If `position.to ?? '9999-99-99' < today, the status is `inactive`. 4. Otherwise the status is `active`. */
export interface IIcLookupEmployeeDataDto {
    employee: IcLookupEmployeeDto;
    position?: IcLookupPositionDto;
}

export class IcLookupEmployeeDto implements IIcLookupEmployeeDto {
    updatedAt!: Date;
    isDraft!: boolean;
    id!: string;
    hasUser!: boolean;
    customId?: string;
    firstName?: string;
    lastName?: string;
    gender?: GenderV3EnumDto;
    birthDate?: Date;
    governmentId?: string;
    workEmail?: string;
    privateEmail?: string;
    defaultPayment?: IcLookupEmployeeDefaultPaymentDto;
    pensionFrom?: Date;
    unionFrom?: Date;
    notes?: string;

    constructor(data?: IIcLookupEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.isDraft = _data["isDraft"];
            this.id = _data["id"];
            this.hasUser = _data["hasUser"];
            this.customId = _data["customId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.governmentId = _data["governmentId"];
            this.workEmail = _data["workEmail"];
            this.privateEmail = _data["privateEmail"];
            this.defaultPayment = _data["defaultPayment"] ? IcLookupEmployeeDefaultPaymentDto.fromJS(_data["defaultPayment"]) : undefined as any;
            this.pensionFrom = _data["pensionFrom"] ? new Date(_data["pensionFrom"].toString()) : undefined as any;
            this.unionFrom = _data["unionFrom"] ? new Date(_data["unionFrom"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): IcLookupEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["isDraft"] = this.isDraft;
        data["id"] = this.id;
        data["hasUser"] = this.hasUser;
        data["customId"] = this.customId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : undefined as any;
        data["governmentId"] = this.governmentId;
        data["workEmail"] = this.workEmail;
        data["privateEmail"] = this.privateEmail;
        data["defaultPayment"] = this.defaultPayment ? this.defaultPayment.toJSON() : undefined as any;
        data["pensionFrom"] = this.pensionFrom ? formatDate(this.pensionFrom) : undefined as any;
        data["unionFrom"] = this.unionFrom ? formatDate(this.unionFrom) : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): IcLookupEmployeeDto {
        const json = this.toJSON();
        let result = new IcLookupEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupEmployeeDto {
    updatedAt: Date;
    isDraft: boolean;
    id: string;
    hasUser: boolean;
    customId?: string;
    firstName?: string;
    lastName?: string;
    gender?: GenderV3EnumDto;
    birthDate?: Date;
    governmentId?: string;
    workEmail?: string;
    privateEmail?: string;
    defaultPayment?: IcLookupEmployeeDefaultPaymentDto;
    pensionFrom?: Date;
    unionFrom?: Date;
    notes?: string;
}

export class IcLookupEmployeeDefaultPaymentDto implements IIcLookupEmployeeDefaultPaymentDto {
    type?: PaymentTypeV3EnumDto;
    accountNumber?: string;

    constructor(data?: IIcLookupEmployeeDefaultPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): IcLookupEmployeeDefaultPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupEmployeeDefaultPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["accountNumber"] = this.accountNumber;
        return data;
    }

    clone(): IcLookupEmployeeDefaultPaymentDto {
        const json = this.toJSON();
        let result = new IcLookupEmployeeDefaultPaymentDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupEmployeeDefaultPaymentDto {
    type?: PaymentTypeV3EnumDto;
    accountNumber?: string;
}

export class IcLookupPositionDto implements IIcLookupPositionDto {
    employeeId!: string;
    positionId!: string;
    from?: Date;
    to?: Date;
    taxUnitId?: string;
    managerId?: string;
    costUnits!: IcLookupPositionCostUnitDto[];
    setOfAccount?: SetOfAccountV3EnumDto;
    tagIds!: string[];
    employmentType?: EmploymentTypeV3EnumDto;
    appointmentType?: AppointmentTypeV3EnumDto;
    occupationCode?: string;
    workTimeAgreementId?: string;
    /** The companion field `actualHoursPerWeek` can be calculated
with the formula described in `employeeV3FtePercentageValueDto`.
Use the `normalWeeklyHoursTimeline` item active on `pay.from`.
 */
    ftePercentage?: string;
    salaryType?: SalaryTypeV3EnumDto;
    pay!: IcLookupPositionPayDto;

    constructor(data?: IIcLookupPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.costUnits = [];
            this.tagIds = [];
            this.pay = new IcLookupPositionPayDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.positionId = _data["positionId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.taxUnitId = _data["taxUnitId"];
            this.managerId = _data["managerId"];
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(IcLookupPositionCostUnitDto.fromJS(item));
            }
            this.setOfAccount = _data["setOfAccount"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.employmentType = _data["employmentType"];
            this.appointmentType = _data["appointmentType"];
            this.occupationCode = _data["occupationCode"];
            this.workTimeAgreementId = _data["workTimeAgreementId"];
            this.ftePercentage = _data["ftePercentage"];
            this.salaryType = _data["salaryType"];
            this.pay = _data["pay"] ? IcLookupPositionPayDto.fromJS(_data["pay"]) : new IcLookupPositionPayDto();
        }
    }

    static fromJS(data: any): IcLookupPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["positionId"] = this.positionId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["taxUnitId"] = this.taxUnitId;
        data["managerId"] = this.managerId;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["setOfAccount"] = this.setOfAccount;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["employmentType"] = this.employmentType;
        data["appointmentType"] = this.appointmentType;
        data["occupationCode"] = this.occupationCode;
        data["workTimeAgreementId"] = this.workTimeAgreementId;
        data["ftePercentage"] = this.ftePercentage;
        data["salaryType"] = this.salaryType;
        data["pay"] = this.pay ? this.pay.toJSON() : undefined as any;
        return data;
    }

    clone(): IcLookupPositionDto {
        const json = this.toJSON();
        let result = new IcLookupPositionDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPositionDto {
    employeeId: string;
    positionId: string;
    from?: Date;
    to?: Date;
    taxUnitId?: string;
    managerId?: string;
    costUnits: IcLookupPositionCostUnitDto[];
    setOfAccount?: SetOfAccountV3EnumDto;
    tagIds: string[];
    employmentType?: EmploymentTypeV3EnumDto;
    appointmentType?: AppointmentTypeV3EnumDto;
    occupationCode?: string;
    workTimeAgreementId?: string;
    /** The companion field `actualHoursPerWeek` can be calculated
with the formula described in `employeeV3FtePercentageValueDto`.
Use the `normalWeeklyHoursTimeline` item active on `pay.from`.
 */
    ftePercentage?: string;
    salaryType?: SalaryTypeV3EnumDto;
    pay: IcLookupPositionPayDto;
}

export class IcLookupPositionCostUnitDto implements IIcLookupPositionCostUnitDto {
    typeCustomId?: string;
    valueCustomId?: string;

    constructor(data?: IIcLookupPositionCostUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            this.valueCustomId = _data["valueCustomId"];
        }
    }

    static fromJS(data: any): IcLookupPositionCostUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPositionCostUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        data["valueCustomId"] = this.valueCustomId;
        return data;
    }

    clone(): IcLookupPositionCostUnitDto {
        const json = this.toJSON();
        let result = new IcLookupPositionCostUnitDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPositionCostUnitDto {
    typeCustomId?: string;
    valueCustomId?: string;
}

/** `inputType` decides which of `hourlyWage`, `fullTimeMonthlySalary` and `fullTimeYearlySalary` is set. The others can be calculated using `ftePercentage`, `workTimeAgreementId` and the corresponding work time agreement's active value on `from`. */
export class IcLookupPositionPayDto implements IIcLookupPositionPayDto {
    from?: Date;
    inputType?: BasePayInputTypeV3EnumDto;
    hourlyWage?: string;
    fullTimeMonthlySalary?: string;
    fullTimeYearlySalary?: string;
    rate4?: string;
    rate5?: string;
    rate6?: string;
    rate7?: string;
    rate8?: string;
    rate9?: string;

    constructor(data?: IIcLookupPositionPayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.inputType = _data["inputType"];
            this.hourlyWage = _data["hourlyWage"];
            this.fullTimeMonthlySalary = _data["fullTimeMonthlySalary"];
            this.fullTimeYearlySalary = _data["fullTimeYearlySalary"];
            this.rate4 = _data["rate4"];
            this.rate5 = _data["rate5"];
            this.rate6 = _data["rate6"];
            this.rate7 = _data["rate7"];
            this.rate8 = _data["rate8"];
            this.rate9 = _data["rate9"];
        }
    }

    static fromJS(data: any): IcLookupPositionPayDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPositionPayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["inputType"] = this.inputType;
        data["hourlyWage"] = this.hourlyWage;
        data["fullTimeMonthlySalary"] = this.fullTimeMonthlySalary;
        data["fullTimeYearlySalary"] = this.fullTimeYearlySalary;
        data["rate4"] = this.rate4;
        data["rate5"] = this.rate5;
        data["rate6"] = this.rate6;
        data["rate7"] = this.rate7;
        data["rate8"] = this.rate8;
        data["rate9"] = this.rate9;
        return data;
    }

    clone(): IcLookupPositionPayDto {
        const json = this.toJSON();
        let result = new IcLookupPositionPayDto();
        result.init(json);
        return result;
    }
}

/** `inputType` decides which of `hourlyWage`, `fullTimeMonthlySalary` and `fullTimeYearlySalary` is set. The others can be calculated using `ftePercentage`, `workTimeAgreementId` and the corresponding work time agreement's active value on `from`. */
export interface IIcLookupPositionPayDto {
    from?: Date;
    inputType?: BasePayInputTypeV3EnumDto;
    hourlyWage?: string;
    fullTimeMonthlySalary?: string;
    fullTimeYearlySalary?: string;
    rate4?: string;
    rate5?: string;
    rate6?: string;
    rate7?: string;
    rate8?: string;
    rate9?: string;
}

export class IcStartClearResponseDto implements IIcStartClearResponseDto {
    callCorrelationId!: string;

    constructor(data?: IIcStartClearResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callCorrelationId = _data["callCorrelationId"];
        }
    }

    static fromJS(data: any): IcStartClearResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcStartClearResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callCorrelationId"] = this.callCorrelationId;
        return data;
    }

    clone(): IcStartClearResponseDto {
        const json = this.toJSON();
        let result = new IcStartClearResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIcStartClearResponseDto {
    callCorrelationId: string;
}

export class IcStartSyncResponseDto implements IIcStartSyncResponseDto {
    callCorrelationId!: string;

    constructor(data?: IIcStartSyncResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callCorrelationId = _data["callCorrelationId"];
        }
    }

    static fromJS(data: any): IcStartSyncResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcStartSyncResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callCorrelationId"] = this.callCorrelationId;
        return data;
    }

    clone(): IcStartSyncResponseDto {
        const json = this.toJSON();
        let result = new IcStartSyncResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIcStartSyncResponseDto {
    callCorrelationId: string;
}

/** First response from get lookup without a type filter. Use `lookup.nextToken` to retrieve remaining responses, which will use the `icLookupOtherResponseDto` schema. */
export class IcLookupInitialResponseDto implements IIcLookupInitialResponseDto {
    /** This will always be set to `true`.
If not present, the response contains another schema.
 */
    isInitialResponseDto!: boolean;
    /** If set, display error message saying company configuration is wrong and
ask to contact support. Display this English error message as details.

`lookup` will not contain any data.
 */
    segmentError?: string;
    /** If `true`, redirect to vintage employee UI.
 */
    needsOnboarding!: boolean;
    /** If this has any entries, the item cache is being loaded for the first time for this company.
Display a message that company data is being prepared (a one time operation).

Await WS message `WsIcSyncCompleted` for each of the entries, then get lookup again.

Alternatively, get lookup filtered on the type in the WS message as each message arrives.
If you do, ensure getting all items already available now using `lookup.nextToken`.

For cost unit values (cuv), a `WsServerPayloadEnum.IcCuvUsedSyncPending` may arrive
while cost units are being synchronized for the first time.
If that happens, also wait for `WsServerPayloadEnum.IcCuvUsedSyncCompleted` for each type
before getting cost unit values.
 */
    initializing!: IcLookupTypeEnumDto[];
    lookup!: IcLookupDto;

    constructor(data?: IIcLookupInitialResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.initializing = [];
            this.lookup = new IcLookupDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInitialResponseDto = _data["isInitialResponseDto"];
            this.segmentError = _data["segmentError"];
            this.needsOnboarding = _data["needsOnboarding"];
            if (Array.isArray(_data["initializing"])) {
                this.initializing = [] as any;
                for (let item of _data["initializing"])
                    this.initializing!.push(item);
            }
            this.lookup = _data["lookup"] ? IcLookupDto.fromJS(_data["lookup"]) : new IcLookupDto();
        }
    }

    static fromJS(data: any): IcLookupInitialResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupInitialResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInitialResponseDto"] = this.isInitialResponseDto;
        data["segmentError"] = this.segmentError;
        data["needsOnboarding"] = this.needsOnboarding;
        if (Array.isArray(this.initializing)) {
            data["initializing"] = [];
            for (let item of this.initializing)
                data["initializing"].push(item);
        }
        data["lookup"] = this.lookup ? this.lookup.toJSON() : undefined as any;
        return data;
    }

    clone(): IcLookupInitialResponseDto {
        const json = this.toJSON();
        let result = new IcLookupInitialResponseDto();
        result.init(json);
        return result;
    }
}

/** First response from get lookup without a type filter. Use `lookup.nextToken` to retrieve remaining responses, which will use the `icLookupOtherResponseDto` schema. */
export interface IIcLookupInitialResponseDto {
    /** This will always be set to `true`.
If not present, the response contains another schema.
 */
    isInitialResponseDto: boolean;
    /** If set, display error message saying company configuration is wrong and
ask to contact support. Display this English error message as details.

`lookup` will not contain any data.
 */
    segmentError?: string;
    /** If `true`, redirect to vintage employee UI.
 */
    needsOnboarding: boolean;
    /** If this has any entries, the item cache is being loaded for the first time for this company.
Display a message that company data is being prepared (a one time operation).

Await WS message `WsIcSyncCompleted` for each of the entries, then get lookup again.

Alternatively, get lookup filtered on the type in the WS message as each message arrives.
If you do, ensure getting all items already available now using `lookup.nextToken`.

For cost unit values (cuv), a `WsServerPayloadEnum.IcCuvUsedSyncPending` may arrive
while cost units are being synchronized for the first time.
If that happens, also wait for `WsServerPayloadEnum.IcCuvUsedSyncCompleted` for each type
before getting cost unit values.
 */
    initializing: IcLookupTypeEnumDto[];
    lookup: IcLookupDto;
}

export class IcLookupOtherResponseDto implements IIcLookupOtherResponseDto {
    /** This will always be set to `true`.
If not present, the response contains another schema.
 */
    isOtherResponseDto!: boolean;
    lookup!: IcLookupDto;

    constructor(data?: IIcLookupOtherResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.lookup = new IcLookupDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOtherResponseDto = _data["isOtherResponseDto"];
            this.lookup = _data["lookup"] ? IcLookupDto.fromJS(_data["lookup"]) : new IcLookupDto();
        }
    }

    static fromJS(data: any): IcLookupOtherResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupOtherResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOtherResponseDto"] = this.isOtherResponseDto;
        data["lookup"] = this.lookup ? this.lookup.toJSON() : undefined as any;
        return data;
    }

    clone(): IcLookupOtherResponseDto {
        const json = this.toJSON();
        let result = new IcLookupOtherResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupOtherResponseDto {
    /** This will always be set to `true`.
If not present, the response contains another schema.
 */
    isOtherResponseDto: boolean;
    lookup: IcLookupDto;
}

/** Lookup data, including employee list. The entities returned here are incomplete and cannot be used to edit themselves. But they should have sufficient information to resolve references to them. Repeat the call as long as `nextToken` is set and merge the lists with results from previous calls. */
export class IcLookupDto implements IIcLookupDto {
    nextToken?: string;
    settings!: IcLookupSettingsDto;
    employees!: IcLookupEmployeeItemDto[];
    taxUnits!: IcLookupTaxUnitItemDto[];
    creditors!: IcLookupCreditorItemDto[];
    unions!: IcLookupUnionItemDto[];
    pensionCompanies!: IcLookupPensionCompanyItemDto[];
    /** Work time agreements
 */
    wtas!: IcLookupWtaItemDto[];
    cars!: IcLookupCarItemDto[];
    tags!: IcLookupTagItemDto[];
    paycodesForExtraPayment!: IcLookupPaycodeForExtraPaymentItemDto[];
    paycodesForFixedTransaction!: IcLookupPaycodeForFixedTransactionItemDto[];
    eventCodesForAbsenceRegistration!: IcLookupEventCodeForAbsenceRegistrationItemDto[];
    costUnitTypes!: IcLookupCostUnitTypeItemDto[];
    /** It is guaranteed that the corresponding type is returned before
its values, but values may appear on later pages too.
 */
    costUnitValues!: IcLookupCostUnitValueItemDto[];

    constructor(data?: IIcLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.settings = new IcLookupSettingsDto();
            this.employees = [];
            this.taxUnits = [];
            this.creditors = [];
            this.unions = [];
            this.pensionCompanies = [];
            this.wtas = [];
            this.cars = [];
            this.tags = [];
            this.paycodesForExtraPayment = [];
            this.paycodesForFixedTransaction = [];
            this.eventCodesForAbsenceRegistration = [];
            this.costUnitTypes = [];
            this.costUnitValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            this.settings = _data["settings"] ? IcLookupSettingsDto.fromJS(_data["settings"]) : new IcLookupSettingsDto();
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(IcLookupEmployeeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["taxUnits"])) {
                this.taxUnits = [] as any;
                for (let item of _data["taxUnits"])
                    this.taxUnits!.push(IcLookupTaxUnitItemDto.fromJS(item));
            }
            if (Array.isArray(_data["creditors"])) {
                this.creditors = [] as any;
                for (let item of _data["creditors"])
                    this.creditors!.push(IcLookupCreditorItemDto.fromJS(item));
            }
            if (Array.isArray(_data["unions"])) {
                this.unions = [] as any;
                for (let item of _data["unions"])
                    this.unions!.push(IcLookupUnionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["pensionCompanies"])) {
                this.pensionCompanies = [] as any;
                for (let item of _data["pensionCompanies"])
                    this.pensionCompanies!.push(IcLookupPensionCompanyItemDto.fromJS(item));
            }
            if (Array.isArray(_data["wtas"])) {
                this.wtas = [] as any;
                for (let item of _data["wtas"])
                    this.wtas!.push(IcLookupWtaItemDto.fromJS(item));
            }
            if (Array.isArray(_data["cars"])) {
                this.cars = [] as any;
                for (let item of _data["cars"])
                    this.cars!.push(IcLookupCarItemDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(IcLookupTagItemDto.fromJS(item));
            }
            if (Array.isArray(_data["paycodesForExtraPayment"])) {
                this.paycodesForExtraPayment = [] as any;
                for (let item of _data["paycodesForExtraPayment"])
                    this.paycodesForExtraPayment!.push(IcLookupPaycodeForExtraPaymentItemDto.fromJS(item));
            }
            if (Array.isArray(_data["paycodesForFixedTransaction"])) {
                this.paycodesForFixedTransaction = [] as any;
                for (let item of _data["paycodesForFixedTransaction"])
                    this.paycodesForFixedTransaction!.push(IcLookupPaycodeForFixedTransactionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["eventCodesForAbsenceRegistration"])) {
                this.eventCodesForAbsenceRegistration = [] as any;
                for (let item of _data["eventCodesForAbsenceRegistration"])
                    this.eventCodesForAbsenceRegistration!.push(IcLookupEventCodeForAbsenceRegistrationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["costUnitTypes"])) {
                this.costUnitTypes = [] as any;
                for (let item of _data["costUnitTypes"])
                    this.costUnitTypes!.push(IcLookupCostUnitTypeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["costUnitValues"])) {
                this.costUnitValues = [] as any;
                for (let item of _data["costUnitValues"])
                    this.costUnitValues!.push(IcLookupCostUnitValueItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IcLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined as any;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taxUnits)) {
            data["taxUnits"] = [];
            for (let item of this.taxUnits)
                data["taxUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.creditors)) {
            data["creditors"] = [];
            for (let item of this.creditors)
                data["creditors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unions)) {
            data["unions"] = [];
            for (let item of this.unions)
                data["unions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pensionCompanies)) {
            data["pensionCompanies"] = [];
            for (let item of this.pensionCompanies)
                data["pensionCompanies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wtas)) {
            data["wtas"] = [];
            for (let item of this.wtas)
                data["wtas"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.paycodesForExtraPayment)) {
            data["paycodesForExtraPayment"] = [];
            for (let item of this.paycodesForExtraPayment)
                data["paycodesForExtraPayment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.paycodesForFixedTransaction)) {
            data["paycodesForFixedTransaction"] = [];
            for (let item of this.paycodesForFixedTransaction)
                data["paycodesForFixedTransaction"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.eventCodesForAbsenceRegistration)) {
            data["eventCodesForAbsenceRegistration"] = [];
            for (let item of this.eventCodesForAbsenceRegistration)
                data["eventCodesForAbsenceRegistration"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.costUnitTypes)) {
            data["costUnitTypes"] = [];
            for (let item of this.costUnitTypes)
                data["costUnitTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.costUnitValues)) {
            data["costUnitValues"] = [];
            for (let item of this.costUnitValues)
                data["costUnitValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IcLookupDto {
        const json = this.toJSON();
        let result = new IcLookupDto();
        result.init(json);
        return result;
    }
}

/** Lookup data, including employee list. The entities returned here are incomplete and cannot be used to edit themselves. But they should have sufficient information to resolve references to them. Repeat the call as long as `nextToken` is set and merge the lists with results from previous calls. */
export interface IIcLookupDto {
    nextToken?: string;
    settings: IcLookupSettingsDto;
    employees: IcLookupEmployeeItemDto[];
    taxUnits: IcLookupTaxUnitItemDto[];
    creditors: IcLookupCreditorItemDto[];
    unions: IcLookupUnionItemDto[];
    pensionCompanies: IcLookupPensionCompanyItemDto[];
    /** Work time agreements
 */
    wtas: IcLookupWtaItemDto[];
    cars: IcLookupCarItemDto[];
    tags: IcLookupTagItemDto[];
    paycodesForExtraPayment: IcLookupPaycodeForExtraPaymentItemDto[];
    paycodesForFixedTransaction: IcLookupPaycodeForFixedTransactionItemDto[];
    eventCodesForAbsenceRegistration: IcLookupEventCodeForAbsenceRegistrationItemDto[];
    costUnitTypes: IcLookupCostUnitTypeItemDto[];
    /** It is guaranteed that the corresponding type is returned before
its values, but values may appear on later pages too.
 */
    costUnitValues: IcLookupCostUnitValueItemDto[];
}

/** These properties will only be set in the first lookup callback not filtered on any other type. If a property is not set, make sure not to apply its falsy value. */
export class IcLookupSettingsDto implements IIcLookupSettingsDto {
    /** Whether to automatically fill the employee's custom id (employee number, aka employee ID),

When enabled, the custom id is generated only when creating a new employee.
Take the custom IDs for all existing employees (draft, inactive, active and future),
order with [natural sort](https://en.wikipedia.org/wiki/Natural_sort_order)
and use the last one that contains a number.
Find the last number group and increase the value by 1.
Algorithm at https://jira.visma.com/browse/VHDI-2937

Examples:
- `null` -> 1
- 1 -> 2
- A1 -> A2
- 1A -> 2A
- 100-12 -> 100-13
- 12B99X -> 12B100X

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.

___
Monolith notes: The vintage UI algorithm is less refined and produces strange results
if any employee has a non-numeric character.
Instead of doing natural sort and increasing the last number group,
it will only consider IDs that start with a number and
then discard anything after the initial numeric value.

Examples:
- `null` -> 1
- 1 -> 2
- A1 -> 1
- 1A -> 2
- 100-12 -> 101
- 12B99X -> 13
___
 */
    enableAutomaticEmployeeCustomId?: boolean;
    /** Whether to show the field for setting an employee's start date from merged company.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    enableMergedCompanyStartDate?: boolean;
    /** Whether to show the field for setting a position's set of account.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    enableSetOfAccount?: boolean;
    /** Whether to show the tax field "report from first krone".

The source for this is the company setting "Tax free org", which is a timeline field.
The tax field will be enabled for the periods that setting is true.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    enableTaxFromFirstKroneTimeline?: BooleanV3TimelineItemDto[];
    /** If `true`, cost unit type names are read-only and new types cannot be added.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    hasExternalCostUnitTypeOwner?: boolean;
    /** If `true`, cost unit value names are read-only and new values cannot be added.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    hasExternalCostUnitValueOwner?: boolean;
    /** URL for configuration event codes for absence registration import.
 */
    eventCodesForArConfigUrl?: string;

    constructor(data?: IIcLookupSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableAutomaticEmployeeCustomId = _data["enableAutomaticEmployeeCustomId"];
            this.enableMergedCompanyStartDate = _data["enableMergedCompanyStartDate"];
            this.enableSetOfAccount = _data["enableSetOfAccount"];
            if (Array.isArray(_data["enableTaxFromFirstKroneTimeline"])) {
                this.enableTaxFromFirstKroneTimeline = [] as any;
                for (let item of _data["enableTaxFromFirstKroneTimeline"])
                    this.enableTaxFromFirstKroneTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
            this.hasExternalCostUnitTypeOwner = _data["hasExternalCostUnitTypeOwner"];
            this.hasExternalCostUnitValueOwner = _data["hasExternalCostUnitValueOwner"];
            this.eventCodesForArConfigUrl = _data["eventCodesForArConfigUrl"];
        }
    }

    static fromJS(data: any): IcLookupSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableAutomaticEmployeeCustomId"] = this.enableAutomaticEmployeeCustomId;
        data["enableMergedCompanyStartDate"] = this.enableMergedCompanyStartDate;
        data["enableSetOfAccount"] = this.enableSetOfAccount;
        if (Array.isArray(this.enableTaxFromFirstKroneTimeline)) {
            data["enableTaxFromFirstKroneTimeline"] = [];
            for (let item of this.enableTaxFromFirstKroneTimeline)
                data["enableTaxFromFirstKroneTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasExternalCostUnitTypeOwner"] = this.hasExternalCostUnitTypeOwner;
        data["hasExternalCostUnitValueOwner"] = this.hasExternalCostUnitValueOwner;
        data["eventCodesForArConfigUrl"] = this.eventCodesForArConfigUrl;
        return data;
    }

    clone(): IcLookupSettingsDto {
        const json = this.toJSON();
        let result = new IcLookupSettingsDto();
        result.init(json);
        return result;
    }
}

/** These properties will only be set in the first lookup callback not filtered on any other type. If a property is not set, make sure not to apply its falsy value. */
export interface IIcLookupSettingsDto {
    /** Whether to automatically fill the employee's custom id (employee number, aka employee ID),

When enabled, the custom id is generated only when creating a new employee.
Take the custom IDs for all existing employees (draft, inactive, active and future),
order with [natural sort](https://en.wikipedia.org/wiki/Natural_sort_order)
and use the last one that contains a number.
Find the last number group and increase the value by 1.
Algorithm at https://jira.visma.com/browse/VHDI-2937

Examples:
- `null` -> 1
- 1 -> 2
- A1 -> A2
- 1A -> 2A
- 100-12 -> 100-13
- 12B99X -> 12B100X

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.

___
Monolith notes: The vintage UI algorithm is less refined and produces strange results
if any employee has a non-numeric character.
Instead of doing natural sort and increasing the last number group,
it will only consider IDs that start with a number and
then discard anything after the initial numeric value.

Examples:
- `null` -> 1
- 1 -> 2
- A1 -> 1
- 1A -> 2
- 100-12 -> 101
- 12B99X -> 13
___
 */
    enableAutomaticEmployeeCustomId?: boolean;
    /** Whether to show the field for setting an employee's start date from merged company.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    enableMergedCompanyStartDate?: boolean;
    /** Whether to show the field for setting a position's set of account.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    enableSetOfAccount?: boolean;
    /** Whether to show the tax field "report from first krone".

The source for this is the company setting "Tax free org", which is a timeline field.
The tax field will be enabled for the periods that setting is true.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    enableTaxFromFirstKroneTimeline?: BooleanV3TimelineItemDto[];
    /** If `true`, cost unit type names are read-only and new types cannot be added.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    hasExternalCostUnitTypeOwner?: boolean;
    /** If `true`, cost unit value names are read-only and new values cannot be added.

Note that this property is optional and must only by applied if it is set.
When the item cache has been initialized, it will be set in the first lookup response.
 */
    hasExternalCostUnitValueOwner?: boolean;
    /** URL for configuration event codes for absence registration import.
 */
    eventCodesForArConfigUrl?: string;
}

export class IcLookupItemDto implements IIcLookupItemDto {
    /** Used for debugging only.
The write version of this item in the item cache.
 */
    version!: number;
    /** Unique for this entity type.
Used as foreign key when referencing this entity.
 */
    id!: string;

    constructor(data?: IIcLookupItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IcLookupItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["id"] = this.id;
        return data;
    }

    clone(): IcLookupItemDto {
        const json = this.toJSON();
        let result = new IcLookupItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupItemDto {
    /** Used for debugging only.
The write version of this item in the item cache.
 */
    version: number;
    /** Unique for this entity type.
Used as foreign key when referencing this entity.
 */
    id: string;
}

export class IcLookupEmployeeItemDto extends IcLookupItemDto implements IIcLookupEmployeeItemDto {
    data!: IcLookupEmployeeDataDto;

    constructor(data?: IIcLookupEmployeeItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupEmployeeDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupEmployeeDataDto.fromJS(_data["data"]) : new IcLookupEmployeeDataDto();
        }
    }

    static override fromJS(data: any): IcLookupEmployeeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupEmployeeItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupEmployeeItemDto {
        const json = this.toJSON();
        let result = new IcLookupEmployeeItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupEmployeeItemDto extends IIcLookupItemDto {
    data: IcLookupEmployeeDataDto;
}

export class IcLookupTaxUnitItemDto extends IcLookupItemDto implements IIcLookupTaxUnitItemDto {
    data!: IcLookupTaxUnitDataDto;

    constructor(data?: IIcLookupTaxUnitItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupTaxUnitDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupTaxUnitDataDto.fromJS(_data["data"]) : new IcLookupTaxUnitDataDto();
        }
    }

    static override fromJS(data: any): IcLookupTaxUnitItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupTaxUnitItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupTaxUnitItemDto {
        const json = this.toJSON();
        let result = new IcLookupTaxUnitItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupTaxUnitItemDto extends IIcLookupItemDto {
    data: IcLookupTaxUnitDataDto;
}

export class IcLookupTaxUnitDataDto implements IIcLookupTaxUnitDataDto {
    from?: Date;
    to?: Date;
    name!: string;
    organizationNumber?: string;

    constructor(data?: IIcLookupTaxUnitDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.name = _data["name"];
            this.organizationNumber = _data["organizationNumber"];
        }
    }

    static fromJS(data: any): IcLookupTaxUnitDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupTaxUnitDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["name"] = this.name;
        data["organizationNumber"] = this.organizationNumber;
        return data;
    }

    clone(): IcLookupTaxUnitDataDto {
        const json = this.toJSON();
        let result = new IcLookupTaxUnitDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupTaxUnitDataDto {
    from?: Date;
    to?: Date;
    name: string;
    organizationNumber?: string;
}

export class IcLookupCreditorItemDto extends IcLookupItemDto implements IIcLookupCreditorItemDto {
    data!: IcLookupCreditorDataDto;

    constructor(data?: IIcLookupCreditorItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupCreditorDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupCreditorDataDto.fromJS(_data["data"]) : new IcLookupCreditorDataDto();
        }
    }

    static override fromJS(data: any): IcLookupCreditorItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCreditorItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupCreditorItemDto {
        const json = this.toJSON();
        let result = new IcLookupCreditorItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupCreditorItemDto extends IIcLookupItemDto {
    data: IcLookupCreditorDataDto;
}

export class IcLookupCreditorDataDto implements IIcLookupCreditorDataDto {
    name!: string;
    accountNumber?: string;
    claimType!: CreditorClaimTypeV3EnumDto;

    constructor(data?: IIcLookupCreditorDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountNumber = _data["accountNumber"];
            this.claimType = _data["claimType"];
        }
    }

    static fromJS(data: any): IcLookupCreditorDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCreditorDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountNumber"] = this.accountNumber;
        data["claimType"] = this.claimType;
        return data;
    }

    clone(): IcLookupCreditorDataDto {
        const json = this.toJSON();
        let result = new IcLookupCreditorDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupCreditorDataDto {
    name: string;
    accountNumber?: string;
    claimType: CreditorClaimTypeV3EnumDto;
}

export class IcLookupUnionItemDto extends IcLookupItemDto implements IIcLookupUnionItemDto {
    data!: IcLookupUnionDataDto;

    constructor(data?: IIcLookupUnionItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupUnionDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupUnionDataDto.fromJS(_data["data"]) : new IcLookupUnionDataDto();
        }
    }

    static override fromJS(data: any): IcLookupUnionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupUnionItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupUnionItemDto {
        const json = this.toJSON();
        let result = new IcLookupUnionItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupUnionItemDto extends IIcLookupItemDto {
    data: IcLookupUnionDataDto;
}

export class IcLookupUnionDataDto implements IIcLookupUnionDataDto {
    name!: string;
    organizationNumber?: string;

    constructor(data?: IIcLookupUnionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organizationNumber = _data["organizationNumber"];
        }
    }

    static fromJS(data: any): IcLookupUnionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupUnionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organizationNumber"] = this.organizationNumber;
        return data;
    }

    clone(): IcLookupUnionDataDto {
        const json = this.toJSON();
        let result = new IcLookupUnionDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupUnionDataDto {
    name: string;
    organizationNumber?: string;
}

export class IcLookupPensionCompanyItemDto extends IcLookupItemDto implements IIcLookupPensionCompanyItemDto {
    data!: IcLookupPensionCompanyDataDto;

    constructor(data?: IIcLookupPensionCompanyItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupPensionCompanyDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupPensionCompanyDataDto.fromJS(_data["data"]) : new IcLookupPensionCompanyDataDto();
        }
    }

    static override fromJS(data: any): IcLookupPensionCompanyItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPensionCompanyItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupPensionCompanyItemDto {
        const json = this.toJSON();
        let result = new IcLookupPensionCompanyItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPensionCompanyItemDto extends IIcLookupItemDto {
    data: IcLookupPensionCompanyDataDto;
}

export class IcLookupPensionCompanyDataDto implements IIcLookupPensionCompanyDataDto {
    from?: Date;
    to?: Date;
    name!: string;

    constructor(data?: IIcLookupPensionCompanyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IcLookupPensionCompanyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPensionCompanyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["name"] = this.name;
        return data;
    }

    clone(): IcLookupPensionCompanyDataDto {
        const json = this.toJSON();
        let result = new IcLookupPensionCompanyDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPensionCompanyDataDto {
    from?: Date;
    to?: Date;
    name: string;
}

export class IcLookupWtaItemDto extends IcLookupItemDto implements IIcLookupWtaItemDto {
    data!: IcLookupWtaDataDto;

    constructor(data?: IIcLookupWtaItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupWtaDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupWtaDataDto.fromJS(_data["data"]) : new IcLookupWtaDataDto();
        }
    }

    static override fromJS(data: any): IcLookupWtaItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupWtaItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupWtaItemDto {
        const json = this.toJSON();
        let result = new IcLookupWtaItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupWtaItemDto extends IIcLookupItemDto {
    data: IcLookupWtaDataDto;
}

export class IcLookupWtaDataDto implements IIcLookupWtaDataDto {
    from?: Date;
    to?: Date;
    name!: string;
    normalWeeklyHoursTimeline!: IcLookupWtaNormalWeeklyHoursItemDto[];

    constructor(data?: IIcLookupWtaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.normalWeeklyHoursTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["normalWeeklyHoursTimeline"])) {
                this.normalWeeklyHoursTimeline = [] as any;
                for (let item of _data["normalWeeklyHoursTimeline"])
                    this.normalWeeklyHoursTimeline!.push(IcLookupWtaNormalWeeklyHoursItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IcLookupWtaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupWtaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.normalWeeklyHoursTimeline)) {
            data["normalWeeklyHoursTimeline"] = [];
            for (let item of this.normalWeeklyHoursTimeline)
                data["normalWeeklyHoursTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IcLookupWtaDataDto {
        const json = this.toJSON();
        let result = new IcLookupWtaDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupWtaDataDto {
    from?: Date;
    to?: Date;
    name: string;
    normalWeeklyHoursTimeline: IcLookupWtaNormalWeeklyHoursItemDto[];
}

export class IcLookupWtaNormalWeeklyHoursItemDto extends FullV3TimelineItemDto implements IIcLookupWtaNormalWeeklyHoursItemDto {
    value!: IcLookupWtaDetailValueDto;

    constructor(data?: IIcLookupWtaNormalWeeklyHoursItemDto) {
        super(data);
        if (!data) {
            this.value = new IcLookupWtaDetailValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? IcLookupWtaDetailValueDto.fromJS(_data["value"]) : new IcLookupWtaDetailValueDto();
        }
    }

    static override fromJS(data: any): IcLookupWtaNormalWeeklyHoursItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupWtaNormalWeeklyHoursItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupWtaNormalWeeklyHoursItemDto {
        const json = this.toJSON();
        let result = new IcLookupWtaNormalWeeklyHoursItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupWtaNormalWeeklyHoursItemDto extends IFullV3TimelineItemDto {
    value: IcLookupWtaDetailValueDto;
}

export class IcLookupWtaDetailValueDto implements IIcLookupWtaDetailValueDto {
    /** Used to calculate `hourlyWage` in employee base pay.
 */
    hourlyWage?: string;
    /** Used to calculate `overtimeRateBasis` in employee base pay.
 */
    overtimeBasis?: string;
    /** Used to calculate `rate2Basis` in employee base pay.
 */
    rate2Basis?: string;
    /** Used to calculate `rate3Basis` in employee base pay.
 */
    rate3Basis?: string;

    constructor(data?: IIcLookupWtaDetailValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyWage = _data["hourlyWage"];
            this.overtimeBasis = _data["overtimeBasis"];
            this.rate2Basis = _data["rate2Basis"];
            this.rate3Basis = _data["rate3Basis"];
        }
    }

    static fromJS(data: any): IcLookupWtaDetailValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupWtaDetailValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyWage"] = this.hourlyWage;
        data["overtimeBasis"] = this.overtimeBasis;
        data["rate2Basis"] = this.rate2Basis;
        data["rate3Basis"] = this.rate3Basis;
        return data;
    }

    clone(): IcLookupWtaDetailValueDto {
        const json = this.toJSON();
        let result = new IcLookupWtaDetailValueDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupWtaDetailValueDto {
    /** Used to calculate `hourlyWage` in employee base pay.
 */
    hourlyWage?: string;
    /** Used to calculate `overtimeRateBasis` in employee base pay.
 */
    overtimeBasis?: string;
    /** Used to calculate `rate2Basis` in employee base pay.
 */
    rate2Basis?: string;
    /** Used to calculate `rate3Basis` in employee base pay.
 */
    rate3Basis?: string;
}

export class IcLookupCarItemDto extends IcLookupItemDto implements IIcLookupCarItemDto {
    data!: IcLookupCarDataDto;

    constructor(data?: IIcLookupCarItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupCarDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupCarDataDto.fromJS(_data["data"]) : new IcLookupCarDataDto();
        }
    }

    static override fromJS(data: any): IcLookupCarItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCarItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupCarItemDto {
        const json = this.toJSON();
        let result = new IcLookupCarItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupCarItemDto extends IIcLookupItemDto {
    data: IcLookupCarDataDto;
}

export class IcLookupCarDataDto implements IIcLookupCarDataDto {
    from?: Date;
    to?: Date;
    name!: string;
    isCarPool!: boolean;
    /** Only available when `isCarPool` is false.
 */
    registrationNumber?: string;
    reportingRule?: CarReportingRuleV3EnumDto;

    constructor(data?: IIcLookupCarDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.name = _data["name"];
            this.isCarPool = _data["isCarPool"];
            this.registrationNumber = _data["registrationNumber"];
            this.reportingRule = _data["reportingRule"];
        }
    }

    static fromJS(data: any): IcLookupCarDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCarDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["name"] = this.name;
        data["isCarPool"] = this.isCarPool;
        data["registrationNumber"] = this.registrationNumber;
        data["reportingRule"] = this.reportingRule;
        return data;
    }

    clone(): IcLookupCarDataDto {
        const json = this.toJSON();
        let result = new IcLookupCarDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupCarDataDto {
    from?: Date;
    to?: Date;
    name: string;
    isCarPool: boolean;
    /** Only available when `isCarPool` is false.
 */
    registrationNumber?: string;
    reportingRule?: CarReportingRuleV3EnumDto;
}

export class IcLookupTagItemDto extends IcLookupItemDto implements IIcLookupTagItemDto {
    data!: IcLookupTagDataDto;

    constructor(data?: IIcLookupTagItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupTagDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupTagDataDto.fromJS(_data["data"]) : new IcLookupTagDataDto();
        }
    }

    static override fromJS(data: any): IcLookupTagItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupTagItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupTagItemDto {
        const json = this.toJSON();
        let result = new IcLookupTagItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupTagItemDto extends IIcLookupItemDto {
    data: IcLookupTagDataDto;
}

export class IcLookupTagDataDto implements IIcLookupTagDataDto {
    name!: string;
    description?: string;
    color?: string;

    constructor(data?: IIcLookupTagDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): IcLookupTagDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupTagDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }

    clone(): IcLookupTagDataDto {
        const json = this.toJSON();
        let result = new IcLookupTagDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupTagDataDto {
    name: string;
    description?: string;
    color?: string;
}

export class IcLookupPaycodeForExtraPaymentItemDto extends IcLookupItemDto implements IIcLookupPaycodeForExtraPaymentItemDto {
    data!: IcLookupPaycodeForExtraPaymentDataDto;

    constructor(data?: IIcLookupPaycodeForExtraPaymentItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupPaycodeForExtraPaymentDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupPaycodeForExtraPaymentDataDto.fromJS(_data["data"]) : new IcLookupPaycodeForExtraPaymentDataDto();
        }
    }

    static override fromJS(data: any): IcLookupPaycodeForExtraPaymentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeForExtraPaymentItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupPaycodeForExtraPaymentItemDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeForExtraPaymentItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPaycodeForExtraPaymentItemDto extends IIcLookupItemDto {
    data: IcLookupPaycodeForExtraPaymentDataDto;
}

/** This paycode is only valid when there is an entry in `isValidTimeline`. The timeline is a gap timeline rather than a full timeline, because paycode types are timeline aware, so a paycode may support being used on an extra payment in one period, but not another period (there are such paycodes in production, eg. 110920 Unpaid tax). The paycode may only for be used an extra payment when the fixed transaction's `[from, to]` range is fully covered by items in `isValidTimeline`. For example ``` isValidTimeline: [  {                     to: '2021-12-31'},  { from: '2022-01-01', to: '2022-12-31' }, // note the 2 year gap after this  { from: '2025-01-01', to: '2026-04-30' }, ], extraPayment1 = {                     to: '2022-12-31', ... } // valid extraPayment2 = {                     to: '2025-12-31', ... } // INVALID extraPayment3 = { from: '2022-01-01',                   ... } // INVALID extraPayment4 = { from: '2025-01-01',                   ... } // INVALID extraPayment5 = { from: '2020-05-06', to: '2022-07-08', ... } // valid extraPayment5 = { from: '2025-01-01', to: '2026-04-30', ... } // valid ``` */
export class IcLookupPaycodeForExtraPaymentDataDto implements IIcLookupPaycodeForExtraPaymentDataDto {
    customId?: string;
    name!: LocalizedStringDto;
    description!: LocalizedStringDto;
    isValidTimeline!: BooleanV3TimelineItemDto[];

    constructor(data?: IIcLookupPaycodeForExtraPaymentDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedStringDto();
            this.description = new LocalizedStringDto();
            this.isValidTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customId = _data["customId"];
            this.name = _data["name"] ? LocalizedStringDto.fromJS(_data["name"]) : new LocalizedStringDto();
            this.description = _data["description"] ? LocalizedStringDto.fromJS(_data["description"]) : new LocalizedStringDto();
            if (Array.isArray(_data["isValidTimeline"])) {
                this.isValidTimeline = [] as any;
                for (let item of _data["isValidTimeline"])
                    this.isValidTimeline!.push(BooleanV3TimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IcLookupPaycodeForExtraPaymentDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeForExtraPaymentDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customId"] = this.customId;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.isValidTimeline)) {
            data["isValidTimeline"] = [];
            for (let item of this.isValidTimeline)
                data["isValidTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IcLookupPaycodeForExtraPaymentDataDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeForExtraPaymentDataDto();
        result.init(json);
        return result;
    }
}

/** This paycode is only valid when there is an entry in `isValidTimeline`. The timeline is a gap timeline rather than a full timeline, because paycode types are timeline aware, so a paycode may support being used on an extra payment in one period, but not another period (there are such paycodes in production, eg. 110920 Unpaid tax). The paycode may only for be used an extra payment when the fixed transaction's `[from, to]` range is fully covered by items in `isValidTimeline`. For example ``` isValidTimeline: [  {                     to: '2021-12-31'},  { from: '2022-01-01', to: '2022-12-31' }, // note the 2 year gap after this  { from: '2025-01-01', to: '2026-04-30' }, ], extraPayment1 = {                     to: '2022-12-31', ... } // valid extraPayment2 = {                     to: '2025-12-31', ... } // INVALID extraPayment3 = { from: '2022-01-01',                   ... } // INVALID extraPayment4 = { from: '2025-01-01',                   ... } // INVALID extraPayment5 = { from: '2020-05-06', to: '2022-07-08', ... } // valid extraPayment5 = { from: '2025-01-01', to: '2026-04-30', ... } // valid ``` */
export interface IIcLookupPaycodeForExtraPaymentDataDto {
    customId?: string;
    name: LocalizedStringDto;
    description: LocalizedStringDto;
    isValidTimeline: BooleanV3TimelineItemDto[];
}

export class IcLookupPaycodeForFixedTransactionItemDto extends IcLookupItemDto implements IIcLookupPaycodeForFixedTransactionItemDto {
    data!: IcLookupPaycodeForFixedTransactionDataDto;

    constructor(data?: IIcLookupPaycodeForFixedTransactionItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupPaycodeForFixedTransactionDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupPaycodeForFixedTransactionDataDto.fromJS(_data["data"]) : new IcLookupPaycodeForFixedTransactionDataDto();
        }
    }

    static override fromJS(data: any): IcLookupPaycodeForFixedTransactionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeForFixedTransactionItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupPaycodeForFixedTransactionItemDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeForFixedTransactionItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPaycodeForFixedTransactionItemDto extends IIcLookupItemDto {
    data: IcLookupPaycodeForFixedTransactionDataDto;
}

/** This paycode is only valid when there is an entry in `timeline`. The timeline is a gap timeline rather than a full timeline, because paycode types are timeline aware, so a paycode may support being used on a transaction in one period, but not another period (there are such paycodes in production, eg. 110920 Unpaid tax). The paycode may only be used for a fixed transaction when the fixed transaction's `[from, to]` range is fully covered by items in `timeline`. For example ``` timeline: [  {                     to: '2021-12-31'},  { from: '2022-01-01', to: '2022-12-31' }, // note the 2 year gap after this  { from: '2025-01-01', to: '2026-04-30' }, ], transaction1 = {                     to: '2022-12-31', ... } // valid transaction2 = {                     to: '2025-12-31', ... } // INVALID transaction3 = { from: '2022-01-01',                   ... } // INVALID transaction4 = { from: '2025-01-01',                   ... } // INVALID transaction5 = { from: '2020-05-06', to: '2022-07-08', ... } // valid transaction5 = { from: '2025-01-01', to: '2026-04-30', ... } // valid ``` However, even though it is valid to use the paycode in the period, there may be further restrictions on additional info. These restrictions may even be impossible to fulfil, in which case the paycode cannot be used in that period. See `timeline[].value.additionalInfo`. */
export class IcLookupPaycodeForFixedTransactionDataDto implements IIcLookupPaycodeForFixedTransactionDataDto {
    customId!: string;
    name!: LocalizedStringDto;
    description!: LocalizedStringDto;
    isOnPosition!: boolean;
    fields!: IcLookupPaycodeFieldsDto;
    /** Determines when the paycode can be used (see parent description),
and describes timelined properties of a paycode (see below).
 */
    timeline!: IcLookupPaycodeTimelineItemDto[];

    constructor(data?: IIcLookupPaycodeForFixedTransactionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedStringDto();
            this.description = new LocalizedStringDto();
            this.fields = new IcLookupPaycodeFieldsDto();
            this.timeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customId = _data["customId"];
            this.name = _data["name"] ? LocalizedStringDto.fromJS(_data["name"]) : new LocalizedStringDto();
            this.description = _data["description"] ? LocalizedStringDto.fromJS(_data["description"]) : new LocalizedStringDto();
            this.isOnPosition = _data["isOnPosition"];
            this.fields = _data["fields"] ? IcLookupPaycodeFieldsDto.fromJS(_data["fields"]) : new IcLookupPaycodeFieldsDto();
            if (Array.isArray(_data["timeline"])) {
                this.timeline = [] as any;
                for (let item of _data["timeline"])
                    this.timeline!.push(IcLookupPaycodeTimelineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IcLookupPaycodeForFixedTransactionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeForFixedTransactionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customId"] = this.customId;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["isOnPosition"] = this.isOnPosition;
        data["fields"] = this.fields ? this.fields.toJSON() : undefined as any;
        if (Array.isArray(this.timeline)) {
            data["timeline"] = [];
            for (let item of this.timeline)
                data["timeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IcLookupPaycodeForFixedTransactionDataDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeForFixedTransactionDataDto();
        result.init(json);
        return result;
    }
}

/** This paycode is only valid when there is an entry in `timeline`. The timeline is a gap timeline rather than a full timeline, because paycode types are timeline aware, so a paycode may support being used on a transaction in one period, but not another period (there are such paycodes in production, eg. 110920 Unpaid tax). The paycode may only be used for a fixed transaction when the fixed transaction's `[from, to]` range is fully covered by items in `timeline`. For example ``` timeline: [  {                     to: '2021-12-31'},  { from: '2022-01-01', to: '2022-12-31' }, // note the 2 year gap after this  { from: '2025-01-01', to: '2026-04-30' }, ], transaction1 = {                     to: '2022-12-31', ... } // valid transaction2 = {                     to: '2025-12-31', ... } // INVALID transaction3 = { from: '2022-01-01',                   ... } // INVALID transaction4 = { from: '2025-01-01',                   ... } // INVALID transaction5 = { from: '2020-05-06', to: '2022-07-08', ... } // valid transaction5 = { from: '2025-01-01', to: '2026-04-30', ... } // valid ``` However, even though it is valid to use the paycode in the period, there may be further restrictions on additional info. These restrictions may even be impossible to fulfil, in which case the paycode cannot be used in that period. See `timeline[].value.additionalInfo`. */
export interface IIcLookupPaycodeForFixedTransactionDataDto {
    customId: string;
    name: LocalizedStringDto;
    description: LocalizedStringDto;
    isOnPosition: boolean;
    fields: IcLookupPaycodeFieldsDto;
    /** Determines when the paycode can be used (see parent description),
and describes timelined properties of a paycode (see below).
 */
    timeline: IcLookupPaycodeTimelineItemDto[];
}

/** List of fields indicating if they are allowed and required on transactions on this paycode. */
export class IcLookupPaycodeFieldsDto implements IIcLookupPaycodeFieldsDto {
    quantity!: IcLookupPaycodeFieldItemDto;
    factor!: IcLookupPaycodeFieldItemDto;
    price!: IcLookupPaycodeFieldItemDto;
    totalPrice!: IcLookupPaycodeFieldItemDto;

    constructor(data?: IIcLookupPaycodeFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.quantity = new IcLookupPaycodeFieldItemDto();
            this.factor = new IcLookupPaycodeFieldItemDto();
            this.price = new IcLookupPaycodeFieldItemDto();
            this.totalPrice = new IcLookupPaycodeFieldItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] ? IcLookupPaycodeFieldItemDto.fromJS(_data["quantity"]) : new IcLookupPaycodeFieldItemDto();
            this.factor = _data["factor"] ? IcLookupPaycodeFieldItemDto.fromJS(_data["factor"]) : new IcLookupPaycodeFieldItemDto();
            this.price = _data["price"] ? IcLookupPaycodeFieldItemDto.fromJS(_data["price"]) : new IcLookupPaycodeFieldItemDto();
            this.totalPrice = _data["totalPrice"] ? IcLookupPaycodeFieldItemDto.fromJS(_data["totalPrice"]) : new IcLookupPaycodeFieldItemDto();
        }
    }

    static fromJS(data: any): IcLookupPaycodeFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity ? this.quantity.toJSON() : undefined as any;
        data["factor"] = this.factor ? this.factor.toJSON() : undefined as any;
        data["price"] = this.price ? this.price.toJSON() : undefined as any;
        data["totalPrice"] = this.totalPrice ? this.totalPrice.toJSON() : undefined as any;
        return data;
    }

    clone(): IcLookupPaycodeFieldsDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeFieldsDto();
        result.init(json);
        return result;
    }
}

/** List of fields indicating if they are allowed and required on transactions on this paycode. */
export interface IIcLookupPaycodeFieldsDto {
    quantity: IcLookupPaycodeFieldItemDto;
    factor: IcLookupPaycodeFieldItemDto;
    price: IcLookupPaycodeFieldItemDto;
    totalPrice: IcLookupPaycodeFieldItemDto;
}

export class IcLookupPaycodeFieldItemDto implements IIcLookupPaycodeFieldItemDto {
    isAllowed!: boolean;
    isRequired!: boolean;

    constructor(data?: IIcLookupPaycodeFieldItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAllowed = _data["isAllowed"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): IcLookupPaycodeFieldItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeFieldItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAllowed"] = this.isAllowed;
        data["isRequired"] = this.isRequired;
        return data;
    }

    clone(): IcLookupPaycodeFieldItemDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeFieldItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPaycodeFieldItemDto {
    isAllowed: boolean;
    isRequired: boolean;
}

export class IcLookupPaycodeTimelineItemDto extends GapV3TimelineItemDto implements IIcLookupPaycodeTimelineItemDto {
    value!: IcLookupPaycodeTimelineValueDto;

    constructor(data?: IIcLookupPaycodeTimelineItemDto) {
        super(data);
        if (!data) {
            this.value = new IcLookupPaycodeTimelineValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? IcLookupPaycodeTimelineValueDto.fromJS(_data["value"]) : new IcLookupPaycodeTimelineValueDto();
        }
    }

    static override fromJS(data: any): IcLookupPaycodeTimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeTimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupPaycodeTimelineItemDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeTimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPaycodeTimelineItemDto extends IGapV3TimelineItemDto {
    value: IcLookupPaycodeTimelineValueDto;
}

export class IcLookupPaycodeTimelineValueDto implements IIcLookupPaycodeTimelineValueDto {
    /** Additional info present on this list are either optional or required.
Additional info not present are prohibited.
The list may be empty.

A fixed transaction can only have a single set of non-timelined additional info.
That set must fulfil the requirements of any additional info requirement
within the transaction's `[from, to]` range.

Scenarios:
- Transaction range is inside a single timeline item.
  - Absent info identifiers are prohibited.
  - Present info identifiers are either optional or required (see `[].isRequired`).
- Otherwise, consider each info identifier:
- Transaction range covers timeline items when info identifier is always absent.
  - Info identifier is prohibited.
- Transaction range covers timeline items when info identifier is always present.
  - If the info is ever required, it is required on the transaction.
  - If the info is never required, it is optional on the transaction.
- Transaction range covers timeline items when info identifier is both present and absent.
  - If the info is ever required, this transaction range is INVALID because the info is also prohibited (absent).
  - If the info is never required, it is prohibited on the transaction.

Example:
```
timeline: [
  {                     to: '2021-12-31', additionalInfo: [
    { identifier:  '2300', isRequired: false },
    { identifier:  '9250', isRequired: false },
    { identifier:  '9280', isRequired: false },
  ]},
  { from: '2022-01-01', to: '2022-12-31' additionalInfo: [
    { identifier:  '2300', isRequired: false },
    { identifier:  '9250', isRequired: true  },
    { identifier: '10100', isRequired: true  },
  ]},
],

transaction = { from: '2019-01-01', to: '2020-06-30', ... }
```

- Additional info 10110 is prohibited (as is any other additional info not mentioned).
- Additional info 2300 is optional.
- Additional info 9250 is required.
- Additional info 9280 is optional.
- Additional info 10100 is both prohibited and required, and causes the transaction range to be invalid.

With the above additional info timeline, a transaction range must either be
within `['0000-00-00', '2021-12-31']` OR
within `['2022-01-01', '2022-12-31']`.

It would be possible for a transaction to span both ranges if
- 10100 was removed from the last item OR
- 10100 was changed to `isRequired: false` in the last item OR
- 10100 was added to the first item, either as required or optional.
 */
    additionalInfo!: IcLookupPaycodeAdditionalInfoDto[];
    /** `additionalInfo` only contains additional info known
to be used by paycodes for fixed transactions.
But users could create custom paycodes with any other additional info, see list below.

If they have, those unsupported additional infos will be set in this property.
Otherwise, this property will not be set.

If `unsupportedAdditionalInfo` is set, transactions cannot be created.
The user should be informed, including which additional info codes prevent the creation.
Existing transactions can be edited by simply keeping the unsupported info unaltered.

Most of the unsupported additional info will probably never be used for fixed transactions.
For reference, here is the full list of unsupported additional info:
  - 1020
  - 2500
  - 2600
  - 2700
  - 2900
  - 3140
  - 3150
  - 3160
  - 3170
  - 3200
  - 3310
  - 3320
  - 3330
  - 3340
  - 4000
  - 4020
  - 4080
  - 5100
  - 9010
  - 9030
  - 9110
  - 9120
  - 9200
  - 9210
  - 9220
  - 9260
  - 9270
  - 9310
  - 9320
 */
    unsupportedAdditionalInfo?: string[];

    constructor(data?: IIcLookupPaycodeTimelineValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.additionalInfo = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(IcLookupPaycodeAdditionalInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["unsupportedAdditionalInfo"])) {
                this.unsupportedAdditionalInfo = [] as any;
                for (let item of _data["unsupportedAdditionalInfo"])
                    this.unsupportedAdditionalInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): IcLookupPaycodeTimelineValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeTimelineValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unsupportedAdditionalInfo)) {
            data["unsupportedAdditionalInfo"] = [];
            for (let item of this.unsupportedAdditionalInfo)
                data["unsupportedAdditionalInfo"].push(item);
        }
        return data;
    }

    clone(): IcLookupPaycodeTimelineValueDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeTimelineValueDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupPaycodeTimelineValueDto {
    /** Additional info present on this list are either optional or required.
Additional info not present are prohibited.
The list may be empty.

A fixed transaction can only have a single set of non-timelined additional info.
That set must fulfil the requirements of any additional info requirement
within the transaction's `[from, to]` range.

Scenarios:
- Transaction range is inside a single timeline item.
  - Absent info identifiers are prohibited.
  - Present info identifiers are either optional or required (see `[].isRequired`).
- Otherwise, consider each info identifier:
- Transaction range covers timeline items when info identifier is always absent.
  - Info identifier is prohibited.
- Transaction range covers timeline items when info identifier is always present.
  - If the info is ever required, it is required on the transaction.
  - If the info is never required, it is optional on the transaction.
- Transaction range covers timeline items when info identifier is both present and absent.
  - If the info is ever required, this transaction range is INVALID because the info is also prohibited (absent).
  - If the info is never required, it is prohibited on the transaction.

Example:
```
timeline: [
  {                     to: '2021-12-31', additionalInfo: [
    { identifier:  '2300', isRequired: false },
    { identifier:  '9250', isRequired: false },
    { identifier:  '9280', isRequired: false },
  ]},
  { from: '2022-01-01', to: '2022-12-31' additionalInfo: [
    { identifier:  '2300', isRequired: false },
    { identifier:  '9250', isRequired: true  },
    { identifier: '10100', isRequired: true  },
  ]},
],

transaction = { from: '2019-01-01', to: '2020-06-30', ... }
```

- Additional info 10110 is prohibited (as is any other additional info not mentioned).
- Additional info 2300 is optional.
- Additional info 9250 is required.
- Additional info 9280 is optional.
- Additional info 10100 is both prohibited and required, and causes the transaction range to be invalid.

With the above additional info timeline, a transaction range must either be
within `['0000-00-00', '2021-12-31']` OR
within `['2022-01-01', '2022-12-31']`.

It would be possible for a transaction to span both ranges if
- 10100 was removed from the last item OR
- 10100 was changed to `isRequired: false` in the last item OR
- 10100 was added to the first item, either as required or optional.
 */
    additionalInfo: IcLookupPaycodeAdditionalInfoDto[];
    /** `additionalInfo` only contains additional info known
to be used by paycodes for fixed transactions.
But users could create custom paycodes with any other additional info, see list below.

If they have, those unsupported additional infos will be set in this property.
Otherwise, this property will not be set.

If `unsupportedAdditionalInfo` is set, transactions cannot be created.
The user should be informed, including which additional info codes prevent the creation.
Existing transactions can be edited by simply keeping the unsupported info unaltered.

Most of the unsupported additional info will probably never be used for fixed transactions.
For reference, here is the full list of unsupported additional info:
  - 1020
  - 2500
  - 2600
  - 2700
  - 2900
  - 3140
  - 3150
  - 3160
  - 3170
  - 3200
  - 3310
  - 3320
  - 3330
  - 3340
  - 4000
  - 4020
  - 4080
  - 5100
  - 9010
  - 9030
  - 9110
  - 9120
  - 9200
  - 9210
  - 9220
  - 9260
  - 9270
  - 9310
  - 9320
 */
    unsupportedAdditionalInfo?: string[];
}

/** Type of the additional information definition. Mapped by bulk operations backend from identifiers used by payroll. Most identifiers do not have a mapping, because they are not expected to be used for fixed transactions. If any happen to be anyway, they will be listed in `unsupportedAdditionalInfo`. */
export class IcLookupPaycodeAdditionalInfoDto implements IIcLookupPaycodeAdditionalInfoDto {
    type!: AdditionalInfoEnumDto;
    isRequired!: boolean;

    constructor(data?: IIcLookupPaycodeAdditionalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): IcLookupPaycodeAdditionalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupPaycodeAdditionalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        return data;
    }

    clone(): IcLookupPaycodeAdditionalInfoDto {
        const json = this.toJSON();
        let result = new IcLookupPaycodeAdditionalInfoDto();
        result.init(json);
        return result;
    }
}

/** Type of the additional information definition. Mapped by bulk operations backend from identifiers used by payroll. Most identifiers do not have a mapping, because they are not expected to be used for fixed transactions. If any happen to be anyway, they will be listed in `unsupportedAdditionalInfo`. */
export interface IIcLookupPaycodeAdditionalInfoDto {
    type: AdditionalInfoEnumDto;
    isRequired: boolean;
}

export class IcLookupEventCodeForAbsenceRegistrationItemDto extends IcLookupItemDto implements IIcLookupEventCodeForAbsenceRegistrationItemDto {
    data!: IcLookupEventCodeForAbsenceRegistrationDataDto;

    constructor(data?: IIcLookupEventCodeForAbsenceRegistrationItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupEventCodeForAbsenceRegistrationDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupEventCodeForAbsenceRegistrationDataDto.fromJS(_data["data"]) : new IcLookupEventCodeForAbsenceRegistrationDataDto();
        }
    }

    static override fromJS(data: any): IcLookupEventCodeForAbsenceRegistrationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupEventCodeForAbsenceRegistrationItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupEventCodeForAbsenceRegistrationItemDto {
        const json = this.toJSON();
        let result = new IcLookupEventCodeForAbsenceRegistrationItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupEventCodeForAbsenceRegistrationItemDto extends IIcLookupItemDto {
    data: IcLookupEventCodeForAbsenceRegistrationDataDto;
}

export class IcLookupEventCodeForAbsenceRegistrationDataDto implements IIcLookupEventCodeForAbsenceRegistrationDataDto {
    name!: LocalizedStringDto;
    /** The IDs used in the source system (eg. Visma Lønn).

Note that when the user change the ID from one event code
to another, the external ID can be temporarily visible on two event codes.

```
Before:
ec1: { id: '1f4ebac5-98b0-46cb-b238-fe66d85ca588', data: { externalIds: ['10', '99'] } }
ec2: { id: '343d181d-10ea-4641-8829-59d6a122f5c9', data: { externalIds: ['11'] } }

After:
ec1: { id: '1f4ebac5-98b0-46cb-b238-fe66d85ca588', data: { externalIds: ['10'] } }
ec2: { id: '343d181d-10ea-4641-8829-59d6a122f5c9', data: { externalIds: ['11', '99'] } }

If the WS message to update ec2 is received before the WS message to update ec1,
99 will be applicable to both ec1 and ec2.
If the latest seen externalId->id mapping is used, there should be no problem.
 */
    externalIds!: string[];

    constructor(data?: IIcLookupEventCodeForAbsenceRegistrationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedStringDto();
            this.externalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] ? LocalizedStringDto.fromJS(_data["name"]) : new LocalizedStringDto();
            if (Array.isArray(_data["externalIds"])) {
                this.externalIds = [] as any;
                for (let item of _data["externalIds"])
                    this.externalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): IcLookupEventCodeForAbsenceRegistrationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupEventCodeForAbsenceRegistrationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        if (Array.isArray(this.externalIds)) {
            data["externalIds"] = [];
            for (let item of this.externalIds)
                data["externalIds"].push(item);
        }
        return data;
    }

    clone(): IcLookupEventCodeForAbsenceRegistrationDataDto {
        const json = this.toJSON();
        let result = new IcLookupEventCodeForAbsenceRegistrationDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupEventCodeForAbsenceRegistrationDataDto {
    name: LocalizedStringDto;
    /** The IDs used in the source system (eg. Visma Lønn).

Note that when the user change the ID from one event code
to another, the external ID can be temporarily visible on two event codes.

```
Before:
ec1: { id: '1f4ebac5-98b0-46cb-b238-fe66d85ca588', data: { externalIds: ['10', '99'] } }
ec2: { id: '343d181d-10ea-4641-8829-59d6a122f5c9', data: { externalIds: ['11'] } }

After:
ec1: { id: '1f4ebac5-98b0-46cb-b238-fe66d85ca588', data: { externalIds: ['10'] } }
ec2: { id: '343d181d-10ea-4641-8829-59d6a122f5c9', data: { externalIds: ['11', '99'] } }

If the WS message to update ec2 is received before the WS message to update ec1,
99 will be applicable to both ec1 and ec2.
If the latest seen externalId->id mapping is used, there should be no problem.
 */
    externalIds: string[];
}

export class IcLookupCostUnitTypeItemDto extends IcLookupItemDto implements IIcLookupCostUnitTypeItemDto {
    data!: IcLookupCostUnitTypeDataDto;

    constructor(data?: IIcLookupCostUnitTypeItemDto) {
        super(data);
        if (!data) {
            this.data = new IcLookupCostUnitTypeDataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IcLookupCostUnitTypeDataDto.fromJS(_data["data"]) : new IcLookupCostUnitTypeDataDto();
        }
    }

    static override fromJS(data: any): IcLookupCostUnitTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCostUnitTypeItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): IcLookupCostUnitTypeItemDto {
        const json = this.toJSON();
        let result = new IcLookupCostUnitTypeItemDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupCostUnitTypeItemDto extends IIcLookupItemDto {
    data: IcLookupCostUnitTypeDataDto;
}

export class IcLookupCostUnitTypeDataDto implements IIcLookupCostUnitTypeDataDto {
    from?: Date;
    to?: Date;
    name?: string;
    /** Only a few thousand values are stored in the item cache.
When this is `true`, some referenced values may be missing from the lookup.
When this is `true`, the backend must be queried when the user searches for a value to assign.

As a performance optimization when `true`, non-existing values that are used (reference by a position)
is stored explicitly as ghost values. See `icLookupCostUnitValueItemDto.isGhost`.
When a used value is missing from the lookup entirely,
the backend must be queried to either get the value or determine that it is a ghost value.

When `false`, any value that is used but missing from the lookup is a ghost value.
 */
    hasMoreValues!: boolean;

    constructor(data?: IIcLookupCostUnitTypeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.name = _data["name"];
            this.hasMoreValues = _data["hasMoreValues"];
        }
    }

    static fromJS(data: any): IcLookupCostUnitTypeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCostUnitTypeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["name"] = this.name;
        data["hasMoreValues"] = this.hasMoreValues;
        return data;
    }

    clone(): IcLookupCostUnitTypeDataDto {
        const json = this.toJSON();
        let result = new IcLookupCostUnitTypeDataDto();
        result.init(json);
        return result;
    }
}

export interface IIcLookupCostUnitTypeDataDto {
    from?: Date;
    to?: Date;
    name?: string;
    /** Only a few thousand values are stored in the item cache.
When this is `true`, some referenced values may be missing from the lookup.
When this is `true`, the backend must be queried when the user searches for a value to assign.

As a performance optimization when `true`, non-existing values that are used (reference by a position)
is stored explicitly as ghost values. See `icLookupCostUnitValueItemDto.isGhost`.
When a used value is missing from the lookup entirely,
the backend must be queried to either get the value or determine that it is a ghost value.

When `false`, any value that is used but missing from the lookup is a ghost value.
 */
    hasMoreValues: boolean;
}

/** To save space and optimize writes, cost unit values does not have versioning. */
export class IcLookupCostUnitValueItemDto implements IIcLookupCostUnitValueItemDto {
    /** Custom id of the cost unit type this value belongs to.
 */
    typeId!: string;
    /** Custom id of this value. Unique within the type.
 */
    valueId!: string;
    from?: Date;
    to?: Date;
    name!: string;
    /** This cost unit value does not exist, but it is being referenced by a position.
`name` will be set to `(not found)`, but actually a localized label should be used
instead of the name, displayed together with `customId` of the ghost reference.
Ghost values must be filtered out from dropdowns where cost unit values are picked.

Only types where `hasMoreValues=true` will have explicit ghost value items in the lookup cache.

Types where `hasMoreValues=false` has all values in the lookup.
So if a value is not found then it is a ghost value.
The FE should display this the same as an explicit ghost value item.
 */
    isGhost?: boolean;

    constructor(data?: IIcLookupCostUnitValueItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.valueId = _data["valueId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.name = _data["name"];
            this.isGhost = _data["isGhost"];
        }
    }

    static fromJS(data: any): IcLookupCostUnitValueItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcLookupCostUnitValueItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["valueId"] = this.valueId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["name"] = this.name;
        data["isGhost"] = this.isGhost;
        return data;
    }

    clone(): IcLookupCostUnitValueItemDto {
        const json = this.toJSON();
        let result = new IcLookupCostUnitValueItemDto();
        result.init(json);
        return result;
    }
}

/** To save space and optimize writes, cost unit values does not have versioning. */
export interface IIcLookupCostUnitValueItemDto {
    /** Custom id of the cost unit type this value belongs to.
 */
    typeId: string;
    /** Custom id of this value. Unique within the type.
 */
    valueId: string;
    from?: Date;
    to?: Date;
    name: string;
    /** This cost unit value does not exist, but it is being referenced by a position.
`name` will be set to `(not found)`, but actually a localized label should be used
instead of the name, displayed together with `customId` of the ghost reference.
Ghost values must be filtered out from dropdowns where cost unit values are picked.

Only types where `hasMoreValues=true` will have explicit ghost value items in the lookup cache.

Types where `hasMoreValues=false` has all values in the lookup.
So if a value is not found then it is a ghost value.
The FE should display this the same as an explicit ghost value item.
 */
    isGhost?: boolean;
}

export class WorkTimeAgreementsResponseDto implements IWorkTimeAgreementsResponseDto {
    /** Contains a list of both built-in and company defined work time agreements (WTAs).
An empty list is never expected because there are built-in work time agreements.

A work time agreement only has a validity range, so it's `id` will be unique in
the timeline.

___
Monolith note: Work time agreements are defined on a group level,
but this is ignored by the Org API mapper.
___
 */
    workTimeAgreementsTimeline!: WorkTimeAgreementItemDto[];

    constructor(data?: IWorkTimeAgreementsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.workTimeAgreementsTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workTimeAgreementsTimeline"])) {
                this.workTimeAgreementsTimeline = [] as any;
                for (let item of _data["workTimeAgreementsTimeline"])
                    this.workTimeAgreementsTimeline!.push(WorkTimeAgreementItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkTimeAgreementsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTimeAgreementsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workTimeAgreementsTimeline)) {
            data["workTimeAgreementsTimeline"] = [];
            for (let item of this.workTimeAgreementsTimeline)
                data["workTimeAgreementsTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): WorkTimeAgreementsResponseDto {
        const json = this.toJSON();
        let result = new WorkTimeAgreementsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IWorkTimeAgreementsResponseDto {
    /** Contains a list of both built-in and company defined work time agreements (WTAs).
An empty list is never expected because there are built-in work time agreements.

A work time agreement only has a validity range, so it's `id` will be unique in
the timeline.

___
Monolith note: Work time agreements are defined on a group level,
but this is ignored by the Org API mapper.
___
 */
    workTimeAgreementsTimeline: WorkTimeAgreementItemDto[];
}

export class WorkTimeAgreementItemDto extends OverlapV3TimelineItemDto implements IWorkTimeAgreementItemDto {
    value!: WorkTimeAgreementValueDto;

    constructor(data?: IWorkTimeAgreementItemDto) {
        super(data);
        if (!data) {
            this.value = new WorkTimeAgreementValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? WorkTimeAgreementValueDto.fromJS(_data["value"]) : new WorkTimeAgreementValueDto();
        }
    }

    static override fromJS(data: any): WorkTimeAgreementItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTimeAgreementItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): WorkTimeAgreementItemDto {
        const json = this.toJSON();
        let result = new WorkTimeAgreementItemDto();
        result.init(json);
        return result;
    }
}

export interface IWorkTimeAgreementItemDto extends IOverlapV3TimelineItemDto {
    value: WorkTimeAgreementValueDto;
}

export class WorkTimeAgreementValueDto implements IWorkTimeAgreementValueDto {
    /** Unique identifier for work time agreement, to be used when updating Org API.
Will only occur once in overlap timeline.
Prohibited when creating a new work time agreement.
 */
    readonly id!: string;
    /** Unique identifier for work time agreement,
to be used as foreign key in employee.

Will only occur once in overlap timeline.
One-to-one with `id`.

Prohibited when creating a new work time agreement.
 */
    readonly legacyId!: string;
    /** Whether this work time agreement is managed by this company.

If `false`, the entire work time agreement is read-only in the current context.
 */
    isDefinedInCompany!: boolean;
    /** Display name.
 */
    name!: string;
    workTimeAgreementDetailTimeline!: WorkTimeAgreementDetailItemDto[];

    constructor(data?: IWorkTimeAgreementValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.workTimeAgreementDetailTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).id = _data["id"];
            (this as any).legacyId = _data["legacyId"];
            this.isDefinedInCompany = _data["isDefinedInCompany"];
            this.name = _data["name"];
            if (Array.isArray(_data["workTimeAgreementDetailTimeline"])) {
                this.workTimeAgreementDetailTimeline = [] as any;
                for (let item of _data["workTimeAgreementDetailTimeline"])
                    this.workTimeAgreementDetailTimeline!.push(WorkTimeAgreementDetailItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkTimeAgreementValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTimeAgreementValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["isDefinedInCompany"] = this.isDefinedInCompany;
        data["name"] = this.name;
        if (Array.isArray(this.workTimeAgreementDetailTimeline)) {
            data["workTimeAgreementDetailTimeline"] = [];
            for (let item of this.workTimeAgreementDetailTimeline)
                data["workTimeAgreementDetailTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): WorkTimeAgreementValueDto {
        const json = this.toJSON();
        let result = new WorkTimeAgreementValueDto();
        result.init(json);
        return result;
    }
}

export interface IWorkTimeAgreementValueDto {
    /** Unique identifier for work time agreement, to be used when updating Org API.
Will only occur once in overlap timeline.
Prohibited when creating a new work time agreement.
 */
    id: string;
    /** Unique identifier for work time agreement,
to be used as foreign key in employee.

Will only occur once in overlap timeline.
One-to-one with `id`.

Prohibited when creating a new work time agreement.
 */
    legacyId: string;
    /** Whether this work time agreement is managed by this company.

If `false`, the entire work time agreement is read-only in the current context.
 */
    isDefinedInCompany: boolean;
    /** Display name.
 */
    name: string;
    workTimeAgreementDetailTimeline: WorkTimeAgreementDetailItemDto[];
}

export class WorkTimeAgreementDetailItemDto extends FullV3TimelineItemDto implements IWorkTimeAgreementDetailItemDto {
    value!: WorkTimeAgreementDetailValueDto;

    constructor(data?: IWorkTimeAgreementDetailItemDto) {
        super(data);
        if (!data) {
            this.value = new WorkTimeAgreementDetailValueDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? WorkTimeAgreementDetailValueDto.fromJS(_data["value"]) : new WorkTimeAgreementDetailValueDto();
        }
    }

    static override fromJS(data: any): WorkTimeAgreementDetailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTimeAgreementDetailItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): WorkTimeAgreementDetailItemDto {
        const json = this.toJSON();
        let result = new WorkTimeAgreementDetailItemDto();
        result.init(json);
        return result;
    }
}

export interface IWorkTimeAgreementDetailItemDto extends IFullV3TimelineItemDto {
    value: WorkTimeAgreementDetailValueDto;
}

export class WorkTimeAgreementDetailValueDto implements IWorkTimeAgreementDetailValueDto {
    /** Used for a-message reporting.

Known values are listed in [workingTimeArrangementV3EnumDto](#model-workingTimeArrangementV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.
 */
    workingTimeArrangement?: string;
    /** Used for a-message reporting.
 */
    reportedNormalWeeklyHours?: string;
    /** Used to calculate `hourlyWage` in employee base pay.
Ignored if `inputType` is `hourly`.

Should be set to 1/52 of the agreed yearly hours for calculating hourly wage.
 */
    normalWeeklyHours?: string;
    /** Used to calculate `overtimeRateBasis` in employee base pay.

Normally this will be the same as `normalWeeklyHours`.
Only if there is an agreement to use a different amount of
yearly hours to derive overtime pay instead of the yearly hours
used to derive hourly wage does this need to be different.
 */
    normalWeeklyHoursForOvertimeBasis?: string;
    /** Mandatory (but not set in built-in WTAs).

Normally this can be the same as `normalWeeklyHours`.
Only if there is an agreement to use a different amount of
yearly hours to derive rate 2 instead of the yearly hours
used to derive hourly wage does this need to be different.
 */
    normalWeeklyHoursForRate2Basis?: string;
    /** Mandatory (but not set in built-in WTAs).

Normally this can be the same as `normalWeeklyHours`.
Only if there is an agreement to use a different amount of
yearly hours to derive rate 3 instead of the yearly hours
used to derive hourly wage does this need to be different.
 */
    normalWeeklyHoursForRate3Basis?: string;

    constructor(data?: IWorkTimeAgreementDetailValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workingTimeArrangement = _data["workingTimeArrangement"];
            this.reportedNormalWeeklyHours = _data["reportedNormalWeeklyHours"];
            this.normalWeeklyHours = _data["normalWeeklyHours"];
            this.normalWeeklyHoursForOvertimeBasis = _data["normalWeeklyHoursForOvertimeBasis"];
            this.normalWeeklyHoursForRate2Basis = _data["normalWeeklyHoursForRate2Basis"];
            this.normalWeeklyHoursForRate3Basis = _data["normalWeeklyHoursForRate3Basis"];
        }
    }

    static fromJS(data: any): WorkTimeAgreementDetailValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTimeAgreementDetailValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workingTimeArrangement"] = this.workingTimeArrangement;
        data["reportedNormalWeeklyHours"] = this.reportedNormalWeeklyHours;
        data["normalWeeklyHours"] = this.normalWeeklyHours;
        data["normalWeeklyHoursForOvertimeBasis"] = this.normalWeeklyHoursForOvertimeBasis;
        data["normalWeeklyHoursForRate2Basis"] = this.normalWeeklyHoursForRate2Basis;
        data["normalWeeklyHoursForRate3Basis"] = this.normalWeeklyHoursForRate3Basis;
        return data;
    }

    clone(): WorkTimeAgreementDetailValueDto {
        const json = this.toJSON();
        let result = new WorkTimeAgreementDetailValueDto();
        result.init(json);
        return result;
    }
}

export interface IWorkTimeAgreementDetailValueDto {
    /** Used for a-message reporting.

Known values are listed in [workingTimeArrangementV3EnumDto](#model-workingTimeArrangementV3EnumDto),
but client must also gracefully accept other values and not modify them unless the user requests it.
 */
    workingTimeArrangement?: string;
    /** Used for a-message reporting.
 */
    reportedNormalWeeklyHours?: string;
    /** Used to calculate `hourlyWage` in employee base pay.
Ignored if `inputType` is `hourly`.

Should be set to 1/52 of the agreed yearly hours for calculating hourly wage.
 */
    normalWeeklyHours?: string;
    /** Used to calculate `overtimeRateBasis` in employee base pay.

Normally this will be the same as `normalWeeklyHours`.
Only if there is an agreement to use a different amount of
yearly hours to derive overtime pay instead of the yearly hours
used to derive hourly wage does this need to be different.
 */
    normalWeeklyHoursForOvertimeBasis?: string;
    /** Mandatory (but not set in built-in WTAs).

Normally this can be the same as `normalWeeklyHours`.
Only if there is an agreement to use a different amount of
yearly hours to derive rate 2 instead of the yearly hours
used to derive hourly wage does this need to be different.
 */
    normalWeeklyHoursForRate2Basis?: string;
    /** Mandatory (but not set in built-in WTAs).

Normally this can be the same as `normalWeeklyHours`.
Only if there is an agreement to use a different amount of
yearly hours to derive rate 3 instead of the yearly hours
used to derive hourly wage does this need to be different.
 */
    normalWeeklyHoursForRate3Basis?: string;
}

export class CarsResponseDto implements ICarsResponseDto {
    /** returned list is not sorted */
    cars!: CarDto[];

    constructor(data?: ICarsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cars = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cars"])) {
                this.cars = [] as any;
                for (let item of _data["cars"])
                    this.cars!.push(CarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CarsResponseDto {
        const json = this.toJSON();
        let result = new CarsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICarsResponseDto {
    /** returned list is not sorted */
    cars: CarDto[];
}

export class CarDto extends OverlapTimelineItem implements ICarDto {
    /** Unique internal identifier for car.
 */
    id!: string;
    legacyId!: string;
    registrationNumber?: string;
    registrationYear!: number;
    displayName!: string;
    reportingRule!: CarReportingRuleV3EnumDto;
    listPrice!: number;
    isElectric!: boolean;

    constructor(data?: ICarDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.legacyId = _data["legacyId"];
            this.registrationNumber = _data["registrationNumber"];
            this.registrationYear = _data["registrationYear"];
            this.displayName = _data["displayName"];
            this.reportingRule = _data["reportingRule"];
            this.listPrice = _data["listPrice"];
            this.isElectric = _data["isElectric"];
        }
    }

    static override fromJS(data: any): CarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["registrationNumber"] = this.registrationNumber;
        data["registrationYear"] = this.registrationYear;
        data["displayName"] = this.displayName;
        data["reportingRule"] = this.reportingRule;
        data["listPrice"] = this.listPrice;
        data["isElectric"] = this.isElectric;
        super.toJSON(data);
        return data;
    }

    clone(): CarDto {
        const json = this.toJSON();
        let result = new CarDto();
        result.init(json);
        return result;
    }
}

export interface ICarDto extends IOverlapTimelineItem {
    /** Unique internal identifier for car.
 */
    id: string;
    legacyId: string;
    registrationNumber?: string;
    registrationYear: number;
    displayName: string;
    reportingRule: CarReportingRuleV3EnumDto;
    listPrice: number;
    isElectric: boolean;
}

export class TagCreateRequestDto extends BaseActionRequestDto implements ITagCreateRequestDto {
    newData!: TagCreateRequestItemDto;

    constructor(data?: ITagCreateRequestDto) {
        super(data);
        if (!data) {
            this.newData = new TagCreateRequestItemDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newData = _data["newData"] ? TagCreateRequestItemDto.fromJS(_data["newData"]) : new TagCreateRequestItemDto();
        }
    }

    static override fromJS(data: any): TagCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TagCreateRequestDto {
        const json = this.toJSON();
        let result = new TagCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITagCreateRequestDto extends IBaseActionRequestDto {
    newData: TagCreateRequestItemDto;
}

export class TagUpdateRequestDto extends BaseActionRequestDto implements ITagUpdateRequestDto {
    oldData!: TagUpdateRequestItemDto;
    newData!: TagUpdateRequestItemDto;

    constructor(data?: ITagUpdateRequestDto) {
        super(data);
        if (!data) {
            this.oldData = new TagUpdateRequestItemDto();
            this.newData = new TagUpdateRequestItemDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldData = _data["oldData"] ? TagUpdateRequestItemDto.fromJS(_data["oldData"]) : new TagUpdateRequestItemDto();
            this.newData = _data["newData"] ? TagUpdateRequestItemDto.fromJS(_data["newData"]) : new TagUpdateRequestItemDto();
        }
    }

    static override fromJS(data: any): TagUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagUpdateRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldData"] = this.oldData ? this.oldData.toJSON() : undefined as any;
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TagUpdateRequestDto {
        const json = this.toJSON();
        let result = new TagUpdateRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITagUpdateRequestDto extends IBaseActionRequestDto {
    oldData: TagUpdateRequestItemDto;
    newData: TagUpdateRequestItemDto;
}

export class TagCreateRequestItemDto implements ITagCreateRequestItemDto {
    name!: string;
    description?: string;
    /** Tag color hex code, prefix with \#. */
    color?: string;

    constructor(data?: ITagCreateRequestItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagCreateRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreateRequestItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }

    clone(): TagCreateRequestItemDto {
        const json = this.toJSON();
        let result = new TagCreateRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface ITagCreateRequestItemDto {
    name: string;
    description?: string;
    /** Tag color hex code, prefix with \#. */
    color?: string;
}

export class TagUpdateRequestItemDto extends TagCreateRequestItemDto implements ITagUpdateRequestItemDto {
    tagId!: string;

    constructor(data?: ITagUpdateRequestItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagId = _data["tagId"];
        }
    }

    static override fromJS(data: any): TagUpdateRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagUpdateRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        super.toJSON(data);
        return data;
    }

    clone(): TagUpdateRequestItemDto {
        const json = this.toJSON();
        let result = new TagUpdateRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface ITagUpdateRequestItemDto extends ITagCreateRequestItemDto {
    tagId: string;
}

export class TagCreateOperationRequestDto extends BaseRequestDto implements ITagCreateOperationRequestDto {
    /** List of tags to create */
    items!: TagCreateOperationItemDto[];

    constructor(data?: ITagCreateOperationRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TagCreateOperationItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TagCreateOperationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreateOperationRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TagCreateOperationRequestDto {
        const json = this.toJSON();
        let result = new TagCreateOperationRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITagCreateOperationRequestDto extends IBaseRequestDto {
    /** List of tags to create */
    items: TagCreateOperationItemDto[];
}

export class TagCreateOperationItemDto implements ITagCreateOperationItemDto {
    name!: string;
    description?: string;
    /** Tag color hex code, prefix with \#. */
    color?: string;

    constructor(data?: ITagCreateOperationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagCreateOperationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreateOperationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }

    clone(): TagCreateOperationItemDto {
        const json = this.toJSON();
        let result = new TagCreateOperationItemDto();
        result.init(json);
        return result;
    }
}

export interface ITagCreateOperationItemDto {
    name: string;
    description?: string;
    /** Tag color hex code, prefix with \#. */
    color?: string;
}

/** Full information about a tag create operation */
export class TagCreateOperationDto extends OperationStateDto implements ITagCreateOperationDto {
    /** List of tag create tasks */
    tasks!: TagCreateTaskDto[];

    constructor(data?: ITagCreateOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TagCreateTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TagCreateOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreateOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TagCreateOperationDto {
        const json = this.toJSON();
        let result = new TagCreateOperationDto();
        result.init(json);
        return result;
    }
}

/** Full information about a tag create operation */
export interface ITagCreateOperationDto extends IOperationStateDto {
    /** List of tag create tasks */
    tasks: TagCreateTaskDto[];
}

export class TagCreateTaskDto extends TaskStateDto implements ITagCreateTaskDto {
    name!: string;
    description?: string;
    /** Tag color hex code, prefix with \#. */
    color?: string;

    constructor(data?: ITagCreateTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): TagCreateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreateTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }

    clone(): TagCreateTaskDto {
        const json = this.toJSON();
        let result = new TagCreateTaskDto();
        result.init(json);
        return result;
    }
}

export interface ITagCreateTaskDto extends ITaskStateDto {
    name: string;
    description?: string;
    /** Tag color hex code, prefix with \#. */
    color?: string;
}

export class TagUpdateOperationRequestDto extends BaseRequestDto implements ITagUpdateOperationRequestDto {
    /** List of tags to update */
    items!: TagUpdateOperationItemDto[];

    constructor(data?: ITagUpdateOperationRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TagUpdateOperationItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TagUpdateOperationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagUpdateOperationRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TagUpdateOperationRequestDto {
        const json = this.toJSON();
        let result = new TagUpdateOperationRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITagUpdateOperationRequestDto extends IBaseRequestDto {
    /** List of tags to update */
    items: TagUpdateOperationItemDto[];
}

export class TagUpdateOperationItemDto implements ITagUpdateOperationItemDto {
    oldData!: TagDto;
    newData!: TagDto;

    constructor(data?: ITagUpdateOperationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.oldData = new TagDto();
            this.newData = new TagDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldData = _data["oldData"] ? TagDto.fromJS(_data["oldData"]) : new TagDto();
            this.newData = _data["newData"] ? TagDto.fromJS(_data["newData"]) : new TagDto();
        }
    }

    static fromJS(data: any): TagUpdateOperationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagUpdateOperationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldData"] = this.oldData ? this.oldData.toJSON() : undefined as any;
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        return data;
    }

    clone(): TagUpdateOperationItemDto {
        const json = this.toJSON();
        let result = new TagUpdateOperationItemDto();
        result.init(json);
        return result;
    }
}

export interface ITagUpdateOperationItemDto {
    oldData: TagDto;
    newData: TagDto;
}

/** Full information about a tag update operation */
export class TagUpdateOperationDto extends OperationStateDto implements ITagUpdateOperationDto {
    /** List of tag update tasks */
    tasks!: TagUpdateTaskDto[];

    constructor(data?: ITagUpdateOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TagUpdateTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TagUpdateOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagUpdateOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TagUpdateOperationDto {
        const json = this.toJSON();
        let result = new TagUpdateOperationDto();
        result.init(json);
        return result;
    }
}

/** Full information about a tag update operation */
export interface ITagUpdateOperationDto extends IOperationStateDto {
    /** List of tag update tasks */
    tasks: TagUpdateTaskDto[];
}

export class TagUpdateTaskDto extends TaskStateDto implements ITagUpdateTaskDto {
    oldData!: TagDto;
    newData!: TagDto;

    constructor(data?: ITagUpdateTaskDto) {
        super(data);
        if (!data) {
            this.oldData = new TagDto();
            this.newData = new TagDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldData = _data["oldData"] ? TagDto.fromJS(_data["oldData"]) : new TagDto();
            this.newData = _data["newData"] ? TagDto.fromJS(_data["newData"]) : new TagDto();
        }
    }

    static override fromJS(data: any): TagUpdateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagUpdateTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldData"] = this.oldData ? this.oldData.toJSON() : undefined as any;
        data["newData"] = this.newData ? this.newData.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TagUpdateTaskDto {
        const json = this.toJSON();
        let result = new TagUpdateTaskDto();
        result.init(json);
        return result;
    }
}

export interface ITagUpdateTaskDto extends ITaskStateDto {
    oldData: TagDto;
    newData: TagDto;
}

export class SessionDto implements ISessionDto {
    odpUserId!: number;
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    userName!: string;
    /** Value resolved in this order: # Value of optionalOrg query parameter, if supplied.
  If user does not have access to that OdpOrgId, 403 will be returned.
# IDS value of lastUsedContext for empman, if it can be retrieved quickly and is in `availableContexts`. # Any value from `availableContexts`.
  If user does not have access to any organization, 403 will be returned.
 */
    lastUsedContextId!: number;
    /** Company contexts where user is an employee administrator. */
    availableContexts!: OrgContextDto[];
    languageCode!: string;
    countryCode!: string;

    constructor(data?: ISessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.availableContexts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odpUserId = _data["odpUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.lastUsedContextId = _data["lastUsedContextId"];
            if (Array.isArray(_data["availableContexts"])) {
                this.availableContexts = [] as any;
                for (let item of _data["availableContexts"])
                    this.availableContexts!.push(OrgContextDto.fromJS(item));
            }
            this.languageCode = _data["languageCode"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): SessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odpUserId"] = this.odpUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["lastUsedContextId"] = this.lastUsedContextId;
        if (Array.isArray(this.availableContexts)) {
            data["availableContexts"] = [];
            for (let item of this.availableContexts)
                data["availableContexts"].push(item ? item.toJSON() : undefined as any);
        }
        data["languageCode"] = this.languageCode;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): SessionDto {
        const json = this.toJSON();
        let result = new SessionDto();
        result.init(json);
        return result;
    }
}

export interface ISessionDto {
    odpUserId: number;
    firstName: string;
    lastName: string;
    emailAddress: string;
    userName: string;
    /** Value resolved in this order: # Value of optionalOrg query parameter, if supplied.
  If user does not have access to that OdpOrgId, 403 will be returned.
# IDS value of lastUsedContext for empman, if it can be retrieved quickly and is in `availableContexts`. # Any value from `availableContexts`.
  If user does not have access to any organization, 403 will be returned.
 */
    lastUsedContextId: number;
    /** Company contexts where user is an employee administrator. */
    availableContexts: OrgContextDto[];
    languageCode: string;
    countryCode: string;
}

export class OrgContextDto implements IOrgContextDto {
    id!: number;
    name!: string;

    constructor(data?: IOrgContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrgContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): OrgContextDto {
        const json = this.toJSON();
        let result = new OrgContextDto();
        result.init(json);
        return result;
    }
}

export interface IOrgContextDto {
    id: number;
    name: string;
}

export class MenuItemsResponseDto implements IMenuItemsResponseDto {
    menuItems?: MenuItemDto[];

    constructor(data?: IMenuItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MenuItemsResponseDto {
        const json = this.toJSON();
        let result = new MenuItemsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IMenuItemsResponseDto {
    menuItems?: MenuItemDto[];
}

export class MenuItemDto implements IMenuItemDto {
    name!: string;
    url!: string;
    webApplicationUri!: string;
    idApplicationModule!: number;
    menuSortOrder!: number;

    constructor(data?: IMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.webApplicationUri = _data["webApplicationUri"];
            this.idApplicationModule = _data["idApplicationModule"];
            this.menuSortOrder = _data["menuSortOrder"];
        }
    }

    static fromJS(data: any): MenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["webApplicationUri"] = this.webApplicationUri;
        data["idApplicationModule"] = this.idApplicationModule;
        data["menuSortOrder"] = this.menuSortOrder;
        return data;
    }

    clone(): MenuItemDto {
        const json = this.toJSON();
        let result = new MenuItemDto();
        result.init(json);
        return result;
    }
}

export interface IMenuItemDto {
    name: string;
    url: string;
    webApplicationUri: string;
    idApplicationModule: number;
    menuSortOrder: number;
}

/** Operation without tasks or operation specific data. */
export class OperationOverviewDto implements IOperationOverviewDto {
    /** Operation id */
    id!: string;
    /** Date time when the operation was started in the backend. */
    createdTime!: Date;
    operationType!: OperationTypeEnum;
    status!: OperationStatusEnum;
    taskCount!: number;
    failedTaskCount!: number;
    succeededTaskCount!: number;
    pollingTimeoutTaskCount!: number;

    constructor(data?: IOperationOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : undefined as any;
            this.operationType = _data["operationType"];
            this.status = _data["status"];
            this.taskCount = _data["taskCount"];
            this.failedTaskCount = _data["failedTaskCount"];
            this.succeededTaskCount = _data["succeededTaskCount"];
            this.pollingTimeoutTaskCount = _data["pollingTimeoutTaskCount"];
        }
    }

    static fromJS(data: any): OperationOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : undefined as any;
        data["operationType"] = this.operationType;
        data["status"] = this.status;
        data["taskCount"] = this.taskCount;
        data["failedTaskCount"] = this.failedTaskCount;
        data["succeededTaskCount"] = this.succeededTaskCount;
        data["pollingTimeoutTaskCount"] = this.pollingTimeoutTaskCount;
        return data;
    }

    clone(): OperationOverviewDto {
        const json = this.toJSON();
        let result = new OperationOverviewDto();
        result.init(json);
        return result;
    }
}

/** Operation without tasks or operation specific data. */
export interface IOperationOverviewDto {
    /** Operation id */
    id: string;
    /** Date time when the operation was started in the backend. */
    createdTime: Date;
    operationType: OperationTypeEnum;
    status: OperationStatusEnum;
    taskCount: number;
    failedTaskCount: number;
    succeededTaskCount: number;
    pollingTimeoutTaskCount: number;
}

/** Paginated list of operations with optional filtering */
export class OperationsPagedResponseDto implements IOperationsPagedResponseDto {
    operations!: OperationOverviewDto[];
    /** Token to fetch the next page. Absent when no more data. */
    nextToken?: string;

    constructor(data?: IOperationsPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.operations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(OperationOverviewDto.fromJS(item));
            }
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): OperationsPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextToken"] = this.nextToken;
        return data;
    }

    clone(): OperationsPagedResponseDto {
        const json = this.toJSON();
        let result = new OperationsPagedResponseDto();
        result.init(json);
        return result;
    }
}

/** Paginated list of operations with optional filtering */
export interface IOperationsPagedResponseDto {
    operations: OperationOverviewDto[];
    /** Token to fetch the next page. Absent when no more data. */
    nextToken?: string;
}

export class WsConnectionsDto implements IWsConnectionsDto {
    connections?: WsConnectionDto[];

    constructor(data?: IWsConnectionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connections"])) {
                this.connections = [] as any;
                for (let item of _data["connections"])
                    this.connections!.push(WsConnectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WsConnectionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WsConnectionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connections)) {
            data["connections"] = [];
            for (let item of this.connections)
                data["connections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): WsConnectionsDto {
        const json = this.toJSON();
        let result = new WsConnectionsDto();
        result.init(json);
        return result;
    }
}

export interface IWsConnectionsDto {
    connections?: WsConnectionDto[];
}

export class WsConnectionDto implements IWsConnectionDto {
    connectionId!: string;
    /** When the connection was created. */
    createdTimeIso!: string;
    odpUserId!: string;
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: IWsConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["connectionId"];
            this.createdTimeIso = _data["createdTimeIso"];
            this.odpUserId = _data["odpUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): WsConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WsConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionId"] = this.connectionId;
        data["createdTimeIso"] = this.createdTimeIso;
        data["odpUserId"] = this.odpUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }

    clone(): WsConnectionDto {
        const json = this.toJSON();
        let result = new WsConnectionDto();
        result.init(json);
        return result;
    }
}

export interface IWsConnectionDto {
    connectionId: string;
    /** When the connection was created. */
    createdTimeIso: string;
    odpUserId: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class DeleteTenantsResponseDto implements IDeleteTenantsResponseDto {
    message!: string;
    /** Number of tenant IDs in the request. */
    requestCount?: number;
    /** Number of tenants that were considered for deletion.

If this is less than `requestCount`, you must discard this number of tenants from the top of the list and resubmit the rest.
 */
    processedCount?: number;
    /** Number of tenants that were found in the database and enqueued for deletion.

A maximum of 300 tenants can enqueued at once. You should wait at least 5 minutes before submitting more.

It might make sense to request more tenants at once because
those with no data are discarded immediately instead of enqueued.
 */
    enqueuedCount?: number;

    constructor(data?: IDeleteTenantsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.requestCount = _data["requestCount"];
            this.processedCount = _data["processedCount"];
            this.enqueuedCount = _data["enqueuedCount"];
        }
    }

    static fromJS(data: any): DeleteTenantsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTenantsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["requestCount"] = this.requestCount;
        data["processedCount"] = this.processedCount;
        data["enqueuedCount"] = this.enqueuedCount;
        return data;
    }

    clone(): DeleteTenantsResponseDto {
        const json = this.toJSON();
        let result = new DeleteTenantsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteTenantsResponseDto {
    message: string;
    /** Number of tenant IDs in the request. */
    requestCount?: number;
    /** Number of tenants that were considered for deletion.

If this is less than `requestCount`, you must discard this number of tenants from the top of the list and resubmit the rest.
 */
    processedCount?: number;
    /** Number of tenants that were found in the database and enqueued for deletion.

A maximum of 300 tenants can enqueued at once. You should wait at least 5 minutes before submitting more.

It might make sense to request more tenants at once because
those with no data are discarded immediately instead of enqueued.
 */
    enqueuedCount?: number;
}

export class StartDatabaseMigrationRequestDto implements IStartDatabaseMigrationRequestDto {
    dryRun!: boolean;
    reason!: string;
    exclusiveStart?: StartDatabaseMigrationExclusiveStart;

    constructor(data?: IStartDatabaseMigrationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dryRun = _data["dryRun"];
            this.reason = _data["reason"];
            this.exclusiveStart = _data["exclusiveStart"] ? StartDatabaseMigrationExclusiveStart.fromJS(_data["exclusiveStart"]) : undefined as any;
        }
    }

    static fromJS(data: any): StartDatabaseMigrationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartDatabaseMigrationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun;
        data["reason"] = this.reason;
        data["exclusiveStart"] = this.exclusiveStart ? this.exclusiveStart.toJSON() : undefined as any;
        return data;
    }

    clone(): StartDatabaseMigrationRequestDto {
        const json = this.toJSON();
        let result = new StartDatabaseMigrationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IStartDatabaseMigrationRequestDto {
    dryRun: boolean;
    reason: string;
    exclusiveStart?: StartDatabaseMigrationExclusiveStart;
}

/** Optional key to continue a previously failed migration. If not specified, the scan will start from the beginning of the database. */
export class StartDatabaseMigrationExclusiveStart implements IStartDatabaseMigrationExclusiveStart {
    /** Partition key of the last item processed in the failed attempt. */
    pk!: string;
    /** Sort key of the last item processed in the failed attempt. */
    sk!: string;

    constructor(data?: IStartDatabaseMigrationExclusiveStart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.sk = _data["sk"];
        }
    }

    static fromJS(data: any): StartDatabaseMigrationExclusiveStart {
        data = typeof data === 'object' ? data : {};
        let result = new StartDatabaseMigrationExclusiveStart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["sk"] = this.sk;
        return data;
    }

    clone(): StartDatabaseMigrationExclusiveStart {
        const json = this.toJSON();
        let result = new StartDatabaseMigrationExclusiveStart();
        result.init(json);
        return result;
    }
}

/** Optional key to continue a previously failed migration. If not specified, the scan will start from the beginning of the database. */
export interface IStartDatabaseMigrationExclusiveStart {
    /** Partition key of the last item processed in the failed attempt. */
    pk: string;
    /** Sort key of the last item processed in the failed attempt. */
    sk: string;
}

export class TransactionsResponseDto implements ITransactionsResponseDto {
    /** Set if and only if there are more transactions available. Use this token to fetch the next page of transactions. Maximum amount of transactions returned in one page is 500
 */
    nextToken?: string;
    /** List of transactions */
    transactions?: TransactionDto[];

    constructor(data?: ITransactionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextToken = _data["nextToken"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(TransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextToken"] = this.nextToken;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TransactionsResponseDto {
        const json = this.toJSON();
        let result = new TransactionsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionsResponseDto {
    /** Set if and only if there are more transactions available. Use this token to fetch the next page of transactions. Maximum amount of transactions returned in one page is 500
 */
    nextToken?: string;
    /** List of transactions */
    transactions?: TransactionDto[];
}

/** A transaction doesn't have a timeline, but a date range where it is applied. */
export class TransactionDto implements ITransactionDto {
    /** Unique transaction id */
    id!: string;
    employeeId!: string;
    positionId?: string;
    paycodeId!: string;
    description?: string;
    /** Start date of the transaction */
    activeStart!: Date;
    /** End date of the transaction (inclusive). Not set means the transactions recurs forever. */
    activeEnd?: Date;
    /** Replaced by `fields` */
    factor?: number;
    /** Replaced by `fields` */
    quantity?: number;
    /** Replaced by `fields` */
    price?: number;
    /** Replaced by `fields` */
    totalPrice?: number;
    fields?: TransactionFieldsDto;
    /** transaction cost units */
    costUnits?: CostUnitForTransactionDto[];
    additionalInfo?: AdditionalInfoForTransactionDto;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.positionId = _data["positionId"];
            this.paycodeId = _data["paycodeId"];
            this.description = _data["description"];
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.factor = _data["factor"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.totalPrice = _data["totalPrice"];
            this.fields = _data["fields"] ? TransactionFieldsDto.fromJS(_data["fields"]) : undefined as any;
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
            this.additionalInfo = _data["additionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["additionalInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["positionId"] = this.positionId;
        data["paycodeId"] = this.paycodeId;
        data["description"] = this.description;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["factor"] = this.factor;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        data["fields"] = this.fields ? this.fields.toJSON() : undefined as any;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : undefined as any;
        return data;
    }

    clone(): TransactionDto {
        const json = this.toJSON();
        let result = new TransactionDto();
        result.init(json);
        return result;
    }
}

/** A transaction doesn't have a timeline, but a date range where it is applied. */
export interface ITransactionDto {
    /** Unique transaction id */
    id: string;
    employeeId: string;
    positionId?: string;
    paycodeId: string;
    description?: string;
    /** Start date of the transaction */
    activeStart: Date;
    /** End date of the transaction (inclusive). Not set means the transactions recurs forever. */
    activeEnd?: Date;
    /** Replaced by `fields` */
    factor?: number;
    /** Replaced by `fields` */
    quantity?: number;
    /** Replaced by `fields` */
    price?: number;
    /** Replaced by `fields` */
    totalPrice?: number;
    fields?: TransactionFieldsDto;
    /** transaction cost units */
    costUnits?: CostUnitForTransactionDto[];
    additionalInfo?: AdditionalInfoForTransactionDto;
}

export class CostUnitForTransactionDto implements ICostUnitForTransactionDto {
    /** Must be unique. */
    typeCustomId!: string;
    values!: CostUnitValuesForTransactionDto[];

    constructor(data?: ICostUnitForTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCustomId = _data["typeCustomId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(CostUnitValuesForTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostUnitForTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitForTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCustomId"] = this.typeCustomId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CostUnitForTransactionDto {
        const json = this.toJSON();
        let result = new CostUnitForTransactionDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitForTransactionDto {
    /** Must be unique. */
    typeCustomId: string;
    values: CostUnitValuesForTransactionDto[];
}

export class CostUnitValuesForTransactionDto implements ICostUnitValuesForTransactionDto {
    customId!: string;
    /** Must sum to 100 for any given type.

All types that have multiple values must have the same percentages in the same order.
This is a restriction in the calculation engine which does not make business sense
because there is no reason different types would be split into the same percentages.
The UI may support only splitting values a single type.
End users are encouraged to split by instead creating multiple transactions.
 */
    percentage!: string;

    constructor(data?: ICostUnitValuesForTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customId = _data["customId"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): CostUnitValuesForTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostUnitValuesForTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customId"] = this.customId;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): CostUnitValuesForTransactionDto {
        const json = this.toJSON();
        let result = new CostUnitValuesForTransactionDto();
        result.init(json);
        return result;
    }
}

export interface ICostUnitValuesForTransactionDto {
    customId: string;
    /** Must sum to 100 for any given type.

All types that have multiple values must have the same percentages in the same order.
This is a restriction in the calculation engine which does not make business sense
because there is no reason different types would be split into the same percentages.
The UI may support only splitting values a single type.
End users are encouraged to split by instead creating multiple transactions.
 */
    percentage: string;
}

/** Additional info set on the transaction. See `additionalInfo` on paycode for which info are required, optional and prohibited. Note that the requiredness does not indicate that the info is necessarily present/absent on the transaction, but that calculation/reporting will fail if transaction info does not follow the requiredness. Transaction API has untyped data, but here its identifiers are mapped to named and typed properties. Only additional info expected to be found on fixed transactions have been mapped. But some transactions may have more additional info than expected. Those are listed in `unsupported`. See also `unsupportedAdditionalInfo` on paycodes. If `unsupported` is set, it must be conveyed back to the server unchanged. It must not be set when creating new transactions. All properties, including `unsupported` are only set if they have a value. */
export class AdditionalInfoForTransactionDto implements IAdditionalInfoForTransactionDto {
    /** Municipality code.

Known values are available as
[employerFeeZoneAssignmentCodeJsonFile](https://static-json.no.visma.net/?urls.primaryName=Employer+fee+zone+assignment+codes).

___
Monolith notes: Identifier 1000

Uses reference table 30010 Municipality.
___
 */
    employerFeeZoneAssignmentCode?: string;
    /** Employer fee zone.

A-message code type `Arbeidsgiveravgiftsone`.

Allowed values are `'1'`, `'1a'`, `'2'`, `'3'`, `'4'`, `'4a'` and `'5'`.

See https://www.skatteetaten.no/satser/arbeidsgiveravgift-soneinndeling/

___
Monolith notes: Identifier 1010

This probably should have been a reference table, but it is a string.
___
 */
    employerFeeZone?: string;
    /** VAT code.

___
Monolith notes: Identifier 1100
___
 */
    vatCode?: string;
    /** Number of journeys (car and boat).

___
Monolith notes: Identifier 1130
___
 */
    journeyCountCarAndBoat?: string;
    /** Tax country of residence.

Known values are available as
[countryCodeJsonFile](https://static-json.no.visma.net/?urls.primaryName=Country+codes).

___
Monolith notes: Identifier 2100
Uses reference table 20000 Country.
___
 */
    taxCountry?: string;
    /** Earned on continental shelf.

___
Monolith notes: Identifier 2200

Uses reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isEarnedOffshore?: boolean;
    /** Country code.

Known values are available as
[countryCodeJsonFile](https://static-json.no.visma.net/?urls.primaryName=Country+codes).

___
Monolith notes: Identifier 2300
Uses reference table 20000 Country.
___
 */
    earningCountry?: string;
    /** Special condition for earning.

___
Monolith notes: Identifier 2400

Uses reference table 41000 Special conditions for earnings
___
 */
    earningSpecialCondition?: EarningSpecialConditionV3EnumDto;
    /** Gross up table number.

See https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/salary-and-benefits/overview-of-salary-and-other-benefits/net-salary-arrangement-expense-allowances-subject-to-withholding-tax-for-work-performed-in-norway/

___
Monolith notes: Identifier 2800
___
 */
    grossUpTableNumber?: string;
    /** Leave type.

___
Monolith notes: Identifier 3000

This probably should have been a reference table, but it is a string.

For built-in paycodes, this is only used by calendar when transforming absence registrations.

This seems like a-message code type `PermisjonsOgPermitteringsBeskrivelse`.
That corresponds to reference table 80080 Type of absence, although its keys are different.
However, the values set by calendar are dissimilar to both.

| A-message code                   | RT key | 3000 value from calendar             | A-message description                | 80080 description                                   | A-message valid-to |
| -------------------------------- | ------ | ------------------------------------ | ------------------------------------ | --------------------------------------------------- | ------------------ |
| permisjon                        | Abs    |                                      | Permisjon                            | Permisjon - Ikke i bruk etter 31.12.2017            | 2018-01            |
| permittering                     | Red    |                                      | Permittering                         | Permittering                                        | 2030-01            |
| permisjonMedForeldrepenger       | Par    | [couldn't generate transaction]      | Permisjon med foreldrepenger         | Permisjon med foreldrepenger                        |                    |
| permisjonVedMilitaertjeneste     | Mil    | permisjon ved militærtjenste         | Permisjon ved militærtjeneste        | Permisjon ved militærtjeneste                       |                    |
| utdanningspermisjon              | Edu    |                                      | Utdanningspermisjon                  | Utdanningspermisjon - Ikke i bruk etter 31.12.2022  | 2023-01            |
| velferdspermisjon                | Oth    |                                      | Velferdspermisjon                    | Velferdspermisjon - Ikke i bruk etter 31.12.2022    | 2023-01            |
| andreLovfestedePermisjoner       | Ots    | andre lovfestede permisjoner         | Andre lovfestede permisjoner         | Andre lovfestede permisjoner                        |                    |
| andreIkkeLovfestedePermisjoner   | Otn    | andre ikke lovfestede permisjoner    | Andre ikke-lovfestede permisjoner    | Andre ikke lovfestede permisjoner                   |                    |
| utdanningspermisjonLovfestet     | Els    | utdanningspermisjon (lovfestet)      | Utdanningspermisjon (Lovfestet)      | Utdanningspermisjon lovfestet                       |                    |
| utdanningspermisjonIkkeLovfestet | Eln    | utdanningspermisjon (ikke lovfestet) | Utdanningspermisjon (Ikke lovfestet) | Utdanningspermisjon ikke lovfestet                  |                    |
___
 */
    leaveType?: string;
    /** FNO status.

___
Monolith notes: Identifier 3100

This probably should have been a reference table, but it is a string.

For built-in paycodes, this is only used by calendar when transforming absence registrations.

Observed values are `'LP'` and `'AP'`.
___
 */
    fnoStatus?: string;
    /** Reported quantity

___
Monolith notes: Identifier 4010
___
 */
    quantityReportOverride?: string;
    /** Number of days participated.

___
Monolith notes: Identifier 5000
___
 */
    dayCountFishingParticipation?: string;
    /** Number of days onboard.

___
Monolith notes: Identifier 5010
___
 */
    dayCountOnboard?: string;
    /** Start date Continental shelf.

___
Monolith notes: Identifier 5140
___
 */
    offshoreFrom?: Date;
    /** End date Continental shelf.

___
Monolith notes: Identifier 5180
___
 */
    offshoreTo?: Date;
    /** Reporting code description.

A-message code type `Loennsbeskrivelse`.

Currently has 82 possible values, see https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.skatteetaten.no%2Fcontentassets%2Fe72315197e7a4e49b000a6e33fda1642%2Fkodeliste-r2-2025.xlsx

___
Monolith notes: Identifier 9020

This probably should have been a reference table, but it is a string.
___
 */
    wageDescriptionCode?: string;
    /** Add info start date pension.

___
Monolith notes: Identifier 9230
___
 */
    pensionFrom?: Date;
    /** Add info end date pension.

___
Monolith notes: Identifier 9240
___
 */
    pensionTo?: Date;
    /** Used to mention whether the pension amount is changed because of correction or back payment.

___
Monolith notes: Identifier 9250

Uses reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isPensionCorrection?: boolean;
    /** Retirement percentage.
Must be one of 20, 40, 60, 80, 100 and 50.

___
Monolith notes: Identifier 

Uses reference table 80270 Retirement percentage
___
 */
    retirementPercentage?: string;
    /** Start amount for loan from employer.

___
Monolith notes: Identifier 10100
___
 */
    employerLoanStartAmount?: string;
    /** Interest for loan from employer.

___
Monolith notes: Identifier 10110
___
 */
    employerLoanInterestPercent?: string;
    /** Known values are listed in [personTypeV3EnumDto](#model-personTypeV3EnumDto)
but client must also gracefully accept other values and not modify them unless the user requests it.

___
Monolith notes: Identifier 20000

Uses reference table 99010 Add info - Type of Person
___
 */
    typeOfPerson?: string;
    /** Enforced payment date.
___
Monolith notes: Identifier 999990
___
 */
    paymentDateOverride?: Date;
    unsupported?: UnsupportedAdditionalInfoForTransactionDto[];

    constructor(data?: IAdditionalInfoForTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerFeeZoneAssignmentCode = _data["employerFeeZoneAssignmentCode"];
            this.employerFeeZone = _data["employerFeeZone"];
            this.vatCode = _data["vatCode"];
            this.journeyCountCarAndBoat = _data["journeyCountCarAndBoat"];
            this.taxCountry = _data["taxCountry"];
            this.isEarnedOffshore = _data["isEarnedOffshore"];
            this.earningCountry = _data["earningCountry"];
            this.earningSpecialCondition = _data["earningSpecialCondition"];
            this.grossUpTableNumber = _data["grossUpTableNumber"];
            this.leaveType = _data["leaveType"];
            this.fnoStatus = _data["fnoStatus"];
            this.quantityReportOverride = _data["quantityReportOverride"];
            this.dayCountFishingParticipation = _data["dayCountFishingParticipation"];
            this.dayCountOnboard = _data["dayCountOnboard"];
            this.offshoreFrom = _data["offshoreFrom"] ? new Date(_data["offshoreFrom"].toString()) : undefined as any;
            this.offshoreTo = _data["offshoreTo"] ? new Date(_data["offshoreTo"].toString()) : undefined as any;
            this.wageDescriptionCode = _data["wageDescriptionCode"];
            this.pensionFrom = _data["pensionFrom"] ? new Date(_data["pensionFrom"].toString()) : undefined as any;
            this.pensionTo = _data["pensionTo"] ? new Date(_data["pensionTo"].toString()) : undefined as any;
            this.isPensionCorrection = _data["isPensionCorrection"];
            this.retirementPercentage = _data["retirementPercentage"];
            this.employerLoanStartAmount = _data["employerLoanStartAmount"];
            this.employerLoanInterestPercent = _data["employerLoanInterestPercent"];
            this.typeOfPerson = _data["typeOfPerson"];
            this.paymentDateOverride = _data["paymentDateOverride"] ? new Date(_data["paymentDateOverride"].toString()) : undefined as any;
            if (Array.isArray(_data["unsupported"])) {
                this.unsupported = [] as any;
                for (let item of _data["unsupported"])
                    this.unsupported!.push(UnsupportedAdditionalInfoForTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdditionalInfoForTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfoForTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerFeeZoneAssignmentCode"] = this.employerFeeZoneAssignmentCode;
        data["employerFeeZone"] = this.employerFeeZone;
        data["vatCode"] = this.vatCode;
        data["journeyCountCarAndBoat"] = this.journeyCountCarAndBoat;
        data["taxCountry"] = this.taxCountry;
        data["isEarnedOffshore"] = this.isEarnedOffshore;
        data["earningCountry"] = this.earningCountry;
        data["earningSpecialCondition"] = this.earningSpecialCondition;
        data["grossUpTableNumber"] = this.grossUpTableNumber;
        data["leaveType"] = this.leaveType;
        data["fnoStatus"] = this.fnoStatus;
        data["quantityReportOverride"] = this.quantityReportOverride;
        data["dayCountFishingParticipation"] = this.dayCountFishingParticipation;
        data["dayCountOnboard"] = this.dayCountOnboard;
        data["offshoreFrom"] = this.offshoreFrom ? formatDate(this.offshoreFrom) : undefined as any;
        data["offshoreTo"] = this.offshoreTo ? formatDate(this.offshoreTo) : undefined as any;
        data["wageDescriptionCode"] = this.wageDescriptionCode;
        data["pensionFrom"] = this.pensionFrom ? formatDate(this.pensionFrom) : undefined as any;
        data["pensionTo"] = this.pensionTo ? formatDate(this.pensionTo) : undefined as any;
        data["isPensionCorrection"] = this.isPensionCorrection;
        data["retirementPercentage"] = this.retirementPercentage;
        data["employerLoanStartAmount"] = this.employerLoanStartAmount;
        data["employerLoanInterestPercent"] = this.employerLoanInterestPercent;
        data["typeOfPerson"] = this.typeOfPerson;
        data["paymentDateOverride"] = this.paymentDateOverride ? formatDate(this.paymentDateOverride) : undefined as any;
        if (Array.isArray(this.unsupported)) {
            data["unsupported"] = [];
            for (let item of this.unsupported)
                data["unsupported"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AdditionalInfoForTransactionDto {
        const json = this.toJSON();
        let result = new AdditionalInfoForTransactionDto();
        result.init(json);
        return result;
    }
}

/** Additional info set on the transaction. See `additionalInfo` on paycode for which info are required, optional and prohibited. Note that the requiredness does not indicate that the info is necessarily present/absent on the transaction, but that calculation/reporting will fail if transaction info does not follow the requiredness. Transaction API has untyped data, but here its identifiers are mapped to named and typed properties. Only additional info expected to be found on fixed transactions have been mapped. But some transactions may have more additional info than expected. Those are listed in `unsupported`. See also `unsupportedAdditionalInfo` on paycodes. If `unsupported` is set, it must be conveyed back to the server unchanged. It must not be set when creating new transactions. All properties, including `unsupported` are only set if they have a value. */
export interface IAdditionalInfoForTransactionDto {
    /** Municipality code.

Known values are available as
[employerFeeZoneAssignmentCodeJsonFile](https://static-json.no.visma.net/?urls.primaryName=Employer+fee+zone+assignment+codes).

___
Monolith notes: Identifier 1000

Uses reference table 30010 Municipality.
___
 */
    employerFeeZoneAssignmentCode?: string;
    /** Employer fee zone.

A-message code type `Arbeidsgiveravgiftsone`.

Allowed values are `'1'`, `'1a'`, `'2'`, `'3'`, `'4'`, `'4a'` and `'5'`.

See https://www.skatteetaten.no/satser/arbeidsgiveravgift-soneinndeling/

___
Monolith notes: Identifier 1010

This probably should have been a reference table, but it is a string.
___
 */
    employerFeeZone?: string;
    /** VAT code.

___
Monolith notes: Identifier 1100
___
 */
    vatCode?: string;
    /** Number of journeys (car and boat).

___
Monolith notes: Identifier 1130
___
 */
    journeyCountCarAndBoat?: string;
    /** Tax country of residence.

Known values are available as
[countryCodeJsonFile](https://static-json.no.visma.net/?urls.primaryName=Country+codes).

___
Monolith notes: Identifier 2100
Uses reference table 20000 Country.
___
 */
    taxCountry?: string;
    /** Earned on continental shelf.

___
Monolith notes: Identifier 2200

Uses reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isEarnedOffshore?: boolean;
    /** Country code.

Known values are available as
[countryCodeJsonFile](https://static-json.no.visma.net/?urls.primaryName=Country+codes).

___
Monolith notes: Identifier 2300
Uses reference table 20000 Country.
___
 */
    earningCountry?: string;
    /** Special condition for earning.

___
Monolith notes: Identifier 2400

Uses reference table 41000 Special conditions for earnings
___
 */
    earningSpecialCondition?: EarningSpecialConditionV3EnumDto;
    /** Gross up table number.

See https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/salary-and-benefits/overview-of-salary-and-other-benefits/net-salary-arrangement-expense-allowances-subject-to-withholding-tax-for-work-performed-in-norway/

___
Monolith notes: Identifier 2800
___
 */
    grossUpTableNumber?: string;
    /** Leave type.

___
Monolith notes: Identifier 3000

This probably should have been a reference table, but it is a string.

For built-in paycodes, this is only used by calendar when transforming absence registrations.

This seems like a-message code type `PermisjonsOgPermitteringsBeskrivelse`.
That corresponds to reference table 80080 Type of absence, although its keys are different.
However, the values set by calendar are dissimilar to both.

| A-message code                   | RT key | 3000 value from calendar             | A-message description                | 80080 description                                   | A-message valid-to |
| -------------------------------- | ------ | ------------------------------------ | ------------------------------------ | --------------------------------------------------- | ------------------ |
| permisjon                        | Abs    |                                      | Permisjon                            | Permisjon - Ikke i bruk etter 31.12.2017            | 2018-01            |
| permittering                     | Red    |                                      | Permittering                         | Permittering                                        | 2030-01            |
| permisjonMedForeldrepenger       | Par    | [couldn't generate transaction]      | Permisjon med foreldrepenger         | Permisjon med foreldrepenger                        |                    |
| permisjonVedMilitaertjeneste     | Mil    | permisjon ved militærtjenste         | Permisjon ved militærtjeneste        | Permisjon ved militærtjeneste                       |                    |
| utdanningspermisjon              | Edu    |                                      | Utdanningspermisjon                  | Utdanningspermisjon - Ikke i bruk etter 31.12.2022  | 2023-01            |
| velferdspermisjon                | Oth    |                                      | Velferdspermisjon                    | Velferdspermisjon - Ikke i bruk etter 31.12.2022    | 2023-01            |
| andreLovfestedePermisjoner       | Ots    | andre lovfestede permisjoner         | Andre lovfestede permisjoner         | Andre lovfestede permisjoner                        |                    |
| andreIkkeLovfestedePermisjoner   | Otn    | andre ikke lovfestede permisjoner    | Andre ikke-lovfestede permisjoner    | Andre ikke lovfestede permisjoner                   |                    |
| utdanningspermisjonLovfestet     | Els    | utdanningspermisjon (lovfestet)      | Utdanningspermisjon (Lovfestet)      | Utdanningspermisjon lovfestet                       |                    |
| utdanningspermisjonIkkeLovfestet | Eln    | utdanningspermisjon (ikke lovfestet) | Utdanningspermisjon (Ikke lovfestet) | Utdanningspermisjon ikke lovfestet                  |                    |
___
 */
    leaveType?: string;
    /** FNO status.

___
Monolith notes: Identifier 3100

This probably should have been a reference table, but it is a string.

For built-in paycodes, this is only used by calendar when transforming absence registrations.

Observed values are `'LP'` and `'AP'`.
___
 */
    fnoStatus?: string;
    /** Reported quantity

___
Monolith notes: Identifier 4010
___
 */
    quantityReportOverride?: string;
    /** Number of days participated.

___
Monolith notes: Identifier 5000
___
 */
    dayCountFishingParticipation?: string;
    /** Number of days onboard.

___
Monolith notes: Identifier 5010
___
 */
    dayCountOnboard?: string;
    /** Start date Continental shelf.

___
Monolith notes: Identifier 5140
___
 */
    offshoreFrom?: Date;
    /** End date Continental shelf.

___
Monolith notes: Identifier 5180
___
 */
    offshoreTo?: Date;
    /** Reporting code description.

A-message code type `Loennsbeskrivelse`.

Currently has 82 possible values, see https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.skatteetaten.no%2Fcontentassets%2Fe72315197e7a4e49b000a6e33fda1642%2Fkodeliste-r2-2025.xlsx

___
Monolith notes: Identifier 9020

This probably should have been a reference table, but it is a string.
___
 */
    wageDescriptionCode?: string;
    /** Add info start date pension.

___
Monolith notes: Identifier 9230
___
 */
    pensionFrom?: Date;
    /** Add info end date pension.

___
Monolith notes: Identifier 9240
___
 */
    pensionTo?: Date;
    /** Used to mention whether the pension amount is changed because of correction or back payment.

___
Monolith notes: Identifier 9250

Uses reference table 10040 No / Yes:
- `false`: `No` (or anything which is not `Yes`)
- `true`: `Yes`
___
 */
    isPensionCorrection?: boolean;
    /** Retirement percentage.
Must be one of 20, 40, 60, 80, 100 and 50.

___
Monolith notes: Identifier 

Uses reference table 80270 Retirement percentage
___
 */
    retirementPercentage?: string;
    /** Start amount for loan from employer.

___
Monolith notes: Identifier 10100
___
 */
    employerLoanStartAmount?: string;
    /** Interest for loan from employer.

___
Monolith notes: Identifier 10110
___
 */
    employerLoanInterestPercent?: string;
    /** Known values are listed in [personTypeV3EnumDto](#model-personTypeV3EnumDto)
but client must also gracefully accept other values and not modify them unless the user requests it.

___
Monolith notes: Identifier 20000

Uses reference table 99010 Add info - Type of Person
___
 */
    typeOfPerson?: string;
    /** Enforced payment date.
___
Monolith notes: Identifier 999990
___
 */
    paymentDateOverride?: Date;
    unsupported?: UnsupportedAdditionalInfoForTransactionDto[];
}

export class UnsupportedAdditionalInfoForTransactionDto implements IUnsupportedAdditionalInfoForTransactionDto {
    identifier!: string;
    value!: string;

    constructor(data?: IUnsupportedAdditionalInfoForTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UnsupportedAdditionalInfoForTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnsupportedAdditionalInfoForTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["value"] = this.value;
        return data;
    }

    clone(): UnsupportedAdditionalInfoForTransactionDto {
        const json = this.toJSON();
        let result = new UnsupportedAdditionalInfoForTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IUnsupportedAdditionalInfoForTransactionDto {
    identifier: string;
    value: string;
}

/** This object is required in new implemenation, but all the properties are optional. There are paycodes that prohibit setting any of these fields. */
export class TransactionFieldsDto implements ITransactionFieldsDto {
    factor?: string;
    quantity?: string;
    price?: string;
    totalPrice?: string;

    constructor(data?: ITransactionFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factor = _data["factor"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): TransactionFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factor"] = this.factor;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        return data;
    }

    clone(): TransactionFieldsDto {
        const json = this.toJSON();
        let result = new TransactionFieldsDto();
        result.init(json);
        return result;
    }
}

/** This object is required in new implemenation, but all the properties are optional. There are paycodes that prohibit setting any of these fields. */
export interface ITransactionFieldsDto {
    factor?: string;
    quantity?: string;
    price?: string;
    totalPrice?: string;
}

export class AddFixedTransactionsRequestDto extends BaseRequestDto implements IAddFixedTransactionsRequestDto {
    /** List of transactions to add */
    items!: AddFixedTransactionsRequestItemDto[];

    constructor(data?: IAddFixedTransactionsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddFixedTransactionsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AddFixedTransactionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddFixedTransactionsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AddFixedTransactionsRequestDto {
        const json = this.toJSON();
        let result = new AddFixedTransactionsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAddFixedTransactionsRequestDto extends IBaseRequestDto {
    /** List of transactions to add */
    items: AddFixedTransactionsRequestItemDto[];
}

export class AddFixedTransactionsRequestItemDto extends BaseRequestItemDto implements IAddFixedTransactionsRequestItemDto {
    positionId?: string;
    employeeId!: string;
    paycodeId!: string;
    /** Used for reporting only. */
    paycodeCustomId!: string;
    paycodeName!: LocalizedStringDto;
    activeStart!: string;
    activeEnd?: string;
    fields!: TransactionFieldsDto;
    description?: string;
    additionalInfo!: AdditionalInfoForTransactionDto;
    /** transaction cost units */
    costUnits!: CostUnitForTransactionDto[];

    constructor(data?: IAddFixedTransactionsRequestItemDto) {
        super(data);
        if (!data) {
            this.paycodeName = new LocalizedStringDto();
            this.fields = new TransactionFieldsDto();
            this.additionalInfo = new AdditionalInfoForTransactionDto();
            this.costUnits = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.positionId = _data["positionId"];
            this.employeeId = _data["employeeId"];
            this.paycodeId = _data["paycodeId"];
            this.paycodeCustomId = _data["paycodeCustomId"];
            this.paycodeName = _data["paycodeName"] ? LocalizedStringDto.fromJS(_data["paycodeName"]) : new LocalizedStringDto();
            this.activeStart = _data["activeStart"];
            this.activeEnd = _data["activeEnd"];
            this.fields = _data["fields"] ? TransactionFieldsDto.fromJS(_data["fields"]) : new TransactionFieldsDto();
            this.description = _data["description"];
            this.additionalInfo = _data["additionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["additionalInfo"]) : new AdditionalInfoForTransactionDto();
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AddFixedTransactionsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddFixedTransactionsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["employeeId"] = this.employeeId;
        data["paycodeId"] = this.paycodeId;
        data["paycodeCustomId"] = this.paycodeCustomId;
        data["paycodeName"] = this.paycodeName ? this.paycodeName.toJSON() : undefined as any;
        data["activeStart"] = this.activeStart;
        data["activeEnd"] = this.activeEnd;
        data["fields"] = this.fields ? this.fields.toJSON() : undefined as any;
        data["description"] = this.description;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : undefined as any;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AddFixedTransactionsRequestItemDto {
        const json = this.toJSON();
        let result = new AddFixedTransactionsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IAddFixedTransactionsRequestItemDto extends IBaseRequestItemDto {
    positionId?: string;
    employeeId: string;
    paycodeId: string;
    /** Used for reporting only. */
    paycodeCustomId: string;
    paycodeName: LocalizedStringDto;
    activeStart: string;
    activeEnd?: string;
    fields: TransactionFieldsDto;
    description?: string;
    additionalInfo: AdditionalInfoForTransactionDto;
    /** transaction cost units */
    costUnits: CostUnitForTransactionDto[];
}

/** full information about an adding of fixed transactions */
export class AddFixedTransactionsOperationDto extends OperationStateDto implements IAddFixedTransactionsOperationDto {
    /** List of transactions being or having been added */
    tasks!: AddFixedTransactionsTaskDto[];

    constructor(data?: IAddFixedTransactionsOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AddFixedTransactionsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AddFixedTransactionsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddFixedTransactionsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AddFixedTransactionsOperationDto {
        const json = this.toJSON();
        let result = new AddFixedTransactionsOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about an adding of fixed transactions */
export interface IAddFixedTransactionsOperationDto extends IOperationStateDto {
    /** List of transactions being or having been added */
    tasks: AddFixedTransactionsTaskDto[];
}

export class AddFixedTransactionsTaskDto extends AddFixedTransactionsRequestItemDto implements IAddFixedTransactionsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IAddFixedTransactionsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): AddFixedTransactionsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddFixedTransactionsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): AddFixedTransactionsTaskDto {
        const json = this.toJSON();
        let result = new AddFixedTransactionsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IAddFixedTransactionsTaskDto extends IAddFixedTransactionsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EndFixedTransactionsRequestDto extends BaseRequestDto implements IEndFixedTransactionsRequestDto {
    /** List of transactions to end */
    items!: EndFixedTransactionsRequestItemDto[];

    constructor(data?: IEndFixedTransactionsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EndFixedTransactionsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EndFixedTransactionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndFixedTransactionsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EndFixedTransactionsRequestDto {
        const json = this.toJSON();
        let result = new EndFixedTransactionsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IEndFixedTransactionsRequestDto extends IBaseRequestDto {
    /** List of transactions to end */
    items: EndFixedTransactionsRequestItemDto[];
}

export class EndFixedTransactionsRequestItemDto extends BaseRequestItemDto implements IEndFixedTransactionsRequestItemDto {
    transactionId!: string;
    /** Used for verification and reporting. */
    positionId?: string;
    /** Used for verification and reporting. */
    employeeId?: string;
    /** Used for verification and reporting. */
    paycodeId!: string;
    /** Replaced by `paycodeCustomId`. Simply start using that instead. */
    paycodeIdentifier?: number;
    /** Used for reporting only. */
    paycodeCustomId?: string;
    paycodeName!: LocalizedStringDto;
    /** Used for reporting only. */
    activeStart!: Date;
    /** Active end time of transaction. Update will fail if this is less than activeStart. */
    activeEnd!: Date;
    /** Used for reporting only. */
    description?: string;
    /** Used for reporting only. */
    additionalInfo?: AdditionalInfoForTransactionDto;
    fields?: TransactionFieldsDto;
    /** Used for reporting only. */
    costUnits?: CostUnitForTransactionDto[];
    /** Replaced by `fields` */
    factor?: number;
    /** Replaced by `fields` */
    quantity?: number;
    /** Replaced by `fields` */
    price?: number;
    /** Replaced by `fields` */
    totalPrice?: number;

    constructor(data?: IEndFixedTransactionsRequestItemDto) {
        super(data);
        if (!data) {
            this.paycodeName = new LocalizedStringDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.positionId = _data["positionId"];
            this.employeeId = _data["employeeId"];
            this.paycodeId = _data["paycodeId"];
            this.paycodeIdentifier = _data["paycodeIdentifier"];
            this.paycodeCustomId = _data["paycodeCustomId"];
            this.paycodeName = _data["paycodeName"] ? LocalizedStringDto.fromJS(_data["paycodeName"]) : new LocalizedStringDto();
            this.activeStart = _data["activeStart"] ? new Date(_data["activeStart"].toString()) : undefined as any;
            this.activeEnd = _data["activeEnd"] ? new Date(_data["activeEnd"].toString()) : undefined as any;
            this.description = _data["description"];
            this.additionalInfo = _data["additionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["additionalInfo"]) : undefined as any;
            this.fields = _data["fields"] ? TransactionFieldsDto.fromJS(_data["fields"]) : undefined as any;
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
            this.factor = _data["factor"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static override fromJS(data: any): EndFixedTransactionsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndFixedTransactionsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["positionId"] = this.positionId;
        data["employeeId"] = this.employeeId;
        data["paycodeId"] = this.paycodeId;
        data["paycodeIdentifier"] = this.paycodeIdentifier;
        data["paycodeCustomId"] = this.paycodeCustomId;
        data["paycodeName"] = this.paycodeName ? this.paycodeName.toJSON() : undefined as any;
        data["activeStart"] = this.activeStart ? formatDate(this.activeStart) : undefined as any;
        data["activeEnd"] = this.activeEnd ? formatDate(this.activeEnd) : undefined as any;
        data["description"] = this.description;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : undefined as any;
        data["fields"] = this.fields ? this.fields.toJSON() : undefined as any;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["factor"] = this.factor;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        super.toJSON(data);
        return data;
    }

    clone(): EndFixedTransactionsRequestItemDto {
        const json = this.toJSON();
        let result = new EndFixedTransactionsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IEndFixedTransactionsRequestItemDto extends IBaseRequestItemDto {
    transactionId: string;
    /** Used for verification and reporting. */
    positionId?: string;
    /** Used for verification and reporting. */
    employeeId?: string;
    /** Used for verification and reporting. */
    paycodeId: string;
    /** Replaced by `paycodeCustomId`. Simply start using that instead. */
    paycodeIdentifier?: number;
    /** Used for reporting only. */
    paycodeCustomId?: string;
    paycodeName: LocalizedStringDto;
    /** Used for reporting only. */
    activeStart: Date;
    /** Active end time of transaction. Update will fail if this is less than activeStart. */
    activeEnd: Date;
    /** Used for reporting only. */
    description?: string;
    /** Used for reporting only. */
    additionalInfo?: AdditionalInfoForTransactionDto;
    fields?: TransactionFieldsDto;
    /** Used for reporting only. */
    costUnits?: CostUnitForTransactionDto[];
    /** Replaced by `fields` */
    factor?: number;
    /** Replaced by `fields` */
    quantity?: number;
    /** Replaced by `fields` */
    price?: number;
    /** Replaced by `fields` */
    totalPrice?: number;
}

/** full information about a single salary update */
export class EndFixedTransactionsOperationDto extends OperationStateDto implements IEndFixedTransactionsOperationDto {
    /** List of transactions being or having been ended */
    tasks!: EndFixedTransactionsTaskDto[];

    constructor(data?: IEndFixedTransactionsOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(EndFixedTransactionsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EndFixedTransactionsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndFixedTransactionsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EndFixedTransactionsOperationDto {
        const json = this.toJSON();
        let result = new EndFixedTransactionsOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single salary update */
export interface IEndFixedTransactionsOperationDto extends IOperationStateDto {
    /** List of transactions being or having been ended */
    tasks: EndFixedTransactionsTaskDto[];
}

export class EndFixedTransactionsTaskDto extends EndFixedTransactionsRequestItemDto implements IEndFixedTransactionsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IEndFixedTransactionsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): EndFixedTransactionsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndFixedTransactionsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): EndFixedTransactionsTaskDto {
        const json = this.toJSON();
        let result = new EndFixedTransactionsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IEndFixedTransactionsTaskDto extends IEndFixedTransactionsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class EditFixedTransactionsRequestDto extends BaseRequestDto implements IEditFixedTransactionsRequestDto {
    /** List of transactions to edit */
    items!: EditFixedTransactionsRequestItemDto[];

    constructor(data?: IEditFixedTransactionsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditFixedTransactionsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditFixedTransactionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFixedTransactionsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditFixedTransactionsRequestDto {
        const json = this.toJSON();
        let result = new EditFixedTransactionsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IEditFixedTransactionsRequestDto extends IBaseRequestDto {
    /** List of transactions to edit */
    items: EditFixedTransactionsRequestItemDto[];
}

export class EditFixedTransactionsRequestItemDto extends BaseRequestItemDto implements IEditFixedTransactionsRequestItemDto {
    transactionId!: string;
    /** Used for verification and reporting. */
    positionId?: string;
    /** Used for verification and reporting. */
    employeeId?: string;
    /** Used for verification and reporting. */
    paycodeId!: string;
    /** Replaced by `paycodeCustomId` when `isCorrection` is set.
 */
    paycodeIdentifier?: number;
    /** Used for reporting only. Will become required along with `isCorrection` (VHDI-3536). */
    paycodeCustomId?: string;
    paycodeName!: LocalizedStringDto;
    /** Indicates whether this is a correction that only changes an existing transaction, or an edit which will normally create a new transaction.
For a correction, `newActiveStart` and `newActiveEnd` replaces the respective values on the existing transaction. For an edit, `editActiveStart` is used to end the existing transaction and start a new transaction.
Expand-contract: Once existing code has been changed to include this, it will become required (VHDI-3536).
 */
    isCorrection?: boolean;
    /** Used for reporting only. */
    oldActiveStart!: Date;
    /** Used for reporting only. */
    oldActiveEnd?: Date;
    oldDescription?: string;
    oldAdditionalInfo?: AdditionalInfoForTransactionDto;
    oldFields?: TransactionFieldsDto;
    /** Replaced by `oldFields` */
    oldFactor?: number;
    /** Replaced by `oldFields` */
    oldQuantity?: number;
    /** Replaced by `oldFields` */
    oldPrice?: number;
    /** Replaced by `oldFields` */
    oldTotalPrice?: number;
    /** Used for reporting only. */
    oldCostUnits?: CostUnitForTransactionDto[];
    /** Active start for edit of transaction to take effect. Old transaction will get activeEnd set to this date - 1 day and new transaction will be created with this date as activeStart. Required when `isCorrection` is false, prohibited when true.
Must be higher than (not equal to) `oldActiveStart` and less than or equal to `oldActiveEnd`.
 */
    editActiveStart?: Date;
    /** Transaction's activeStart will be set to this value. If `isCorrection` is true, this is required
 */
    newActiveStart?: Date;
    /** Transaction's activeEnd will be set to this value. Prohibited if `oldActiveEnd` is not set. Optional if `isCorrection` is true.
 */
    newActiveEnd?: Date;
    newDescription?: string;
    newAdditionalInfo?: AdditionalInfoForTransactionDto;
    newFields?: TransactionFieldsDto;
    /** Replaced by `newFields` */
    newFactor?: number;
    /** Replaced by `newFields` */
    newQuantity?: number;
    /** Replaced by `newFields` */
    newPrice?: number;
    /** Replaced by `newFields` */
    newTotalPrice?: number;
    newCostUnits?: CostUnitForTransactionDto[];

    constructor(data?: IEditFixedTransactionsRequestItemDto) {
        super(data);
        if (!data) {
            this.paycodeName = new LocalizedStringDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.positionId = _data["positionId"];
            this.employeeId = _data["employeeId"];
            this.paycodeId = _data["paycodeId"];
            this.paycodeIdentifier = _data["paycodeIdentifier"];
            this.paycodeCustomId = _data["paycodeCustomId"];
            this.paycodeName = _data["paycodeName"] ? LocalizedStringDto.fromJS(_data["paycodeName"]) : new LocalizedStringDto();
            this.isCorrection = _data["isCorrection"];
            this.oldActiveStart = _data["oldActiveStart"] ? new Date(_data["oldActiveStart"].toString()) : undefined as any;
            this.oldActiveEnd = _data["oldActiveEnd"] ? new Date(_data["oldActiveEnd"].toString()) : undefined as any;
            this.oldDescription = _data["oldDescription"];
            this.oldAdditionalInfo = _data["oldAdditionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["oldAdditionalInfo"]) : undefined as any;
            this.oldFields = _data["oldFields"] ? TransactionFieldsDto.fromJS(_data["oldFields"]) : undefined as any;
            this.oldFactor = _data["oldFactor"];
            this.oldQuantity = _data["oldQuantity"];
            this.oldPrice = _data["oldPrice"];
            this.oldTotalPrice = _data["oldTotalPrice"];
            if (Array.isArray(_data["oldCostUnits"])) {
                this.oldCostUnits = [] as any;
                for (let item of _data["oldCostUnits"])
                    this.oldCostUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
            this.editActiveStart = _data["editActiveStart"] ? new Date(_data["editActiveStart"].toString()) : undefined as any;
            this.newActiveStart = _data["newActiveStart"] ? new Date(_data["newActiveStart"].toString()) : undefined as any;
            this.newActiveEnd = _data["newActiveEnd"] ? new Date(_data["newActiveEnd"].toString()) : undefined as any;
            this.newDescription = _data["newDescription"];
            this.newAdditionalInfo = _data["newAdditionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["newAdditionalInfo"]) : undefined as any;
            this.newFields = _data["newFields"] ? TransactionFieldsDto.fromJS(_data["newFields"]) : undefined as any;
            this.newFactor = _data["newFactor"];
            this.newQuantity = _data["newQuantity"];
            this.newPrice = _data["newPrice"];
            this.newTotalPrice = _data["newTotalPrice"];
            if (Array.isArray(_data["newCostUnits"])) {
                this.newCostUnits = [] as any;
                for (let item of _data["newCostUnits"])
                    this.newCostUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditFixedTransactionsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFixedTransactionsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["positionId"] = this.positionId;
        data["employeeId"] = this.employeeId;
        data["paycodeId"] = this.paycodeId;
        data["paycodeIdentifier"] = this.paycodeIdentifier;
        data["paycodeCustomId"] = this.paycodeCustomId;
        data["paycodeName"] = this.paycodeName ? this.paycodeName.toJSON() : undefined as any;
        data["isCorrection"] = this.isCorrection;
        data["oldActiveStart"] = this.oldActiveStart ? formatDate(this.oldActiveStart) : undefined as any;
        data["oldActiveEnd"] = this.oldActiveEnd ? formatDate(this.oldActiveEnd) : undefined as any;
        data["oldDescription"] = this.oldDescription;
        data["oldAdditionalInfo"] = this.oldAdditionalInfo ? this.oldAdditionalInfo.toJSON() : undefined as any;
        data["oldFields"] = this.oldFields ? this.oldFields.toJSON() : undefined as any;
        data["oldFactor"] = this.oldFactor;
        data["oldQuantity"] = this.oldQuantity;
        data["oldPrice"] = this.oldPrice;
        data["oldTotalPrice"] = this.oldTotalPrice;
        if (Array.isArray(this.oldCostUnits)) {
            data["oldCostUnits"] = [];
            for (let item of this.oldCostUnits)
                data["oldCostUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["editActiveStart"] = this.editActiveStart ? formatDate(this.editActiveStart) : undefined as any;
        data["newActiveStart"] = this.newActiveStart ? formatDate(this.newActiveStart) : undefined as any;
        data["newActiveEnd"] = this.newActiveEnd ? formatDate(this.newActiveEnd) : undefined as any;
        data["newDescription"] = this.newDescription;
        data["newAdditionalInfo"] = this.newAdditionalInfo ? this.newAdditionalInfo.toJSON() : undefined as any;
        data["newFields"] = this.newFields ? this.newFields.toJSON() : undefined as any;
        data["newFactor"] = this.newFactor;
        data["newQuantity"] = this.newQuantity;
        data["newPrice"] = this.newPrice;
        data["newTotalPrice"] = this.newTotalPrice;
        if (Array.isArray(this.newCostUnits)) {
            data["newCostUnits"] = [];
            for (let item of this.newCostUnits)
                data["newCostUnits"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditFixedTransactionsRequestItemDto {
        const json = this.toJSON();
        let result = new EditFixedTransactionsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IEditFixedTransactionsRequestItemDto extends IBaseRequestItemDto {
    transactionId: string;
    /** Used for verification and reporting. */
    positionId?: string;
    /** Used for verification and reporting. */
    employeeId?: string;
    /** Used for verification and reporting. */
    paycodeId: string;
    /** Replaced by `paycodeCustomId` when `isCorrection` is set.
 */
    paycodeIdentifier?: number;
    /** Used for reporting only. Will become required along with `isCorrection` (VHDI-3536). */
    paycodeCustomId?: string;
    paycodeName: LocalizedStringDto;
    /** Indicates whether this is a correction that only changes an existing transaction, or an edit which will normally create a new transaction.
For a correction, `newActiveStart` and `newActiveEnd` replaces the respective values on the existing transaction. For an edit, `editActiveStart` is used to end the existing transaction and start a new transaction.
Expand-contract: Once existing code has been changed to include this, it will become required (VHDI-3536).
 */
    isCorrection?: boolean;
    /** Used for reporting only. */
    oldActiveStart: Date;
    /** Used for reporting only. */
    oldActiveEnd?: Date;
    oldDescription?: string;
    oldAdditionalInfo?: AdditionalInfoForTransactionDto;
    oldFields?: TransactionFieldsDto;
    /** Replaced by `oldFields` */
    oldFactor?: number;
    /** Replaced by `oldFields` */
    oldQuantity?: number;
    /** Replaced by `oldFields` */
    oldPrice?: number;
    /** Replaced by `oldFields` */
    oldTotalPrice?: number;
    /** Used for reporting only. */
    oldCostUnits?: CostUnitForTransactionDto[];
    /** Active start for edit of transaction to take effect. Old transaction will get activeEnd set to this date - 1 day and new transaction will be created with this date as activeStart. Required when `isCorrection` is false, prohibited when true.
Must be higher than (not equal to) `oldActiveStart` and less than or equal to `oldActiveEnd`.
 */
    editActiveStart?: Date;
    /** Transaction's activeStart will be set to this value. If `isCorrection` is true, this is required
 */
    newActiveStart?: Date;
    /** Transaction's activeEnd will be set to this value. Prohibited if `oldActiveEnd` is not set. Optional if `isCorrection` is true.
 */
    newActiveEnd?: Date;
    newDescription?: string;
    newAdditionalInfo?: AdditionalInfoForTransactionDto;
    newFields?: TransactionFieldsDto;
    /** Replaced by `newFields` */
    newFactor?: number;
    /** Replaced by `newFields` */
    newQuantity?: number;
    /** Replaced by `newFields` */
    newPrice?: number;
    /** Replaced by `newFields` */
    newTotalPrice?: number;
    newCostUnits?: CostUnitForTransactionDto[];
}

/** full information about an edit of fixed transactions */
export class EditFixedTransactionsOperationDto extends OperationStateDto implements IEditFixedTransactionsOperationDto {
    /** List of transactions being or having been edited */
    tasks!: EditFixedTransactionsTaskDto[];

    constructor(data?: IEditFixedTransactionsOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(EditFixedTransactionsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditFixedTransactionsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFixedTransactionsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditFixedTransactionsOperationDto {
        const json = this.toJSON();
        let result = new EditFixedTransactionsOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about an edit of fixed transactions */
export interface IEditFixedTransactionsOperationDto extends IOperationStateDto {
    /** List of transactions being or having been edited */
    tasks: EditFixedTransactionsTaskDto[];
}

export class EditFixedTransactionsTaskDto extends EditFixedTransactionsRequestItemDto implements IEditFixedTransactionsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;
    /** Additional information about the state of the task. This is only set if the task is in a state where additional information is needed. The keys and values are specific to the task and state.
 */
    statusDetails?: EditFixedTransactionsTaskStatusDetailsDto;

    constructor(data?: IEditFixedTransactionsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
            this.statusDetails = _data["statusDetails"] ? EditFixedTransactionsTaskStatusDetailsDto.fromJS(_data["statusDetails"]) : undefined as any;
        }
    }

    static override fromJS(data: any): EditFixedTransactionsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFixedTransactionsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        data["statusDetails"] = this.statusDetails ? this.statusDetails.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): EditFixedTransactionsTaskDto {
        const json = this.toJSON();
        let result = new EditFixedTransactionsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IEditFixedTransactionsTaskDto extends IEditFixedTransactionsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
    /** Additional information about the state of the task. This is only set if the task is in a state where additional information is needed. The keys and values are specific to the task and state.
 */
    statusDetails?: EditFixedTransactionsTaskStatusDetailsDto;
}

/** This is only set if the task is in a status where additional information is needed. */
export class EditFixedTransactionsTaskStatusDetailsDto implements IEditFixedTransactionsTaskStatusDetailsDto {
    /** Set to true if the new transaction was created successfully.
 */
    isNewTransactionCreated?: boolean;
    /** Set to true if the old transaction was ended successfully.
 */
    isOldTransactionEnded?: boolean;

    constructor(data?: IEditFixedTransactionsTaskStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNewTransactionCreated = _data["isNewTransactionCreated"];
            this.isOldTransactionEnded = _data["isOldTransactionEnded"];
        }
    }

    static fromJS(data: any): EditFixedTransactionsTaskStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFixedTransactionsTaskStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNewTransactionCreated"] = this.isNewTransactionCreated;
        data["isOldTransactionEnded"] = this.isOldTransactionEnded;
        return data;
    }

    clone(): EditFixedTransactionsTaskStatusDetailsDto {
        const json = this.toJSON();
        let result = new EditFixedTransactionsTaskStatusDetailsDto();
        result.init(json);
        return result;
    }
}

/** This is only set if the task is in a status where additional information is needed. */
export interface IEditFixedTransactionsTaskStatusDetailsDto {
    /** Set to true if the new transaction was created successfully.
 */
    isNewTransactionCreated?: boolean;
    /** Set to true if the old transaction was ended successfully.
 */
    isOldTransactionEnded?: boolean;
}

export class DeleteFixedTransactionsRequestDto extends BaseRequestDto implements IDeleteFixedTransactionsRequestDto {
    items!: DeleteFixedTransactionsRequestItemDto[];

    constructor(data?: IDeleteFixedTransactionsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeleteFixedTransactionsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeleteFixedTransactionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFixedTransactionsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeleteFixedTransactionsRequestDto {
        const json = this.toJSON();
        let result = new DeleteFixedTransactionsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteFixedTransactionsRequestDto extends IBaseRequestDto {
    items: DeleteFixedTransactionsRequestItemDto[];
}

export class DeleteFixedTransactionsRequestItemDto extends BaseRequestItemDto implements IDeleteFixedTransactionsRequestItemDto {
    transactionId!: string;
    positionId?: string;
    employeeId!: string;
    paycodeId!: string;
    /** Used for reporting only. */
    paycodeCustomId!: string;
    paycodeName!: LocalizedStringDto;
    description?: string;
    additionalInfo!: AdditionalInfoForTransactionDto;
    fields!: TransactionFieldsDto;
    costUnits!: CostUnitForTransactionDto[];

    constructor(data?: IDeleteFixedTransactionsRequestItemDto) {
        super(data);
        if (!data) {
            this.paycodeName = new LocalizedStringDto();
            this.additionalInfo = new AdditionalInfoForTransactionDto();
            this.fields = new TransactionFieldsDto();
            this.costUnits = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.positionId = _data["positionId"];
            this.employeeId = _data["employeeId"];
            this.paycodeId = _data["paycodeId"];
            this.paycodeCustomId = _data["paycodeCustomId"];
            this.paycodeName = _data["paycodeName"] ? LocalizedStringDto.fromJS(_data["paycodeName"]) : new LocalizedStringDto();
            this.description = _data["description"];
            this.additionalInfo = _data["additionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["additionalInfo"]) : new AdditionalInfoForTransactionDto();
            this.fields = _data["fields"] ? TransactionFieldsDto.fromJS(_data["fields"]) : new TransactionFieldsDto();
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeleteFixedTransactionsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFixedTransactionsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["positionId"] = this.positionId;
        data["employeeId"] = this.employeeId;
        data["paycodeId"] = this.paycodeId;
        data["paycodeCustomId"] = this.paycodeCustomId;
        data["paycodeName"] = this.paycodeName ? this.paycodeName.toJSON() : undefined as any;
        data["description"] = this.description;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : undefined as any;
        data["fields"] = this.fields ? this.fields.toJSON() : undefined as any;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeleteFixedTransactionsRequestItemDto {
        const json = this.toJSON();
        let result = new DeleteFixedTransactionsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteFixedTransactionsRequestItemDto extends IBaseRequestItemDto {
    transactionId: string;
    positionId?: string;
    employeeId: string;
    paycodeId: string;
    /** Used for reporting only. */
    paycodeCustomId: string;
    paycodeName: LocalizedStringDto;
    description?: string;
    additionalInfo: AdditionalInfoForTransactionDto;
    fields: TransactionFieldsDto;
    costUnits: CostUnitForTransactionDto[];
}

export class DeleteFixedTransactionsOperationDto extends OperationStateDto implements IDeleteFixedTransactionsOperationDto {
    tasks!: DeleteFixedTransactionsTaskDto[];

    constructor(data?: IDeleteFixedTransactionsOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(DeleteFixedTransactionsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeleteFixedTransactionsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFixedTransactionsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeleteFixedTransactionsOperationDto {
        const json = this.toJSON();
        let result = new DeleteFixedTransactionsOperationDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteFixedTransactionsOperationDto extends IOperationStateDto {
    tasks: DeleteFixedTransactionsTaskDto[];
}

export class DeleteFixedTransactionsTaskDto extends DeleteFixedTransactionsRequestItemDto implements IDeleteFixedTransactionsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IDeleteFixedTransactionsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): DeleteFixedTransactionsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFixedTransactionsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): DeleteFixedTransactionsTaskDto {
        const json = this.toJSON();
        let result = new DeleteFixedTransactionsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteFixedTransactionsTaskDto extends IDeleteFixedTransactionsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class PauseFixedTransactionsRequestDto extends BaseRequestDto implements IPauseFixedTransactionsRequestDto {
    /** List of transactions to pause */
    items!: PauseFixedTransactionsRequestItemDto[];

    constructor(data?: IPauseFixedTransactionsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PauseFixedTransactionsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PauseFixedTransactionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PauseFixedTransactionsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PauseFixedTransactionsRequestDto {
        const json = this.toJSON();
        let result = new PauseFixedTransactionsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPauseFixedTransactionsRequestDto extends IBaseRequestDto {
    /** List of transactions to pause */
    items: PauseFixedTransactionsRequestItemDto[];
}

export class PauseFixedTransactionsRequestItemDto extends BaseRequestItemDto implements IPauseFixedTransactionsRequestItemDto {
    /** ID of the transaction to pause */
    transactionId!: string;
    /** Used for verification and reporting. */
    positionId?: string;
    /** Used for verification and reporting. */
    employeeId?: string;
    /** Used for verification and reporting. */
    paycodeId!: string;
    /** Used for reporting only. */
    paycodeCustomId?: string;
    paycodeName!: LocalizedStringDto;
    /** Used for reporting only. */
    oldActiveStart!: Date;
    /** Used for reporting only. */
    oldActiveEnd?: Date;
    /** Date when the pause begins */
    pauseStart!: Date;
    /** Date when the pause ends */
    pauseEnd!: Date;
    /** Used for reporting only. */
    description?: string;
    /** Used for reporting only. */
    additionalInfo?: AdditionalInfoForTransactionDto;
    fields?: TransactionFieldsDto;
    /** Used for reporting only. */
    costUnits?: CostUnitForTransactionDto[];

    constructor(data?: IPauseFixedTransactionsRequestItemDto) {
        super(data);
        if (!data) {
            this.paycodeName = new LocalizedStringDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.positionId = _data["positionId"];
            this.employeeId = _data["employeeId"];
            this.paycodeId = _data["paycodeId"];
            this.paycodeCustomId = _data["paycodeCustomId"];
            this.paycodeName = _data["paycodeName"] ? LocalizedStringDto.fromJS(_data["paycodeName"]) : new LocalizedStringDto();
            this.oldActiveStart = _data["oldActiveStart"] ? new Date(_data["oldActiveStart"].toString()) : undefined as any;
            this.oldActiveEnd = _data["oldActiveEnd"] ? new Date(_data["oldActiveEnd"].toString()) : undefined as any;
            this.pauseStart = _data["pauseStart"] ? new Date(_data["pauseStart"].toString()) : undefined as any;
            this.pauseEnd = _data["pauseEnd"] ? new Date(_data["pauseEnd"].toString()) : undefined as any;
            this.description = _data["description"];
            this.additionalInfo = _data["additionalInfo"] ? AdditionalInfoForTransactionDto.fromJS(_data["additionalInfo"]) : undefined as any;
            this.fields = _data["fields"] ? TransactionFieldsDto.fromJS(_data["fields"]) : undefined as any;
            if (Array.isArray(_data["costUnits"])) {
                this.costUnits = [] as any;
                for (let item of _data["costUnits"])
                    this.costUnits!.push(CostUnitForTransactionDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PauseFixedTransactionsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PauseFixedTransactionsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["positionId"] = this.positionId;
        data["employeeId"] = this.employeeId;
        data["paycodeId"] = this.paycodeId;
        data["paycodeCustomId"] = this.paycodeCustomId;
        data["paycodeName"] = this.paycodeName ? this.paycodeName.toJSON() : undefined as any;
        data["oldActiveStart"] = this.oldActiveStart ? formatDate(this.oldActiveStart) : undefined as any;
        data["oldActiveEnd"] = this.oldActiveEnd ? formatDate(this.oldActiveEnd) : undefined as any;
        data["pauseStart"] = this.pauseStart ? formatDate(this.pauseStart) : undefined as any;
        data["pauseEnd"] = this.pauseEnd ? formatDate(this.pauseEnd) : undefined as any;
        data["description"] = this.description;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : undefined as any;
        data["fields"] = this.fields ? this.fields.toJSON() : undefined as any;
        if (Array.isArray(this.costUnits)) {
            data["costUnits"] = [];
            for (let item of this.costUnits)
                data["costUnits"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PauseFixedTransactionsRequestItemDto {
        const json = this.toJSON();
        let result = new PauseFixedTransactionsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IPauseFixedTransactionsRequestItemDto extends IBaseRequestItemDto {
    /** ID of the transaction to pause */
    transactionId: string;
    /** Used for verification and reporting. */
    positionId?: string;
    /** Used for verification and reporting. */
    employeeId?: string;
    /** Used for verification and reporting. */
    paycodeId: string;
    /** Used for reporting only. */
    paycodeCustomId?: string;
    paycodeName: LocalizedStringDto;
    /** Used for reporting only. */
    oldActiveStart: Date;
    /** Used for reporting only. */
    oldActiveEnd?: Date;
    /** Date when the pause begins */
    pauseStart: Date;
    /** Date when the pause ends */
    pauseEnd: Date;
    /** Used for reporting only. */
    description?: string;
    /** Used for reporting only. */
    additionalInfo?: AdditionalInfoForTransactionDto;
    fields?: TransactionFieldsDto;
    /** Used for reporting only. */
    costUnits?: CostUnitForTransactionDto[];
}

/** full information about a pause of fixed transactions */
export class PauseFixedTransactionsOperationDto extends OperationStateDto implements IPauseFixedTransactionsOperationDto {
    /** List of transactions being or having been paused */
    tasks?: PauseFixedTransactionsTaskDto[];

    constructor(data?: IPauseFixedTransactionsOperationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(PauseFixedTransactionsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PauseFixedTransactionsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PauseFixedTransactionsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PauseFixedTransactionsOperationDto {
        const json = this.toJSON();
        let result = new PauseFixedTransactionsOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a pause of fixed transactions */
export interface IPauseFixedTransactionsOperationDto extends IOperationStateDto {
    /** List of transactions being or having been paused */
    tasks?: PauseFixedTransactionsTaskDto[];
}

export class PauseFixedTransactionsTaskDto extends PauseFixedTransactionsRequestItemDto implements IPauseFixedTransactionsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;
    /** Additional information about the state of the task. This is only set if the task is in a state where additional information is needed. The keys and values are specific to the task and state.
 */
    statusDetails?: PauseFixedTransactionsTaskStatusDetailsDto;

    constructor(data?: IPauseFixedTransactionsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
            this.statusDetails = _data["statusDetails"] ? PauseFixedTransactionsTaskStatusDetailsDto.fromJS(_data["statusDetails"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PauseFixedTransactionsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PauseFixedTransactionsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        data["statusDetails"] = this.statusDetails ? this.statusDetails.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): PauseFixedTransactionsTaskDto {
        const json = this.toJSON();
        let result = new PauseFixedTransactionsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IPauseFixedTransactionsTaskDto extends IPauseFixedTransactionsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
    /** Additional information about the state of the task. This is only set if the task is in a state where additional information is needed. The keys and values are specific to the task and state.
 */
    statusDetails?: PauseFixedTransactionsTaskStatusDetailsDto;
}

/** This is only set if the task is in a status where additional information is needed. */
export class PauseFixedTransactionsTaskStatusDetailsDto implements IPauseFixedTransactionsTaskStatusDetailsDto {
    /** Set to true if the transaction was resumed successfully.
 */
    isTransactionResumed?: boolean;
    /** Set to true if the transaction was paused successfully.
 */
    isTransactionPaused?: boolean;

    constructor(data?: IPauseFixedTransactionsTaskStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTransactionResumed = _data["isTransactionResumed"];
            this.isTransactionPaused = _data["isTransactionPaused"];
        }
    }

    static fromJS(data: any): PauseFixedTransactionsTaskStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PauseFixedTransactionsTaskStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTransactionResumed"] = this.isTransactionResumed;
        data["isTransactionPaused"] = this.isTransactionPaused;
        return data;
    }

    clone(): PauseFixedTransactionsTaskStatusDetailsDto {
        const json = this.toJSON();
        let result = new PauseFixedTransactionsTaskStatusDetailsDto();
        result.init(json);
        return result;
    }
}

/** This is only set if the task is in a status where additional information is needed. */
export interface IPauseFixedTransactionsTaskStatusDetailsDto {
    /** Set to true if the transaction was resumed successfully.
 */
    isTransactionResumed?: boolean;
    /** Set to true if the transaction was paused successfully.
 */
    isTransactionPaused?: boolean;
}

export class TimeAgreementsResponseDto implements ITimeAgreementsResponseDto {
    timeAgreements!: TimeAgreementDto[];

    constructor(data?: ITimeAgreementsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.timeAgreements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timeAgreements"])) {
                this.timeAgreements = [] as any;
                for (let item of _data["timeAgreements"])
                    this.timeAgreements!.push(TimeAgreementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeAgreementsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAgreementsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeAgreements)) {
            data["timeAgreements"] = [];
            for (let item of this.timeAgreements)
                data["timeAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TimeAgreementsResponseDto {
        const json = this.toJSON();
        let result = new TimeAgreementsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAgreementsResponseDto {
    timeAgreements: TimeAgreementDto[];
}

export class TimeAgreementDto implements ITimeAgreementDto {
    /** Unique internal identifier for time agreement. */
    id!: string;
    name!: LocalizedStringDto;

    constructor(data?: ITimeAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedStringDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? LocalizedStringDto.fromJS(_data["name"]) : new LocalizedStringDto();
        }
    }

    static fromJS(data: any): TimeAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        return data;
    }

    clone(): TimeAgreementDto {
        const json = this.toJSON();
        let result = new TimeAgreementDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAgreementDto {
    /** Unique internal identifier for time agreement. */
    id: string;
    name: LocalizedStringDto;
}

export class EmployeesTimeAgreementsResponseDto implements IEmployeesTimeAgreementsResponseDto {
    employeesTimeAgreements!: EmployeeTimeAgreementDto[];

    constructor(data?: IEmployeesTimeAgreementsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.employeesTimeAgreements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeesTimeAgreements"])) {
                this.employeesTimeAgreements = [] as any;
                for (let item of _data["employeesTimeAgreements"])
                    this.employeesTimeAgreements!.push(EmployeeTimeAgreementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeesTimeAgreementsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesTimeAgreementsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeesTimeAgreements)) {
            data["employeesTimeAgreements"] = [];
            for (let item of this.employeesTimeAgreements)
                data["employeesTimeAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmployeesTimeAgreementsResponseDto {
        const json = this.toJSON();
        let result = new EmployeesTimeAgreementsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesTimeAgreementsResponseDto {
    employeesTimeAgreements: EmployeeTimeAgreementDto[];
}

export class EmployeeTimeAgreementDto implements IEmployeeTimeAgreementDto {
    employeeId!: string;
    positionId!: string;
    /** Unique internal identifier for time agreement. */
    timeAgreementId?: string;
    /** Version of current employee time agreement. */
    version?: string;

    constructor(data?: IEmployeeTimeAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.positionId = _data["positionId"];
            this.timeAgreementId = _data["timeAgreementId"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): EmployeeTimeAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTimeAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["positionId"] = this.positionId;
        data["timeAgreementId"] = this.timeAgreementId;
        data["version"] = this.version;
        return data;
    }

    clone(): EmployeeTimeAgreementDto {
        const json = this.toJSON();
        let result = new EmployeeTimeAgreementDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeTimeAgreementDto {
    employeeId: string;
    positionId: string;
    /** Unique internal identifier for time agreement. */
    timeAgreementId?: string;
    /** Version of current employee time agreement. */
    version?: string;
}

export class ChangeTimeAgreementsRequestDto extends BaseRequestDto implements IChangeTimeAgreementsRequestDto {
    /** List of all employees time agreements to change */
    items!: ChangeTimeAgreementsRequestItemDto[];

    constructor(data?: IChangeTimeAgreementsRequestDto) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangeTimeAgreementsRequestItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChangeTimeAgreementsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTimeAgreementsRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChangeTimeAgreementsRequestDto {
        const json = this.toJSON();
        let result = new ChangeTimeAgreementsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IChangeTimeAgreementsRequestDto extends IBaseRequestDto {
    /** List of all employees time agreements to change */
    items: ChangeTimeAgreementsRequestItemDto[];
}

export class ChangeTimeAgreementsRequestItemDto extends BaseRequestItemDto implements IChangeTimeAgreementsRequestItemDto {
    employeeId!: string;
    positionId!: string;
    oldTimeAgreementId?: string;
    oldTimeAgreementName?: LocalizedStringDto;
    newTimeAgreementId!: string;
    newTimeAgreementName!: LocalizedStringDto;
    /** current employee time agreement version, if there is no previous time agreement for employee, this should not be set
 */
    version?: string;

    constructor(data?: IChangeTimeAgreementsRequestItemDto) {
        super(data);
        if (!data) {
            this.newTimeAgreementName = new LocalizedStringDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.positionId = _data["positionId"];
            this.oldTimeAgreementId = _data["oldTimeAgreementId"];
            this.oldTimeAgreementName = _data["oldTimeAgreementName"] ? LocalizedStringDto.fromJS(_data["oldTimeAgreementName"]) : undefined as any;
            this.newTimeAgreementId = _data["newTimeAgreementId"];
            this.newTimeAgreementName = _data["newTimeAgreementName"] ? LocalizedStringDto.fromJS(_data["newTimeAgreementName"]) : new LocalizedStringDto();
            this.version = _data["version"];
        }
    }

    static override fromJS(data: any): ChangeTimeAgreementsRequestItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTimeAgreementsRequestItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["positionId"] = this.positionId;
        data["oldTimeAgreementId"] = this.oldTimeAgreementId;
        data["oldTimeAgreementName"] = this.oldTimeAgreementName ? this.oldTimeAgreementName.toJSON() : undefined as any;
        data["newTimeAgreementId"] = this.newTimeAgreementId;
        data["newTimeAgreementName"] = this.newTimeAgreementName ? this.newTimeAgreementName.toJSON() : undefined as any;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }

    clone(): ChangeTimeAgreementsRequestItemDto {
        const json = this.toJSON();
        let result = new ChangeTimeAgreementsRequestItemDto();
        result.init(json);
        return result;
    }
}

export interface IChangeTimeAgreementsRequestItemDto extends IBaseRequestItemDto {
    employeeId: string;
    positionId: string;
    oldTimeAgreementId?: string;
    oldTimeAgreementName?: LocalizedStringDto;
    newTimeAgreementId: string;
    newTimeAgreementName: LocalizedStringDto;
    /** current employee time agreement version, if there is no previous time agreement for employee, this should not be set
 */
    version?: string;
}

/** full information about a single time agreement change */
export class ChangeTimeAgreementsOperationDto extends OperationStateDto implements IChangeTimeAgreementsOperationDto {
    /** List of time agreements being or having been changed */
    tasks!: ChangeTimeAgreementsTaskDto[];

    constructor(data?: IChangeTimeAgreementsOperationDto) {
        super(data);
        if (!data) {
            this.tasks = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ChangeTimeAgreementsTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChangeTimeAgreementsOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTimeAgreementsOperationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChangeTimeAgreementsOperationDto {
        const json = this.toJSON();
        let result = new ChangeTimeAgreementsOperationDto();
        result.init(json);
        return result;
    }
}

/** full information about a single time agreement change */
export interface IChangeTimeAgreementsOperationDto extends IOperationStateDto {
    /** List of time agreements being or having been changed */
    tasks: ChangeTimeAgreementsTaskDto[];
}

export class ChangeTimeAgreementsTaskDto extends ChangeTimeAgreementsRequestItemDto implements IChangeTimeAgreementsTaskDto {
    /** Task id */
    id!: string;
    status!: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber!: string;
    employeeName!: string;

    constructor(data?: IChangeTimeAgreementsTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"] ? LocalizedStringDto.fromJS(_data["errorMessage"]) : undefined as any;
            this.errorCorrelation = _data["errorCorrelation"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeName = _data["employeeName"];
        }
    }

    static override fromJS(data: any): ChangeTimeAgreementsTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTimeAgreementsTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage ? this.errorMessage.toJSON() : undefined as any;
        data["errorCorrelation"] = this.errorCorrelation;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeName"] = this.employeeName;
        super.toJSON(data);
        return data;
    }

    clone(): ChangeTimeAgreementsTaskDto {
        const json = this.toJSON();
        let result = new ChangeTimeAgreementsTaskDto();
        result.init(json);
        return result;
    }
}

export interface IChangeTimeAgreementsTaskDto extends IChangeTimeAgreementsRequestItemDto {
    /** Task id */
    id: string;
    status: TaskStatusEnum;
    /** For absence registration import, use `errorMessage` instead */
    error?: string;
    errorMessage?: LocalizedStringDto;
    errorCorrelation?: string;
    /** Organization specific employee number */
    employeeNumber: string;
    employeeName: string;
}

export class BooleanV3TimelineItemDto extends GapV3TimelineItemDto implements IBooleanV3TimelineItemDto {
    /** Only `true` is accepted. Absence of value on a date implies `false`.
 */
    value!: boolean;

    constructor(data?: IBooleanV3TimelineItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BooleanV3TimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanV3TimelineItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): BooleanV3TimelineItemDto {
        const json = this.toJSON();
        let result = new BooleanV3TimelineItemDto();
        result.init(json);
        return result;
    }
}

export interface IBooleanV3TimelineItemDto extends IGapV3TimelineItemDto {
    /** Only `true` is accepted. Absence of value on a date implies `false`.
 */
    value: boolean;
}

export enum CostUnitPrecedenceEnum {
    TransactionPositionPaycode = "transactionPositionPaycode",
    TransactionPaycodePosition = "transactionPaycodePosition",
}

/** More information can be found in `additionalInfoForTransactionDto` Possible values:  * `employerFeeZoneAssignmentCode` - Identifier is `1000` for employer fee zone assignment code.  * `employerFeeZone` - Identifier is `1010` for employer fee zone.  * `vatCode` - Identifier is `1100` for VAT code.  * `journeyCountCarAndBoat` - Identifier is `1130` for number of journeys (car and boat).  * `taxCountry` - Identifier is `2100` for tax country.  * `isEarnedOffshore` - Identifier is `2200` for is earned offshore.  * `earningCountry` - Identifier is `2300` for earning country.  * `earningSpecialCondition` - Identifier is `2400` for earning special condition.  * `grossUpTableNumber` - Identifier is `2800` for gross up table number.  * `leaveType` - Identifier is `3000` for leave type.  * `fnoStatus` - Identifier is `3100` for FNO status.  * `quantityReportOverride` - Identifier is `4010` for quantity report override.  * `dayCountFishingParticipation` - Identifier is `5000` for number of days participated.  * `dayCountOnboard` - Identifier is `5010` for number of days onboard.  * `offshoreFrom` - Identifier is `5140` for start date continental shelf.  * `offshoreTo` - Identifier is `5180` for end date continental shelf.  * `wageDescriptionCode` - Identifier is `9020` for reporting code description.  * `pensionFrom` - Identifier is `9230` for add info start date pension.  * `pensionTo` - Identifier is `9240` for add info end date pension.  * `isPensionCorrection` - Identifier is `9250` for is pension correction.  * `retirementPercentage` - Identifier is `9280` for retirement percentage.  * `employerLoanStartAmount` - Identifier is `10100` for employer loan start amount.  * `employerLoanInterestPercent` - Identifier is `10110` for employer loan interest percent.  * `typeOfPerson` - Identifier is `20000` for type of person.  * `paymentDateOverride` - Identifier is `999990` for enforced payment date. */
export enum AdditionalInfoEnumDto {
    EmployerFeeZoneAssignmentCode = "employerFeeZoneAssignmentCode",
    EmployerFeeZone = "employerFeeZone",
    VatCode = "vatCode",
    JourneyCountCarAndBoat = "journeyCountCarAndBoat",
    TaxCountry = "taxCountry",
    IsEarnedOffshore = "isEarnedOffshore",
    EarningCountry = "earningCountry",
    EarningSpecialCondition = "earningSpecialCondition",
    GrossUpTableNumber = "grossUpTableNumber",
    LeaveType = "leaveType",
    FnoStatus = "fnoStatus",
    QuantityReportOverride = "quantityReportOverride",
    DayCountFishingParticipation = "dayCountFishingParticipation",
    DayCountOnboard = "dayCountOnboard",
    OffshoreFrom = "offshoreFrom",
    OffshoreTo = "offshoreTo",
    WageDescriptionCode = "wageDescriptionCode",
    PensionFrom = "pensionFrom",
    PensionTo = "pensionTo",
    IsPensionCorrection = "isPensionCorrection",
    RetirementPercentage = "retirementPercentage",
    EmployerLoanStartAmount = "employerLoanStartAmount",
    EmployerLoanInterestPercent = "employerLoanInterestPercent",
    TypeOfPerson = "typeOfPerson",
    PaymentDateOverride = "paymentDateOverride",
}

export enum OperationTypeEnum {
    AbsenceRegistrationImport = "absenceRegistrationImport",
    AddFixedTransactions = "addFixedTransactions",
    AssignUser = "assignUser",
    ChangeManager = "changeManager",
    ChangeTimeAgreements = "changeTimeAgreements",
    CostUnitTypesCreate = "costUnitTypesCreate",
    CostUnitTypesUpdate = "costUnitTypesUpdate",
    CostUnitValueUpsert = "costUnitValueUpsert",
    DeleteFixedTransactions = "deleteFixedTransactions",
    EditFixedTransactions = "editFixedTransactions",
    EditPositionEndDates = "editPositionEndDates",
    EndFixedTransactions = "endFixedTransactions",
    EndPositions = "endPositions",
    ManageCostUnitValues = "manageCostUnitValues",
    PauseFixedTransactions = "pauseFixedTransactions",
    PayRateUpdate = "payRateUpdate",
    PositionTagsUpdate = "positionTagsUpdate",
    SalaryUpdateV2 = "salaryUpdateV2",
    TagCreate = "tagCreate",
    TagUpdate = "tagUpdate",
    VacationBalanceImport = "vacationBalanceImport",
}

/** Possible values:  * `inProgress` - Initial status. Does not change until all tasks have reached their final status.  * `successful` - All tasks completed with status `successful`.  * `incomplete` - No more tasks are scheduled and one or more tasks have status `failed` or `pollingTimeout`. */
export enum OperationStatusEnum {
    InProgress = "inProgress",
    Successful = "successful",
    Incomplete = "incomplete",
}

/** Indicates the type of change to be performed on the item. Possible values:  * `upsert` - To insert or update the item.  * `delete` - To delete the item. */
export enum OperationChangeTypeEnum {
    Upsert = "upsert",
    Delete = "delete",
}

/** Possible values:  * `created` - Initial status. Does not change until the external service returns (or times out).  * `polling` - DEPRECATED replaced by waiting.    Task has been submitted to external service and the job status is scheduled for querying.  * `waiting` - Job has been submitted, but still waiting for the job status change.  * `successful` - All work related to the task has been completed successfully.  * `failed` - No more work related to the task will be done, and something appears to have gone wrong.    Corner case: an asynchronous third party that we timed out waiting for could still do more work. */
export enum TaskStatusEnum {
    Created = "created",
    Polling = "polling",
    Waiting = "waiting",
    Successful = "successful",
    Failed = "failed",
}

export enum IcLookupTypeEnumDto {
    Settings = "settings",
    Employee = "employee",
    Position = "position",
    TaxUnit = "taxUnit",
    Creditor = "creditor",
    Union = "union",
    PensionCompany = "pensionCompany",
    Wta = "wta",
    Car = "car",
    Tag = "tag",
    PaycodeForEp = "paycodeForEp",
    PaycodeForFt = "paycodeForFt",
    EventCodeForAr = "eventCodeForAr",
    CostUnitType = "costUnitType",
    Cuv = "cuv",
}

/** National insurance (arbeidsgiveravgift) is affected by calculation code and municipality number. Possible values:  * `general` - maps to 'Ordinary' in org API.  * `agriculture` - maps to 'Agriculture' in org API, meant for agriculture, forestry, fisheries etc.  * `svalbard` - PAYE for Svalbard (payroll deduction), maps to 'Svalbard' in org API.  * `sectorExempt` - sector-exempt activity, maps to 'SectorExceptedActivity' in org API.  * `transport` - road freight transport, maps to 'FreightTransportation' in org API.  * `financialDifficulties` - financial difficulties, maps to 'oekonomiskeVanskeligheter' in org API. */
export enum EmployerFeeCalculationCodeEnum {
    General = "general",
    Agriculture = "agriculture",
    Svalbard = "svalbard",
    SectorExempt = "sectorExempt",
    Transport = "transport",
    FinancialDifficulties = "financialDifficulties",
}

export enum ActionTypeEnum {
    CostUnitTypeCreate = "costUnitTypeCreate",
    CostUnitTypeUpdate = "costUnitTypeUpdate",
    TagCreate = "tagCreate",
    TagUpdate = "tagUpdate",
}

export enum ActionStatusEnum {
    Created = "created",
    Waiting = "waiting",
    Successful = "successful",
    Failed = "failed",
}

export enum NextActionStatusEnum {
    Successful = "successful",
    Failed = "failed",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}